// İSG uzmanı portalı — statik arayüz metinleri (tr/en/de).
//
// Bu paket uygulamanın KENDİ microcopy'sidir; backend dil paketi (`/resources`)
// hata kodlarını + `label.*`'ı ekler ve aynı anahtarlar için ÜZERİNE yazar
// (i18n.ts birleştirme). Böylece backend erişilemese bile ham anahtar sızmaz.
//
// Anahtarlar `.` içerir ama i18next `keySeparator:false` ile bunları literal alır.
// Almanca metinler ä/ö/ü/ß içerir — font charset doğrulaması için görünür kanıt.

import type { AppResources } from '@isgportal/shared';

const tr: Record<string, string> = {
  // Paylaşılan `Pagination` özeti (S33-8 review fix #2) — `packages/shared/src/ui/Pagination.tsx`
  // TEK bir kanonik anahtarla kendi özetini hesaplar; modül başına 18 farklı format YERİNE.
  'pagination.summary': '{{from}}–{{to}} / {{total}} kayıt',
  'pagination.summaryEmpty': '0 kayıt',
  // `document.title` aktif dile göre (S33-8 review fix #9) — `index.html`'in statik başlığı
  // (tr) JS-öncesi düşüş olarak KALIR, `main.tsx` `initI18n` sonrası + her dil değişiminde
  // bunu bu anahtarla EZER.
  'app.title': 'İSG Portal — Uzman Portalı',
  // Tehlike sınıfı (hazard) — nötr namespace (S34-2 design review §1): eskiden `permits.hazard.*`
  // + `contractors.hazard.*` AYRI iki kopyaydı (EN/DE metinleri birbirinden HAFİF farklıydı);
  // hazard bir izin/taşeron ALANI değil sınıflandırmanın kendisi, bu yüzden TEK yerde yaşar —
  // `@isgportal/shared` `HazardTag`, izin/taşeron/izin-tipi/departman kontrolü HEPSİ bunu okur.
  'hazard.1': 'Az Tehlikeli',
  'hazard.2': 'Tehlikeli',
  'hazard.3': 'Çok Tehlikeli',
  // Paylaşılan liste-boş aksiyonu (S34-2 design review §2, M13) — "sonuç yok" (filtre sonrası)
  // durumunun TEK aksiyonu, her listede aynı metin.
  'common.clearFilters': 'Filtreleri temizle',
  'common.cancel': 'Vazgeç',
  'personnelForm.tc.show': 'Göster',
  'personnelForm.tc.hide': 'Gizle',
  'personnelForm.field.phone': 'Telefon',
  'personnelForm.field.email': 'E-posta',
  'personnelForm.field.tcKimlikNo': 'T.C. Kimlik No',
  'personnelForm.masked.notice':
    '“Kişisel veri” yetkiniz olmadığı için kişisel bilgiler kısmen gizlenmiştir.',
  // Ortak personel düzenleme formu (#29, `packages/shared/src/personnel/`) — SP ile aynı anahtarlar;
  // T.C. geçen metinler EP'nin kendi etiket terimini kullanır.
  'personnelForm.edit.action': 'Düzenle',
  'personnelForm.edit.title': 'Personeli düzenle',
  'personnelForm.field.firstName': 'Ad',
  'personnelForm.field.lastName': 'Soyad',
  'personnelForm.field.tcKimlikNoHint':
    '11 haneli, sağlama toplamı geçerli olmalıdır; yalnız bir kez girilir.',
  'personnelForm.field.accessLevel': 'Erişim seviyesi',
  'personnelForm.access.personeli': 'Personel',
  'personnelForm.access.yetkili': 'Yetkili',
  'personnelForm.field.accessHint':
    'Yetkili, web portalından personel ekleyip firma evrakı yükleyebilir; Personel yalnız mobil uygulamada kendi verisini görür.',
  'personnelForm.field.active': 'Aktif',
  'personnelForm.field.activeHint': 'Pasif personel giriş yapamaz ve sahaya erişemez.',
  'personnelForm.refreshNote':
    'Erişim seviyesi ve aktif/pasif durumu değişiklikleri en geç 15 dakika içinde (bir sonraki oturum yenilemesinde) geçerli olur.',
  'personnelForm.lock.tcSetOnce':
    'T.C. Kimlik No bir kez girildikten sonra bu ekrandan değiştirilemez. Değişiklik gerekiyorsa destek ile iletişime geçin.',
  'personnelForm.lock.tcNoPermission':
    "T.C. Kimlik No'yu yalnızca “Kişisel veri” yetkisi olan kullanıcılar girebilir.",
  'personnelForm.lock.contact':
    'Telefon ve e-posta, kişi hesabını etkinleştirirken doğrulanıp kaydedilir; buradan değiştirilemez.',
  'personnelForm.submit': 'Kaydet',
  'personnelForm.saved': 'Bilgiler güncellendi.',
  'personnelForm.discardEdit.title': 'Değişiklikler kaydedilmesin mi?',
  'personnelForm.discardEdit.body': 'Düzenlemeden çıkarsanız girdiğiniz değişiklikler kaydedilmez.',
  'personnelForm.discardEdit.cancel': 'Geri dön',
  'personnelForm.discardEdit.confirm': 'Değişiklikleri at',
  'personnelForm.validation.firstNameRequired': 'Ad zorunludur.',
  'personnelForm.validation.lastNameRequired': 'Soyad zorunludur.',
  'personnelForm.validation.firstNameTooLong': 'Ad en fazla {{max}} karakter olabilir.',
  'personnelForm.validation.lastNameTooLong': 'Soyad en fazla {{max}} karakter olabilir.',
  'personnelForm.validation.tcInvalid':
    'Girilen T.C. Kimlik No geçersiz. Lütfen kontrol edip tekrar deneyin.',
  'personnelForm.validation.tcExistsFallback':
    'Bu T.C. Kimlik No ile kayıtlı bir personel zaten var.',
  'personnelForm.hydrate.loading': 'Kişi kaydı yükleniyor…',
  // Yalnız EP: izin çekmecesinde Düzenle'nin hedefi taşeron kayıt listesinden hidrate edilir (#29).
  'personnelForm.hydrate.failed': 'Kişi kaydı yüklenemedi.',
  'personnelForm.hydrate.retry': 'Yeniden dene',
  'personnelForm.hydrate.notInRegistry': 'Bu kişi artık taşeron kaydında değil; düzenlenemez.',
  'common.close': 'Kapat',
  'common.loading': 'Yükleniyor...',
  // Paylaşılan araç bileşenleri (VehicleDocStatus, belge sunumu) `contractors.compliance.*` ile aynı metni okur.
  'compliance.valid': 'Uygun',
  'compliance.expiring': 'Süresi Yaklaşıyor',
  'compliance.expired': 'Süresi Geçmiş',
  'compliance.missing': 'Eksik',
  // Paylaşılan "sonuç yok" gövde satırı (turkish-ohs-expert S34 copy geçişi) — HER noResults
  // `EmptyState`inde başlığın yanında görünür, ayrı ayrı yazılmaz.
  'common.noResults.body': 'Aramayı veya filtreleri değiştirin ya da temizleyin.',
  // Yoğunluk geçişi (S34-2 design review §2 "Density toggle") — TableToolbar'ın erişilebilir
  // adı, basılı/basılı-değil FARK ETMEKSİZİN aynı metin (aria-pressed durumu taşır).
  'common.compactRows': 'Kompakt satırlar',
  // "Daha fazla filtre" katlanır grubu (owner review B2 item 2) — `MoreFiltersToggle.tsx`;
  // İş İzinleri ve Risk Değerlendirme listelerinin ORTAK metni.
  'common.moreFilters': 'Daha fazla filtre',
  'permitTypes.nav': 'Çalışma İzni Tipleri',
  'permitTypes.title': 'Çalışma İzni Tipleri',
  // Kabuğun (`PermitTypesShell.tsx`) genel alt başlığı — DÖRT sekmenin TAMAMINI kapsar (owner
  // review B2 item 7); tab'a özel `permitTypes.list.subtitle` yalnız Tipler sekmesinin KENDİ
  // içerik alanında (artık ONA ÖZGÜ bir yer yok, silindi — bkz. `PermitTypesListPage.tsx`).
  'permitTypes.subtitle':
    'Çalışma izni tiplerini, KKD ve kontrol maddesi kataloglarını ve onay yönlendirmesini yönetin.',
  'permitTypes.list.search': 'Tip ara',
  'permitTypes.list.searchPlaceholder': 'Ada göre ara',
  'permitTypes.list.new': 'Yeni Tip',
  'permitTypes.list.count': '{{count}} tip listeleniyor',
  'permitTypes.list.count_one': '{{count}} tip listeleniyor',
  'permitTypes.list.empty': 'Henüz çalışma izni tipi yok.',
  'permitTypes.list.empty.body': 'İlk tipi oluşturduğunuzda burada listelenir.',
  'permitTypes.list.noResults': 'Filtrelerle eşleşen çalışma izni tipi yok.',
  'permitTypes.list.col.name': 'Ad',
  'permitTypes.list.col.hazard': 'Tehlike sınıfı',
  'permitTypes.list.col.requiredDocs': 'İstenen belge',
  'permitTypes.list.col.status': 'Durum',
  'permitTypes.list.filter.status': 'Durum',
  'permitTypes.list.filter.allStatuses': 'Tüm durumlar',
  'permitTypes.list.filter.active': 'Aktif',
  'permitTypes.list.filter.inactive': 'Pasif',
  'permitTypes.list.action.delete': 'Sil',
  'permitTypes.list.action.openMenu': '{{name}} için işlemler',
  'permitTypes.list.created': 'Çalışma izni tipi oluşturuldu.',
  'permitTypes.list.updated': 'Çalışma izni tipi güncellendi.',
  'permitTypes.list.deleted': 'Çalışma izni tipi silindi.',
  'permitTypes.status.active': 'Aktif',
  'permitTypes.status.inactive': 'Pasif',
  'permitTypes.common.actions': 'İşlemler',
  'permitTypes.common.loading': 'Yükleniyor...',
  'permitTypes.common.cancel': 'Vazgeç',
  'permitTypes.common.save': 'Kaydet',
  'permitTypes.common.create': 'Oluştur',
  'permitTypes.common.close': 'Kapat',
  'permitTypes.pagination.nav': 'Sayfalama',
  'permitTypes.pagination.previous': 'Önceki',
  'permitTypes.pagination.next': 'Sonraki',
  'permitTypes.form.create.title': 'Yeni Çalışma İzni Tipi',
  'permitTypes.form.edit.title': 'Çalışma İzni Tipini Düzenle',
  'permitTypes.form.description': 'Tip adını, tehlike sınıfını ve istenen belgeleri girin.',
  'permitTypes.form.loading': 'Tip yükleniyor...',
  'permitTypes.form.field.name': 'Ad',
  'permitTypes.form.field.description': 'Açıklama',
  'permitTypes.form.field.hazardClass': 'Tehlike sınıfı',
  'permitTypes.form.field.requiredDocuments': 'İstenen belgeler',
  'permitTypes.form.requiredDocs.personnel': 'Personel belgeleri',
  'permitTypes.form.requiredDocs.vehicle': 'Araç belgeleri',
  'permitTypes.form.requiredDocs.inactiveHint':
    'Pasif belge türleri yüklenemez; biri işaretli kalırsa bu tipteki izinler hazır olamaz.',
  'permitTypes.form.requiredDocs.rejected':
    'Şu belge türleri artık seçilemiyor ve seçimden çıkarıldı: {{types}}. Belge türü listesi yenilendi; kaydetmeden önce seçimi gözden geçirin.',
  'permitTypes.form.field.isActive': 'Aktif',
  'permitTypes.form.hazardNone': 'Diğer',
  'permitTypes.form.hazardHint': "'Diğer' seçilirse tehlike sınıfı, izin açılışında elle seçilir.",
  'permitTypes.form.requiredDocsNote':
    'Bu tipteki bir izin için istenecek personel ve araç belgelerini seçin.',
  'permitTypes.form.isActiveHint':
    'Pasif tip yeni veya güncellenen izinlerde seçilemez; mevcut izinler etkilenmez.',
  'permitTypes.validation.nameRequired': 'Ad gerekli.',
  'permitTypes.delete.title': 'Çalışma izni tipini sil',
  'permitTypes.delete.body':
    '"{{name}}" tipi silinecek. Mevcut izinler etkilenmez. Devam edilsin mi?',
  'permitTypes.delete.confirm': 'Sil',
  'permitTypes.gate.loadingLabel': 'Çalışma İzni Tipleri erişimi denetleniyor...',
  'permitTypes.forbidden.title': 'Erişim yetkiniz yok',
  'permitTypes.forbidden.body':
    'Çalışma İzni Tipleri modülüne erişim yetkiniz bulunmuyor. Lütfen firma yöneticinizle görüşün.',
  'permitTypes.forbidden.back': 'Panele dön',
  'permitTypes.unavailable.title': 'Çalışma İzni Tipleri yüklenemedi',
  'permitTypes.unavailable.body': 'Servise şu anda ulaşılamıyor. Lütfen daha sonra tekrar deneyin.',
  'permitTypes.unavailable.retry': 'Tekrar dene',
  'permitTypes.catalog.tabs.label': 'Çalışma İzni Tipleri bölümleri',
  'permitTypes.catalog.tabs.types': 'Tipler',
  'permitTypes.catalog.tabs.ppe': 'KKD Kataloğu',
  'permitTypes.catalog.tabs.controls': 'Kontrol Maddeleri',
  'permitTypes.catalog.col.origin': 'Kaynak',
  'permitTypes.catalog.origin.default': 'Genel',
  'permitTypes.catalog.origin.custom': 'Firma',
  'permitTypes.catalog.inactiveSuffix': '(pasif)',
  'permitTypes.catalog.delete.confirm': 'Pasifleştir',
  'permitTypes.catalog.form.field.isActive': 'Aktif',
  'permitTypes.catalog.form.isActiveHint':
    'Pasif öge yeni tip atamasında seçilebilir listede kalır ama önerilmez.',
  'permitTypes.catalog.ppe.title': 'KKD Kataloğu',
  'permitTypes.catalog.ppe.search': 'KKD ara',
  'permitTypes.catalog.ppe.searchPlaceholder': 'Ada göre ara',
  'permitTypes.catalog.ppe.new': 'Yeni KKD',
  'permitTypes.catalog.ppe.count': '{{count}} KKD ögesi listeleniyor',
  'permitTypes.catalog.ppe.count_one': '{{count}} KKD ögesi listeleniyor',
  'permitTypes.catalog.ppe.empty': 'Henüz KKD ögesi yok.',
  'permitTypes.catalog.ppe.empty.body': 'İlk ögeyi oluşturduğunuzda burada listelenir.',
  'permitTypes.catalog.ppe.noResults': 'Filtrelerle eşleşen KKD ögesi yok.',
  'permitTypes.catalog.ppe.col.name': 'Ad',
  'permitTypes.catalog.ppe.created': 'KKD ögesi oluşturuldu.',
  'permitTypes.catalog.ppe.updated': 'KKD ögesi güncellendi.',
  'permitTypes.catalog.ppe.deleted': 'KKD ögesi pasifleştirildi.',
  'permitTypes.catalog.ppe.delete.title': 'KKD ögesini pasifleştir',
  'permitTypes.catalog.ppe.delete.body':
    '"{{name}}" ögesini pasifleştirmek istediğinize emin misiniz? Tipe önceden bağlanmış izinler etkilenmez.',
  'permitTypes.catalog.ppe.validation.nameRequired': 'Ad zorunludur.',
  'permitTypes.catalog.ppe.form.create.title': 'Yeni KKD Ögesi',
  'permitTypes.catalog.ppe.form.edit.title': 'KKD Ögesini Düzenle',
  'permitTypes.catalog.ppe.form.description': 'KKD adını ve isteğe bağlı açıklamayı girin.',
  'permitTypes.catalog.ppe.form.field.name': 'Ad',
  'permitTypes.catalog.ppe.form.field.description': 'Açıklama',
  'permitTypes.catalog.control.title': 'Kontrol Maddeleri',
  'permitTypes.catalog.control.search': 'Kontrol maddesi ara',
  'permitTypes.catalog.control.searchPlaceholder': 'Metne göre ara',
  'permitTypes.catalog.control.new': 'Yeni Kontrol Maddesi',
  'permitTypes.catalog.control.count': '{{count}} kontrol maddesi listeleniyor',
  'permitTypes.catalog.control.count_one': '{{count}} kontrol maddesi listeleniyor',
  'permitTypes.catalog.control.empty': 'Henüz kontrol maddesi yok.',
  'permitTypes.catalog.control.empty.body':
    'İlk kontrol maddesini oluşturduğunuzda burada listelenir.',
  'permitTypes.catalog.control.noResults': 'Filtrelerle eşleşen kontrol maddesi yok.',
  'permitTypes.catalog.control.col.text': 'Kontrol maddesi',
  'permitTypes.catalog.control.created': 'Kontrol maddesi oluşturuldu.',
  'permitTypes.catalog.control.updated': 'Kontrol maddesi güncellendi.',
  'permitTypes.catalog.control.deleted': 'Kontrol maddesi pasifleştirildi.',
  'permitTypes.catalog.control.delete.title': 'Kontrol maddesini pasifleştir',
  'permitTypes.catalog.control.delete.body':
    '"{{text}}" maddesini pasifleştirmek istediğinize emin misiniz? Tipe önceden bağlanmış izinler etkilenmez.',
  'permitTypes.catalog.control.validation.textRequired': 'Kontrol maddesi metni zorunludur.',
  'permitTypes.catalog.control.form.create.title': 'Yeni Kontrol Maddesi',
  'permitTypes.catalog.control.form.edit.title': 'Kontrol Maddesini Düzenle',
  'permitTypes.catalog.control.form.description':
    'Kontrol ifadesini ve isteğe bağlı açıklamayı girin.',
  'permitTypes.catalog.control.form.field.text': 'Kontrol maddesi',
  'permitTypes.catalog.control.form.field.description': 'Açıklama',
  'permitTypes.form.field.protectiveEquipment': 'İstenen KKD',
  'permitTypes.form.protectiveEquipmentNote':
    'Bu tipteki bir izin için gerekli kişisel koruyucu donanımları seçin.',
  'permitTypes.form.protectiveEquipmentEmpty':
    'Katalogda KKD ögesi yok. Önce KKD Kataloğu sekmesinden öge ekleyin.',
  'permitTypes.form.field.controlItems': 'Kontrol maddeleri',
  'permitTypes.form.controlItemsNote':
    'Bu tipteki bir izinde İSG uzmanının işaretleyeceği kontrol maddelerini seçin.',
  'permitTypes.form.controlItemsEmpty':
    'Katalogda kontrol maddesi yok. Önce Kontrol Maddeleri sekmesinden öge ekleyin.',
  'app.name': 'İSG Portal',
  'app.expertPortal': 'Uzman Portalı',
  'app.tagline': 'İş sağlığı ve güvenliği süreçlerini tek platformdan yönetin.',

  'login.title': 'Uzman Portalına giriş',
  'login.subtitle': 'Hesabınıza erişmek için e-posta ve parolanızı girin.',
  'login.email': 'E-posta',
  'login.emailPlaceholder': 'ornek@firma.com',
  'login.password': 'Parola',
  'login.submit': 'Giriş yap',
  'login.forgotPassword': 'Parolamı unuttum',

  'forgot.title': 'Parola sıfırlama',
  'forgot.subtitle': 'Hesabınıza bağlı e-posta veya telefonu girin; doğrulama kodu gönderelim.',
  'forgot.identifier': 'E-posta veya telefon',
  'forgot.submit': 'Kod gönder',
  'forgot.backToLogin': 'Girişe dön',
  'forgot.sentTitle': 'Kodu gönderdik',
  'forgot.sentBody':
    'Hesabınız kayıtlıysa doğrulama kodunu ilettik. Kod ile yeni parolanızı belirleyebilirsiniz.',
  'forgot.continue': 'Kodu girdim, devam et',

  'reset.title': 'Yeni parola belirleyin',
  'reset.subtitle': 'Size ileten doğrulama kodunu ve yeni parolanızı girin.',
  'reset.code': 'Doğrulama kodu',
  'reset.newPassword': 'Yeni parola',
  'reset.passwordHint': 'En az 8 karakter; en az bir harf ve bir rakam içermeli.',
  'reset.submit': 'Parolayı güncelle',
  'reset.successTitle': 'Parolanız güncellendi',
  'reset.successBody': 'Yeni parolanızla giriş yapabilirsiniz.',
  'reset.toLogin': 'Girişe git',

  'layout.dashboard': 'Panel',
  // S34-3 — tek `<nav>` (bkz. SideNav.tsx dosya başlığı); üç bölüm (Operasyon/Uyum/Sistem) bu
  // TEK erişilebilir adı paylaşır, her bölümün kendi görünür başlığı zaten `aria-labelledby`.
  'layout.nav.primary': 'Ana menü',
  'layout.skipToContent': 'İçeriğe geç',
  'layout.account': 'Hesap',
  'layout.profile': 'Profil',
  'layout.logout': 'Çıkış yap',

  // S34-3 UI Shell — kenar çubuğu bölüm başlıkları (owner kararı, review M9 "Yönetim" çakışmasını
  // da çözer: üçüncü bölüm artık "Sistem", içindeki "Yönetim" öğesiyle AYNI ad DEĞİL).
  'layout.navGroup.operations': 'Operasyon',
  'layout.navGroup.compliance': 'Uyum Yönetimi',
  'layout.navGroup.system': 'Sistem',
  // Rail (daraltılmış) mod — review M5 "no flyout".
  'layout.rail.collapse': 'Menüyü daralt',
  'layout.rail.expand': 'Menüyü genişlet',
  'layout.rail.permitsPending': 'Çalışma İzinleri: {{count}} izin onay bekliyor',
  // Hesap menüsü (M7) — dil seçici artık BU menünün içinde, bkz. AppHeader.tsx.
  'layout.user.menu': 'Kullanıcı menüsü',
  'layout.user.signedInAs': 'Giriş yapan hesap',
  'layout.user.role': 'Rol',
  'layout.user.company': 'Firma',
  'layout.user.language': 'Dil',

  // Bilinmeyen rota (404, owner review B2 item 5) — kabuğun İÇİNDE (giriş yapılmışsa), köşe
  // çizgisiz (breadcrumb yok, "bilinmeyen" bir konumun ebeveyni tanımsız); Panel'e dönüş.
  'notFound.title': 'Sayfa bulunamadı',
  'notFound.body': 'Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.',
  'notFound.back': "Panel'e dön",

  // Genel arama (Header search, S34-5, api-contract §34.3) — Carbon UI Shell deseni; yalnız
  // `permits/list` erişimi VARSA görünür (`AppHeader.tsx`).
  'search.trigger': 'Ara',
  'search.shortcutHint': '"/" tuşuyla açın',
  'search.label': 'Genel arama',
  'search.placeholder': 'Çalışma izni, taşeron veya personel arayın',
  'search.close': 'Aramayı kapat',
  'search.minChars': 'Aramak için en az 2 karakter yazın.',
  'search.loading': 'Aranıyor…',
  'search.noResults': 'Sonuç bulunamadı',
  'search.noResults.body': 'Farklı bir terimle tekrar deneyin.',
  // Grup başlıkları — turkish-ohs-expert kararı: nav anahtarlarını (`permits.nav` vb.) yeniden
  // KULLANMAZ, KENDİ kopyası. Nav "Çalışma İzinleri" (bölüm başlığı, Title Case) — arama grubu
  // burada BİLEREK cümle içi (sentence case) bir sonuç grubu etiketi, ikisi aynı bağlam DEĞİL.
  'search.group.permits': 'Çalışma izinleri',
  'search.group.contractors': 'Taşeronlar',
  'search.group.personnel': 'Personel',
  'search.group.hasMore': 'Daha fazla sonuç var; aramanızı daraltın.',
  'search.status.results': '{{count}} sonuç bulundu',
  'search.status.results_one': '{{count}} sonuç bulundu',

  // Saha bağlamı (site context) — store S34-3'te geliyor, sayfa seçicisi S34-4 (bkz.
  // `useSiteContext`, `packages/shared/src/state/siteContext.ts`).
  'dashboard.site.label': 'Saha',
  'dashboard.site.all': 'Tüm sahalar',

  // Profil (Self) — api-contract §18.1
  'profile.title': 'Profil',
  'profile.subtitle': 'Hesap bilgilerinizi görüntüleyin ve güncelleyin.',
  'profile.loading': 'Profil yükleniyor...',
  'profile.info.title': 'Hesap bilgileri',
  'profile.info.subtitle': 'Bu bilgiler yalnızca görüntülenir.',
  'profile.field.fullName': 'Ad Soyad',
  'profile.field.firstName': 'Ad',
  'profile.field.lastName': 'Soyad',
  'profile.field.email': 'E-posta',
  'profile.field.company': 'Firma',
  'profile.field.role': 'Rol',
  'profile.edit.title': 'Ad-soyad düzenle',
  'profile.edit.subtitle': 'Görünen adınızı güncelleyin.',
  'profile.edit.save': 'Kaydet',
  'profile.updated': 'Profil güncellendi.',
  'profile.validation.firstNameRequired': 'Ad zorunludur.',
  'profile.validation.lastNameRequired': 'Soyad zorunludur.',
  'profile.password.title': 'Parola değiştir',
  'profile.password.subtitle': 'Güvenliğiniz için güçlü bir parola seçin.',
  'profile.password.current': 'Mevcut parola',
  'profile.password.new': 'Yeni parola',
  'profile.password.confirm': 'Yeni parola (tekrar)',
  'profile.password.hint': 'En az 8 karakter; en az bir harf ve bir rakam içermeli.',
  'profile.password.save': 'Parolayı güncelle',
  'profile.password.updated': 'Parolanız güncellendi.',
  'profile.password.wrongCurrent': 'Mevcut şifre hatalı.',
  'profile.validation.currentPasswordRequired': 'Mevcut parola zorunludur.',
  'profile.validation.confirmRequired': 'Parolayı tekrar girin.',
  'profile.validation.passwordMismatch': 'Parolalar eşleşmiyor.',

  // --- Panel (S34-4, api-contract §34) ---
  'dashboard.title': 'Panel',
  'dashboard.retry': 'Tekrar dene',
  'dashboard.kpi.activePermits': 'Aktif izinler',
  'dashboard.kpi.pendingApproval': 'Onay bekleyen izinler',
  'dashboard.kpi.expiringPermits': '7 gün içinde sona erecek izinler',
  'dashboard.kpi.personnelNotReady': 'Sahaya girişi engelli personel',
  'dashboard.kpi.personnelNotReady.context': '{{count}} izin kaydında',
  'dashboard.kpi.entriesToday': 'Bugünkü girişler',
  // S36 #5b (coordinator — ayrı 7. karo tek başına 2. satırda dağınık dururdu) — `entriesToday`
  // karosunun KENDİ bağlam satırı: personelden AYRI bir sayı (ziyaretçinin çıkışı vardır "şu an
  // sahada", personel "bugün giriş onayı aldı" demektir — §34.1 etiket kuralı, TOPLANMAZ). `GET
  // /visits?status=OnSite`, `filteredTotal` — YENİ uç YOK, `visits/list` grant'ı yoksa bu satır
  // hiç EKLENMEZ (karo öncekiyle AYNI, bağlamsız + `/security` linkli kalır). Türkçe sayıdan
  // sonra tekil (`ziyaretçi`, çoğul eki YOK) — `_one`/`_other` yalnız en/de'de (ayrı istek).
  'dashboard.kpi.entriesToday.context': 'Sahada {{count}} ziyaretçi',
  'dashboard.kpi.contractorDocsExpiring': 'Belge süresi dolan taşeronlar',
  // owner review B4-7 (S35-design.md "QA note (a)", Seçenek A) — eski cümle ("{{count}} taşeronun
  // belgesi 30 gün içinde dolacak", 56 karakter) 1584px sayfa tavanındaki ~206px'lik metin
  // sütununa HİÇBİR genişlikte sığmıyordu. Sayı-önce, kısa biçim: hem tek başına HEM
  // `scopeCompanyWide` önekiyle birleşince ("Firma geneli · 30 gün içinde dolacak: 0") kısa kalır.
  'dashboard.kpi.contractorDocsExpiring.context': '30 gün içinde dolacak: {{count}}',
  // S35 (owner review B3-1) — saha seçiliyken taşeron firma belgesi karosunun bağlam satırının
  // BAŞINA eklenir (§35.2 normatif: bu alanlar bir sahaya değil firmaya aittir; owner review
  // B4-7 — kısa, kendi başına bir önek, uzun bir cümlenin SONUNA eklenmez).
  'dashboard.kpi.scopeCompanyWide': 'Firma geneli',
  'dashboard.actions.title': 'Aksiyon gerekli',
  'dashboard.actions.filter.all': 'Tümü',
  'dashboard.actions.filter.groupLabel': 'Aksiyon türü süzgeci',
  'dashboard.actions.kind.entryBlocked': 'Giriş engelli',
  'dashboard.actions.kind.permitExpiring': 'Süresi dolacak izin',
  'dashboard.actions.kind.pendingApproval': 'Onay bekliyor',
  'dashboard.actions.line.personReason': '{{person}} — {{reason}}',
  'dashboard.actions.reason.missingDocument': 'Eksik belge: {{document}}',
  'dashboard.actions.reason.missingTraining': 'Eksik eğitim: {{training}}',
  'dashboard.actions.reason.missingTraining.generic': 'Eksik eğitim',
  'dashboard.actions.due.overdue': 'Süresi geçti',
  'dashboard.actions.due.permitStarted': 'İzin başladı',
  'dashboard.actions.due.startDatePassed': 'Başlangıç tarihi geçti',
  'dashboard.actions.due.startsToday': 'Bugün başlıyor',
  'dashboard.actions.due.startsTomorrow': 'Yarın başlıyor',
  'dashboard.actions.due.startsOnDate': '{{date}} başlıyor',
  'dashboard.actions.due.endsToday': 'Bugün bitiyor',
  'dashboard.actions.due.endsTomorrow': 'Yarın bitiyor',
  'dashboard.actions.due.endsOnDate': '{{date}} bitiyor',
  'dashboard.actions.empty': 'Şu anda aksiyon gerektiren bir durum yok.',
  'dashboard.actions.empty.body':
    'Giriş engelleri, süresi dolacak izinler ve onay bekleyen izinler burada listelenir.',
  'dashboard.actions.empty.filtered': 'Bu türde bekleyen aksiyon yok.',
  'dashboard.actions.empty.showAll': 'Tümünü göster',
  'dashboard.actions.pagination.nav': 'Sayfalama',
  'dashboard.actions.pagination.previous': 'Önceki',
  'dashboard.actions.pagination.next': 'Sonraki',
  'dashboard.chart.permitsByStatus.title': 'Açık izinlerin durumu',
  'dashboard.chart.bucket.preparing': 'Hazırlanıyor',
  'dashboard.chart.bucket.withContractor': 'Taşeronda',
  'dashboard.chart.bucket.inReview': 'İncelemede',
  'dashboard.chart.bucket.active': 'Aktif',
  'dashboard.chart.permitsByStatus.empty': 'Açık çalışma izni yok.',
  'dashboard.chart.permitsByStatus.total_one': '{{count}} açık izin',
  'dashboard.chart.permitsByStatus.total': '{{count}} açık izin',
  'dashboard.chart.permitsByStatus.terminal': 'Kapanan / reddedilen / süresi dolan: {{count}}',
  'dashboard.chart.permitsOpened.title': 'Son 30 günde açılan izinler',
  'dashboard.chart.permitsOpened.axis': 'İzin sayısı',
  'dashboard.chart.permitsOpened.col.date': 'Tarih',
  'dashboard.chart.permitsOpened.empty': 'Son 30 günde açılan izin yok.',
  'dashboard.chart.permitsOpened.summary_one':
    'Son 30 günde {{count}} izin; en yoğun gün {{date}} ({{peakCount}})',
  'dashboard.chart.permitsOpened.summary':
    'Son 30 günde {{count}} izin; en yoğun gün {{date}} ({{peakCount}})',
  'dashboard.chart.unavailable': 'Yüklenemedi',
  'dashboard.entries.title': 'Bugünkü girişler',
  'dashboard.entries.summary': '{{allowed}} giriş · {{denied}} ret',
  'dashboard.entries.col.time': 'Saat',
  'dashboard.entries.col.name': 'Ad Soyad',
  'dashboard.entries.col.contractor': 'Taşeron',
  'dashboard.entries.col.status': 'Durum',
  'dashboard.entries.empty': 'Bugün henüz giriş yok.',
  'dashboard.entries.empty.body': 'Kiosk veya kapı kodu ile yapılan girişler burada listelenir.',
  'dashboard.entries.selectSite': 'Girişleri görmek için bir saha seçin.',
  // S36 #5 — "Tüm sahalar"da üstteki "Bugünkü girişler" karosu firma genelini SAYIYOR (0
  // değil), bu panel ise tek sahaya özel bir uca bağlı (`GET /security/entries`, `siteUuid`
  // zorunlu) — açıklama olmadan kullanıcı "adım atladım" okurdu, oysa ikisi de doğru davranıyor.
  'dashboard.entries.selectSite.body':
    'Bu liste tek bir sahaya özeldir — üstteki "Bugünkü girişler" karosu firma genelinde sayar.',

  // --- Mobil Uygulama (§26 app-store linkleri; D4) + sistem-admin app-link ayarı ---
  'layout.mobileApp': 'Mobil Uygulama',
  'mobileApp.title': 'Mobil Uygulama',
  'mobileApp.subtitle':
    'İSG Portal yönetici uygulamasını indirin; saha denetimlerinize, çalışma izinlerinize ve bildirimlerinize telefonunuzdan erişin.',
  'appDownload.storesTitle': 'Mağazadan indirin',
  'appDownload.ios': "App Store'dan indir",
  'appDownload.android': "Google Play'den indir",
  'appDownload.comingSoon.body':
    'Mobil uygulama yakında mağazalarda olacak. İndirme bağlantıları hazır olduğunda burada görünecektir.',
  'appDownload.loading': 'Uygulama bilgileri yükleniyor…',
  // Sistem-admin app-link ayar ekranı (§26.2 PUT /admin/app-settings — IsSystemAdmin)
  'admin.tab.appSettings': 'Uygulama Bağlantıları',
  'appSettings.field.iosAppUrl': 'iOS uygulama bağlantısı (App Store)',
  'appSettings.field.androidAppUrl': 'Android uygulama bağlantısı (Google Play)',
  'appSettings.field.hint': 'Tam bir https bağlantısı girin. Boş bırakırsanız bağlantı kaldırılır.',
  'appSettings.validation.invalidUrl': 'Geçerli bir bağlantı girin (https ile başlamalı).',
  'appSettings.updated': 'Mobil uygulama bağlantıları güncellendi.',
  'appSettings.save': 'Kaydet',
  'appSettings.loading': 'Bağlantılar yükleniyor…',

  // --- Yönetim (Admin) paneli — api-contract §9 ---
  'admin.nav': 'Yönetim',
  'admin.subtitle':
    'Rolleri ve yetkileri, firmaları, kiosk cihazlarını ve uygulama bağlantılarını yönetin.',
  'admin.tab.roles': 'Yetki Yönetimi',
  'admin.tab.companies': 'Firma Yönetimi',
  'admin.gate.loadingLabel': 'Yönetim paneli yükleniyor',
  'admin.forbidden.title': 'Bu alana erişim yetkiniz yok',
  'admin.forbidden.body':
    'Yönetim paneli sistem yöneticilerine özeldir. Erişime ihtiyacınız varsa lütfen yöneticinizle iletişime geçin.',
  'admin.forbidden.back': 'Panele dön',
  'admin.unavailable.title': 'Yönetim servisine ulaşılamadı',
  'admin.unavailable.body':
    'Yönetim uçları şu anda yanıt vermiyor. Lütfen kısa bir süre sonra tekrar deneyin.',
  'admin.unavailable.retry': 'Tekrar dene',

  'admin.common.search': 'Ara',
  'admin.common.new': 'Yeni',
  'admin.common.edit': 'Düzenle',
  'admin.common.save': 'Kaydet',
  'admin.common.cancel': 'Vazgeç',
  'admin.common.create': 'Oluştur',
  'admin.common.close': 'Kapat',
  'admin.common.loading': 'Yükleniyor...',
  'admin.common.empty': 'Kayıt bulunamadı.',
  'admin.common.noData': 'Henüz kayıt yok.',
  'admin.common.noData.body': 'İlk kaydı oluşturduğunuzda burada listelenir.',
  'admin.common.actions': 'İşlemler',
  'admin.common.createdAt': 'Oluşturulma',
  'admin.pagination.nav': 'Sayfalama',
  'admin.pagination.previous': 'Önceki',
  'admin.pagination.next': 'Sonraki',

  'admin.roles.title': 'Roller',
  'admin.roles.count': '{{count}} rol listeleniyor',
  'admin.roles.count_one': '{{count}} rol listeleniyor',
  'admin.roles.searchPlaceholder': 'Rol adı veya kodu ara',
  'admin.roles.new': 'Yeni rol',
  'admin.roles.col.name': 'Ad',
  'admin.roles.col.value': 'Kod',
  'admin.roles.col.scope': 'Kapsam',
  'admin.roles.col.status': 'Durum',
  'admin.roles.scope.company': 'Firma #{{id}}',
  'admin.roles.scope.global': 'Genel',
  'admin.roles.status.active': 'Aktif',
  'admin.roles.status.passive': 'Pasif',
  'admin.roles.badge.systemAdmin': 'Sistem Yöneticisi',
  'admin.roles.action.edit': 'Rolü düzenle',
  'admin.roles.action.delete': 'Rolü pasifleştir',
  'admin.roles.action.openMenu': '{{name}} için işlemler',
  'admin.roles.create.title': 'Yeni rol',
  'admin.roles.edit.title': 'Rolü düzenle',
  'admin.roles.field.name': 'Rol adı',
  'admin.roles.field.description': 'Açıklama',
  'admin.roles.field.active': 'Aktif',
  'admin.roles.field.value': 'Kod',
  'admin.roles.delete.title': 'Rolü pasifleştir',
  'admin.roles.delete.body':
    '"{{name}}" rolü pasifleştirilecek. Pasif rolün yetkileri geçerli olmaz. Devam edilsin mi?',
  'admin.roles.delete.confirm': 'Pasifleştir',
  'admin.roles.created': 'Rol oluşturuldu.',
  'admin.roles.updated': 'Rol güncellendi.',
  'admin.roles.deleted': 'Rol pasifleştirildi.',

  'admin.perm.title': 'Yetki matrisi',
  'admin.perm.subtitle': '"{{role}}" rolünün modül ve aksiyon yetkileri.',
  'admin.perm.back': 'Rollere dön',
  'admin.perm.save': 'Yetkileri kaydet',
  'admin.perm.saved': 'Yetkiler güncellendi.',
  'admin.perm.locked': 'Sistem yöneticisi rolü kilitlidir; yetkileri değiştirilemez.',
  'admin.perm.reset': 'Değişiklikleri geri al',
  'admin.perm.auto': 'Otomatik',
  'admin.perm.na': 'Bu modülde yok',
  'admin.perm.legend':
    'İşaretli hücre, o role ilgili aksiyon için yetki verildiği anlamına gelir. "Otomatik" aksiyonlar herkese açıktır ve ayrı yetki gerektirmez.',
  'admin.perm.col.module': 'Modül',
  'admin.perm.cellLabel': '{{module}} — {{action}}',
  'admin.action.list': 'Listele',
  'admin.action.get': 'Görüntüle',
  'admin.action.create': 'Oluştur',
  'admin.action.update': 'Güncelle',
  'admin.action.delete': 'Sil',
  'admin.action.personal-data': 'Kişisel veri',

  'admin.companies.title': 'Firmalar',
  'admin.companies.count': '{{count}} firma listeleniyor',
  'admin.companies.count_one': '{{count}} firma listeleniyor',
  'admin.companies.searchPlaceholder': 'Firma adı, unvan veya vergi no ara',
  'admin.companies.new': 'Yeni firma',
  'admin.companies.action.openMenu': '{{name}} için işlemler',
  'admin.companies.col.name': 'Firma',
  'admin.companies.col.legalName': 'Yasal unvan',
  'admin.companies.col.taxNumber': 'Vergi no',
  'admin.companies.col.createdAt': 'Oluşturulma',
  'admin.companies.create.title': 'Yeni firma',
  'admin.companies.edit.title': 'Firmayı düzenle',
  'admin.companies.field.name': 'Firma adı',
  'admin.companies.field.legalName': 'Yasal unvan',
  'admin.companies.field.taxNumber': 'Vergi numarası',
  'admin.companies.field.adminFirstName': 'Ad',
  'admin.companies.field.adminLastName': 'Soyad',
  'admin.companies.field.adminEmail': 'E-posta',
  'admin.companies.field.adminPassword': 'Parola',
  'admin.companies.adminToggle': 'İlk yöneticiyi de oluştur',
  'admin.companies.adminHint':
    'İşaretlenirse firmaya bağlı bir kurumsal yönetici (CorporateAdmin) oluşturulur. Bu yönetici sistem yöneticisi değildir.',
  'admin.companies.created': 'Firma oluşturuldu.',
  'admin.companies.updated': 'Firma güncellendi.',

  'admin.branches.title': 'Şubeler',
  'admin.branches.new': 'Yeni şube',
  'admin.branches.count': '{{count}} şube listeleniyor',
  'admin.branches.count_one': '{{count}} şube listeleniyor',
  'admin.branches.searchPlaceholder': 'Şube adı veya kodu ara',
  'admin.branches.col.name': 'Şube',
  'admin.branches.col.code': 'Kod',
  'admin.branches.action.sites': 'Sahalar',
  'admin.branches.create.title': 'Yeni şube',
  'admin.branches.edit.title': 'Şubeyi düzenle',
  'admin.branches.field.name': 'Şube adı',
  'admin.branches.field.code': 'Kod',
  'admin.branches.created': 'Şube oluşturuldu.',
  'admin.branches.updated': 'Şube güncellendi.',

  'admin.sites.title': 'Sahalar',
  'admin.sites.new': 'Yeni saha',
  'admin.sites.count': '{{count}} saha listeleniyor',
  'admin.sites.count_one': '{{count}} saha listeleniyor',
  'admin.sites.searchPlaceholder': 'Saha adı veya kodu ara',
  'admin.sites.branchFallback': 'Seçili şube',
  'admin.sites.col.name': 'Saha',
  'admin.sites.col.code': 'Kod',
  'admin.sites.create.title': 'Yeni saha',
  'admin.sites.edit.title': 'Sahayı düzenle',
  'admin.sites.field.name': 'Saha adı',
  'admin.sites.field.code': 'Kod',
  'admin.sites.created': 'Saha oluşturuldu.',
  'admin.sites.updated': 'Saha güncellendi.',

  'admin.validation.nameRequired': 'Ad zorunludur.',
  'admin.validation.emailRequired': 'E-posta zorunludur.',
  'admin.validation.emailInvalid': 'Geçerli bir e-posta girin.',
  'admin.validation.passwordPolicy': 'Parola en az 8 karakter, bir harf ve bir rakam içermeli.',
  'admin.validation.firstNameRequired': 'Ad zorunludur.',
  'admin.validation.lastNameRequired': 'Soyad zorunludur.',

  // --- Kiosk Cihaz Yönetimi — api-contract §5.9 ---
  'admin.tab.kiosk': 'Kiosk Cihazları',
  'kiosk.title': 'Kiosk Cihazları',
  'kiosk.count': '{{count}} kiosk cihazı listeleniyor',
  'kiosk.count_one': '{{count}} kiosk cihazı listeleniyor',
  'kiosk.searchPlaceholder': 'Cihaz adı ara',
  'kiosk.empty': 'Henüz kayıtlı kiosk cihazı yok.',
  'kiosk.empty.body': 'İlk cihazı kaydettiğinizde burada listelenir.',
  'kiosk.list.noResults': 'Aramanızla eşleşen kiosk cihazı yok.',
  'kiosk.col.name': 'Cihaz',
  'kiosk.col.site': 'Saha',
  'kiosk.col.status': 'Durum',
  'kiosk.col.roles': 'Roller',
  'kiosk.col.lastSeen': 'Son görülme',
  'kiosk.col.createdAt': 'Oluşturulma',
  'kiosk.status.Active': 'Aktif',
  'kiosk.status.Pending': 'Beklemede',
  'kiosk.status.Disabled': 'Devre dışı',
  'kiosk.action.revokeSessions': 'Oturumları iptal',
  'kiosk.action.disable': 'Devre dışı bırak',
  'kiosk.action.openMenu': '{{name}} için işlemler',

  'kiosk.register.new': 'Cihaz kaydet',
  'kiosk.register.title': 'Kiosk cihazı kaydet',
  'kiosk.register.description':
    'Cihaza bir ad verin; dilerseniz saha ve rol atayın. Kayıt sonrası tek kullanımlık bir aktivasyon kodu üretilir.',
  'kiosk.register.submit': 'Kaydet ve kod üret',
  'kiosk.register.field.name': 'Cihaz adı',
  'kiosk.register.field.namePlaceholder': 'Örn. Ana Giriş Turnike 1',
  'kiosk.register.field.site': 'Saha (opsiyonel)',
  'kiosk.register.field.siteHint':
    'Cihaz bu sahaya sabitlenir; ziyaretçi girişleri bu sahaya işlenir.',
  'kiosk.register.site.placeholder': 'Saha seçin (opsiyonel)',
  'kiosk.register.field.roles': 'Roller (opsiyonel)',
  'kiosk.register.field.rolesHint':
    'Cihazın yetkileri seçilen rollerden gelir. Kiosk için yetkili rolü seçin (ör. "Kiosk Cihaz").',
  'kiosk.register.roles.empty': 'Atanabilir aktif rol bulunamadı.',
  'kiosk.register.createdMessage': 'Kiosk cihazı kaydedildi.',
  'kiosk.register.successTitle': 'Cihaz kaydedildi',
  'kiosk.register.successDescription': '"{{name}}" cihazı için aktivasyon kodu hazır.',
  'kiosk.register.codeWarning':
    'Bu kod yalnız bir kez gösterilir; kiosk cihazına girin. Kaybederseniz cihazı yeniden kaydedin.',
  'kiosk.register.codeLabel': 'Aktivasyon kodu',
  'kiosk.register.copy': 'Kopyala',
  'kiosk.register.copied': 'Kopyalandı',
  'kiosk.register.deviceUuid': 'Cihaz kimliği',
  'kiosk.register.expiresAt': 'Son kullanma',
  'kiosk.register.nextStep':
    'Kodu kiosk cihazının aktivasyon ekranına girerek cihazı etkinleştirin.',
  'kiosk.validation.nameRequired': 'Cihaz adı zorunludur.',

  'kiosk.revoke.revokeTitle': 'Oturumları iptal et',
  'kiosk.revoke.revokeBody':
    '"{{name}}" cihazının tüm aktif oturumları sonlandırılacak; mevcut cihaz oturumu geçersizleşir. Cihaz kaydı silinmez. Devam edilsin mi?',
  'kiosk.revoke.revokeConfirm': 'Oturumları iptal et',
  'kiosk.revoke.revokedMessage': '"{{name}}" cihazının oturumları iptal edildi.',
  'kiosk.revoke.disableTitle': 'Cihazı devre dışı bırak',
  'kiosk.revoke.disableBody':
    '"{{name}}" cihazı devre dışı bırakılacak ve tüm oturumları sonlandırılacak. Yeniden kullanmak için cihazın yeniden aktive edilmesi gerekir. Devam edilsin mi?',
  'kiosk.revoke.disableConfirm': 'Devre dışı bırak',
  'kiosk.revoke.disabledMessage': '"{{name}}" cihazı devre dışı bırakıldı.',

  // --- Ayarlar (Settings) — api-contract §10 (tenant-scoped) ---
  'settings.nav': 'Ayarlar',
  'settings.subtitle': 'Firma bilgilerinizi, şubelerinizi ve sahalarınızı yönetin.',
  'settings.tab.company': 'Firma bilgileri',
  'settings.tab.branches': 'Şube bilgileri',
  'settings.tab.sites': 'Saha bilgileri',
  'settings.gate.loadingLabel': 'Ayarlar yükleniyor',
  'settings.forbidden.title': 'Ayarlara erişim yetkiniz yok',
  'settings.forbidden.body':
    'Firma ayarları yalnızca yetkili kullanıcılara açıktır. Erişime ihtiyacınız varsa lütfen firma yöneticinizle iletişime geçin.',
  'settings.forbidden.back': 'Panele dön',
  'settings.unavailable.title': 'Ayarlara ulaşılamadı',
  'settings.unavailable.body':
    'Ayarlar servisi şu anda yanıt vermiyor. Lütfen kısa bir süre sonra tekrar deneyin.',
  'settings.unavailable.retry': 'Tekrar dene',

  'settings.common.search': 'Ara',
  'settings.common.edit': 'Düzenle',
  'settings.common.save': 'Kaydet',
  'settings.common.cancel': 'Vazgeç',
  'settings.common.create': 'Oluştur',
  'settings.common.close': 'Kapat',
  'settings.common.loading': 'Yükleniyor...',
  'settings.common.empty': 'Kayıt bulunamadı.',
  'settings.common.noData': 'Henüz kayıt yok.',
  'settings.common.noData.body': 'İlk kaydı oluşturduğunuzda burada listelenir.',
  'settings.common.actions': 'İşlemler',
  'settings.pagination.nav': 'Sayfalama',
  'settings.pagination.previous': 'Önceki',
  'settings.pagination.next': 'Sonraki',

  'settings.company.updated': 'Firma bilgileri güncellendi.',
  'settings.company.field.name': 'Firma adı',
  'settings.company.field.legalName': 'Yasal unvan',
  'settings.company.field.taxNumber': 'Vergi numarası',
  'settings.company.field.taxOffice': 'Vergi dairesi',
  'settings.company.field.address': 'Adres',
  'settings.company.field.phone': 'Telefon',
  'settings.company.field.email': 'E-posta',

  'settings.branches.title': 'Şubeler',
  'settings.branches.count': '{{count}} şube listeleniyor',
  'settings.branches.count_one': '{{count}} şube listeleniyor',
  'settings.branches.searchPlaceholder': 'Şube adı veya kodu ara',
  'settings.branches.new': 'Yeni şube',
  'settings.branches.col.name': 'Şube',
  'settings.branches.col.code': 'Kod',
  'settings.branches.col.address': 'Adres',
  'settings.branches.col.phone': 'Telefon',
  'settings.branches.action.delete': 'Şubeyi sil',
  'settings.branches.action.openMenu': '{{name}} için işlemler',
  'settings.branches.create.title': 'Yeni şube',
  'settings.branches.edit.title': 'Şubeyi düzenle',
  'settings.branches.field.name': 'Şube adı',
  'settings.branches.field.code': 'Kod',
  'settings.branches.field.address': 'Adres',
  'settings.branches.field.phone': 'Telefon',
  'settings.branches.created': 'Şube oluşturuldu.',
  'settings.branches.updated': 'Şube güncellendi.',
  'settings.branches.deleted': 'Şube silindi.',
  'settings.branches.delete.title': 'Şubeyi sil',
  'settings.branches.delete.body':
    '"{{name}}" şubesi silinecek. Bu işlem geri alınamaz. Devam edilsin mi?',
  'settings.branches.delete.confirm': 'Sil',

  'settings.sites.title': 'Sahalar',
  'settings.sites.count': '{{count}} saha listeleniyor',
  'settings.sites.count_one': '{{count}} saha listeleniyor',
  'settings.sites.searchPlaceholder': 'Saha adı veya kodu ara',
  'settings.sites.new': 'Yeni saha',
  'settings.sites.noBranches':
    'Saha eklemek için önce en az bir şube oluşturmalısınız. Lütfen Şube bilgileri sekmesinden bir şube ekleyin.',
  'settings.sites.branchPlaceholder': 'Şube seçin',
  'settings.sites.filter.branch': 'Şubeye göre filtrele',
  'settings.sites.filter.allBranches': 'Tüm şubeler',
  'settings.sites.col.name': 'Saha',
  'settings.sites.col.code': 'Kod',
  'settings.sites.col.branch': 'Şube',
  'settings.sites.col.address': 'Adres',
  'settings.sites.action.delete': 'Sahayı sil',
  'settings.sites.action.openMenu': '{{name}} için işlemler',
  'settings.sites.create.title': 'Yeni saha',
  'settings.sites.edit.title': 'Sahayı düzenle',
  'settings.sites.field.branch': 'Şube',
  'settings.sites.field.name': 'Saha adı',
  'settings.sites.field.code': 'Kod',
  'settings.sites.field.address': 'Adres',
  'settings.sites.created': 'Saha oluşturuldu.',
  'settings.sites.updated': 'Saha güncellendi.',
  'settings.sites.deleted': 'Saha silindi.',
  'settings.sites.delete.title': 'Sahayı sil',
  'settings.sites.delete.body':
    '"{{name}}" sahası silinecek. Bu işlem geri alınamaz. Devam edilsin mi?',
  'settings.sites.delete.confirm': 'Sil',

  'settings.validation.nameRequired': 'Ad zorunludur.',
  'settings.validation.branchRequired': 'Şube seçimi zorunludur.',

  // --- Ziyaretçiler (Visitors) — api-contract §11 (tenant-scoped) ---
  'visitors.nav': 'Ziyaretçiler',
  'visitors.title': 'Ziyaretçiler',
  'visitors.subtitle':
    'Sahadaki ziyaretçileri izleyin, geçmiş ziyaretleri görüntüleyin ve güvenlik brifingini yönetin.',
  'visitors.tab.onSite': 'Sahada',
  'visitors.tab.history': 'Geçmiş',
  'visitors.tab.briefing': 'Güvenlik brifingi',
  'visitors.gate.loadingLabel': 'Ziyaretçiler yükleniyor',
  'visitors.forbidden.title': 'Ziyaretçilere erişim yetkiniz yok',
  'visitors.forbidden.body':
    'Ziyaretçi yönetimi yalnızca yetkili kullanıcılara açıktır. Erişime ihtiyacınız varsa lütfen firma yöneticinizle iletişime geçin.',
  'visitors.forbidden.back': 'Panele dön',
  'visitors.unavailable.title': 'Ziyaretçilere ulaşılamadı',
  'visitors.unavailable.body':
    'Ziyaretçi servisi şu anda yanıt vermiyor. Lütfen kısa bir süre sonra tekrar deneyin.',
  'visitors.unavailable.retry': 'Tekrar dene',

  'visitors.common.search': 'Ara',
  'visitors.common.loading': 'Yükleniyor...',
  'visitors.common.empty': 'Kayıt bulunamadı.',
  'visitors.common.actions': 'İşlemler',
  'visitors.common.cancel': 'Vazgeç',
  'visitors.common.close': 'Kapat',
  'visitors.common.save': 'Kaydet',
  'visitors.pagination.nav': 'Sayfalama',
  'visitors.pagination.previous': 'Önceki',
  'visitors.pagination.next': 'Sonraki',

  // Sahada olanlar (acil durum / tahliye ekranı)
  'visitors.onSite.title': 'Şu an sahada',
  'visitors.onSite.checkIn': 'Ziyaretçi Girişi',
  'visitors.onSite.searchPlaceholder': 'Ziyaretçi adı veya telefon ara',
  'visitors.onSite.count': 'Sahada {{count}} ziyaretçi',
  'visitors.onSite.count_one': 'Sahada {{count}} ziyaretçi',
  'visitors.onSite.col.visitor': 'Ziyaretçi',
  'visitors.onSite.col.location': 'Saha / şube',
  'visitors.onSite.col.host': 'Ev sahibi',
  'visitors.onSite.col.purpose': 'Amaç',
  'visitors.onSite.col.checkInAt': 'Giriş saati',
  'visitors.onSite.action.checkOut': 'Çıkış',
  'visitors.onSite.empty': 'Şu anda sahada kayıtlı ziyaretçi yok.',
  'visitors.onSite.empty.body': 'Bir ziyaretçi giriş yaptığında burada listelenir.',
  'visitors.onSite.noResults': 'Aramanızla eşleşen ziyaretçi yok.',
  'visitors.onSite.checkOut.title': 'Çıkış onayı',
  'visitors.onSite.checkOut.body':
    '"{{name}}" için çıkış alınacak ve ziyaretçi sahadan düşecek. Devam edilsin mi?',
  'visitors.onSite.checkOut.confirm': 'Çıkış al',
  'visitors.onSite.checkedOut': '"{{name}}" için çıkış alındı.',

  // Check-in formu
  'visitors.checkIn.title': 'Ziyaretçi girişi',
  'visitors.checkIn.description':
    'Ziyaretçi bilgilerini girin. KVKK aydınlatma onayı ve güvenlik brifingi onayı zorunludur.',
  'visitors.checkIn.section.visitor': 'Ziyaretçi bilgileri',
  'visitors.checkIn.section.visit': 'Ziyaret bilgileri',
  'visitors.checkIn.section.consent': 'Onaylar (zorunlu)',
  'visitors.checkIn.field.firstName': 'Ad',
  'visitors.checkIn.field.lastName': 'Soyad',
  'visitors.checkIn.field.phone': 'Telefon',
  'visitors.checkIn.field.email': 'E-posta',
  'visitors.checkIn.field.idNumber': 'Kimlik / pasaport no',
  'visitors.checkIn.field.organization': 'Temsil ettiği kurum',
  'visitors.checkIn.field.site': 'Saha',
  'visitors.checkIn.field.branch': 'Şube',
  'visitors.checkIn.field.host': 'Ev sahibi',
  'visitors.checkIn.field.purpose': 'Ziyaret amacı',
  'visitors.checkIn.site.placeholder': 'Saha seçin (isteğe bağlı)',
  'visitors.checkIn.branch.placeholder': 'Şube seçin (isteğe bağlı)',
  'visitors.checkIn.branch.autoFilledHint': 'Seçilen sahanın şubesi otomatik dolduruldu.',
  'visitors.checkIn.host.placeholder': 'Ev sahibi seçin (isteğe bağlı)',
  'visitors.checkIn.consent.kvkk':
    'KVKK aydınlatma metnini ziyaretçiye ilettim; ziyaretçi kişisel verilerinin işlenmesine açık rıza verdi.',
  'visitors.checkIn.consent.kvkkHint':
    'Açık rıza olmadan giriş alınamaz; rıza yoksa ziyaretçi verisi kaydedilmez.',
  'visitors.checkIn.consent.briefing':
    'Güvenlik brifingini ziyaretçiye ilettim; ziyaretçi kuralları okuyup onayladı.',
  'visitors.checkIn.briefing.title': 'Güvenlik brifingi',
  'visitors.checkIn.briefing.version': 'Sürüm {{version}}',
  'visitors.checkIn.briefing.notConfigured':
    'Henüz güvenlik brifingi metni yapılandırılmadı. Metni "Güvenlik brifingi" sekmesinden ekleyebilirsiniz; ziyaretçi yine de brifing kurallarının iletildiğini onaylamalıdır.',
  'visitors.checkIn.submit': 'Girişi al',
  'visitors.checkIn.success': 'Ziyaretçi girişi alındı.',
  'visitors.checkIn.badge': 'Çıkış kodu: {{code}}',

  // Geçmiş / rapor
  'visitors.history.title': 'Ziyaret geçmişi',
  'visitors.history.count': '{{count}} ziyaret listeleniyor',
  'visitors.history.count_one': '{{count}} ziyaret listeleniyor',
  'visitors.history.searchPlaceholder': 'Ziyaretçi adı veya telefon ara',
  'visitors.history.filter.status': 'Durum',
  'visitors.history.filter.site': 'Saha',
  'visitors.history.filter.branch': 'Şube',
  'visitors.history.filter.from': 'Başlangıç tarihi',
  'visitors.history.filter.to': 'Bitiş tarihi',
  'visitors.history.filter.allStatuses': 'Tüm durumlar',
  'visitors.history.filter.allSites': 'Tüm sahalar',
  'visitors.history.filter.allBranches': 'Tüm şubeler',
  'visitors.history.col.visitor': 'Ziyaretçi',
  'visitors.history.col.status': 'Durum',
  'visitors.history.col.location': 'Saha / şube',
  'visitors.history.col.host': 'Ev sahibi',
  'visitors.history.col.checkInAt': 'Giriş',
  'visitors.history.col.checkOutAt': 'Çıkış',
  'visitors.history.action.detail': 'Ziyaret detayı',
  'visitors.history.empty': 'Henüz ziyaret kaydı yok.',
  'visitors.history.empty.body': 'Bir ziyaretçi çıkış yaptığında burada listelenir.',
  'visitors.history.noResults': 'Filtrelerle eşleşen ziyaret kaydı bulunamadı.',

  'visitors.status.onSite': 'Sahada',
  'visitors.status.checkedOut': 'Çıkış yaptı',
  'visitors.entryMethod.manual': 'Manuel',
  'visitors.entryMethod.kiosk': 'Kiosk',

  // Ziyaret detayı
  'visitors.detail.title': 'Ziyaret detayı',
  'visitors.detail.section.visitor': 'Ziyaretçi',
  'visitors.detail.section.visit': 'Ziyaret',
  'visitors.detail.field.phone': 'Telefon',
  'visitors.detail.field.email': 'E-posta',
  'visitors.detail.field.idNumber': 'Kimlik / pasaport no',
  'visitors.detail.field.organization': 'Kurum',
  'visitors.detail.field.status': 'Durum',
  'visitors.detail.field.location': 'Saha / şube',
  'visitors.detail.field.host': 'Ev sahibi',
  'visitors.detail.field.purpose': 'Amaç',
  'visitors.detail.field.entryMethod': 'Giriş yöntemi',
  'visitors.detail.field.checkInAt': 'Giriş',
  'visitors.detail.field.checkOutAt': 'Çıkış',
  'visitors.detail.field.briefing': 'Güvenlik brifingi onayı',
  'visitors.detail.field.badge': 'Çıkış kodu',
  'visitors.detail.briefingAccepted': 'Onaylandı',
  'visitors.detail.briefingNotAccepted': 'Onaylanmadı',
  'visitors.detail.loading': 'Ziyaret yükleniyor...',

  // Güvenlik brifingi yapılandırma
  'visitors.briefing.subtitle':
    'Ziyaretçilerin girişte onaylayacağı güvenlik brifingi metni. Kaydedildiğinde sürüm otomatik artar; onaylanan sürüm ziyaret kaydına yazılır.',
  'visitors.briefing.currentVersion': 'Güncel sürüm: {{version}}',
  'visitors.briefing.notConfigured': 'Henüz brifing metni yapılandırılmadı (sürüm 0).',
  'visitors.briefing.field.tr': 'Metin (Türkçe)',
  'visitors.briefing.field.en': 'Metin (İngilizce)',
  'visitors.briefing.field.de': 'Metin (Almanca)',
  'visitors.briefing.placeholder': 'Ziyaretçilerin uyması gereken güvenlik kurallarını yazın.',
  'visitors.briefing.save': 'Brifingi kaydet',
  'visitors.briefing.updated': 'Güvenlik brifingi güncellendi.',

  'visitors.validation.firstNameRequired': 'Ad zorunludur.',
  'visitors.validation.lastNameRequired': 'Soyad zorunludur.',
  'visitors.validation.kvkkRequired': 'KVKK açık rıza onayı zorunludur.',
  'visitors.validation.briefingRequired': 'Güvenlik brifingi onayı zorunludur.',
  'visitors.validation.contentTrRequired': 'Türkçe metin zorunludur.',

  // --- Taşeron/Yüklenici Yönetimi — api-contract §13 + §8 ---
  'contractors.nav': 'Taşeron/Yüklenici',
  'contractors.title': 'Taşeron/Yüklenici',
  'contractors.gate.loadingLabel': 'Taşeron modülü yükleniyor...',
  'contractors.forbidden.title': 'Erişim yetkiniz yok',
  'contractors.forbidden.body':
    'Taşeron/Yüklenici modülüne erişim için yetkiniz bulunmuyor. Yetki talebiniz için firma yöneticinizle iletişime geçebilirsiniz.',
  'contractors.forbidden.back': 'Panele dön',
  'contractors.unavailable.title': 'Modül şu anda kullanılamıyor',
  'contractors.unavailable.body':
    'Taşeron verilerine şu anda ulaşılamıyor. Lütfen birazdan tekrar deneyin.',
  'contractors.unavailable.retry': 'Tekrar dene',

  'contractors.common.close': 'Kapat',
  'contractors.common.cancel': 'Vazgeç',
  'drawer.discard.title': 'Kaydetmeden kapatılsın mı?',
  'drawer.discard.body':
    'Formda kaydedilmemiş bilgiler var. Paneli kapatırsanız girdiğiniz bilgiler kaydedilmez.',
  'drawer.discard.cancel': 'Geri dön',
  'drawer.discard.confirm': 'Kaydetmeden kapat',
  'contractors.common.save': 'Kaydet',
  'contractors.common.create': 'Oluştur',
  'contractors.common.add': 'Ekle',
  'contractors.common.done': 'Tamam',
  'contractors.common.loading': 'Yükleniyor...',
  'contractors.common.actions': 'İşlemler',

  'contractors.status.active': 'Aktif',
  'contractors.status.suspended': 'Askıda',
  'contractors.status.inactive': 'Pasif',

  'contractors.compliance.valid': 'Uygun',
  'contractors.compliance.expiring': 'Süresi Yaklaşıyor',
  'contractors.compliance.expired': 'Süresi Geçmiş',
  'contractors.compliance.missing': 'Eksik',

  // Liste
  'contractors.list.subtitle':
    'Sahalarınızda çalışan taşeron ve alt-yüklenici firmaları, uygunluk belgelerini ve saha erişimlerini buradan yönetin.',
  'contractors.list.search': 'Taşeron ara',
  'contractors.list.searchPlaceholder': 'Firma adı veya vergi no ara',
  'contractors.list.new': 'Taşeron Ekle',
  'contractors.list.filter.status': 'Duruma göre filtrele',
  'contractors.list.filter.allStatuses': 'Tüm durumlar',
  // §13.1/§34.1 drill-through süzgeci — manuel bir kontrolü yok, yalnız toolbar özet satırında
  // "· <bu metin>" olarak eklenir (bkz. `ContractorsListPage.tsx`'in `complianceSummarySuffix`ı).
  'contractors.list.filter.compliance.expired': 'Süresi dolmuş belge',
  'contractors.list.filter.compliance.expiring': 'Süresi dolacak belge',
  'contractors.list.count': '{{count}} taşeron listeleniyor',
  'contractors.list.count_one': '{{count}} taşeron listeleniyor',
  'contractors.list.col.name': 'Firma',
  'contractors.list.col.taxNumber': 'Vergi No',
  'contractors.list.col.hazardClass': 'Tehlike sınıfı',
  'contractors.list.col.status': 'Durum',
  'contractors.list.col.compliance': 'Uygunluk',
  // S34-2 — eskiden TEK metin hem "veri yok" hem "sonuç yok" için kullanılıyordu ve metni
  // HER ZAMAN "filtrelerle eşleşmedi" diyordu (yanlış, liste gerçekten boşken de) — artık ayrı
  // (design review §2, M13).
  'contractors.list.empty': 'Henüz taşeron kaydı yok.',
  'contractors.list.empty.body': 'İlk taşeronu eklediğinizde burada listelenir.',
  'contractors.list.noResults': 'Filtrelerle eşleşen taşeron yok.',

  'contractors.pagination.nav': 'Sayfalama',
  'contractors.pagination.previous': 'Önceki',
  'contractors.pagination.next': 'Sonraki',

  // Kayıt/düzenleme formu
  'contractors.form.create.title': 'Taşeron Ekle',
  'contractors.form.edit.title': 'Taşeronu Düzenle',
  'contractors.form.description':
    'Firma bilgilerini, tehlike sınıfını ve sözleşme dönemini girin. Yıldızlı alanlar zorunludur.',
  'contractors.form.section.identity': 'Firma kimliği',
  'contractors.form.section.contact': 'İletişim ve sözleşme',
  'contractors.form.field.name': 'Firma adı',
  'contractors.form.field.legalName': 'Yasal unvan',
  'contractors.form.field.taxNumber': 'Vergi numarası',
  'contractors.form.field.taxOffice': 'Vergi dairesi',
  'contractors.form.field.isgKatipNo': 'İSG-KATİP numarası',
  'contractors.form.field.hazardClass': 'Tehlike sınıfı',
  'contractors.form.field.phone': 'Telefon',
  'contractors.form.field.email': 'E-posta',
  'contractors.form.field.address': 'Adres',
  'contractors.form.field.contractStart': 'Sözleşme başlangıcı',
  'contractors.form.field.contractEnd': 'Sözleşme bitişi',
  'contractors.form.field.status': 'Durum',
  'contractors.validation.nameRequired': 'Firma adı zorunludur.',

  // Detay
  'contractors.detail.back': 'Taşeron listesine dön',
  'contractors.detail.loading': 'Taşeron yükleniyor...',
  'contractors.detail.edit': 'Düzenle',
  'contractors.detail.header.compliance': 'Uygunluk: {{status}}',
  'contractors.detail.compliance.title': 'Uygunluk',
  'contractors.detail.identity.title': 'Kimlik bilgileri',
  'contractors.detail.compliance.documents': 'Belge sayısı',
  'contractors.detail.compliance.expiring': 'Süresi yaklaşan',
  'contractors.detail.compliance.expired': 'Süresi geçmiş',
  'contractors.detail.compliance.overall': 'Genel uygunluk',
  'contractors.detail.tab.documents': 'Uygunluk Belgeleri',
  'contractors.detail.tab.personnel': 'Personel',
  'contractors.detail.tab.vehicles': 'Araçlar',
  'contractors.detail.tab.sites': 'Saha Erişimi',

  // Belgeler
  'contractors.documents.title': 'Uygunluk belgeleri',
  'contractors.documents.subtitle':
    'SGK, vergi levhası, İSG-KATİP, sözleşme ve sigorta gibi belgeleri yükleyin; geçerlilik durumunu izleyin.',
  'contractors.documents.empty': 'Bu taşeron için henüz belge eklenmemiş.',
  'contractors.documents.col.type': 'Belge türü',
  'contractors.documents.col.file': 'Dosya',
  'contractors.documents.col.validity': 'Geçerlilik',
  'contractors.documents.col.status': 'Durum',
  'contractors.documents.action.download': 'İndir',
  'contractors.documents.action.delete': 'Sil',
  'contractors.documents.add.new': 'Belge Ekle',
  'contractors.documents.add.title': 'Uygunluk belgesi ekle',
  'contractors.documents.add.description':
    'Dosyayı seçin, belge türünü ve geçerlilik tarihini girin. Dosya doğrudan güvenli depolamaya yüklenir.',
  'contractors.documents.add.submit': 'Yükle ve ekle',
  'contractors.documents.add.uploading': 'Yükleniyor...',
  'contractors.documents.add.progress': 'Yükleniyor: %{{percent}}',
  'contractors.documents.field.file': 'Belge dosyası',
  'contractors.documents.field.filePlaceholder': 'Dosya seçin (PDF, görsel veya ofis belgesi)',
  'contractors.documents.field.fileHint':
    'En fazla 20 MB. PDF, görsel (PNG/JPG) veya ofis belgesi.',
  'contractors.documents.field.type': 'Belge türü',
  'contractors.documents.field.validFrom': 'Geçerlilik başlangıcı',
  'contractors.documents.field.validUntil': 'Geçerlilik bitişi',
  'documents.validity.fromOnly': '{{date}} tarihinden itibaren geçerli',
  'documents.validity.untilOnly': '{{date}} tarihine kadar geçerli',
  'contractors.documents.field.note': 'Not (opsiyonel)',
  'contractors.documents.delete.title': 'Belgeyi kaldır',
  'contractors.documents.delete.body':
    '"{{type}}" belgesini bu taşerondan kaldırmak istediğinize emin misiniz? Belge kaydı arşivlenir.',
  'contractors.documents.delete.confirm': 'Belgeyi kaldır',

  // Personel
  'contractors.personnel.title': 'Personel',
  'contractors.personnel.subtitle':
    'Bu taşerona bağlı personeli görüntüleyin; yeni personel oluşturun ve isterseniz hesabını etkinleştirmesi için bağlantı gönderin.',
  'contractors.personnel.empty': 'Bu taşerona henüz personel bağlanmamış.',
  'contractors.personnel.create': 'Personel Oluştur',
  'contractors.personnel.col.name': 'Ad soyad',
  'contractors.personnel.col.contact': 'E-posta / telefon',
  'contractors.personnel.col.status': 'Durum',
  'contractors.personnel.col.access': 'Erişim',
  'contractors.personnel.col.date': 'Tarih',
  // Durum rozetleri (aktive personel + bekleyen davet — §13.3)
  'contractors.personnel.status.active': 'Aktif',
  'contractors.personnel.status.inactive': 'Pasif',
  // Davetsiz oluşturulmuş, çalışan aktif personel — giriş bilgisi yok (S25-A7c `NoLogin`).
  'contractors.personnel.status.notactivated': 'Etkinleştirilmedi',
  'contractors.personnel.status.pending': 'Bekliyor',
  'contractors.personnel.status.expired': 'Süresi doldu',
  // Erişim seviyesi (§13.3)
  'contractors.personnel.access.personeli': 'Personel',
  'contractors.personnel.access.yetkili': 'Yetkili',
  'contractors.personnel.drawer.activatedAt': 'Aktivasyon tarihi',
  'contractors.personnel.drawer.createdAt': 'Kayıt tarihi',
  // Satır aksiyonları
  'contractors.personnel.action.delete': 'Personeli çıkar',
  'contractors.personnel.action.openMenu': '{{name}} için işlemler',
  // Personeli çıkar (onay)
  'contractors.personnel.delete.title': 'Personeli çıkar',
  'contractors.personnel.delete.body':
    '"{{name}}" bu taşerondan çıkarılsın mı? Personelin varsa diğer firmalardaki bağları korunur.',
  'contractors.personnel.delete.confirm': 'Çıkar',
  // Daveti iptal et (onay)

  // Personel daveti

  // Saha erişimi
  'contractors.sites.title': 'Saha erişimi',
  'contractors.sites.subtitle':
    'Taşeronun hangi sahalarda çalışabileceğini belirleyin. Erişimi dilediğiniz zaman kaldırabilirsiniz.',
  'contractors.sites.empty': 'Bu taşerona henüz saha erişimi tanımlanmamış.',
  'contractors.sites.add.new': 'Saha Ekle',
  'contractors.sites.add.title': 'Saha erişimi ekle',
  'contractors.sites.add.description': 'Taşeronun erişebileceği bir saha seçin.',
  'contractors.sites.field.site': 'Saha',
  'contractors.sites.sitePlaceholder': 'Saha seçin',
  'contractors.sites.noSites':
    'Eklenebilecek başka saha yok. Sahalar Ayarlar bölümünden tanımlanır.',
  'contractors.sites.col.site': 'Saha',
  'contractors.sites.col.code': 'Kod',
  'contractors.sites.col.since': 'Erişim tarihi',
  'contractors.sites.action.remove': 'Erişimi kaldır',
  'contractors.sites.remove.title': 'Saha erişimini kaldır',
  'contractors.sites.remove.body':
    '"{{site}}" sahasına erişimi kaldırmak istediğinize emin misiniz?',
  'contractors.sites.remove.confirm': 'Erişimi kaldır',
  'contractors.validation.siteRequired': 'Lütfen bir saha seçin.',

  // Taşeron/Doküman hata kodları (api-contract §13 + §8; SITE_NOT_FOUND §9'da tanımlı)
  CONTRACTOR_NOT_FOUND: 'Taşeron kaydı bulunamadı.',
  CONTRACTOR_DOCUMENT_NOT_FOUND: 'Belge bulunamadı veya bu taşerona ait değil.',
  CONTRACTOR_SITE_NOT_FOUND: 'Taşeronun bu sahaya aktif erişimi bulunmuyor.',
  PERSONNEL_NOT_FOUND: 'Personel bulunamadı veya bu taşerona bağlı değil.',
  INVITATION_NOT_FOUND: 'Böyle bir davet bulunamadı.',
  ACCESS_LEVEL_ROLE_NOT_CONFIGURED:
    'Seçilen erişim seviyesi için rol tanımlı değil. Lütfen sistem yöneticinizle iletişime geçin.',
  DOCUMENT_NOT_FOUND: 'Belge bulunamadı. Lütfen dosyayı yeniden yükleyin.',
  DOCUMENT_NOT_UPLOADED: 'Dosya yüklemesi tamamlanamadı. Lütfen tekrar deneyin.',
  DOCUMENT_NOT_CONFIRMED: 'Dosya henüz doğrulanmadı. Lütfen tekrar deneyin.',
  DOCUMENT_TOO_LARGE: 'Dosya boyutu izin verilen sınırı aşıyor (en fazla 20 MB).',
  DOCUMENT_TYPE_UNSUPPORTED:
    'Bu dosya türü desteklenmiyor. PDF, görsel veya ofis belgesi yükleyin.',
  DOCUMENT_UPLOAD_FAILED: 'Dosya yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.',
  DOCUMENT_UPLOAD_ABORTED: 'Dosya yüklemesi iptal edildi.',
  GUEST_INVITE_INVALID: 'Davet bağlantısı geçersiz veya kullanılmış.',
  GUEST_INVITE_EXPIRED: 'Davetin süresi dolmuş. Lütfen yeni bir davet oluşturun.',
  INVITE_CHANNEL_UNAVAILABLE:
    'Seçilen gönderim kanalı bu davetin iletişim bilgileriyle kullanılamıyor. Lütfen davetteki e-posta adresine veya telefon numarasına uygun bir kanal seçin.',
  ACTIVATION_LINK_COOLDOWN:
    'Bu iletişim bilgisine kısa süre önce bir aktivasyon bağlantısı gönderildi. Lütfen biraz bekleyip tekrar deneyin.',
  'personnelCreate.title': 'Personel oluştur',
  'personnelCreate.description':
    'Personeli kaydedin; isterseniz hesabını etkinleştirmesi için bir bağlantı da gönderebilirsiniz.',
  'personnelCreate.submit': 'Oluştur',
  'personnelCreate.another': 'Yeni personel oluştur',
  'personnelCreate.contact.title': 'Aktivasyon bağlantısı (isteğe bağlı)',
  'personnelCreate.contact.hint':
    'E-posta veya telefon girerseniz kişiye hesabını etkinleştirmesi için bir bağlantı gönderilir. Bu bilgi kişinin kaydına yazılmaz.',
  'personnelCreate.success.created': 'Personel oluşturuldu.',
  'personnelCreate.success.linkSent': 'Personel oluşturuldu. Aktivasyon bağlantısı hazırlandı.',
  'personnelCreate.validation.tcRequired': 'T.C. kimlik numarası zorunludur.',
  'personnelCreate.cooldownUntil':
    'Bu iletişim bilgisine kısa süre önce bir bağlantı gönderildi. Saat {{availableAt}} itibarıyla tekrar deneyin ya da iletişim alanlarını boşaltıp kişiyi şimdi oluşturun; bağlantıyı daha sonra gönderebilirsiniz.',
  'personnelCreate.cooldownGeneric':
    'Bu iletişim bilgisine kısa süre önce bir bağlantı gönderildi. Biraz bekleyip tekrar deneyin ya da iletişim alanlarını boşaltıp kişiyi şimdi oluşturun; bağlantıyı daha sonra gönderebilirsiniz.',
  'personnelCreate.dailyLimit':
    'Bu taşeron için günlük bağlantı gönderim sınırına ulaşıldı. İletişim alanlarını boşaltıp kişiyi şimdi oluşturun; bağlantıyı daha sonra gönderebilirsiniz.',
  'personnelLink.cooldownUntil':
    'Bu kişiye ya da bu iletişim bilgisine kısa süre önce bir aktivasyon bağlantısı gönderildi. Saat {{availableAt}} itibarıyla tekrar deneyebilirsiniz.',
  'personnelLink.field.email': 'E-posta',
  'personnelLink.field.emailPlaceholder': 'ad@firma.com',
  'personnelLink.field.phone': 'Telefon',
  'personnelLink.field.phonePlaceholder': '+90 555 123 45 67',
  'personnelLink.field.phoneHint':
    'Cep telefonu numarası. Yurt dışı numaralarda + ve ülke kodunu yazın.',
  'personnelLink.field.channel': 'Gönderim kanalı',
  'personnelLink.field.channelHint':
    'Aktivasyon bağlantısı seçtiğiniz kanaldan otomatik gönderilir; bağlantı yine ekranda kalır.',
  'personnelLink.channel.email': 'E-posta',
  'personnelLink.channel.sms': 'SMS',
  'personnelLink.channel.both': 'E-posta ve SMS',
  'personnelLink.field.link': 'Aktivasyon bağlantısı',
  'personnelLink.copy': 'Kopyala',
  'personnelLink.copied': 'Kopyalandı',
  'personnelLink.copyFailed': 'Bağlantı kopyalanamadı. Lütfen elle seçip kopyalayın.',
  'personnelLink.expiresAt': 'Bağlantı {{date}} tarihine kadar geçerlidir.',
  'personnelLink.dispatch.emailSent': 'Aktivasyon bağlantısı e-posta ile gönderildi.',
  'personnelLink.dispatch.smsSent': 'Aktivasyon bağlantısı SMS ile gönderildi.',
  'personnelLink.dispatch.emailFailed':
    'Aktivasyon bağlantısı e-posta ile gönderilemedi. Bağlantıyı kopyalayıp personele iletin.',
  'personnelLink.dispatch.smsFailed':
    'Aktivasyon bağlantısı SMS ile gönderilemedi. Bağlantıyı kopyalayıp personele iletin.',
  'personnelLink.dispatch.none':
    'Otomatik gönderim yapılamadı. Lütfen aşağıdaki bağlantıyı kopyalayıp personele iletin.',
  'personnelLink.validation.contactRequired': 'E-posta veya telefon zorunludur.',
  'personnelLink.validation.emailInvalid': 'Geçerli bir e-posta adresi girin.',
  'personnelLink.validation.phoneInvalid':
    'Geçerli bir cep telefonu numarası girin. Yurt dışı numaralarda + ve ülke kodunu yazın.',
  'personnelLink.validation.emailTaken':
    'Bu e-posta adresine aktivasyon bağlantısı gönderilemiyor. Başka bir e-posta adresi veya telefon numarası deneyin.',
  'personnelLink.validation.phoneTaken':
    'Bu telefon numarasına aktivasyon bağlantısı gönderilemiyor. Başka bir telefon numarası veya e-posta adresi deneyin.',
  'personnelLink.validation.contactTaken':
    'Girdiğiniz iletişim bilgisine aktivasyon bağlantısı gönderilemiyor. Başka bir e-posta adresi veya telefon numarası deneyin.',
  'personnelLink.pending.sent': 'Gönderildi',
  'personnelLink.pending.expired': 'Süresi doldu',
  'personnelLink.action.send': 'Aktivasyon bağlantısı gönder',
  'personnelLink.action.resend': 'Bağlantıyı tekrar gönder',
  'personnelLink.action.cancel': 'Bağlantıyı iptal et',
  'personnelLink.cancel.title': 'Bağlantıyı iptal et',
  'personnelLink.cancel.body.person':
    '{{name}} için gönderilen aktivasyon bağlantısı iptal edilir; kişi artık bu bağlantıyla hesabını etkinleştiremez ve listede “Etkinleştirilmedi” olarak kalır.',
  'personnelLink.notFound':
    'Bu bağlantı artık geçerli değil; bu arada yeniden gönderilmiş, iptal edilmiş veya kişi hesabını etkinleştirmiş olabilir. Liste yenilendi; pencereyi kapatıp kişinin güncel durumunu kontrol edin.',
  'personnelLink.cancel.body.invite':
    '{{name}} için gönderilen aktivasyon bağlantısı iptal edilir; kişi artık bu bağlantıyla hesabını etkinleştiremez. Bu satır listeden kaldırılır.',
  'personnelLink.cancel.confirm': 'Bağlantıyı iptal et',
  'personnelLink.send.title': 'Aktivasyon bağlantısı gönder',
  'personnelLink.send.description':
    '{{name}} için bir aktivasyon bağlantısı gönderin. Bağlantı yalnızca girdiğiniz e-posta adresine veya telefon numarasına gider; bu bilgi kişinin kaydına yazılmaz.',
  'personnelLink.send.tcMissing':
    'Bu kişinin kaydında T.C. kimlik numarası yok. Aktivasyon bağlantısı gönderilebilmesi için önce kayda T.C. kimlik numarası eklenmelidir.',
  'personnelLink.send.contactHint':
    'E-posta veya telefondan en az birini girin; ikisini de girebilirsiniz.',
  'personnelLink.send.submit': 'Gönder',
  'personnelLink.resend.title': 'Bağlantıyı tekrar gönder',
  'personnelLink.resend.description':
    '{{name}} için yeni bir aktivasyon bağlantısı oluşturulup gönderilir. Önceki bağlantı geçersiz olur.',
  'personnelLink.resend.channelHint':
    'Yeni bağlantı seçtiğiniz kanaldan gönderilir ve ekranda kopyalanabilir kalır.',
  'personnelLink.resend.via.email': 'Yeni bağlantı e-posta ile gönderilecek.',
  'personnelLink.resend.via.sms': 'Yeni bağlantı SMS ile gönderilecek.',
  'personnelLink.resend.submit': 'Tekrar gönder',
  'personnelLink.resend.noContact':
    'Bu bağlantı için kayıtlı bir e-posta veya telefon yok; tekrar gönderilemez.',
  'personnelLink.success.title': 'Aktivasyon bağlantısı hazır',
  'personnelLink.success.body':
    'Gönderim durumu aşağıdadır. Dilerseniz bağlantıyı kopyalayıp kişiye kendiniz de iletebilirsiniz.',
  ACTIVATION_LINK_DAILY_LIMIT:
    'Günlük bağlantı gönderim sınırına ulaşıldı. Lütfen daha sonra tekrar deneyin.',
  PERSONNEL_INACTIVE:
    'Pasif bir personele aktivasyon bağlantısı gönderilemez. Önce personelin durumunu Aktif yapın.',
  PERSONNEL_TC_REQUIRED:
    'Kişinin kaydında T.C. kimlik numarası yok. Numara kayda eklenmeden aktivasyon bağlantısı gönderilemez ve aktivasyon tamamlanamaz.',
  GUEST_INVITE_CONTACT_ALREADY_EXISTS:
    'Bu e-posta adresi veya telefon numarası başka bir hesapta kayıtlı; davet bu iletişim bilgileriyle tamamlanamaz.',
  PERSONNEL_ALREADY_HAS_LOGIN: 'Bu personelin zaten bir hesabı var; yeni bir davet gönderilemez.',

  // Ziyaretçi hata kodları (api-contract §11) — SITE/BRANCH_NOT_FOUND §9'da tanımlı
  VEHICLE_DOCUMENT_IN_USE:
    'Bu belge kullanımda olduğu için silinemez: araca bu belge yüklüyken saha giriş izni verildi ya da araç aktif bir izinde. Belge hatalıysa reddedin; güncel belge için yenisini yükleyin.',
  VEHICLE_DOCUMENT_NOT_PENDING:
    'Bu belge zaten değerlendirildi; artık silinemez. Yerine yeni bir belge yükleyin.',
  VEHICLE_HAS_OPEN_PERMITS:
    'Bu araç açık bir izinde olduğu için silinemez. Önce aracı açık izinlerden çıkarın.',
  VEHICLE_HAS_LOCKED_DOCUMENTS:
    'Bu araç silinemez: onaylı bir belgesi var ya da belgelerinden biri kullanımda (araca bu belge yüklüyken saha giriş izni verildi veya araç aktif bir izinde). Araç listede kalır; farklı bir araç için yeni bir araç ekleyin.',
  VEHICLE_PLATE_LOCKED:
    'Bu aracın plakası artık değiştirilemez: araç daha önce bir izne eklenmiş ya da belgelerinden biri onaylanmış. Farklı bir plaka için yeni bir araç ekleyin.',
  VEHICLE_PLATE_ALREADY_EXISTS:
    'Bu plakayla kayıtlı bir araç zaten var (boşluk ve noktalama dikkate alınmaz). Listedeki mevcut aracı kullanın.',
  VEHICLE_DOCUMENT_NOT_FOUND: 'Bu araç belgesi bulunamadı ya da artık mevcut değil.',
  VEHICLE_NOT_FOUND: 'Araç bulunamadı; silinmiş ya da izinden çıkarılmış olabilir.',
  VISIT_NOT_FOUND: 'Ziyaret kaydı bulunamadı.',
  HOST_NOT_FOUND: 'Seçilen ev sahibi firmanın aktif kullanıcısı değil.',
  SAFETY_BRIEFING_REQUIRED: 'Güvenlik brifingi onayı zorunludur.',
  KVKK_CONSENT_REQUIRED: 'KVKK açık rıza onayı zorunludur; rıza olmadan giriş alınamaz.',
  VISIT_ALREADY_CHECKED_OUT: 'Bu ziyaret için çıkış zaten alınmış.',

  // Yönetim hata kodları (api-contract §9)
  FORBIDDEN: 'Bu işlem için yetkiniz yok.',
  ROLE_NOT_FOUND: 'Rol bulunamadı.',
  SYSTEM_ADMIN_ROLE_LOCKED: 'Sistem yöneticisi rolü kilitlidir; değiştirilemez.',
  UNKNOWN_ACTION: 'Tanınmayan bir aksiyon gönderildi. Lütfen sayfayı yenileyip tekrar deneyin.',
  COMPANY_NOT_FOUND: 'Firma bulunamadı.',
  BRANCH_NOT_FOUND: 'Şube bulunamadı.',
  SITE_NOT_FOUND: 'Saha bulunamadı.',
  USER_ALREADY_EXISTS: 'Bu e-posta zaten kullanımda. Lütfen farklı bir e-posta girin.',

  'validation.emailRequired': 'E-posta zorunludur.',
  'validation.emailInvalid': 'Geçerli bir e-posta girin.',
  'validation.passwordRequired': 'Parola zorunludur.',
  'validation.identifierRequired': 'E-posta veya telefon zorunludur.',
  'validation.codeRequired': 'Doğrulama kodu zorunludur.',
  'validation.passwordPolicy': 'Parola en az 8 karakter, bir harf ve bir rakam içermeli.',

  // Backend hata kodları için yerel yedek (backend paketi geldiğinde üzerine yazılır).
  'error.generic': 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
  NETWORK_ERROR: 'Sunucuya ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.',
  INVALID_CREDENTIALS: 'E-posta veya parola hatalı.',
  VALIDATION_FAILED: 'Lütfen alanları kontrol edin.',
  UNAUTHORIZED: 'Oturumunuz doğrulanamadı. Lütfen tekrar giriş yapın.',
  PASSWORD_POLICY_ERROR: 'Parola en az 8 karakter, bir harf ve bir rakam içermeli.',
  CODE_INVALID: 'Doğrulama kodu hatalı veya kullanılmış. Yeni kod isteyin.',
  CODE_EXPIRED: 'Doğrulama kodunun süresi doldu. Yeni kod isteyin.',
  CODE_TOO_FREQUENT: 'Çok sık kod istediniz. Lütfen biraz bekleyip tekrar deneyin.',

  // ---- İş İzni (Permits — §14/§17) ----
  'permits.nav': 'Çalışma İzinleri',
  'permits.nav.pendingApproval': 'Onay Bekleyen',
  'permits.nav.active': 'Aktif',
  'permits.nav.all': 'Tüm İzinler',
  'permits.title': 'Çalışma İzinleri',
  'permits.list.subtitle': 'Tehlikeli görevler için taşeron çalışma izinlerini yönetin.',
  'permits.common.actions': 'İşlemler',
  'permits.common.loading': 'Yükleniyor...',
  'permits.common.close': 'Kapat',
  'permits.common.cancel': 'Vazgeç',
  'permits.common.save': 'Kaydet',
  'permits.common.create': 'Oluştur',
  'permits.common.add': 'Ekle',
  'permits.gate.loadingLabel': 'Çalışma İzni erişimi denetleniyor...',
  'permits.forbidden.title': 'Erişim yetkiniz yok',
  'permits.forbidden.body':
    'Çalışma İzni modülüne erişim yetkiniz bulunmuyor. Lütfen firma yöneticinizle görüşün.',
  'permits.forbidden.back': 'Panele dön',
  'permits.unavailable.title': 'Çalışma İzni yüklenemedi',
  'permits.unavailable.body': 'Servise şu anda ulaşılamıyor. Lütfen daha sonra tekrar deneyin.',
  'permits.unavailable.retry': 'Tekrar dene',
  'permits.list.search': 'İzin ara',
  'permits.list.searchPlaceholder': 'Başlığa göre ara',
  'permits.list.new': 'Yeni İzin',
  'permits.list.count': '{{count}} çalışma izni listeleniyor',
  'permits.list.count_one': '{{count}} çalışma izni listeleniyor',
  'permits.list.empty': 'Henüz çalışma izni yok.',
  'permits.list.empty.body': 'İlk izni oluşturduğunuzda burada listelenir.',
  'permits.list.noResults': 'Filtrelerle eşleşen çalışma izni yok.',
  'permits.list.col.permitType': 'Çalışma izni tipi',
  'permits.list.col.title': 'Başlık',
  // Owner review B2 item 1 — Taşeron + Sahalar TEK sütunda istiflenir (`ContractorAndSites`);
  // ayrı `permits.list.col.contractor`/`.sites` başlıkları bu yüzden KALKTI (yalnız bu tabloda
  // kullanılıyorlardı).
  'permits.list.col.contractorSites': 'Taşeron / Saha',
  'permits.list.sitesMore': '+{{count}}',
  'permits.list.col.hazard': 'Tehlike',
  'permits.list.col.validity': 'Geçerlilik',
  'permits.list.col.status': 'Durum',
  'permits.list.col.personnel': 'Personel',
  'permits.list.filter.status': 'Durum',
  'permits.list.filter.contractor': 'Taşeron',
  'permits.list.filter.site': 'Saha',
  'permits.list.filter.permitType': 'Çalışma izni tipi',
  'permits.list.filter.from': 'Başlangıç (en erken)',
  'permits.list.filter.to': 'Bitiş (en geç)',
  // §34.4 — yalnız `validityEnd` üzerinde aralık (yukarıdaki `from`/`to` pencere-kesişimden farklı)
  'permits.list.filter.validityEndFrom': 'Sona erme (en erken)',
  'permits.list.filter.validityEndTo': 'Sona erme (en geç)',
  'permits.list.filter.allStatuses': 'Tüm durumlar',
  'permits.list.filter.allContractors': 'Tüm taşeronlar',
  'permits.list.filter.allSites': 'Tüm sahalar',
  'permits.list.filter.allPermitTypes': 'Tüm izin tipleri',
  'permits.pagination.nav': 'Sayfalama',
  'permits.pagination.previous': 'Önceki',
  'permits.pagination.next': 'Sonraki',
  'permits.status.Draft': 'Taslak',
  // SPEC §1: "Submitted" = ISG onayı bekleyen izin — kullanıcıya "Onay Bekliyor" daha nettir
  // ("Gönderildi" aksiyonu değil, bekleyen DURUMU ifade eder; brief 098 İş 3-a).
  'permits.status.Submitted': 'Onay Bekliyor',
  'permits.status.Approved': 'Onaylandı',
  'permits.status.Active': 'Aktif',
  'permits.status.Rejected': 'Reddedildi',
  'permits.status.Expired': 'Süresi doldu',
  'permits.status.Closed': 'Kapatıldı',
  'permits.form.create.title': 'Yeni Çalışma İzni',
  'permits.form.edit.title': 'Çalışma İznini Düzenle',
  'permits.form.description':
    'Görev bilgilerini ve geçerlilik penceresini girin. İzin taslak olarak oluşturulur.',
  'permits.form.section.task': 'Görev bilgileri',
  'permits.form.section.validity': 'Geçerlilik',
  'permits.form.section.trainings': 'Gerekli eğitimler',
  'permits.form.field.contractor': 'Taşeron',
  'permits.form.field.sites': 'Sahalar',
  'permits.form.field.permitType': 'Çalışma izni tipi',
  'permits.form.field.title': 'Başlık',
  'permits.form.field.description': 'Açıklama',
  'permits.form.field.hazardClass': 'Tehlike sınıfı',
  'permits.form.field.validityStart': 'Başlangıç',
  'permits.form.field.validityEnd': 'Bitiş',
  'permits.form.field.notes': 'Notlar',
  'permits.form.contractorPlaceholder': 'Taşeron seçin',
  'permits.form.permitTypePlaceholder': 'İzin tipi seçin',
  'permits.form.hazardPlaceholder': 'Tehlike sınıfı seçin',
  'permits.form.hazardFromTypeHint':
    'Tehlike sınıfı, seçilen izin tipinden gelir ve değiştirilemez.',
  'permits.form.hazardManualHint': 'Bu izin tipi için tehlike sınıfını seçin.',
  'permits.form.noPermitTypes':
    'Önce en az bir çalışma izni tipi tanımlayın. Çalışma İzni Tipleri ekranından ekleyebilirsiniz.',
  'permits.form.sitesNote':
    'İznin kapsadığı sahaları seçin (opsiyonel, birden çok seçilebilir). Boş bırakırsanız izin belirli bir sahaya bağlanmaz.',
  'permits.form.sitesLoading': 'Sahalar yükleniyor...',
  'permits.form.sitesEmpty': 'Tanımlı saha yok. Sahalar Ayarlar ekranından eklenebilir.',
  'permits.form.trainingsEmpty': 'Eklenebilecek aktif eğitim yok.',
  'permits.form.trainingsLoading': 'Eğitimler yükleniyor...',
  'permits.form.trainingsNote':
    'Personel açılışta seçilmez; izin oluşturulduktan sonra detay ekranından eklenir. Gerekli eğitimleri de detay ekranından yönetmeyi sürdürebilirsiniz.',
  'permits.validation.contractorRequired': 'Lütfen bir taşeron seçin.',
  'permits.validation.permitTypeRequired': 'Lütfen izin tipi seçin.',
  'permits.validation.hazardClassRequired': 'Lütfen tehlike sınıfı seçin.',
  'permits.validation.titleRequired': 'Başlık gerekli.',
  'permits.validation.validityStartRequired': 'Başlangıç tarihi gerekli.',
  'permits.validation.validityEndRequired': 'Bitiş tarihi gerekli.',
  'permits.validation.validityRange': 'Bitiş, başlangıçtan önce olamaz.',
  'permits.validation.reasonRequired': 'Red gerekçesi gerekli.',
  'permits.detail.back': 'Çalışma İzinlerine dön',
  'permits.detail.loading': 'İzin yükleniyor...',
  'permits.detail.edit': 'Düzenle',
  'permits.detail.readOnlyNote': 'Bu izin artık düzenlenemez ({{status}}).',
  'permits.detail.field.contractor': 'Taşeron',
  'permits.detail.field.sites': 'Sahalar',
  'permits.detail.field.permitType': 'Çalışma izni tipi',
  'permits.detail.field.hazardClass': 'Tehlike sınıfı',
  'permits.detail.field.validity': 'Geçerlilik',
  'permits.detail.field.description': 'Açıklama',
  'permits.detail.field.notes': 'Notlar',
  'permits.detail.field.approvedBy': 'Onaylayan',
  'permits.detail.field.approvedAt': 'Onay tarihi',
  'permits.detail.field.createdAt': 'Oluşturulma',
  'permits.detail.section.personnel': 'Kapsanan personel',
  'permits.detail.section.trainings': 'Gerekli eğitimler',
  'permits.detail.requiredDocuments': 'İstenen belgeler',
  'permits.detail.requiredDocumentsEmpty': 'Bu izin tipinde personel belgesi istenmiyor.',
  'permits.lifecycle.submit': 'Gönder',
  'permits.lifecycle.approve': 'Onayla',
  'permits.lifecycle.reject': 'Reddet',
  'permits.lifecycle.close': 'Kapat',
  'permits.lifecycle.submit.title': 'İzni gönder',
  'permits.lifecycle.submit.body': 'İzin onaya gönderilecek. Devam edilsin mi?',
  'permits.lifecycle.submit.confirm': 'Gönder',
  'permits.lifecycle.approve.title': 'İzni onayla',
  'permits.lifecycle.approve.body':
    'İzin onaylanacak ve taşerondan izin bilgilerini (personel, araç, belge) tamamlaması istenecek; taşeron yetkililerine bildirim gönderilir. Devam edilsin mi?',
  'permits.lifecycle.approve.confirm': 'Onayla',
  'permits.lifecycle.close.title': 'İzni kapat',
  'permits.lifecycle.close.body': 'İzin kalıcı olarak kapatılacak. Devam edilsin mi?',
  'permits.lifecycle.close.confirm': 'Kapat',
  'permits.lifecycle.rerunAiReview': 'AI incelemesini yeniden çalıştır',
  'permits.lifecycle.rerunAiReview.title': 'AI incelemesini yeniden çalıştır',
  'permits.lifecycle.rerunAiReview.body':
    'İzin için AI incelemesi yeniden çalıştırılacak; sonuca göre izin Kontrol aşamasına geçecek ya da Revize durumuna dönecek. Devam edilsin mi?',
  'permits.lifecycle.rerunAiReview.confirm': 'Yeniden çalıştır',
  'permits.lifecycle.issueEntryPermits': 'Giriş izinlerini ver',
  'permits.lifecycle.issueEntryPermits.title': 'Giriş izinlerini ver',
  'permits.lifecycle.issueEntryPermits.body':
    'İzin kapsamındaki tüm personele ve varsa araçlara saha giriş izni verilecek, personele bildirim gönderilecek ve izin Aktif duruma geçecek. Devam edilsin mi?',
  'permits.lifecycle.issueEntryPermits.confirm': 'Giriş izni ver',
  'permits.lifecycle.goToReview': 'Kontrole git',
  'permits.lifecycle.action.openMenu': '{{name}} için işlemler',
  'permits.reject.title': 'İzni reddet',
  'permits.reject.description': 'İzin reddedilecek. Lütfen bir gerekçe girin.',
  'permits.reject.field.reason': 'Gerekçe',
  'permits.reject.reasonPlaceholder': 'Red gerekçesini yazın',
  'permits.reject.confirm': 'Reddet',
  'permits.personnel.subtitle': 'İzin kapsamındaki taşeron personeli ve eğitim hazırlık durumu.',
  'permits.personnel.add': 'Personel Ekle',
  'permits.personnel.empty': 'Bu izne henüz personel eklenmemiş.',
  'permits.personnel.col.name': 'Ad Soyad',
  'permits.personnel.col.contact': 'İletişim',
  'permits.personnel.col.training': 'Eğitim',
  'permits.personnel.col.readiness': 'Hazırlık',
  'permits.personnel.trainingProgress': '{{completed}} / {{required}} tamamlandı',
  'permits.personnel.ready': 'Hazır',
  'permits.personnel.notReady': 'Eksik',
  'permits.personnel.action.remove': 'Kapsamdan çıkar',
  'permits.personnel.remove.title': 'Personeli çıkar',
  'permits.personnel.remove.body': '{{name}} izin kapsamından çıkarılsın mı?',
  'permits.personnel.remove.confirm': 'Çıkar',
  'permits.personnel.add.title': 'Personel Ekle',
  'permits.personnel.add.description':
    'İznin taşeronuna bağlı personelden seçin. Etkinleştirilmemiş kişiler de eklenebilir.',
  'permits.personnel.add.createNew': 'Yeni personel oluştur',
  'permits.personnel.notActivated': 'Etkinleştirilmedi',
  'permits.personnel.notActivated.hint':
    'Kişi, hesabını etkinleştirmeden bu iznin gerekli eğitimlerini tamamlayamaz. Aktivasyon bağlantısı, taşeronun Personel sekmesinden gönderilir.',
  'permits.personnel.add.field.personnel': 'Personel',
  'permits.personnel.add.empty': 'Eklenebilecek uygun personel yok.',
  'permits.personnel.readiness.documents': 'Belgeler',
  'permits.personnel.readiness.training': 'Eğitimler',
  'permits.personnel.missingDocuments': 'Eksik belgeler',
  'permits.personnel.missingTrainings': 'Eksik eğitimler',

  'permits.entry.grant': 'Giriş İzni Ver',
  'permits.entry.grantBlocked': 'Giriş İzni Ver (belge veya eğitim eksik)',
  'permits.entry.granted': 'Giriş izni verildi',
  'permits.entry.grantedMeta': '{{date}} · Veren: {{by}}',
  'permits.entry.revoke': 'Giriş İznini Geri Al',
  'permits.entry.readyHint': 'Personel hazır; saha giriş izni verilebilir.',
  'permits.entry.notReadyHint':
    'Giriş izni için tüm belgeler onaylanmış ve eğitimler tamamlanmış olmalı.',
  'permits.entry.grantSuccess': 'Giriş izni verildi.',
  'permits.entry.revokeSuccess': 'Giriş izni geri alındı.',
  'permits.entry.grantError':
    'Giriş izni verilemedi. Personelin tüm belgeleri onaylanmış ve eğitimleri tamamlanmış olmalı.',
  'permits.entry.revoke.title': 'Giriş iznini geri al',
  'permits.entry.revoke.body': '{{name}} için verilen saha giriş izni geri alınsın mı?',
  'permits.entry.revoke.confirm': 'Geri Al',

  'permits.personnelDocs.title': 'Belgeler',
  'permits.personnelDocs.col.type': 'Tür',
  'permits.personnelDocs.col.validityStatus': 'Durum',
  // GL25 — tek belge onay/red kontrolü (taslak metinler; alan-dili incelemesi bekliyor).
  'documents.review.download': 'İndir: {{type}}',
  'documents.review.approve': 'Onayla: {{type}}',
  'documents.review.reject': 'Reddet: {{type}}',
  'documents.review.delete': 'Sil: {{type}}',
  'documents.review.reason.label': 'Red gerekçesi',
  'documents.review.reason.placeholder': 'Örn. Belge okunaksız veya süresi geçmiş.',
  'documents.review.reason.required': 'Red gerekçesi zorunludur.',
  'documents.review.reason.tooLong': 'Red gerekçesi en fazla {{max}} karakter olabilir.',
  'documents.review.reject.confirm': 'Reddet',
  'documents.review.rejectionReason': 'Red gerekçesi: {{reason}}',
  'documents.review.approveSuccess': 'Belge onaylandı.',
  'documents.review.rejectSuccess': 'Belge reddedildi.',
  'vehicles.docStatus.allApproved': 'Tümü onaylı',
  'vehicles.docStatus.none': 'Belge yok',
  'vehicles.docStatus.missingEnd': 'Bitiş tarihi yok',
  'vehicles.openPermits.yes': 'Açık izinde',
  'vehicles.sheet.docs.title': 'Araç belgeleri',
  'vehicles.sheet.docs.upload': 'Belge yükle',
  'vehicles.sheet.docs.empty': 'Bu araca henüz belge eklenmemiş.',
  'vehicles.sheet.docs.note':
    'Belgeler araçla birlikte tutulur; onay veya red aracın eklendiği tüm izinlerde geçerlidir.',
  'vehicles.sheet.plateLocked': 'Plaka kilitli',
  'vehicles.doc.inUse': 'Kullanımda: silinemez',
  'vehicles.doc.delete.title': 'Belgeyi sil',
  'vehicles.doc.delete.body':
    '"{{type}}" belgesi silinsin mi? Belge, aracın eklendiği izinlerde de artık görünmez.',
  'vehicles.doc.delete.confirm': 'Sil',
  'vehicles.upload.title': 'Araç Belgesi Yükle',
  'vehicles.upload.description': '{{plate}} plakalı araç için belge ekleyin. Belge onay bekler.',
  'vehicles.upload.chooseFile': 'Dosya seç',
  'vehicles.upload.submit': 'Yükle',
  'vehicles.upload.uploading': 'Yükleniyor…',
  'vehicles.upload.progress': '%{{percent}} yüklendi',
  'vehicles.upload.noteTooLong': 'Not en fazla {{max}} karakter olabilir.',
  'vehicles.validation.plateInvalid':
    'Plaka geçersiz: en fazla {{max}} karakter ve en fazla {{keyMax}} harf ve rakam olabilir, görünmeyen karakter içeremez. Plakayı elle yeniden yazın.',
  'vehicles.title': 'Araçlar',
  'vehicles.subtitle':
    'Taşeronun bu firmadaki araçları. Araç ekleyin, belgelerini yükleyip onaylayın; onay, aracın eklendiği tüm izinlerde geçerlidir.',
  'vehicles.add': 'Araç Ekle',
  'vehicles.empty': 'Bu taşerona henüz araç eklenmemiş.',
  'vehicles.col.plate': 'Plaka',
  'vehicles.col.description': 'Açıklama',
  'vehicles.col.documents': 'Belgeler',
  'vehicles.col.docStatus': 'Belge durumu',
  'vehicles.col.openPermits': 'Açık izin',
  'vehicles.action.openMenu': '{{plate}} plakalı araç işlemleri',
  'vehicles.action.upload': 'Belge yükle',
  'vehicles.action.edit': 'Düzenle',
  'vehicles.action.delete': 'Sil',
  'vehicles.action.deleteBlocked': 'Sil (önce açık izinlerden çıkarın)',
  'vehicles.action.deleteBlockedInUse': 'Sil (belgesi kullanımda)',
  'vehicles.delete.title': 'Aracı sil',
  'vehicles.delete.body':
    '{{plate}} plakalı araç ve belgeleri silinsin mi? Geçmiş izinlerde plaka görünmeye devam eder.',
  'vehicles.delete.confirm': 'Sil',
  'vehicles.form.edit.title': 'Aracı düzenle',
  'vehicles.form.edit.description': 'Değişiklik, aracın eklendiği tüm izinlerde görünür.',
  'vehicles.form.create.description': 'Taşeronun araç listesine yeni bir araç ekleyin.',
  'vehicles.form.submit.edit': 'Kaydet',
  'vehicles.form.submit.create': 'Ekle',
  'vehicles.form.field.plate': 'Plaka',
  'vehicles.form.field.description': 'Açıklama',
  'vehicles.form.platePlaceholder': 'Örn. 34 ABC 123',
  'vehicles.form.plateLocked':
    'Plaka artık değiştirilemez: aracın belgelerinden biri onaylanmış. Farklı bir plaka için yeni araç ekleyin.',
  'vehicles.validation.plateRequired': 'Plaka zorunludur.',
  'vehicles.validation.plateTooLong': 'Plaka en fazla {{max}} karakter olabilir.',
  'vehicles.validation.plateKeyTooLong': 'Plakada en fazla {{max}} harf ve rakam olabilir.',
  'vehicles.validation.descriptionTooLong': 'Açıklama en fazla {{max}} karakter olabilir.',
  'vehicles.permitAdd.title': 'Araç Ekle',
  'vehicles.permitAdd.description':
    'Taşeronun araçlarından seçin ya da yeni bir plaka girin. Yeni plaka taşeronun araç listesine de eklenir.',
  'vehicles.permitAdd.submit': 'Ekle',
  'vehicles.permitAdd.registered': 'Kayıtlı araçlar',
  'vehicles.permitAdd.registeredEmpty': 'İzne eklenebilecek kayıtlı araç yok.',
  'vehicles.permitAdd.newVehicle': 'Yeni araç',
  'vehicles.permitAdd.plateOnPermit': 'Bu araç zaten izinde.',
  'vehicles.permitAdd.plateExisting': 'Bu plaka listede var; mevcut araç izne eklenecek.',
  'vehicles.permitAdd.plateNew': 'Yeni araç; araç listesine de eklenecek.',
  'vehicles.permitAdd.partialFailure': '{{plate}} plakalı araç eklenemedi.',
  'vehicles.unlink.action': 'İzinden çıkar',
  'vehicles.unlink.title': 'Aracı izinden çıkar',
  'vehicles.unlink.body':
    '{{plate}} plakalı araç bu izinden çıkarılsın mı? Araç ve belgeleri araç listesinde kalır.',
  'vehicles.unlink.confirm': 'Çıkar',

  'permits.docApproval.pending': 'Onay bekliyor',
  'permits.docApproval.approved': 'Onaylandı',
  'permits.docApproval.rejected': 'Reddedildi',

  // Araçlar (§23). Araç belge türü etiketleri §27 kaydındandır (uygulama anahtarı yok).
  'permits.form.field.hasVehicles': 'Araç olacak mı?',
  'permits.form.hasVehiclesHint':
    'İşaretlerseniz izin detayında araç plakası ve evraklarını ekleyebilirsiniz.',
  'permits.detail.section.vehicles': 'Araçlar',
  'permits.detail.tab.personnelIncomplete_one': '{{count}} kişi hazır değil',
  'permits.detail.tab.personnelIncomplete_other': '{{count}} kişi hazır değil',
  'permits.detail.tab.vehiclesIncomplete_one': '{{count}} araç hazır değil',
  'permits.detail.tab.vehiclesIncomplete_other': '{{count}} araç hazır değil',
  'permits.detail.section.ppe': 'KKD',
  'permits.detail.section.controls': 'Kontrol listesi',
  'permits.detail.section.documentRequests': 'Ek belge talepleri',
  'permits.ppe.subtitle':
    'İznin tipinde istenen kişisel koruyucu donanımlar (donanımı taşeron temin eder).',
  'permits.ppe.empty': 'Bu izinde KKD yok.',
  'permits.ppe.col.name': 'KKD',
  'permits.controls.subtitle': 'İznin kontrol maddeleri — sahada doğruladıkça işaretleyin.',
  'permits.controls.lockedHint':
    'Kontrol listesi izin aktif olunca (iş başlayınca) doldurulabilir. Madde ekleyip silebilirsiniz.',
  'permits.controls.empty': 'Bu izinde kontrol maddesi yok.',
  'permits.controls.col.item': 'Madde',
  'permits.controls.col.status': 'Durum',
  'permits.controls.checked': 'İşaretlendi',
  'permits.controls.unchecked': 'İşaretlenmedi',
  'permits.controls.checkedBy': '{{name}} · {{date}}',
  'permits.controls.note': 'Not',
  'permits.controls.notePlaceholder': 'İsteğe bağlı not',
  'permits.controls.noteSave': 'Notu kaydet',
  'permits.docRequests.subtitle':
    'İznin tipinde istenen standart belgelere ek olarak, bu izne özel belge türü talep edin. Talep izindeki tüm personele uygulanır ve hazırlık durumuna katılır.',
  'permits.docRequests.empty': 'Bu izin için ek belge talebi bulunmuyor.',
  'permits.docRequests.readOnlyHint':
    'Ek belge taleplerini yalnız görüntülüyorsunuz; ekleme veya kaldırma için düzenleme yetkisi gerekir.',
  'permits.docRequests.allRequested':
    'Kataloğdaki tüm belge türleri için zaten talep oluşturulmuş.',
  'permits.docRequests.typeLabel': 'Belge türü',
  'permits.docRequests.typePlaceholder': 'Belge türü seçin',
  'permits.docRequests.note': 'Not',
  'permits.docRequests.col.requested': 'Talep eden',
  'permits.docRequests.notePlaceholder': 'İsteğe bağlı açıklama',
  'permits.docRequests.add': 'Talep ekle',
  'permits.docRequests.requestedBy': '{{name}} · {{date}}',
  'permits.docRequests.remove': 'Talebi kaldır',
  'permits.docRequests.remove.title': 'Belge talebini kaldır',
  'permits.docRequests.remove.body': '"{{type}}" belge talebi bu izinden kaldırılsın mı?',
  'permits.docRequests.remove.confirm': 'Kaldır',
  'permits.vehicles.requiredDocumentsEmpty': 'Bu izin tipinde araç belgesi istenmiyor.',
  'permits.vehicles.requiredDocsLine': 'İstenen araç belgeleri: {{list}}',
  'permits.vehicles.readySummary': '{{ready}} / {{total}} hazır',
  'permits.vehicles.col.documents': 'Belgeler',
  'permits.vehicles.col.readiness': 'Hazırlık',
  'permits.vehicles.action.openMenu': '{{plate}} için işlemler',
  'permits.vehicles.add': 'Araç Ekle',
  'permits.vehicles.empty': 'Bu izne henüz araç eklenmemiş.',
  'permits.vehicles.ready': 'Hazır',
  'permits.vehicles.notReady': 'Eksik',
  'permits.vehicles.missingDocuments': 'Eksik araç belgeleri',
  'permits.vehicles.form.field.plate': 'Plaka',
  'permits.vehicles.docs.col.type': 'Tür',
  'permits.vehicles.docs.col.approval': 'Onay',
  'permits.trainings.subtitle': 'İzin kapsamındaki personelin tamamlaması gereken eğitimler.',
  'permits.trainings.add': 'Eğitim Ekle',
  'permits.trainings.empty': 'Bu izin için gerekli eğitim tanımlanmamış.',
  'permits.trainings.action.remove': 'Kaldır',
  'permits.trainings.remove.title': 'Eğitimi kaldır',
  'permits.trainings.remove.body': '"{{title}}" gerekli eğitimlerden kaldırılsın mı?',
  'permits.trainings.remove.confirm': 'Kaldır',
  'permits.trainings.add.title': 'Gerekli Eğitim Ekle',
  'permits.trainings.add.description': 'Aktif eğitimlerden bu izne gerekli olanları seçin.',
  'permits.trainings.add.field.trainings': 'Eğitimler',
  'permits.trainings.add.empty': 'Eklenebilecek aktif eğitim yok.',
  // Onay akışı durum etiketleri (SPEC §1) — Draft/Submitted/Approved/Active/Rejected/Expired/Closed
  // yukarıda; aşağısı Faz B genişletmesi.
  'permits.status.AwaitingSupplierInfo': 'Taşeron Bilgisi Bekleniyor',
  'permits.status.AwaitingAiReview': 'AI Onayı Bekleniyor',
  'permits.status.Revision': 'Revize',
  'permits.status.DepartmentReview': 'Kontrol',
  'permits.status.AwaitingEntryPermit': 'Giriş İzni Bekleniyor',
  // ===== Kontrol aşaması (DepartmentReview) + Firma Onay-Routing (§31 / brief 095) — Faz B Dalga 2 =====
  // Onay departmanları (İSG / İşyeri Hekimi / İK) — brief 095 §2 sabit küme.
  'permits.department.Isg': 'İSG',
  'permits.department.Hekim': 'İşyeri Hekimi',
  'permits.department.Ik': 'İnsan Kaynakları',
  // Kontrol aşaması kuyruğu + detay + departman onay/ret.
  'departmentReview.nav': 'Kontrol',
  'departmentReview.title': 'Kontrol',
  'departmentReview.subtitle': 'Departmanınızın onayını bekleyen çalışma izinleri.',
  'departmentReview.count': '{{count}} izin onayınızı bekliyor',
  'departmentReview.count_one': '{{count}} izin onayınızı bekliyor',
  'departmentReview.loading': 'Kontrol kuyruğu yükleniyor...',
  'departmentReview.empty': 'Şu anda onayınızı bekleyen izin yok.',
  'departmentReview.col.permit': 'İzin',
  'departmentReview.col.contractor': 'Taşeron',
  'departmentReview.col.validity': 'Geçerlilik',
  'departmentReview.col.permitStatus': 'İzin durumu',
  'departmentReview.col.myStatus': 'Departman durumunuz',
  'departmentReview.pagination.nav': 'Sayfalama',
  'departmentReview.pagination.previous': 'Önceki',
  'departmentReview.pagination.next': 'Sonraki',
  'departmentReview.status.Pending': 'Bekliyor',
  'departmentReview.status.Approved': 'Onaylandı',
  'departmentReview.status.Rejected': 'Reddedildi',
  'departmentReview.gate.loadingLabel': 'Kontrol erişimi denetleniyor...',
  'departmentReview.forbidden.title': 'Kontrol erişiminiz yok',
  'departmentReview.forbidden.body':
    'Bu alan yalnız onay departmanlarına (İSG, İşyeri Hekimi, İnsan Kaynakları) açıktır. Erişim gerekiyorsa lütfen yöneticinizle görüşün.',
  'departmentReview.forbidden.back': 'Panele dön',
  'departmentReview.unavailable.title': 'Kontrol şu anda kullanılamıyor',
  'departmentReview.unavailable.body':
    'Kontrol servisine şu anda ulaşılamıyor. Lütfen birazdan tekrar deneyin.',
  'departmentReview.unavailable.retry': 'Tekrar dene',
  'departmentReview.detail.back': 'Kontrol kuyruğuna dön',
  'departmentReview.detail.loading': 'İzin yükleniyor...',
  'departmentReview.detail.sitesLabel': 'İznin kapsadığı sahalar',
  'departmentReview.detail.reviewUnavailable':
    'Departman onay bilgisi şu anda yüklenemedi; izin içeriği gösteriliyor. Lütfen birazdan tekrar deneyin.',
  'departmentReview.detail.approvalsTitle': 'Departman onayları',
  'departmentReview.detail.escalatedFrom': '{{department}} biriminden eskale edildi',
  'departmentReview.detail.section.aiNotes': 'AI notları',
  // §31 düzeltme bloğu (gerçek §31.2/§31.4/§31.5'e hizalama) — Faz B Dalga 2
  DEPARTMENT_FORBIDDEN:
    'Bu işlem için ilgili departmanın (İSG, İşyeri Hekimi veya İnsan Kaynakları) üyesi olmanız gerekir.',
  'approvalRouting.filter.allTypes': 'Tüm belge türleri',
  'approvalRouting.filter.entity': 'Belge grubu filtresi',
  'departmentReview.detail.reviewingAs': 'İnceleyen departman:',
  'departmentReview.detail.noDepartment':
    'Kayıtlı bir Kontrol departmanınız bulunamadı. Bu ekran yalnız İSG, İşyeri Hekimi veya İnsan Kaynakları rollerine açıktır.',
  'departmentReview.detail.responsibleDocsTitle': 'Sorumlu olduğunuz belgeler',
  'departmentReview.detail.responsibleDocsEmpty':
    'Bu izinde departmanınızın sorumlu olduğu belge türü yok.',
  'departmentReview.detail.responsibleDocs.personnel': 'Personel belgeleri',
  'departmentReview.detail.responsibleDocs.vehicle': 'Araç belgeleri',
  'departmentReview.detail.trainingsEmpty': 'Bu izne gerekli eğitim tanımlanmamış.',
  'departmentReview.detail.vehiclesEmpty': 'Bu izne araç eklenmemiş.',
  'departmentReview.detail.vehicleNoDocs': 'Bu araca henüz belge eklenmemiş.',
  'departmentReview.action.approve': 'Onayla',
  'departmentReview.action.reject': 'Reddet',
  'departmentReview.approve.title': 'İzni onayla',
  'departmentReview.approve.body':
    '{{department}} departmanı adına bu izni onaylıyorsunuz. Tüm gerekli departmanlar onayladığında izin giriş iznine ilerler.',
  'departmentReview.approve.confirm': 'Onayla',
  'departmentReview.reject.title': 'İzni reddet',
  'departmentReview.reject.description':
    'İzin revizeye döner; taşeron ve izni açan kişi bilgilendirilir. Lütfen gerekçe girin.',
  'departmentReview.reject.confirm': 'Reddet',
  'departmentReview.reject.reasonRequired': 'Lütfen bir gerekçe girin.',
  'departmentReview.reject.reasonPlaceholder': 'Reddetme gerekçesini yazın',
  'departmentReview.reject.field.reason': 'Gerekçe',
  // Firma Onay-Routing ayarı (belge türü → departman) — brief 095 §2.
  'permitTypes.catalog.tabs.approvalRouting': 'Onay Yönlendirme',
  'approvalRouting.title': 'Onay Yönlendirme',
  'approvalRouting.defaultNote':
    'Kural tanımlanmayan belge türleri varsayılan olarak yalnız İSG onayı bekler.',
  'approvalRouting.list.new': 'Yeni Kural',
  'approvalRouting.list.col.documentType': 'Belge türü',
  'approvalRouting.list.col.departments': 'Onaylayan departmanlar',
  'approvalRouting.list.col.escalation': 'Eskalasyon',
  'approvalRouting.list.count': '{{count}} onay yönlendirme kuralı listeleniyor',
  'approvalRouting.list.count_one': '{{count}} onay yönlendirme kuralı listeleniyor',
  'approvalRouting.list.action.openMenu': '{{name}} için işlemler',
  'approvalRouting.list.empty': 'Henüz onay yönlendirme kuralı yok.',
  'approvalRouting.list.empty.body':
    'Kural tanımlanmadıkça tüm belge türleri yalnızca İSG onayından geçer.',
  'approvalRouting.list.noResults': 'Filtreyle eşleşen onay yönlendirme kuralı yok.',
  'approvalRouting.list.deleted': 'Onay yönlendirme kuralı kaldırıldı.',
  'approvalRouting.list.escalationSummary': '{{hours}} saat sonra {{department}}',
  'approvalRouting.delete.title': 'Kuralı kaldır',
  'approvalRouting.delete.body':
    '{{documentType}} belge türünün onay yönlendirme kuralı kaldırılsın mı? Bu tür varsayılan (yalnız İSG) onaya döner.',
  'approvalRouting.form.create.title': 'Yeni Onay Yönlendirme Kuralı',
  'approvalRouting.form.edit.title': 'Onay Yönlendirme Kuralını Düzenle',
  'approvalRouting.form.description':
    'Belge türünü, onaylayacak departmanları ve isteğe bağlı eskalasyonu tanımlayın.',
  'approvalRouting.form.field.documentType': 'Belge türü',
  'approvalRouting.form.field.departments': 'Onaylayan departmanlar',
  'approvalRouting.form.field.escalationHours': 'Eskalasyon süresi (saat)',
  'approvalRouting.form.field.escalationDepartment': 'Eskale edilecek departman',
  'approvalRouting.form.departmentsHint':
    'Bir veya birden çok departman seçebilirsiniz (örneğin İK ve İSG birlikte).',
  'approvalRouting.form.escalationHint':
    'Süre dolduğunda onay eskale edilecek departmana geçer. Süre girerseniz departman da zorunludur.',
  'approvalRouting.form.escalationHoursPlaceholder': 'Örn. 24',
  'approvalRouting.form.noEscalationDept': 'Eskalasyon yok',
  'approvalRouting.form.created': 'Onay yönlendirme kuralı oluşturuldu.',
  'approvalRouting.form.updated': 'Onay yönlendirme kuralı güncellendi.',
  'approvalRouting.form.error.documentType': 'Lütfen bir belge türü seçin.',
  'approvalRouting.form.error.departments': 'Lütfen en az bir departman seçin.',
  'approvalRouting.form.error.hoursPositive': 'Süre pozitif bir tam sayı olmalıdır.',
  'approvalRouting.form.error.hoursRequired': 'Eskale departmanı seçtiğinizde süre de zorunludur.',
  'approvalRouting.form.error.escalationDeptRequired':
    'Süre girdiğinizde eskale departmanı zorunludur.',
  'approvalRouting.form.allConfigured':
    'Tüm aktif personel ve araç belge türleri için zaten bir onay yönlendirme kuralı var. Değiştirmek için listedeki kuralı düzenleyin.',
  // Açılış kaydetme kipi butonları (SPEC §2).
  'permits.form.saveDraft': 'Taslak Kaydet',
  'permits.form.submitForApproval': 'Onaya Gönder',
  // Aksiyonlar tabı (SPEC §5).
  'permits.detail.section.activities': 'Aksiyonlar',
  'permits.activities.subtitle':
    'İzne ilişkin tüm değişiklikler ve yorumlar burada görünür; en yenisi en üstte.',
  'permits.activities.loading': 'Aksiyonlar yükleniyor...',
  'permits.activities.empty': 'Henüz aksiyon kaydı yok.',
  'permits.activities.systemAuthor': 'Sistem',
  'permits.activities.systemLog': 'Sistem kaydı',
  'permits.activities.comment': 'Yorum',
  'permits.activities.commentLabel': 'Yorum ekle',
  'permits.activities.commentPlaceholder': 'İzinle ilgili bir not veya yorum yazın',
  'permits.activities.commentSubmit': 'Gönder',
  'permits.activities.aiAuthor': 'AI',
  'permits.activities.actorRole.supplier': 'Tedarikçi',
  'permits.activities.actorRole.reviewer': 'İSG onaylayıcı',
  'permits.activities.actorRole.opener': 'İzni açan',
  'permits.activities.reasonLabel': 'Gerekçe: {{reason}}',
  'permits.activities.subjectLabel': 'Kişi: {{name}}',
  'permits.activities.event.Created': 'İzin taslağı oluşturuldu',
  'permits.activities.event.Submitted': 'İzin onaya gönderildi',
  'permits.activities.event.AutoApproved':
    'Oluşturan onay yetkisine sahip olduğu için otomatik onaylandı',
  'permits.activities.event.Approved': 'İzin onaylandı',
  'permits.activities.event.Rejected': 'İzin reddedildi',
  'permits.activities.event.SupplierSubmitted': 'Tedarikçi bilgileri gönderildi',
  'permits.activities.event.AiRevisionRequested': 'AI revizyon istedi',
  'permits.activities.event.DepartmentReviewStarted': 'Departman incelemesi başladı',
  'permits.activities.event.DepartmentRejected': 'Departman reddetti',
  'permits.activities.event.DepartmentReviewCompleted': 'Departman incelemesi tamamlandı',
  'permits.activities.event.EntryPermitsIssued': 'Giriş izinleri verildi',
  'permits.activities.event.Closed': 'İzin kapatıldı',
  'permits.activities.event.Expired': 'İzin süresi doldu',
  'permits.activities.event.AiReviewCompleted': 'AI incelemesi tamamlandı',
  'permits.activities.event.AiReviewFailed': 'AI incelemesi başarısız oldu',
  'permits.activities.event.DepartmentApproved': 'Departman onayladı',
  'permits.activities.event.DepartmentEscalated': 'Departman eskalasyonu yapıldı',
  'permits.activities.event.EntryGranted': 'Giriş izni verildi',
  'permits.activities.event.EntryRevoked': 'Giriş izni geri alındı',
  'permits.activities.event.PersonnelAssigned': 'Personel izin kapsamına eklendi',
  'permits.activities.event.PersonnelUnassigned': 'Personel izin kapsamından çıkarıldı',
  'permits.activities.event.InfoUpdated': 'Bilgiler güncellendi',
  'permits.activities.event.ProtectiveEquipmentAdded': 'KKD eklendi: {{item}}',
  'permits.activities.event.ProtectiveEquipmentRemoved': 'KKD kaldırıldı: {{item}}',
  'permits.activities.event.ControlItemAdded': 'Kontrol maddesi eklendi: {{item}}',
  'permits.activities.event.ControlItemRemoved': 'Kontrol maddesi kaldırıldı: {{item}}',
  'permits.activities.event.DocumentRequestAdded': 'Ek belge talebi eklendi: {{item}}',
  'permits.activities.event.DocumentRequestRemoved': 'Ek belge talebi kaldırıldı: {{item}}',
  // Değişiklik kaydı alan etiketleri (ChangeSet "alan: eski → yeni"). Eksik alan için makine adı
  // gösterilir (defaultValue); buradaki alanlar sık değişenlerdir.
  'permits.field.title': 'Başlık',
  'permits.field.description': 'Açıklama',
  'permits.field.hazardClass': 'Tehlike sınıfı',
  'permits.field.validityStart': 'Geçerlilik başlangıcı',
  'permits.field.validityEnd': 'Geçerlilik bitişi',
  'permits.field.status': 'Durum',
  'permits.field.permitType': 'İzin tipi',
  'permits.field.sites': 'Sahalar',
  'permits.field.hasVehicles': 'Araç olacak mı?',
  // Kontrol maddesi ekle/sil (SPEC §2.1).
  'permits.controls.add': 'Madde ekle',
  'permits.controls.addPlaceholder': 'Yeni kontrol maddesi yazın',
  'permits.controls.remove': 'Maddeyi sil',
  'permits.controls.remove.title': 'Kontrol maddesini sil',
  'permits.controls.remove.body': '"{{text}}" maddesi bu izinden silinsin mi?',
  'permits.controls.remove.confirm': 'Sil',
  // KKD ekle/sil (SPEC §2.1).
  'permits.ppe.add': 'KKD ekle',
  'permits.ppe.addPlaceholder': 'Katalogdan KKD seçin',
  'permits.ppe.addEmpty': 'Eklenebilecek başka KKD yok.',
  'permits.ppe.remove': '{{name}} donanımını kaldır',
  'permits.ppe.remove.title': 'KKD kaldır',
  'permits.ppe.remove.body': '"{{name}}" bu izinden kaldırılsın mı?',
  'permits.ppe.remove.confirm': 'Kaldır',
  // S33 Carbon Slice 3 (permit detayı — referans sayfa) yeni anahtarları.
  'permits.detail.section.details': 'Bilgiler',
  'permits.detail.section.progress': 'İlerleme',
  // Onay ÖNCESİ statüler (Draft/Submitted/AwaitingSupplierInfo/AwaitingAiReview/
  // DepartmentReview/Revision + Rejected) — "engelliyor" burada doğru (bkz.
  // `permitIssuesPastApproval`). Türkçe sayıdan sonra çekim ALMADIĞI için `_one`/`_other`
  // metni AYNI — bu bir hata değil, i18next'in çoğul-anahtar sözleşmesi gereği ikisi de
  // tanımlanmak ZORUNDA (yalnız bare `message` varsa `t(key,{count})` eşleşmeyebilir).
  // turkish-ohs-expert review (S33 QA): "madde" belirsiz — engelleyen şey ya PERSONEL ya
  // ARAÇTIR (checklist maddesi değil, bkz. yukarıdaki `issueCount` notu), "personel/araç"
  // daha doğru okunur.
  'permits.detail.issues.message_one': '{{count}} personel/araç onayı engelliyor.',
  'permits.detail.issues.message_other': '{{count}} personel/araç onayı engelliyor.',
  // Onay SONRASI statüler (AwaitingEntryPermit/Active/Expired/Closed) — onay zaten verildi,
  // burada gerçek engel saha girişidir (bkz. `permits.entry.grant`in `!ready` kapısı).
  'permits.detail.issues.entryMessage_one': '{{count}} personel/araç saha girişine hazır değil.',
  'permits.detail.issues.entryMessage_other': '{{count}} personel/araç saha girişine hazır değil.',
  // Uyarının ikinci satırı (README "Title + body on next line") — hangi kişi/araç engelliyor.
  'permits.detail.issues.personnelFacts': 'Personel: {{list}}',
  'permits.detail.issues.vehicleFacts': 'Araçlar: {{list}}',
  'permits.detail.issues.moreCount_one': '+{{count}} daha',
  'permits.detail.issues.moreCount_other': '+{{count}} daha',
  'permits.progress.review': 'İnceleme',
  'permits.progress.activeMeta': '{{date}} · Onaylayan: {{name}}',
  'permits.personnel.readySummary': '{{ready}} / {{total}} hazır',
  'permits.personnel.search': 'Personel ara',
  'permits.personnel.searchPlaceholder': 'Ad veya iletişim bilgisiyle ara',
  'permits.personnel.searchPlaceholderNameOnly': 'Ad ile ara',
  'permits.personnel.requiredDocsLine': 'İstenen personel belgeleri: {{list}}',
  'permits.personnel.col.documents': 'Belgeler',
  'permits.personnel.col.siteAccess': 'Giriş İzni',
  'permits.personnel.searchEmpty': 'Aramayla eşleşen personel yok.',
  'permits.personnel.readiness.trainingMissing': 'Eğitim eksik',
  'permits.personnel.readiness.documentsMissing': 'Belge eksik',
  'permits.personnel.siteAccess.granted': 'Verildi',
  'permits.personnel.siteAccess.notGranted': 'Verilmedi',
  'permits.personnel.action.openMenu': '{{name}} için işlemler',
  PERMIT_NOT_FOUND: 'Çalışma izni bulunamadı.',
  PROTECTIVE_EQUIPMENT_NOT_FOUND: 'KKD ögesi bulunamadı.',
  CONTROL_ITEM_NOT_FOUND: 'Kontrol maddesi bulunamadı.',
  DUPLICATE_DOCUMENT_REQUEST: 'Bu belge türü için zaten bir talep bulunuyor.',
  DOCUMENT_REQUEST_NOT_FOUND: 'Belge talebi bulunamadı.',
  PERMIT_NOT_EDITABLE: 'Bu izin yalnız Taslak veya Gönderildi durumundayken düzenlenebilir.',
  PERMIT_INVALID_STATE: 'İzin bu işlem için uygun durumda değil.',
  TRAINING_NOT_FOUND: 'Eğitim bulunamadı veya aktif değil.',
  PERSONNEL_DOCUMENT_NOT_FOUND: 'Belge bulunamadı veya bu personele ait değil.',
  VIDEO_TOO_LARGE: 'Video boyutu izin verilen sınırı aşıyor (en fazla 500 MB).',
  VIDEO_TYPE_UNSUPPORTED: 'Desteklenmeyen video türü. MP4, WebM veya MOV yükleyin.',

  // ---- Eğitim & Test (Training — §16 authoring) ----
  'trainings.nav': 'Eğitimler',
  'trainings.title': 'Eğitimler',
  'trainings.gate.loadingLabel': 'Eğitimler yükleniyor…',
  'trainings.forbidden.title': 'Erişim yok',
  'trainings.forbidden.body':
    'Bu bölümü görüntüleme yetkiniz yok. Erişim için yöneticinizle iletişime geçin.',
  'trainings.forbidden.back': 'Panele dön',
  'trainings.unavailable.title': 'Eğitimler yüklenemedi',
  'trainings.unavailable.body': 'Servise şu anda ulaşılamıyor. Lütfen birazdan tekrar deneyin.',
  'trainings.unavailable.retry': 'Tekrar dene',
  'trainings.common.actions': 'İşlemler',
  'trainings.common.loading': 'Yükleniyor…',
  'trainings.common.cancel': 'Vazgeç',
  'trainings.common.save': 'Kaydet',
  'trainings.common.create': 'Oluştur',
  'trainings.status.active': 'Aktif',
  'trainings.status.inactive': 'Pasif',
  'trainings.list.subtitle':
    'Personelin izlemesi ve testini geçmesi gereken eğitimleri hazırlayın.',
  'trainings.list.search': 'Eğitim ara',
  'trainings.list.searchPlaceholder': 'Başlığa göre ara…',
  'trainings.list.new': 'Yeni Eğitim',
  'trainings.list.filter.status': 'Durum',
  'trainings.list.filter.allStatuses': 'Tüm durumlar',
  'trainings.list.count': '{{count}} eğitim listeleniyor',
  'trainings.list.count_one': '{{count}} eğitim listeleniyor',
  'trainings.list.col.title': 'Başlık',
  'trainings.list.col.video': 'Video',
  'trainings.list.col.questions': 'Soru',
  'trainings.list.col.passThreshold': 'Geçme eşiği',
  'trainings.list.passThreshold.ratio': '{{correct}}/{{total}}',
  'trainings.list.passThreshold.correctOnly': '{{correct}} doğru',
  'trainings.list.passThreshold.warning.label': 'Geçme eşiği soru sayısıyla tutarsız',
  'trainings.list.passThreshold.warning.content':
    'Geçme eşiği (gereken doğru cevap sayısı) 1 ile soru sayısı arasında olmalıdır. Eğitimi düzenleyerek eşiği düzeltin.',
  'trainings.list.col.status': 'Durum',
  'trainings.list.col.created': 'Oluşturulma',
  'trainings.list.video.yes': 'Var',
  'trainings.list.video.no': 'Yok',
  'trainings.list.action.delete': 'Sil',
  'trainings.list.action.openMenu': '{{name}} için işlemler',
  'trainings.list.empty': 'Henüz eğitim tanımlanmamış.',
  'trainings.list.empty.body': 'İlk eğitimi oluşturduğunuzda burada listelenir.',
  'trainings.list.noResults': 'Filtrelerle eşleşen eğitim yok.',
  'trainings.pagination.nav': 'Sayfalama',
  'trainings.pagination.previous': 'Önceki',
  'trainings.pagination.next': 'Sonraki',
  'trainings.delete.title': 'Eğitimi sil',
  'trainings.delete.body': '"{{title}}" eğitimi silinsin mi? Bu işlem geri alınamaz.',
  'trainings.delete.confirm': 'Eğitimi sil',
  'trainings.editor.back': 'Eğitimlere dön',
  'trainings.editor.loading': 'Eğitim yükleniyor…',
  'trainings.editor.createTitle': 'Yeni Eğitim',
  'trainings.editor.editTitle': 'Eğitimi Düzenle',
  'trainings.editor.section.meta': 'Eğitim bilgileri',
  'trainings.editor.section.video': 'Eğitim videosu',
  'trainings.editor.field.title': 'Başlık',
  'trainings.editor.field.description': 'Açıklama',
  'trainings.editor.field.passThreshold': 'Geçme eşiği (doğru sayısı)',
  'trainings.editor.field.passThresholdHint': '1 ile soru sayısı arasında olmalı.',
  'trainings.editor.field.isActive': 'Aktif (personele atanabilir)',
  'trainings.editor.video.description':
    'İsteğe bağlı. Büyük dosyalar doğrudan güvenli depolamaya yüklenir.',
  'trainings.editor.video.placeholder': 'Video yüklemek için tıklayın',
  'trainings.editor.video.hint': 'MP4, WebM veya MOV — en fazla 500 MB',
  'trainings.editor.video.linked': 'Yüklü video',
  'trainings.editor.video.replace': 'Değiştir',
  'trainings.editor.video.remove': 'Kaldır',
  'trainings.editor.video.uploading': 'Video yükleniyor',
  'trainings.editor.video.progress': '%{{percent}} yüklendi',
  'trainings.editor.quiz.title': 'Test soruları',
  'trainings.editor.quiz.hint':
    'Her soru için doğru cevabı işaretleyin. Personel yalnız soruları görür; cevap anahtarı yalnız burada.',
  'trainings.editor.quiz.addQuestion': 'Soru ekle',
  'trainings.editor.quiz.empty': 'En az bir soru ekleyin.',
  'trainings.editor.quiz.questionText': 'Soru metni',
  'trainings.editor.quiz.removeQuestion': 'Soruyu kaldır',
  'trainings.editor.quiz.options': 'Seçenekler',
  'trainings.editor.quiz.correctHint': 'Doğru cevabı radyo ile seçin',
  'trainings.editor.quiz.markCorrect': '{{number}}. seçeneği doğru işaretle',
  'trainings.editor.quiz.optionPlaceholder': '{{number}}. seçenek',
  'trainings.editor.quiz.removeOption': 'Seçeneği kaldır',
  'trainings.editor.quiz.addOption': 'Seçenek ekle',
  'trainings.editor.quiz.correctAnswerNote': 'Doğru cevap: {{number}}. seçenek',
  'trainings.editor.validation.titleRequired': 'Başlık zorunludur.',
  'trainings.editor.validation.passThresholdRange':
    'Geçme eşiği 1 ile soru sayısı arasında olmalıdır.',
  'trainings.editor.validation.questionRequired': 'Soru metni zorunludur.',
  'trainings.editor.validation.optionRequired': 'Seçenek boş olamaz.',
  'trainings.editor.validation.optionsRange': 'Her soruda 2 ile 5 arası seçenek olmalıdır.',
  'trainings.editor.validation.correctRequired': 'Doğru cevabı seçin.',
  'trainings.editor.validation.correctRange': 'Doğru cevap seçenekler arasından olmalıdır.',
  'trainings.editor.validation.atLeastOneQuestion': 'En az bir soru ekleyin.',

  // ---- Personel Belgeleri (§15 yol A — KVKK) ----
  'contractors.personnelDocs.loading': 'Belgeler yükleniyor…',
  'contractors.personnelDocs.notFound': 'Personel bulunamadı.',
  'contractors.personnelDocs.kvkk':
    'Hassas kişisel veri. Belgelere yalnız yetkili İSG uzmanı erişebilir; indirme bağlantıları kısa ömürlüdür.',
  'contractors.personnelDocs.empty': 'Bu personel için henüz belge yüklenmemiş.',
  'contractors.personnelDocs.add.new': 'Belge Yükle',
  'contractors.personnelDocs.add.title': 'Personel Belgesi Ekle',
  'contractors.personnelDocs.add.description':
    'Dosyayı yükleyin ve belge türü ile geçerlilik bilgisini girin.',
  'contractors.personnelDocs.add.submit': 'Ekle',
  'contractors.personnelDocs.add.uploading': 'Yükleniyor…',
  'contractors.personnelDocs.add.progress': '%{{percent}} yüklendi',
  'contractors.personnelDocs.field.file': 'Dosya',
  'contractors.personnelDocs.field.filePlaceholder': 'Dosya seçin',
  'contractors.personnelDocs.field.fileHint': 'PDF veya görsel — en fazla 20 MB',
  'contractors.personnelDocs.field.type': 'Belge türü',
  'contractors.personnelDocs.field.validFrom': 'Geçerlilik başlangıcı',
  'contractors.personnelDocs.field.validUntil': 'Geçerlilik bitişi',
  'contractors.personnelDocs.field.note': 'Not',
  'contractors.personnelDocs.delete.title': 'Belgeyi sil',
  'contractors.personnelDocs.delete.body': '"{{type}}" belgesi silinsin mi?',
  'contractors.personnelDocs.delete.confirm': 'Belgeyi sil',

  // ---- Risk Değerlendirme (Risk — §19) ----
  RISK_ASSESSMENT_NOT_FOUND: 'Risk değerlendirmesi bulunamadı.',
  RISK_ITEM_NOT_FOUND: 'Tehlike kalemi bulunamadı veya bu değerlendirmeye ait değil.',
  RISK_ACTION_NOT_FOUND: 'DÖF bulunamadı veya bu kaleme ait değil.',
  RISK_ASSESSMENT_NOT_EDITABLE:
    'Bu değerlendirme yalnız Taslak, Gönderildi, Gözden Geçiriliyor veya Revize Edildi durumundayken düzenlenebilir.',
  RISK_ASSESSMENT_INVALID_STATE: 'Değerlendirme bu işlem için uygun durumda değil.',
  USER_NOT_FOUND: 'Seçilen sorumlu firmanın bir kullanıcısı değil.',

  'risk.nav': 'Risk Değerlendirme',
  'risk.title': 'Risk Değerlendirme',
  'risk.common.actions': 'İşlemler',
  'risk.common.loading': 'Yükleniyor...',
  'risk.common.close': 'Kapat',
  'risk.common.cancel': 'Vazgeç',
  'risk.common.save': 'Kaydet',
  'risk.common.create': 'Oluştur',
  'risk.common.add': 'Ekle',
  'risk.gate.loadingLabel': 'Risk Değerlendirme erişimi denetleniyor...',
  'risk.forbidden.title': 'Erişim yetkiniz yok',
  'risk.forbidden.body':
    'Risk Değerlendirme modülüne erişim yetkiniz bulunmuyor. Lütfen firma yöneticinizle iletişime geçin.',
  'risk.forbidden.back': 'Panele dön',
  'risk.unavailable.title': 'Risk Değerlendirme yüklenemedi',
  'risk.unavailable.body': 'Servise şu anda ulaşılamıyor. Lütfen daha sonra tekrar deneyin.',
  'risk.unavailable.retry': 'Tekrar dene',
  'risk.list.subtitle':
    'Sahalarınız için tehlikeleri değerlendirin, önlem ve DÖF atayın, artık riski izleyin.',
  'risk.list.search': 'Değerlendirme ara',
  'risk.list.searchPlaceholder': 'Başlığa göre ara',
  'risk.list.new': 'Yeni Değerlendirme',
  'risk.list.count': '{{count}} değerlendirme listeleniyor',
  'risk.list.count_one': '{{count}} değerlendirme listeleniyor',
  'risk.list.empty': 'Henüz risk değerlendirmesi yok.',
  'risk.list.empty.body': 'İlk değerlendirmeyi oluşturduğunuzda burada listelenir.',
  'risk.list.noResults': 'Filtrelerle eşleşen risk değerlendirmesi yok.',
  'risk.list.col.title': 'Başlık',
  'risk.list.col.site': 'Saha',
  'risk.list.col.date': 'Değerlendirme tarihi',
  'risk.list.col.status': 'Durum',
  'risk.list.col.revision': 'Revizyon',
  'risk.list.col.items': 'Kalem',
  'risk.list.col.highestLevel': 'En yüksek seviye',
  'risk.list.filter.status': 'Durum',
  'risk.list.filter.site': 'Saha',
  'risk.list.filter.level': 'Seviye',
  'risk.list.filter.from': 'Başlangıç (en erken)',
  'risk.list.filter.to': 'Bitiş (en geç)',
  'risk.list.filter.allStatuses': 'Tüm durumlar',
  'risk.list.filter.allSites': 'Tüm sahalar',
  'risk.list.filter.allLevels': 'Tüm seviyeler',
  'risk.pagination.nav': 'Sayfalama',
  'risk.pagination.previous': 'Önceki',
  'risk.pagination.next': 'Sonraki',
  'risk.status.Draft': 'Taslak',
  'risk.status.Submitted': 'Gönderildi',
  'risk.status.Approved': 'Onaylandı',
  'risk.status.Active': 'Yürürlükte',
  'risk.status.UnderReview': 'Gözden Geçiriliyor',
  'risk.status.Revised': 'Revize Edildi',
  'risk.status.Archived': 'Arşivlendi',
  'risk.level.Onemsiz': 'Önemsiz',
  'risk.level.Dusuk': 'Düşük',
  'risk.level.Orta': 'Orta',
  'risk.level.Yuksek': 'Yüksek',
  'risk.level.KabulEdilemez': 'Kabul Edilemez',
  'risk.methodology.LType5x5': '5x5 L-Tipi Matris',
  'risk.action.status.Open': 'Açık',
  'risk.action.status.InProgress': 'Devam Ediyor',
  'risk.action.status.Done': 'Tamamlandı',
  'risk.action.status.Cancelled': 'İptal Edildi',
  'risk.matrix.severity': 'Şiddet',
  'risk.matrix.probability': 'Olasılık',
  'risk.matrix.gridLabel': 'Olasılık × Şiddet matrisi',
  'risk.matrix.cellLabel':
    'Olasılık {{probability}}, Şiddet {{severity}} — skor {{score}}, {{level}}',
  'risk.matrix.previewLabel': 'Seçilen risk:',
  'risk.matrix.previewEmpty': 'Skoru görmek için matristen bir hücre seçin.',
  'risk.editor.createTitle': 'Yeni Risk Değerlendirmesi',
  'risk.editor.section.meta': 'Değerlendirme bilgileri',
  'risk.editor.section.items': 'Tehlike kalemleri',
  'risk.editor.field.title': 'Başlık',
  'risk.editor.field.site': 'Saha',
  'risk.editor.field.area': 'Alan / faaliyet',
  'risk.editor.field.assessmentDate': 'Değerlendirme tarihi',
  'risk.editor.field.nextReviewDate': 'Sonraki gözden geçirme',
  'risk.editor.field.nextReviewDateHint': 'Değerlendirmenin geçerlilik tarihi (opsiyonel).',
  'risk.editor.field.notes': 'Notlar',
  'risk.editor.sitePlaceholder': 'Saha seçin',
  'risk.editor.items.add': 'Tehlike ekle',
  'risk.editor.items.hint':
    'Her tehlike için Olasılık ve Şiddet seçin; skor ve seviye sunucuda hesaplanır. DÖF, değerlendirme oluşturulduktan sonra kalem üzerinden eklenir.',
  'risk.editor.items.empty':
    'Kalem eklemeden de değerlendirme oluşturabilir, tehlikeleri sonra ekleyebilirsiniz.',
  'risk.editor.items.remove': 'Kalemi kaldır',
  'risk.editor.validation.titleRequired': 'Başlık gerekli.',
  'risk.editor.validation.siteRequired': 'Lütfen bir saha seçin.',
  'risk.editor.validation.assessmentDateRequired': 'Değerlendirme tarihi gerekli.',
  'risk.editor.validation.hazardRequired': 'Tehlike tanımı gerekli.',
  'risk.editor.validation.scoreRequired': 'Lütfen matristen Olasılık ve Şiddet seçin.',
  'risk.editor.validation.residualIncomplete':
    'Artık risk için Olasılık ve Şiddet birlikte seçilmeli veya ikisi de boş bırakılmalı.',
  'risk.form.edit.title': 'Değerlendirmeyi Düzenle',
  'risk.form.description':
    'Değerlendirme bilgilerini güncelleyin. Tehlike kalemleri detay ekranından yönetilir.',
  'risk.item.field.hazard': 'Tehlike',
  'risk.item.field.risk': 'Olası sonuç / risk',
  'risk.item.field.affectedPersons': 'Etkilenen kişiler',
  'risk.item.field.existingControls': 'Mevcut önlemler',
  'risk.item.field.recommendedControls': 'Alınacak önlemler',
  'risk.item.score.title': 'Risk (Olasılık × Şiddet)',
  'risk.item.residual.title': 'Artık risk (önlem sonrası)',
  'risk.item.residual.hint':
    'Önlem sonrası beklenen Olasılık ve Şiddet. Opsiyonel — ikisi birlikte doldurulur.',
  'risk.item.residual.clear': 'Temizle',
  'risk.item.add.title': 'Tehlike Kalemi Ekle',
  'risk.item.edit.title': 'Tehlike Kalemini Düzenle',
  'risk.item.form.description':
    'Tehlikeyi tanımlayın ve Olasılık × Şiddet ile skorlayın. Skor ve seviye sunucuda hesaplanır.',
  'risk.item.scoreDisplay': 'Olasılık {{probability}} × Şiddet {{severity}}',
  'risk.item.residualLabel': 'Artık:',
  'risk.action.add.title': 'DÖF Ekle',
  'risk.action.edit.title': 'DÖF Düzenle',
  'risk.action.form.description':
    'Düzeltici/önleyici faaliyeti tanımlayın, sorumlu ve termin atayın.',
  'risk.action.field.description': 'Açıklama',
  'risk.action.field.responsible': 'Sorumlu',
  'risk.action.field.dueDate': 'Termin',
  'risk.action.field.status': 'Durum',
  'risk.action.field.note': 'Not',
  'risk.action.responsibleNone': 'Sorumlu yok',
  'risk.action.validation.descriptionRequired': 'Açıklama gerekli.',
  'risk.lifecycle.submit': 'Gönder',
  'risk.lifecycle.approve': 'Onayla',
  'risk.lifecycle.review': 'Gözden Geçir',
  'risk.lifecycle.revise': 'Revize Et',
  'risk.lifecycle.archive': 'Arşivle',
  'risk.lifecycle.submit.title': 'Değerlendirmeyi gönder',
  'risk.lifecycle.submit.body': 'Değerlendirme onaya gönderilecek. Devam edilsin mi?',
  'risk.lifecycle.submit.confirm': 'Gönder',
  'risk.lifecycle.approve.title': 'Değerlendirmeyi onayla',
  'risk.lifecycle.approve.body': 'Onaylandığında değerlendirme yürürlüğe girer.',
  'risk.lifecycle.approve.confirm': 'Onayla',
  'risk.lifecycle.review.title': 'Gözden geçirmeye al',
  'risk.lifecycle.review.body': 'Değerlendirme gözden geçirmeye alınacak. Devam edilsin mi?',
  'risk.lifecycle.review.confirm': 'Gözden Geçir',
  'risk.lifecycle.revise.title': 'Revize et',
  'risk.lifecycle.revise.body':
    'Değerlendirme revizyona açılacak ve revizyon numarası artacak. Devam edilsin mi?',
  'risk.lifecycle.revise.confirm': 'Revize Et',
  'risk.lifecycle.archive.title': 'Değerlendirmeyi arşivle',
  'risk.lifecycle.archive.body':
    'Değerlendirme kalıcı olarak arşivlenecek. Bu işlem geri alınamaz. Devam edilsin mi?',
  'risk.lifecycle.archive.confirm': 'Arşivle',
  'risk.detail.back': 'Risk Değerlendirmelerine dön',
  'risk.detail.loading': 'Değerlendirme yükleniyor...',
  'risk.detail.edit': 'Bilgileri düzenle',
  'risk.detail.readOnlyNote': 'Bu değerlendirme artık düzenlenemez ({{status}}).',
  'risk.detail.revision': 'Revizyon {{revision}}',
  'risk.detail.field.site': 'Saha',
  'risk.detail.field.area': 'Alan / faaliyet',
  'risk.detail.field.assessmentDate': 'Değerlendirme tarihi',
  'risk.detail.field.nextReviewDate': 'Sonraki gözden geçirme',
  'risk.detail.field.methodology': 'Metodoloji',
  'risk.detail.field.revision': 'Revizyon no',
  'risk.detail.field.assessedBy': 'Değerlendiren',
  'risk.detail.field.approvedBy': 'Onaylayan',
  'risk.detail.field.approvedAt': 'Onay tarihi',
  'risk.detail.items.title': 'Tehlike Kalemleri',
  'risk.detail.items.add': 'Kalem Ekle',
  'risk.detail.items.edit': 'Kalemi düzenle',
  'risk.detail.items.remove': 'Kalemi kaldır',
  'risk.detail.items.empty': 'Bu değerlendirmede henüz tehlike kalemi yok.',
  'risk.detail.items.delete.title': 'Kalemi kaldır',
  'risk.detail.items.delete.body':
    '"{{hazard}}" tehlike kalemi kaldırılsın mı? Bağlı DÖF kayıtları da kaldırılır.',
  'risk.detail.items.delete.confirm': 'Kaldır',
  'risk.detail.action.title': 'DÖF (Düzeltici/Önleyici Faaliyet)',
  'risk.detail.action.add': 'DÖF Ekle',
  'risk.detail.action.edit': 'DÖF düzenle',
  'risk.detail.action.remove': 'DÖF kaldır',
  'risk.detail.action.empty': 'Bu kalem için DÖF tanımlanmamış.',
  'risk.detail.action.overdue': 'Gecikmiş',
  'risk.detail.action.delete.title': 'DÖF kaldır',
  'risk.detail.action.delete.body': '"{{description}}" DÖF kaydı kaldırılsın mı?',
  'risk.detail.action.delete.confirm': 'Kaldır',

  // ---- Kullanıcı yönetimi (Users — §12, tenant-scoped) ----
  'users.nav': 'Kullanıcılar',
  'users.title': 'Kullanıcılar',
  'users.subtitle': 'Firmanızın kullanıcılarını ekleyin, düzenleyin ve rollerini yönetin.',
  'users.count': '{{count}} kullanıcı listeleniyor',
  'users.count_one': '{{count}} kullanıcı listeleniyor',
  'users.searchPlaceholder': 'Ad, soyad veya e-posta ile ara',
  'users.new': 'Kullanıcı Ekle',
  'users.col.name': 'Ad Soyad',
  'users.col.email': 'E-posta',
  'users.col.role': 'Rol',
  'users.col.status': 'Durum',
  'users.status.active': 'Aktif',
  'users.status.passive': 'Pasif',
  'users.action.delete': 'Sil',
  'users.action.openMenu': '{{name}} için işlemler',
  'users.created': 'Kullanıcı oluşturuldu.',
  'users.updated': 'Kullanıcı güncellendi.',
  'users.deleted': 'Kullanıcı pasifleştirildi.',
  'users.common.search': 'Kullanıcı ara',
  'users.common.actions': 'İşlemler',
  'users.common.loading': 'Kullanıcılar yükleniyor...',
  'users.common.empty': 'Henüz kullanıcı yok.',
  'users.common.empty.body': 'İlk kullanıcıyı eklediğinizde burada listelenir.',
  'users.list.noResults': 'Aramanızla eşleşen kullanıcı yok.',
  'users.common.close': 'Kapat',
  'users.common.cancel': 'Vazgeç',
  'users.common.save': 'Kaydet',
  'users.common.create': 'Oluştur',
  'users.pagination.nav': 'Sayfalama',
  'users.pagination.previous': 'Önceki',
  'users.pagination.next': 'Sonraki',
  'users.gate.loadingLabel': 'Kullanıcılar yükleniyor...',
  'users.forbidden.title': 'Erişim yok',
  'users.forbidden.body': 'Kullanıcı yönetimi için yetkiniz bulunmuyor.',
  'users.forbidden.back': 'Panele dön',
  'users.unavailable.title': 'Kullanıcılar açılamadı',
  'users.unavailable.body':
    'Servise şu an ulaşılamıyor. Lütfen kısa bir süre sonra tekrar deneyin.',
  'users.unavailable.retry': 'Tekrar dene',
  'users.create.title': 'Kullanıcı ekle',
  'users.create.description': 'Ad, e-posta, parola ve rol bilgilerini girin.',
  'users.edit.title': 'Kullanıcıyı düzenle',
  'users.edit.description': 'Kullanıcı bilgilerini ve rollerini güncelleyin.',
  'users.edit.loading': 'Kullanıcı bilgileri yükleniyor...',
  'users.field.firstName': 'Ad',
  'users.field.lastName': 'Soyad',
  'users.field.email': 'E-posta',
  'users.field.password': 'Parola',
  'users.field.passwordShow': 'Parolayı göster',
  'users.field.passwordHide': 'Parolayı gizle',
  'users.field.status': 'Durum',
  'users.field.isActive': 'Aktif',
  'users.field.selfActiveHint': 'Kendi hesabınızı pasifleştiremezsiniz.',
  'users.field.roles': 'Roller',
  'users.roles.loading': 'Roller yükleniyor...',
  'users.roles.empty': 'Atanabilir rol bulunmuyor.',
  'users.validation.firstNameRequired': 'Ad zorunludur.',
  'users.validation.lastNameRequired': 'Soyad zorunludur.',
  'users.validation.emailRequired': 'E-posta zorunludur.',
  'users.validation.emailInvalid': 'Geçerli bir e-posta girin.',
  'users.validation.passwordPolicy': 'Parola en az 8 karakter, bir harf ve bir rakam içermeli.',
  'users.validation.rolesRequired': 'En az bir rol seçin.',
  'users.delete.title': 'Kullanıcıyı pasifleştir',
  'users.delete.body':
    '"{{name}}" kullanıcısı pasifleştirilsin mi? Kullanıcı giriş yapamaz; kaydı korunur.',
  'users.delete.confirm': 'Pasifleştir',
  // Kullanıcı yönetimi hata kodları (§12 guard'ları)
  CANNOT_DEACTIVATE_SELF: 'Kendi hesabınızı pasifleştiremezsiniz.',
  CANNOT_DELETE_SELF: 'Kendi hesabınızı silemezsiniz.',
  ROLE_NOT_ASSIGNABLE:
    'Seçilen rol bu kullanıcıya atanamaz. Lütfen listeyi yenileyip tekrar deneyin.',

  // ---- Belge Şemaları (GL #7 — platform belge türü kaydının yönetimi) ----------------------
  'documentSchemas.nav': 'Belge Şemaları',
  'documentSchemas.title': 'Belge Şemaları',
  'documentSchemas.tab.types': 'Türler',
  'documentSchemas.common.search': 'Ara',
  'documentSchemas.gate.loadingLabel': 'Belge şemaları yükleniyor…',
  'documentSchemas.forbidden.title': 'Bu bölüme erişiminiz yok',
  'documentSchemas.forbidden.body': 'Belge Şeması Yönetimi için gerekli yetkiye sahip değilsiniz.',
  'documentSchemas.forbidden.back': 'Panele dön',
  'documentSchemas.unavailable.title': 'Şu anda ulaşılamıyor',
  'documentSchemas.unavailable.body':
    'Belge şemaları şu anda yüklenemedi. Lütfen daha sonra tekrar deneyin.',
  'documentSchemas.unavailable.retry': 'Tekrar dene',
  'documentSchemas.types.subtitle':
    'Belge türleri tüm firmalarda ortaktır. AI tanıma bu ekrandan değiştirilmez.',
  'documentSchemas.types.count': '{{count}} belge türü listeleniyor',
  'documentSchemas.types.count_one': '{{count}} belge türü listeleniyor',
  'documentSchemas.types.searchPlaceholder': 'Tür ara…',
  'documentSchemas.types.pagination.nav': 'Sayfalama',
  'documentSchemas.types.pagination.previous': 'Önceki',
  'documentSchemas.types.pagination.next': 'Sonraki',
  'documentSchemas.types.new': 'Yeni belge türü',
  'documentSchemas.types.created': 'Belge türü oluşturuldu.',
  'documentSchemas.types.updated': 'Belge türü güncellendi.',
  'documentSchemas.types.aiUnknown':
    'AI tanıma durumu şu anda alınamadı; diğer bilgiler günceldir.',
  'documentSchemas.types.filter.entity': 'Belge grubu',
  'documentSchemas.types.filter.allEntities': 'Tüm belge grupları',
  'documentSchemas.types.filter.status': 'Durum',
  'documentSchemas.types.filter.allStatuses': 'Tüm durumlar',
  'documentSchemas.types.col.label': 'Etiket',
  'documentSchemas.types.col.entity': 'Grup',
  'documentSchemas.types.col.sortOrder': 'Sıra',
  'documentSchemas.types.col.expiryRule': 'Geçerlilik kuralı',
  'documentSchemas.types.col.captureFormat': 'Çekim',
  'documentSchemas.types.col.ai': 'AI tanıma',
  'documentSchemas.types.col.status': 'Durum',
  'documentSchemas.type.status.active': 'Aktif',
  'documentSchemas.type.status.inactive': 'Pasif',
  'documentSchemas.types.empty': 'Henüz belge türü yok.',
  'documentSchemas.types.noResults': 'Eşleşen belge türü yok.',
  // Belge sahibi (contract `entity`, küçük harf) — Onay Yönlendirme listesi/formu da bu sözcükleri okur
  // ("Personel belgesi · X"); "Varlık" kullanılmaz.
  'documentSchemas.entity.personnel': 'Personel belgesi',
  'documentSchemas.entity.vehicle': 'Araç belgesi',
  'documentSchemas.entity.company': 'Firma belgesi',
  // Geçerlilik kuralı (contract `expiryRule`). `documents.expiryHint.*`: kurala göre ipucu — yönetici formu VE
  // yükleme formları aynı anahtarları okur (Task 3a yenisini eklemez).
  'documentSchemas.expiryRule.EndDateRequired': 'Bitiş tarihi zorunlu',
  'documentSchemas.expiryRule.EndDateOptional': 'Bitiş tarihi isteğe bağlı',
  'documentSchemas.expiryRule.NoExpiry': 'Süresiz',
  'documents.expiryHint.EndDateRequired':
    'Bitiş tarihi zorunludur; tarih geçince belge geçersiz sayılır.',
  'documents.expiryHint.EndDateOptional':
    'Bitiş tarihi isteğe bağlıdır; girilirse süresi takip edilir.',
  'documents.expiryHint.NoExpiry': 'Bu belge türünde bitiş tarihi takip edilmez.',
  // Çekim biçimi (contract `captureFormat`): liste kısa adı + form seçeneği.
  'documentSchemas.captureFormat.Card': 'Kart',
  'documentSchemas.captureFormat.Page': 'Sayfa',
  'documentSchemas.captureFormat.option.Card': 'Kart (ön ve arka yüz)',
  'documentSchemas.captureFormat.option.Page': 'Sayfa (A4)',
  'documentSchemas.ai.manualOnly': 'Yalnız elle',
  'documentSchemas.ai.unknownSr': 'AI tanıma durumu alınamadı',
  // Yapay zekâ tanıma işareti (`RecognitionMark`: Belge Şemaları + uzmanın personel belge satırları).
  'documents.recognition.set': 'AI v{{n}}',
  'documents.recognition.none': 'AI tanıması yok',
  'documents.recognition.srSet': 'Yapay zekâ bu dosyayı bu türde tanıdı (tanıma sürümü {{n}})',
  // Belge türü seçici (§27 kaydı; firma/personel/araç ekleme modalları) + bitiş tarihi kuralı (GL #7).
  'documentTypes.placeholder': 'Belge türü seçin',
  'documentTypes.loading': 'Yükleniyor…',
  'documentTypes.loadError': 'Belge türleri yüklenemedi.',
  'documentTypes.retry': 'Tekrar dene',
  'documentTypes.empty':
    "Seçilebilecek aktif belge türü yok. Belge türleri Belge Şemaları'nda yönetilir.",
  'documentTypes.required': 'Belge türü seçimi zorunludur.',
  'documentTypes.typeRejected':
    'Bu belge türü artık kullanılamıyor. Tür listesi yenilendi; lütfen yeniden seçin.',
  'documents.field.validUntilRequired': 'Bu belge türünde bitiş tarihi zorunludur.',
  'documentSchemas.form.create.title': 'Yeni belge türü',
  'documentSchemas.form.edit.title': 'Belge türünü düzenle',
  'documentSchemas.form.create': 'Oluştur',
  'documentSchemas.form.save': 'Kaydet',
  'documentSchemas.form.selectPlaceholder': 'Seçin',
  'documentSchemas.form.field.entity': 'Belge grubu',
  'documentSchemas.form.field.code': 'Kod',
  'documentSchemas.form.codeHint':
    'Büyük harfle başlar; Türkçe karakter (ç, ğ, ı, ö, ş, ü) ve boşluk içermez. Sonradan değiştirilemez.',
  'documentSchemas.form.section.labels': 'Etiket',
  'documentSchemas.form.field.labelTr': 'Türkçe',
  'documentSchemas.form.field.labelEn': 'English',
  'documentSchemas.form.field.labelDe': 'Deutsch',
  'documentSchemas.form.section.rules': 'Kurallar',
  'documentSchemas.form.field.expiryRule': 'Geçerlilik kuralı',
  'documentSchemas.form.field.captureFormat': 'Çekim biçimi',
  'documentSchemas.form.captureFormatHint':
    'Yalnız mobil uygulamadaki kamera çerçevesini belirler.',
  'documentSchemas.form.field.sortOrder': 'Sıra',
  'documentSchemas.form.sortOrderHint': 'Boş bırakılırsa bu grubun sonuna eklenir.',
  'documentSchemas.form.field.isActive': 'Aktif',
  'documentSchemas.form.isActiveHint':
    'Pasif bir tür yüklemede seçilemez; bu türü isteyen izinler hazır olamaz.',
  'documentSchemas.form.validation.entityRequired': 'Belge grubunu seçin.',
  'documentSchemas.form.validation.codeRequired': 'Kod zorunludur.',
  'documentSchemas.form.validation.codeInvalid':
    'Kod büyük harfle başlamalı; yalnız İngilizce harf ve rakam içerebilir (2-40 karakter).',
  'documentSchemas.form.validation.codeReserved': '"Other" kodu ayrılmıştır; başka bir kod girin.',
  'documentSchemas.form.validation.labelRequired': 'Etiket zorunludur.',
  'documentSchemas.form.validation.labelInvalid':
    'Etiket en fazla {{max}} karakter olabilir; kontrol karakteri ve görünmeyen karakter içeremez. Metni elle yeniden yazın.',
  'documentSchemas.form.validation.ruleRequired': 'Geçerlilik kuralını seçin.',
  'documentSchemas.form.validation.formatRequired': 'Çekim biçimini seçin.',
  'documentSchemas.form.validation.sortOrderRequired': 'Sıra zorunludur.',
  'documentSchemas.form.validation.sortOrderInvalid':
    'Sıra 0 veya daha büyük bir tam sayı olmalıdır.',
  // Onaylar (D1/D2): kapsam "tüm firmalarda"; kural değişikliği yönüne göre.
  'documentSchemas.confirm.deactivate.title': 'Belge türünü pasifleştir',
  'documentSchemas.confirm.deactivate.confirm': 'Pasifleştir',
  'documentSchemas.confirm.deactivate.lead':
    '"{{label}}" ({{entity}}) tüm firmalarda pasifleşecek.',
  'documentSchemas.confirm.deactivate.permits':
    'Bu türü isteyen izinler, tür yeniden aktif edilene ya da gereksinim kaldırılana kadar hazır olamaz.',
  'documentSchemas.confirm.deactivate.documents': 'Pasifleştirme mevcut belgeleri değiştirmez.',
  'documentSchemas.confirm.rule.title': 'Geçerlilik kuralını değiştir',
  'documentSchemas.confirm.rule.confirm': 'Kuralı değiştir',
  'documentSchemas.confirm.rule.lead':
    '"{{label}}" ({{entity}}) için geçerlilik kuralı tüm firmalarda değişecek: {{from}} → {{to}}.',
  'documentSchemas.confirm.rule.retroactive':
    'Yeni kural tüm firmalardaki mevcut belgelere geriye dönük uygulanır.',
  'documentSchemas.confirm.rule.toRequired':
    'Bitiş tarihi olmayan mevcut belgeler Eksik sayılır; bu türü isteyen izinler tüm firmalarda engellenir.',
  'documentSchemas.confirm.both.title': 'Bu değişiklik izinleri ve belgeleri etkiler',
  'documentSchemas.confirm.both.confirm': 'Kaydet ve uygula',
  'documentSchemas.confirm.both.lead':
    '"{{label}}" ({{entity}}) tüm firmalarda pasifleşecek ve geçerlilik kuralı değişecek: {{from}} → {{to}}.',
  // Belge türü yönetimi hata kodları (contract §4.6) — backend dil paketi üzerine yazar.
  DOCUMENT_TYPE_CODE_EXISTS:
    'Bu kod bu belge grubunda zaten kullanılıyor (pasif türler dâhil; büyük/küçük harf ayrımı yapılmaz). Başka bir kod girin.',
  DOCUMENT_TYPE_NOT_FOUND: 'Belge türü bulunamadı. Liste yenilendi.',

  // ---- Saha Girişi / Güvenlik masası (§29, S32) ----
  'security.nav': 'Saha Girişi',
  'security.subtitle':
    'Sahaya girişi kapı kodu, personel QR kodu ya da T.C. kimlik no ile kontrol edin.',
  'security.gate.loadingLabel': 'Saha Girişi erişimi denetleniyor...',
  'security.forbidden.title': 'Saha Girişine erişim yetkiniz yok',
  'security.forbidden.body':
    'Saha Girişi modülüne erişim yetkiniz bulunmuyor. Lütfen firma yöneticinizle görüşün.',
  'security.forbidden.back': 'Panele dön',
  'security.unavailable.title': 'Saha Girişine ulaşılamadı',
  'security.unavailable.body': 'Servise şu anda ulaşılamıyor. Lütfen daha sonra tekrar deneyin.',
  'security.unavailable.retry': 'Tekrar dene',
  'security.common.loading': 'Yükleniyor...',
  'security.context.siteSelect': 'Saha seç',
  'security.context.sitePlaceholder': 'Saha seçin',
  'security.context.offline': 'Bağlantı yok — sorgular ve güncellemeler başarısız olabilir',
  'security.context.offlineGateStale':
    'Bağlantı yok — kapı kodu artık yenilenmiyor, ekrandaki kod eskimiş olabilir',
  'security.context.fullScreen': 'Tam ekran',
  'security.context.exitFullScreen': 'Tam ekrandan çık',
  'security.noSites.body': 'Bu firmada saha tanımlı değil. Sahaları İSG uzmanı/yetkili tanımlar.',
  'security.noSiteSelected.body': 'Önce bir saha seçin.',
  'security.tab.gate': 'Kapı kodu',
  'security.tab.tc': 'TC ile sorgu',
  'security.panel.decision.title': 'Karar',
  'security.panel.entry.title': 'Giriş',
  'security.panel.today.title': 'Bugün',
  'security.giris.tab.ariaLabel': 'Giriş yöntemi',
  'security.giris.tab.qr.short': 'QR',
  'security.giris.tab.tc.short': 'T.C. Kimlik',
  'security.giris.codeActiveSr': 'kod açık',
  'security.giris.codeStillLive': 'Kapı kodu hâlâ açık; okutmalar arka planda kaydediliyor.',
  'security.gate.intro.title': 'Kapı kodunu göster',
  'security.gate.intro.body':
    'Ekranda 120 saniyelik bir kod belirir; personel bunu kendi telefonuyla okutur. Kod kendiliğinden yenilenir.',
  'security.gate.show': 'Kapı kodu göster',
  'security.gate.stop': 'Kodu durdur',
  'security.gate.issuing': 'Kod üretiliyor...',
  'security.gate.workerInstruction': 'Telefonunuzdaki uygulamadan bu kodu okutun.',
  'security.gate.rotatesIn': '{{seconds}} sn sonra yenilenir',
  'security.gate.qrRenderError': 'Kod oluşturulamadı.',
  'security.gate.qrAriaLabel': 'Kapı kodu (QR)',
  'security.gate.forbidden.title': 'Kapı kodu yetkisi verilmemiş',
  'security.gate.forbidden.body':
    "Kapı kodu yetkisi verilmemiş. Firma yöneticisi yetki matrisinden 'security: gate-result' iznini vermeli.",
  'security.gate.issueError.body': 'Kod üretilemedi. Bağlantınızı kontrol edip tekrar deneyin.',
  'security.gate.retry': 'Tekrar dene',
  'security.gate.expired.title': 'Kod süresi doldu',
  'security.gate.expired.body': 'Bu kodun süresi doldu. Yeni bir kod üretin.',
  'security.gate.newCode': 'Yeni kod üret',
  // S32d (owner talebi) — bir karar sahnedeyken kapı QR'ı gizlenir, `GateStage.tsx` dosya başı
  // notu (tam gerekçe + sahibe bayraklanmış gerilim orada).
  'security.gate.hidden.title': 'Kod gizlendi',
  'security.gate.hidden.body': 'Ekranda bir karar var; kod, kapatana kadar gizli kalır.',
  'security.verdict.allowed': 'GİRİŞ SERBEST',
  'security.verdict.denied': 'GİRİŞ YOK',
  'security.verdict.notFound': 'KAYIT BULUNAMADI',
  'security.verdict.networkError': 'KARAR ALINAMADI',
  'security.verdict.decidedAt': "{{time}}'de karar verildi",
  // S32d — ARTIK ayrı bir yaş şeridinin (`VerdictAgeLine`) metni DEĞİL, zaman yuvasına eklenen
  // KISA bir sonek (`VerdictAgeSuffix`, `VerdictCard.tsx`) — "17:36'de karar verildi · 3 dk önce".
  'security.verdict.decidedAgo': '{{minutes}} dk önce',
  'security.verdict.idle.title': 'Henüz karar yok',
  'security.verdict.idle.body':
    'Kapı kodu okutulduğunda ya da T.C. ile sorgu yapıldığında karar burada görünür.',
  'security.verdict.permit.entryPermitted': 'giriş izni var',
  'security.verdict.permit.entryNotPermitted': 'giriş izni yok',
  // S32f (§16/§21.3) — pencere dışı bir izin NÖTR bir tarih sözcüğü taşır, KIRMIZI/YEŞİL DEĞİL
  // (kırmızı zaten "giriş izni yok"un anlamı; ikinci bir anlam guard'ı yanlış telefon
  // görüşmesine yollar). Tarih BİLEREK yok — bkz. `security.verdict.permits.count.future` notu.
  'security.verdict.permit.future': 'ileri tarihli',
  'security.verdict.permit.expired': 'süresi geçmiş',
  // S32f [taste, yalnız modal] — pencere dışı bir satırda rozet PENCEREYİ söylediğinden hibe
  // olgusu alt satıra GEÇMİŞ ZAMANLA taşınır ("verilmiş" bir OLGU, "var" bir ŞİMDİ iddiasıdır —
  // §16 tense notu; kartta YOK, kartın tek satırında pencere yeterlidir).
  'security.verdict.permit.grantedPast': 'giriş izni verilmiş',
  'security.verdict.permit.notGrantedPast': 'giriş izni verilmemiş',
  // S32d — karar kartının kanıt şeridi (eyebrow satırı + kırpma bilgisi).
  'security.verdict.permits.eyebrow': 'İZİNLER ({{count}})',
  // S32e §2 Option A — S32f'de kart üzerinde ARTIK render EDİLMİYOR (tavan kalktı, §19), ama
  // backend dil paketi eşleşen anahtarları ÜZERİNE YAZAR (bkz. dosya başı repo notu) — burada
  // KALIYOR, silinmesi eski metni her yeşil kapıda YENİDEN göndermez.
  'security.verdict.permits.more': '+{{count}} izin daha',
  'security.verdict.permits.moreBlocked':
    '+{{count}} izin daha · {{blocked}} izinde giriş izni yok',
  // S32f §19 — pinned satır: pencere-dışı kırılımı (TÜM liste üzerinden, yalnız uygulanan
  // parçalar) + kaydırma varsa görünen bir işaret. Sayı yerine YALNIZ varlık — "kaç satır
  // kayıtlı" bir piksel ölçümü, ilk çizimde YANLIŞ olurdu.
  'security.verdict.permits.count.future': '{{count}} ileri tarihli',
  'security.verdict.permits.count.expired': '{{count}} süresi geçmiş',
  'security.verdict.permits.scrollMore': 'aşağıda devam ediyor',
  'security.verdict.permits.empty': 'İzin bilgisi yok.',
  'security.verdict.liveMismatch': 'İzin bu okutmadan sonra değişti.',
  'security.verdict.selectedSite': 'Seçili saha: {{site}}',
  'security.verdict.acknowledge': 'Kapat',
  'security.verdict.acknowledgeQueued': 'Sıradaki ({{count}})',
  'security.verdict.acknowledgeQueuedSr': 'Sıradaki karara geç — {{count}} kişi bekliyor',
  // S32d/S32c §4.5 — `Sıradaki (N)` kuyruğun BAŞI bir ret olduğunda bir `OctagonX` taşır; bu
  // onun `sr-only` uyarısı.
  'security.verdict.acknowledgeQueuedDenialSr': 'Sıradaki karar bir reddir',
  'security.contractor.srLabel': 'Taşeron',
  'security.site.srLabel': 'Saha',
  'security.verdict.networkError.title': 'Karar alınamadı',
  'security.verdict.networkError.body':
    'Sunucuya ulaşılamadı. Bu bir ret DEĞİLDİR — bağlantı düzelince tekrar deneyin.',
  'security.reason.NoPermit.label': 'Çalışma izni yok',
  'security.reason.NoPermit.body': 'Girişe izin vermeyin.',
  'security.reason.NoPermit.action':
    'Kişiyi taşeron yetkilisine yönlendirin — çalışma izni açılmalı.',
  'security.reason.OutOfSite.label': 'Bu saha değil',
  'security.reason.OutOfSite.body': 'Girişe izin vermeyin.',
  'security.reason.OutOfSite.action': 'Doğru sahayı sorun; saha seçiminizi kontrol edin.',
  'security.reason.EntryNotPermitted.label': 'Giriş izni verilmemiş',
  'security.reason.EntryNotPermitted.body': 'Girişe izin vermeyin.',
  'security.reason.EntryNotPermitted.action': 'İSG uzmanına bildirin — giriş izni verilmemiş.',
  'security.reason.OutOfValidity.label': 'Süre dışı',
  'security.reason.OutOfValidity.body': 'Girişe izin vermeyin.',
  'security.reason.OutOfValidity.action':
    'İzin şu anda geçerli değil — taşeron yetkilisinin süreyi uzatması gerekir.',
  'security.reason.Terminal.label': 'İzin kapalı / reddedilmiş',
  'security.reason.Terminal.body': 'Girişe izin vermeyin.',
  'security.reason.Terminal.action':
    'İSG uzmanına bildirin — bu izin kapatılmış ya da reddedilmiş.',
  'security.reason.unknown.label': 'Sebep tanınmıyor',
  'security.reason.unknown.body': 'Bu sonuç tanınmayan bir kodla geldi.',
  'security.reason.unknown.action': 'Ekranı yeniden okutun; sorun sürerse İSG uzmanına bildirin.',
  'security.reason.TokenExpired.label': 'Kod süresi doldu',
  'security.reason.TokenConsumed.label': 'Kod okutma sınırına ulaştı',
  'security.reason.TokenExpired.action':
    'Personelden giriş QR kodunu yenilemesini rica edin; kod kısa sürede kendiliğinden yenilenir.',
  'security.reason.TokenConsumed.action':
    'Bu QR kodu daha önce okutuldu. Personelden yeni bir giriş QR kodu üretmesini rica edin.',
  'security.reason.TokenInvalid.label': 'Geçersiz QR kodu',
  'security.reason.TokenInvalid.action':
    'Kod okunamadı ya da bu sahaya ait değil. Personelden giriş QR kodunu yeniden göstermesini rica edin.',
  'security.tab.scan': 'Personel QR kodunu oku',
  'security.giris.tab.scan.short': 'Personel QR',
  'security.scan.intro.title': 'Personel giriş QR kodunu okuyun',
  'security.scan.intro.body':
    'Personelin mobil uygulamada ürettiği giriş QR kodunu kameraya gösterin; giriş uygunluğu anında kontrol edilir.',
  'security.scan.start': 'Kamerayı aç',
  'security.scan.stop': 'Kamerayı kapat',
  'security.scan.instruction': 'Personelin giriş QR kodunu kamera çerçevesine hizalayın.',
  'security.scan.verifying': 'Doğrulanıyor...',
  'security.scan.cameraAriaLabel': 'Personel QR kodu okuma kamerası önizlemesi',
  'security.scan.cameraError.denied.title': 'Kamera izni verilmedi',
  'security.scan.cameraError.denied.body':
    'Tarayıcıdan kamera erişimine izin verip yeniden deneyebilir ya da kodu aşağıya elle girebilirsiniz.',
  'security.scan.cameraError.noDevice.title': 'Kamera bulunamadı',
  'security.scan.cameraError.noDevice.body':
    'Bu cihazda kullanılabilir bir kamera görünmüyor. Kodu aşağıya elle girerek doğrulayabilirsiniz.',
  'security.scan.cameraError.error.title': 'Kamera açılamadı',
  'security.scan.cameraError.error.body':
    'Kamera şu anda kullanılamıyor. Kodu aşağıya elle girerek doğrulayabilirsiniz.',
  'security.scan.manual.toggle': 'Kodu elle gir',
  'security.scan.manual.tryCamera': 'Kamerayı dene',
  'security.scan.manual.hint':
    'Personelin giriş QR kodunu okutamıyorsanız, kod içeriğini aşağıya yapıştırarak doğrulayabilirsiniz.',
  'security.scan.manual.label': 'QR kodu',
  'security.scan.manual.placeholder': 'QR kodu içeriğini yapıştırın',
  'security.scan.manual.submit': 'Doğrula',
  'security.scan.manual.validation.required': 'Lütfen doğrulanacak kodu girin.',
  'security.tc.field.label': 'T.C. Kimlik No',
  'security.tc.field.placeholder': '11 haneli T.C. kimlik no',
  'security.tc.submit': 'Sorgula',
  'security.tc.hint': 'Kamera veya kod olmadan personeli T.C. kimlik numarasıyla sorgulayın.',
  'security.tc.validation.required': 'T.C. kimlik no gerekli.',
  'security.tc.validation.invalid': 'Geçerli bir T.C. kimlik no girin.',
  'security.tc.notFound.title': 'Kayıt bulunamadı',
  'security.tc.notFound.action':
    'T.C. kimlik numarasını yeniden girin. Numara doğruysa bu kişi firmaya kayıtlı değildir — kişiyi taşeron yetkilisine yönlendirin.',
  'security.day.summary': '{{total}} giriş · {{security}} güvenlik · {{selfAsserted}} beyan',
  'security.day.empty': 'Bugün bu sahada henüz geçiş yok.',
  'security.day.error': 'Gün listesi yüklenemedi.',
  'security.day.methodDisclaimer':
    'Kapı kodu ile gelen satırlar personelin kendi beyanıdır; güvenlik tarafından doğrulanmamıştır.',
  'security.day.filter.all': 'Tümü',
  'security.day.filter.allowed': 'Girenler',
  'security.day.filter.groupLabel': 'Bugün süzgeci',
  'security.day.status.allowed': 'Girdi',
  'security.day.status.denied': 'Reddedildi',
  'security.day.col.status': 'Durum',
  'security.day.col.time': 'Saat',
  'security.day.col.name': 'Ad Soyad',
  // S32e §6.1 (YENİ sütun) — `xl`+'de kendi sütunu, altında ad hücresinin alt satırına döner.
  'security.day.col.contractor': 'Taşeron',
  'security.day.col.method': 'Yöntem',
  'security.day.col.reason': 'Sebep',
  'security.day.truncated':
    'Bazı reddedilen denemeler gösterilmiyor (yalnız en yeni 200 gösterilir); daha eski rettler bu listede görünmez.',
  'security.day.deniedNote':
    'Ayrıca {{count}} reddedilen deneme — bu sayı girişlere dâhil değildir.',
  'security.day.col.detail': 'Detay',
  // S32d Part Two — "Bugün" satırının salt-okuma detay modalı (`EntryDetailModal.tsx`,
  // `docs/reviews/S32d-verdict-and-detail.md` §6/§9). `security.common.close` diğer modüllerin
  // `<modül>.common.close` deseniyle AYNI (bkz. `visitors.common.close`) — `security.verdict.
  // acknowledge`'ın "Kapat"ıyla değer olarak ÇAKIŞIR ama anlamca AYRIDIR (o karar kartını
  // ATAR, bu salt-okuma bir kaydı KAPATIR).
  'security.common.close': 'Kapat',
  'security.detail.title': 'Geçiş kaydı',
  'security.detail.open': 'Geçiş kaydını aç — {{name}}, {{time}}',
  'security.detail.section.reason': 'Reddedilme sebebi',
  // Bilinçli olarak "action"/"body" DEĞİL, yalnız "label" + bu nötr geçmiş-zaman cümlesi
  // (tasarım spec'i §6.1) — `security.reason.<kod>.action` canlı bir karar için YAZILMIŞTIR
  // ("Taşeron yetkilisine yönlendir…") ve saatler önceki bir denemenin kaydında bir EYLEM
  // ÇAĞRISI gibi okunurdu.
  'security.detail.deniedAt': "Bu deneme {{time}}'da reddedildi.",
  'security.detail.permits.title': 'Uygunluk',
  // `liveAsOf` İLE etiketlenir — denemenin kendi anıyla (`at`) DEĞİL (normatif, §29.5/§6.3):
  // izin listesi OKUMA ANINDAKİ durumdur, geçmişteki hâl DEĞİLDİR.
  'security.detail.permits.asOf': 'Şu anki durum — {{time}} itibarıyla',
  'security.detail.permits.empty': 'Bu sahaya kapsanan bir izin kaydı yok.',
  'security.detail.error': 'İzin listesi yüklenemedi.',
  // S32g — kapı uygunluk kontrol listesi (`lib/eligibility.ts`, `EligibilityChecklist.tsx`;
  // api-contract §29.5 S32g bloğu). Kartta `UYGUNLUK · {{title}}` eyebrow'u + pencere çipi
  // (§6.3) — çip OLMADAN bir `OutOfValidity` reddi üç yeşil tik altında `GİRİŞ YOK` gösterirdi.
  'security.eligibility.eyebrow': 'UYGUNLUK · {{title}}',
  'security.eligibility.documents': 'Zorunlu Evraklar',
  'security.eligibility.trainings': 'İSG Eğitimleri',
  // Görünen (kısa) etiket — Almanca'da tam cümleden KISA (§10); TAM cümle `.srLabel`'de,
  // `EntryPanel.tsx:83-88`'in AYNI `aria-hidden`+`sr-only` deseniyle.
  'security.eligibility.approval': 'İSG Uzmanı Onayı',
  'security.eligibility.approval.srLabel': 'İSG Uzmanı Onayı',
  'security.eligibility.state.verified': 'Doğrulandı',
  'security.eligibility.state.completed': 'Tamamlandı',
  'security.eligibility.state.missing': 'Eksik ({{count}})',
  // Satır durumu BOOLEAN'dan okunur, liste UZUNLUĞUNDAN ASLA (§29.5 madde 4) — çözülemeyen bir
  // eğitim/belge kaydı SESSİZCE düşer; bu durumda SAYI YOK, yalnız "Eksik".
  'security.eligibility.state.missingUnknown': 'Eksik',
  'security.eligibility.state.granted': 'Verildi',
  'security.eligibility.state.awaiting': 'Bekleniyor',
  // `Revoked` bir YÖNLENDİRMEDİR, bir SUÇLAMA DEĞİL (§29.5 madde 5/8) — `danger` tonuyla
  // BOYANMAZ, `Bekleniyor` ile AYNI nötr muameleyi görür.
  'security.eligibility.state.revoked': 'Geri alındı',
  // Tasarım otoritesi §2.1 (J6) — kartın TEK yönlendirme cümlesi, `security.reason.<kod>.
  // action`'ın YERİNE geçer, ASLA yığılmaz. Sözcükler CANONİKTİR, paraphrase EDİLMEZ (S33-8
  // Pass B'de `turkish-ohs-expert` copy geçişiyle GÜNCELLENDİ — yeni metin de aynı şekilde
  // kanoniktir, bir sonraki paraphrase girişimi buna karşı da geçersizdir).
  'security.eligibility.route.contractor':
    'Eksik evrak/eğitim var — taşeron yetkilisine yönlendirin.',
  'security.eligibility.route.expert': 'Evrak ve eğitimler tamam — İSG uzmanı onayı bekleniyor.',
  // §29.5 madde 4 — `missingTrainingTitles = []` MEŞRU bir birleşimdir ("eksik yok" DEĞİL).
  'security.eligibility.items.unresolved': 'Eksik var, adı gösterilemiyor.',
  'security.method.gateQr': 'kapı kodu',
  // S32d §3.1 — YALNIZ karar kartının kimlik satırı kullanır (`MethodMarker`'ın
  // `selfAssertedSuffix` propu); §6'nın self-assertion ayrımını burada TEKRAR yazar.
  'security.method.gateQr.selfAsserted': 'kapı kodu (kendi beyanı)',
  'security.method.tcLookup': 'TC ile',
  'security.method.personnelQr': 'güvenlik',
};

const en: Record<string, string> = {
  'pagination.summary': '{{from}}–{{to}} of {{total}}',
  'pagination.summaryEmpty': '0 records',
  'app.title': 'İSG Portal — Expert Portal',
  'hazard.1': 'Less hazardous',
  'hazard.2': 'Hazardous',
  'hazard.3': 'Very hazardous',
  'common.clearFilters': 'Clear filters',
  'common.cancel': 'Cancel',
  'personnelForm.tc.show': 'Show',
  'personnelForm.tc.hide': 'Hide',
  'personnelForm.field.phone': 'Phone',
  'personnelForm.field.email': 'Email',
  'personnelForm.field.tcKimlikNo': 'ID number (T.C. Kimlik No)',
  'personnelForm.masked.notice':
    "Personal information is partly hidden because you don't have the “Personal data” permission.",
  // Shared personnel edit form (#29) — same keys as SP; T.C. strings use EP's own label term.
  'personnelForm.edit.action': 'Edit',
  'personnelForm.edit.title': 'Edit personnel',
  'personnelForm.field.firstName': 'First name',
  'personnelForm.field.lastName': 'Last name',
  'personnelForm.field.tcKimlikNoHint':
    'Must be 11 digits with a valid checksum; can only be entered once.',
  'personnelForm.field.accessLevel': 'Access level',
  'personnelForm.access.personeli': 'Staff',
  'personnelForm.access.yetkili': 'Manager',
  'personnelForm.field.accessHint':
    'A Manager can add personnel and upload company documents from the web portal; Staff only see their own data in the mobile app.',
  'personnelForm.field.active': 'Active',
  'personnelForm.field.activeHint': 'Inactive personnel cannot sign in or access sites.',
  'personnelForm.refreshNote':
    'Changes to access level and active/inactive status take effect within 15 minutes at the latest (at the next session refresh).',
  'personnelForm.lock.tcSetOnce':
    'Once entered, the ID number (T.C. Kimlik No) cannot be changed from this screen. Contact support if a change is needed.',
  'personnelForm.lock.tcNoPermission':
    'Only users with the “Personal data” permission can enter the ID number (T.C. Kimlik No).',
  'personnelForm.lock.contact':
    "Phone and email are verified and saved when the person activates their account; they can't be changed here.",
  'personnelForm.submit': 'Save',
  'personnelForm.saved': 'Information updated.',
  'personnelForm.discardEdit.title': 'Discard changes?',
  'personnelForm.discardEdit.body':
    'If you leave editing, the changes you entered will not be saved.',
  'personnelForm.discardEdit.cancel': 'Go back',
  'personnelForm.discardEdit.confirm': 'Discard changes',
  'personnelForm.validation.firstNameRequired': 'First name is required.',
  'personnelForm.validation.lastNameRequired': 'Last name is required.',
  'personnelForm.validation.firstNameTooLong': 'The first name can be at most {{max}} characters.',
  'personnelForm.validation.lastNameTooLong': 'The last name can be at most {{max}} characters.',
  'personnelForm.validation.tcInvalid':
    'The ID number (T.C. Kimlik No) you entered is invalid. Please check it and try again.',
  'personnelForm.validation.tcExistsFallback':
    'A personnel record with this ID number (T.C. Kimlik No) already exists.',
  'personnelForm.hydrate.loading': 'Loading person record…',
  'personnelForm.hydrate.failed': "Couldn't load the person record.",
  'personnelForm.hydrate.retry': 'Retry',
  'personnelForm.hydrate.notInRegistry':
    "This person is no longer in the contractor's registry and can't be edited.",
  'common.close': 'Close',
  'common.loading': 'Loading...',
  'compliance.valid': 'Compliant',
  'compliance.expiring': 'Expiring Soon',
  'compliance.expired': 'Expired',
  'compliance.missing': 'Missing',
  'common.noResults.body': 'Try changing or clearing your search and filters.',
  'common.compactRows': 'Compact rows',
  'common.moreFilters': 'More filters',
  'permitTypes.nav': 'Permit Types',
  'permitTypes.title': 'Permit Types',
  'permitTypes.subtitle':
    'Manage your permit type catalog, PPE and control item catalogs, and approval routing.',
  'permitTypes.list.search': 'Search types',
  'permitTypes.list.searchPlaceholder': 'Search by name',
  'permitTypes.list.new': 'New Type',
  'permitTypes.list.count': '{{count}} permit types listed',
  'permitTypes.list.count_one': '{{count}} permit type listed',
  'permitTypes.list.empty': 'No permit types yet.',
  'permitTypes.list.empty.body': 'Once you create the first type, it appears here.',
  'permitTypes.list.noResults': 'No permit types match your filters.',
  'permitTypes.list.col.name': 'Name',
  'permitTypes.list.col.hazard': 'Hazard class',
  'permitTypes.list.col.requiredDocs': 'Required documents',
  'permitTypes.list.col.status': 'Status',
  'permitTypes.list.filter.status': 'Status',
  'permitTypes.list.filter.allStatuses': 'All statuses',
  'permitTypes.list.filter.active': 'Active',
  'permitTypes.list.filter.inactive': 'Inactive',
  'permitTypes.list.action.delete': 'Delete',
  'permitTypes.list.action.openMenu': 'Actions for {{name}}',
  'permitTypes.list.created': 'Permit type created.',
  'permitTypes.list.updated': 'Permit type updated.',
  'permitTypes.list.deleted': 'Permit type deleted.',
  'permitTypes.status.active': 'Active',
  'permitTypes.status.inactive': 'Inactive',
  'permitTypes.common.actions': 'Actions',
  'permitTypes.common.loading': 'Loading...',
  'permitTypes.common.cancel': 'Cancel',
  'permitTypes.common.save': 'Save',
  'permitTypes.common.create': 'Create',
  'permitTypes.common.close': 'Close',
  'permitTypes.pagination.nav': 'Pagination',
  'permitTypes.pagination.previous': 'Previous',
  'permitTypes.pagination.next': 'Next',
  'permitTypes.form.create.title': 'New Permit Type',
  'permitTypes.form.edit.title': 'Edit Permit Type',
  'permitTypes.form.description': 'Enter the type name, hazard class and required documents.',
  'permitTypes.form.loading': 'Loading type...',
  'permitTypes.form.field.name': 'Name',
  'permitTypes.form.field.description': 'Description',
  'permitTypes.form.field.hazardClass': 'Hazard class',
  'permitTypes.form.field.requiredDocuments': 'Required documents',
  'permitTypes.form.requiredDocs.personnel': 'Personnel documents',
  'permitTypes.form.requiredDocs.vehicle': 'Vehicle documents',
  'permitTypes.form.requiredDocs.inactiveHint':
    'Inactive document types cannot be uploaded; if one stays checked, permits of this type cannot become ready.',
  'permitTypes.form.requiredDocs.rejected':
    'These document types can no longer be selected and were removed from the selection: {{types}}. The document type list has been refreshed; review the selection before saving.',
  'permitTypes.form.field.isActive': 'Active',
  'permitTypes.form.hazardNone': 'Other',
  'permitTypes.form.hazardHint':
    "If 'Other' is selected, the hazard class is chosen manually when the permit is created.",
  'permitTypes.form.requiredDocsNote':
    'Select the personnel and vehicle documents required for a permit of this type.',
  'permitTypes.form.isActiveHint':
    'An inactive type cannot be chosen for new or updated permits; existing permits are not affected.',
  'permitTypes.validation.nameRequired': 'Name is required.',
  'permitTypes.delete.title': 'Delete permit type',
  'permitTypes.delete.body':
    'The type "{{name}}" will be deleted. Existing permits are not affected. Continue?',
  'permitTypes.delete.confirm': 'Delete',
  'permitTypes.gate.loadingLabel': 'Checking Permit Types access...',
  'permitTypes.forbidden.title': 'You do not have access',
  'permitTypes.forbidden.body':
    'You do not have access to the Permit Types module. Please contact your company administrator.',
  'permitTypes.forbidden.back': 'Back to dashboard',
  'permitTypes.unavailable.title': 'Could not load Permit Types',
  'permitTypes.unavailable.body': 'The service is currently unavailable. Please try again later.',
  'permitTypes.unavailable.retry': 'Try again',
  'permitTypes.catalog.tabs.label': 'Permit Types sections',
  'permitTypes.catalog.tabs.types': 'Types',
  'permitTypes.catalog.tabs.ppe': 'PPE Catalog',
  'permitTypes.catalog.tabs.controls': 'Control Items',
  'permitTypes.catalog.col.origin': 'Source',
  'permitTypes.catalog.origin.default': 'General',
  'permitTypes.catalog.origin.custom': 'Company',
  'permitTypes.catalog.inactiveSuffix': '(inactive)',
  'permitTypes.catalog.delete.confirm': 'Deactivate',
  'permitTypes.catalog.form.field.isActive': 'Active',
  'permitTypes.catalog.form.isActiveHint':
    'An inactive item stays selectable for new type assignment but is not recommended.',
  'permitTypes.catalog.ppe.title': 'PPE Catalog',
  'permitTypes.catalog.ppe.search': 'Search PPE',
  'permitTypes.catalog.ppe.searchPlaceholder': 'Search by name',
  'permitTypes.catalog.ppe.new': 'New PPE',
  'permitTypes.catalog.ppe.count': '{{count}} PPE items listed',
  'permitTypes.catalog.ppe.count_one': '{{count}} PPE item listed',
  'permitTypes.catalog.ppe.empty': 'No PPE items yet.',
  'permitTypes.catalog.ppe.empty.body': 'Once you create the first item, it appears here.',
  'permitTypes.catalog.ppe.noResults': 'No PPE items match your filters.',
  'permitTypes.catalog.ppe.col.name': 'Name',
  'permitTypes.catalog.ppe.created': 'PPE item created.',
  'permitTypes.catalog.ppe.updated': 'PPE item updated.',
  'permitTypes.catalog.ppe.deleted': 'PPE item deactivated.',
  'permitTypes.catalog.ppe.delete.title': 'Deactivate PPE item',
  'permitTypes.catalog.ppe.delete.body':
    'Are you sure you want to deactivate "{{name}}"? Permits already linked to a type are not affected.',
  'permitTypes.catalog.ppe.validation.nameRequired': 'Name is required.',
  'permitTypes.catalog.ppe.form.create.title': 'New PPE Item',
  'permitTypes.catalog.ppe.form.edit.title': 'Edit PPE Item',
  'permitTypes.catalog.ppe.form.description': 'Enter the PPE name and an optional description.',
  'permitTypes.catalog.ppe.form.field.name': 'Name',
  'permitTypes.catalog.ppe.form.field.description': 'Description',
  'permitTypes.catalog.control.title': 'Control Items',
  'permitTypes.catalog.control.search': 'Search control items',
  'permitTypes.catalog.control.searchPlaceholder': 'Search by text',
  'permitTypes.catalog.control.new': 'New Control Item',
  'permitTypes.catalog.control.count': '{{count}} control items listed',
  'permitTypes.catalog.control.count_one': '{{count}} control item listed',
  'permitTypes.catalog.control.empty': 'No control items yet.',
  'permitTypes.catalog.control.empty.body': 'Once you create the first item, it appears here.',
  'permitTypes.catalog.control.noResults': 'No control items match your filters.',
  'permitTypes.catalog.control.col.text': 'Control item',
  'permitTypes.catalog.control.created': 'Control item created.',
  'permitTypes.catalog.control.updated': 'Control item updated.',
  'permitTypes.catalog.control.deleted': 'Control item deactivated.',
  'permitTypes.catalog.control.delete.title': 'Deactivate control item',
  'permitTypes.catalog.control.delete.body':
    'Are you sure you want to deactivate "{{text}}"? Permits already linked to a type are not affected.',
  'permitTypes.catalog.control.validation.textRequired': 'Control item text is required.',
  'permitTypes.catalog.control.form.create.title': 'New Control Item',
  'permitTypes.catalog.control.form.edit.title': 'Edit Control Item',
  'permitTypes.catalog.control.form.description':
    'Enter the control statement and an optional description.',
  'permitTypes.catalog.control.form.field.text': 'Control item',
  'permitTypes.catalog.control.form.field.description': 'Description',
  'permitTypes.form.field.protectiveEquipment': 'Required PPE',
  'permitTypes.form.protectiveEquipmentNote':
    'Select the personal protective equipment required for a permit of this type.',
  'permitTypes.form.protectiveEquipmentEmpty':
    'No PPE items in the catalog. Add items from the PPE Catalog tab first.',
  'permitTypes.form.field.controlItems': 'Control items',
  'permitTypes.form.controlItemsNote':
    'Select the control items the HSE expert will check on a permit of this type.',
  'permitTypes.form.controlItemsEmpty':
    'No control items in the catalog. Add items from the Control Items tab first.',
  'app.name': 'İSG Portal',
  'app.expertPortal': 'Expert Portal',
  'app.tagline': 'Manage occupational health and safety from a single platform.',

  'login.title': 'Sign in to the Expert Portal',
  'login.subtitle': 'Enter your email and password to access your account.',
  'login.email': 'Email',
  'login.emailPlaceholder': 'name@company.com',
  'login.password': 'Password',
  'login.submit': 'Sign in',
  'login.forgotPassword': 'Forgot password',

  'forgot.title': 'Reset password',
  'forgot.subtitle': 'Enter the email or phone linked to your account and we will send a code.',
  'forgot.identifier': 'Email or phone',
  'forgot.submit': 'Send code',
  'forgot.backToLogin': 'Back to sign in',
  'forgot.sentTitle': 'Code sent',
  'forgot.sentBody':
    'If your account exists, we have sent a verification code. Use it to set a new password.',
  'forgot.continue': 'I have the code, continue',

  'reset.title': 'Set a new password',
  'reset.subtitle': 'Enter the verification code you received and your new password.',
  'reset.code': 'Verification code',
  'reset.newPassword': 'New password',
  'reset.passwordHint': 'At least 8 characters, including a letter and a digit.',
  'reset.submit': 'Update password',
  'reset.successTitle': 'Your password has been updated',
  'reset.successBody': 'You can now sign in with your new password.',
  'reset.toLogin': 'Go to sign in',

  'layout.dashboard': 'Dashboard',
  'layout.nav.primary': 'Main navigation',
  'layout.skipToContent': 'Skip to content',
  'layout.account': 'Account',
  'layout.profile': 'Profile',
  'layout.logout': 'Sign out',

  'layout.navGroup.operations': 'Operations',
  'layout.navGroup.compliance': 'Compliance',
  'layout.navGroup.system': 'System',
  'layout.rail.collapse': 'Collapse menu',
  'layout.rail.expand': 'Expand menu',
  'layout.rail.permitsPending': 'Work permits: {{count}} awaiting approval',
  'layout.user.menu': 'User menu',
  'layout.user.signedInAs': 'Signed in as',
  'layout.user.role': 'Role',
  'layout.user.company': 'Company',
  'layout.user.language': 'Language',

  // Unknown route (404, owner review B2 item 5) — inside the shell (if logged in), no
  // breadcrumb (an "unknown" location has no defined parent); links back to the dashboard.
  'notFound.title': 'Page not found',
  'notFound.body': 'The page you are looking for may have moved or never existed.',
  'notFound.back': 'Back to dashboard',

  // Global header search (S34-5, api-contract §34.3) — Carbon UI Shell pattern; visible only
  // with `permits/list` access (`AppHeader.tsx`).
  'search.trigger': 'Search',
  'search.shortcutHint': 'Press "/" to open',
  'search.label': 'Global search',
  'search.placeholder': 'Search work permits, contractors or personnel',
  'search.close': 'Close search',
  'search.minChars': 'Type at least 2 characters to search.',
  'search.loading': 'Searching…',
  'search.noResults': 'No results',
  'search.noResults.body': 'Try a different search term.',
  'search.group.permits': 'Work permits',
  'search.group.contractors': 'Contractors',
  'search.group.personnel': 'Personnel',
  'search.group.hasMore': 'More results are available; narrow your search.',
  'search.status.results': '{{count}} results found',
  'search.status.results_one': '{{count}} result found',

  'dashboard.site.label': 'Site',
  'dashboard.site.all': 'All sites',

  // --- Dashboard (S34-4, api-contract §34) ---
  'dashboard.title': 'Dashboard',
  'dashboard.retry': 'Retry',
  'dashboard.kpi.activePermits': 'Active permits',
  'dashboard.kpi.pendingApproval': 'Permits awaiting approval',
  'dashboard.kpi.expiringPermits': 'Permits expiring within 7 days',
  'dashboard.kpi.personnelNotReady': 'Personnel blocked from site entry',
  'dashboard.kpi.personnelNotReady.context_one': 'Across {{count}} permit record',
  'dashboard.kpi.personnelNotReady.context': 'Across {{count}} permit records',
  'dashboard.kpi.entriesToday': "Today's entries",
  'dashboard.kpi.entriesToday.context_one': '{{count}} visitor on site',
  'dashboard.kpi.entriesToday.context': '{{count}} visitors on site',
  'dashboard.kpi.contractorDocsExpiring': 'Contractors with expired documents',
  // owner review B4-7 — short, count-first form; no noun to pluralize, so no `_one` variant.
  'dashboard.kpi.contractorDocsExpiring.context': 'Expiring within 30 days: {{count}}',
  'dashboard.kpi.scopeCompanyWide': 'Company-wide',
  'dashboard.actions.title': 'Action required',
  'dashboard.actions.filter.all': 'All',
  'dashboard.actions.filter.groupLabel': 'Action kind filter',
  'dashboard.actions.kind.entryBlocked': 'Entry blocked',
  'dashboard.actions.kind.permitExpiring': 'Permit expiring',
  'dashboard.actions.kind.pendingApproval': 'Awaiting approval',
  'dashboard.actions.line.personReason': '{{person}} — {{reason}}',
  'dashboard.actions.reason.missingDocument': 'Missing document: {{document}}',
  'dashboard.actions.reason.missingTraining': 'Missing training: {{training}}',
  'dashboard.actions.reason.missingTraining.generic': 'Missing training',
  'dashboard.actions.due.overdue': 'Overdue',
  'dashboard.actions.due.permitStarted': 'Permit has started',
  'dashboard.actions.due.startDatePassed': 'Start date has passed',
  'dashboard.actions.due.startsToday': 'Starts today',
  'dashboard.actions.due.startsTomorrow': 'Starts tomorrow',
  'dashboard.actions.due.startsOnDate': 'Starts {{date}}',
  'dashboard.actions.due.endsToday': 'Ends today',
  'dashboard.actions.due.endsTomorrow': 'Ends tomorrow',
  'dashboard.actions.due.endsOnDate': 'Ends {{date}}',
  'dashboard.actions.empty': 'Nothing needs your attention right now.',
  'dashboard.actions.empty.body':
    'Entry blocks, permits about to expire, and permits awaiting approval are listed here.',
  'dashboard.actions.empty.filtered': 'No pending actions of this kind.',
  'dashboard.actions.empty.showAll': 'Show all',
  'dashboard.actions.pagination.nav': 'Pagination',
  'dashboard.actions.pagination.previous': 'Previous',
  'dashboard.actions.pagination.next': 'Next',
  'dashboard.chart.permitsByStatus.title': 'Open permits by status',
  'dashboard.chart.bucket.preparing': 'Preparing',
  'dashboard.chart.bucket.withContractor': 'With contractor',
  'dashboard.chart.bucket.inReview': 'In review',
  'dashboard.chart.bucket.active': 'Active',
  'dashboard.chart.permitsByStatus.empty': 'There are no open work permits.',
  'dashboard.chart.permitsByStatus.total_one': '{{count}} open permit',
  'dashboard.chart.permitsByStatus.total': '{{count}} open permits',
  'dashboard.chart.permitsByStatus.terminal': 'Closed / rejected / expired: {{count}}',
  'dashboard.chart.permitsOpened.title': 'Permits opened in the last 30 days',
  'dashboard.chart.permitsOpened.axis': 'Number of permits',
  'dashboard.chart.permitsOpened.col.date': 'Date',
  'dashboard.chart.permitsOpened.empty': 'No permits were opened in the last 30 days.',
  'dashboard.chart.permitsOpened.summary_one':
    '{{count}} permit in the last 30 days; busiest day {{date}} ({{peakCount}})',
  'dashboard.chart.permitsOpened.summary':
    '{{count}} permits in the last 30 days; busiest day {{date}} ({{peakCount}})',
  'dashboard.chart.unavailable': 'Could not load',
  'dashboard.entries.title': "Today's entries",
  'dashboard.entries.summary': '{{allowed}} entries · {{denied}} denied',
  'dashboard.entries.col.time': 'Time',
  'dashboard.entries.col.name': 'Full name',
  'dashboard.entries.col.contractor': 'Contractor',
  'dashboard.entries.col.status': 'Status',
  'dashboard.entries.empty': 'No entries yet today.',
  'dashboard.entries.empty.body': 'Entries made via kiosk or door code are listed here.',
  'dashboard.entries.selectSite': 'Select a site to see its entries.',
  'dashboard.entries.selectSite.body':
    'This list is site-specific — the "Today\'s entries" tile above counts company-wide.',

  // Profile (Self) — api-contract §18.1
  'profile.title': 'Profile',
  'profile.subtitle': 'View and update your account details.',
  'profile.loading': 'Loading profile...',
  'profile.info.title': 'Account details',
  'profile.info.subtitle': 'These details are read-only.',
  'profile.field.fullName': 'Full name',
  'profile.field.firstName': 'First name',
  'profile.field.lastName': 'Last name',
  'profile.field.email': 'Email',
  'profile.field.company': 'Company',
  'profile.field.role': 'Role',
  'profile.edit.title': 'Edit name',
  'profile.edit.subtitle': 'Update your display name.',
  'profile.edit.save': 'Save',
  'profile.updated': 'Profile updated.',
  'profile.validation.firstNameRequired': 'First name is required.',
  'profile.validation.lastNameRequired': 'Last name is required.',
  'profile.password.title': 'Change password',
  'profile.password.subtitle': 'Choose a strong password for your security.',
  'profile.password.current': 'Current password',
  'profile.password.new': 'New password',
  'profile.password.confirm': 'New password (repeat)',
  'profile.password.hint': 'At least 8 characters, including a letter and a digit.',
  'profile.password.save': 'Update password',
  'profile.password.updated': 'Your password has been updated.',
  'profile.password.wrongCurrent': 'Current password is incorrect.',
  'profile.validation.currentPasswordRequired': 'Current password is required.',
  'profile.validation.confirmRequired': 'Please repeat the password.',
  'profile.validation.passwordMismatch': 'Passwords do not match.',

  // --- Mobile app (§26 app-store links; D4) + system-admin app-link setting ---
  'layout.mobileApp': 'Mobile app',
  'mobileApp.title': 'Mobile app',
  'mobileApp.subtitle':
    'Download the İSG Portal manager app to reach your site inspections, work permits and notifications from your phone.',
  'appDownload.storesTitle': 'Download from the stores',
  'appDownload.ios': 'Download on the App Store',
  'appDownload.android': 'Get it on Google Play',
  'appDownload.comingSoon.body':
    'The mobile app will be available in the stores soon. The download links will appear here once they are ready.',
  'appDownload.loading': 'Loading app information…',
  // System-admin app-link setting screen (§26.2 PUT /admin/app-settings — IsSystemAdmin)
  'admin.tab.appSettings': 'App links',
  'appSettings.field.iosAppUrl': 'iOS app link (App Store)',
  'appSettings.field.androidAppUrl': 'Android app link (Google Play)',
  'appSettings.field.hint': 'Enter a full https link. Leave empty to remove the link.',
  'appSettings.validation.invalidUrl': 'Enter a valid link (must start with https).',
  'appSettings.updated': 'Mobile app links updated.',
  'appSettings.save': 'Save',
  'appSettings.loading': 'Loading links…',

  // --- Admin panel — api-contract §9 ---
  'admin.nav': 'Administration',
  'admin.subtitle': 'Manage roles and permissions, companies, kiosk devices and app links.',
  'admin.tab.roles': 'Access Management',
  'admin.tab.companies': 'Company Management',
  'admin.gate.loadingLabel': 'Loading admin panel',
  'admin.forbidden.title': 'You do not have access to this area',
  'admin.forbidden.body':
    'The admin panel is reserved for system administrators. If you need access, please contact your administrator.',
  'admin.forbidden.back': 'Back to dashboard',
  'admin.unavailable.title': 'Admin service is unavailable',
  'admin.unavailable.body':
    'The admin endpoints are not responding right now. Please try again shortly.',
  'admin.unavailable.retry': 'Try again',

  'admin.common.search': 'Search',
  'admin.common.new': 'New',
  'admin.common.edit': 'Edit',
  'admin.common.save': 'Save',
  'admin.common.cancel': 'Cancel',
  'admin.common.create': 'Create',
  'admin.common.close': 'Close',
  'admin.common.loading': 'Loading...',
  'admin.common.empty': 'No records found.',
  'admin.common.noData': 'No records yet.',
  'admin.common.noData.body': 'Once you create the first record, it appears here.',
  'admin.common.actions': 'Actions',
  'admin.common.createdAt': 'Created',
  'admin.pagination.nav': 'Pagination',
  'admin.pagination.previous': 'Previous',
  'admin.pagination.next': 'Next',

  'admin.roles.title': 'Roles',
  'admin.roles.count': '{{count}} roles listed',
  'admin.roles.count_one': '{{count}} role listed',
  'admin.roles.searchPlaceholder': 'Search role name or code',
  'admin.roles.new': 'New role',
  'admin.roles.col.name': 'Name',
  'admin.roles.col.value': 'Code',
  'admin.roles.col.scope': 'Scope',
  'admin.roles.col.status': 'Status',
  'admin.roles.scope.company': 'Company #{{id}}',
  'admin.roles.scope.global': 'Global',
  'admin.roles.status.active': 'Active',
  'admin.roles.status.passive': 'Inactive',
  'admin.roles.badge.systemAdmin': 'System Administrator',
  'admin.roles.action.edit': 'Edit role',
  'admin.roles.action.delete': 'Deactivate role',
  'admin.roles.action.openMenu': 'Actions for {{name}}',
  'admin.roles.create.title': 'New role',
  'admin.roles.edit.title': 'Edit role',
  'admin.roles.field.name': 'Role name',
  'admin.roles.field.description': 'Description',
  'admin.roles.field.active': 'Active',
  'admin.roles.field.value': 'Code',
  'admin.roles.delete.title': 'Deactivate role',
  'admin.roles.delete.body':
    'The role "{{name}}" will be deactivated. An inactive role grants no permissions. Continue?',
  'admin.roles.delete.confirm': 'Deactivate',
  'admin.roles.created': 'Role created.',
  'admin.roles.updated': 'Role updated.',
  'admin.roles.deleted': 'Role deactivated.',

  'admin.perm.title': 'Permission matrix',
  'admin.perm.subtitle': 'Module and action permissions for the "{{role}}" role.',
  'admin.perm.back': 'Back to roles',
  'admin.perm.save': 'Save permissions',
  'admin.perm.saved': 'Permissions updated.',
  'admin.perm.locked':
    'The system administrator role is locked; its permissions cannot be changed.',
  'admin.perm.reset': 'Revert changes',
  'admin.perm.auto': 'Automatic',
  'admin.perm.na': 'Not in this module',
  'admin.perm.legend':
    'A checked cell means the role is granted that action. "Automatic" actions are public and require no permission.',
  'admin.perm.col.module': 'Module',
  'admin.perm.cellLabel': '{{module}} — {{action}}',
  'admin.action.list': 'List',
  'admin.action.get': 'View',
  'admin.action.create': 'Create',
  'admin.action.update': 'Update',
  'admin.action.delete': 'Delete',
  'admin.action.personal-data': 'Personal data',

  'admin.companies.title': 'Companies',
  'admin.companies.count': '{{count}} companies listed',
  'admin.companies.count_one': '{{count}} company listed',
  'admin.companies.searchPlaceholder': 'Search name, legal name or tax number',
  'admin.companies.new': 'New company',
  'admin.companies.action.openMenu': 'Actions for {{name}}',
  'admin.companies.col.name': 'Company',
  'admin.companies.col.legalName': 'Legal name',
  'admin.companies.col.taxNumber': 'Tax number',
  'admin.companies.col.createdAt': 'Created',
  'admin.companies.create.title': 'New company',
  'admin.companies.edit.title': 'Edit company',
  'admin.companies.field.name': 'Company name',
  'admin.companies.field.legalName': 'Legal name',
  'admin.companies.field.taxNumber': 'Tax number',
  'admin.companies.field.adminFirstName': 'First name',
  'admin.companies.field.adminLastName': 'Last name',
  'admin.companies.field.adminEmail': 'Email',
  'admin.companies.field.adminPassword': 'Password',
  'admin.companies.adminToggle': 'Also create the first administrator',
  'admin.companies.adminHint':
    'If enabled, a corporate administrator (CorporateAdmin) bound to the company is created. This administrator is not a system administrator.',
  'admin.companies.created': 'Company created.',
  'admin.companies.updated': 'Company updated.',

  'admin.branches.title': 'Branches',
  'admin.branches.new': 'New branch',
  'admin.branches.count': '{{count}} branches listed',
  'admin.branches.count_one': '{{count}} branch listed',
  'admin.branches.searchPlaceholder': 'Search branch name or code',
  'admin.branches.col.name': 'Branch',
  'admin.branches.col.code': 'Code',
  'admin.branches.action.sites': 'Sites',
  'admin.branches.create.title': 'New branch',
  'admin.branches.edit.title': 'Edit branch',
  'admin.branches.field.name': 'Branch name',
  'admin.branches.field.code': 'Code',
  'admin.branches.created': 'Branch created.',
  'admin.branches.updated': 'Branch updated.',

  'admin.sites.title': 'Sites',
  'admin.sites.new': 'New site',
  'admin.sites.count': '{{count}} sites listed',
  'admin.sites.count_one': '{{count}} site listed',
  'admin.sites.searchPlaceholder': 'Search site name or code',
  'admin.sites.branchFallback': 'Selected branch',
  'admin.sites.col.name': 'Site',
  'admin.sites.col.code': 'Code',
  'admin.sites.create.title': 'New site',
  'admin.sites.edit.title': 'Edit site',
  'admin.sites.field.name': 'Site name',
  'admin.sites.field.code': 'Code',
  'admin.sites.created': 'Site created.',
  'admin.sites.updated': 'Site updated.',

  'admin.validation.nameRequired': 'Name is required.',
  'admin.validation.emailRequired': 'Email is required.',
  'admin.validation.emailInvalid': 'Enter a valid email address.',
  'admin.validation.passwordPolicy':
    'Password must be at least 8 characters with a letter and a digit.',
  'admin.validation.firstNameRequired': 'First name is required.',
  'admin.validation.lastNameRequired': 'Last name is required.',

  // --- Kiosk Device Management — api-contract §5.9 ---
  'admin.tab.kiosk': 'Kiosk Devices',
  'kiosk.title': 'Kiosk Devices',
  'kiosk.count': '{{count}} kiosk devices listed',
  'kiosk.count_one': '{{count}} kiosk device listed',
  'kiosk.searchPlaceholder': 'Search device name',
  'kiosk.empty': 'No kiosk devices registered yet.',
  'kiosk.empty.body': 'Once you register the first device, it appears here.',
  'kiosk.list.noResults': 'No kiosk devices match your search.',
  'kiosk.col.name': 'Device',
  'kiosk.col.site': 'Site',
  'kiosk.col.status': 'Status',
  'kiosk.col.roles': 'Roles',
  'kiosk.col.lastSeen': 'Last seen',
  'kiosk.col.createdAt': 'Created',
  'kiosk.status.Active': 'Active',
  'kiosk.status.Pending': 'Pending',
  'kiosk.status.Disabled': 'Disabled',
  'kiosk.action.revokeSessions': 'Revoke sessions',
  'kiosk.action.disable': 'Disable',
  'kiosk.action.openMenu': 'Actions for {{name}}',

  'kiosk.register.new': 'Register device',
  'kiosk.register.title': 'Register kiosk device',
  'kiosk.register.description':
    'Give the device a name; optionally assign a site and roles. A single-use activation code is generated after registration.',
  'kiosk.register.submit': 'Register and generate code',
  'kiosk.register.field.name': 'Device name',
  'kiosk.register.field.namePlaceholder': 'e.g. Main Entrance Turnstile 1',
  'kiosk.register.field.site': 'Site (optional)',
  'kiosk.register.field.siteHint':
    'The device is bound to this site; visitor check-ins are recorded against it.',
  'kiosk.register.site.placeholder': 'Select a site (optional)',
  'kiosk.register.field.roles': 'Roles (optional)',
  'kiosk.register.field.rolesHint':
    'The device’s permissions come from the selected roles. Choose a kiosk-authorized role (e.g. “Kiosk Device”).',
  'kiosk.register.roles.empty': 'No active roles available to assign.',
  'kiosk.register.createdMessage': 'Kiosk device registered.',
  'kiosk.register.successTitle': 'Device registered',
  'kiosk.register.successDescription': 'The activation code for “{{name}}” is ready.',
  'kiosk.register.codeWarning':
    'This code is shown only once; enter it on the kiosk device. If you lose it, register the device again.',
  'kiosk.register.codeLabel': 'Activation code',
  'kiosk.register.copy': 'Copy',
  'kiosk.register.copied': 'Copied',
  'kiosk.register.deviceUuid': 'Device ID',
  'kiosk.register.expiresAt': 'Expires',
  'kiosk.register.nextStep':
    'Activate the device by entering this code on the kiosk device’s activation screen.',
  'kiosk.validation.nameRequired': 'Device name is required.',

  'kiosk.revoke.revokeTitle': 'Revoke sessions',
  'kiosk.revoke.revokeBody':
    'All active sessions of “{{name}}” will be ended; the current device session becomes invalid. The device registration is kept. Continue?',
  'kiosk.revoke.revokeConfirm': 'Revoke sessions',
  'kiosk.revoke.revokedMessage': 'Sessions of “{{name}}” have been revoked.',
  'kiosk.revoke.disableTitle': 'Disable device',
  'kiosk.revoke.disableBody':
    '“{{name}}” will be disabled and all its sessions ended. The device must be re-activated to be used again. Continue?',
  'kiosk.revoke.disableConfirm': 'Disable',
  'kiosk.revoke.disabledMessage': '“{{name}}” has been disabled.',

  // --- Settings — api-contract §10 (tenant-scoped) ---
  'settings.nav': 'Settings',
  'settings.subtitle': 'Manage your company details, branches and sites.',
  'settings.tab.company': 'Company details',
  'settings.tab.branches': 'Branches',
  'settings.tab.sites': 'Sites',
  'settings.gate.loadingLabel': 'Loading settings',
  'settings.forbidden.title': 'You do not have access to settings',
  'settings.forbidden.body':
    'Company settings are reserved for authorized users. If you need access, please contact your company administrator.',
  'settings.forbidden.back': 'Back to dashboard',
  'settings.unavailable.title': 'Settings are unavailable',
  'settings.unavailable.body':
    'The settings service is not responding right now. Please try again shortly.',
  'settings.unavailable.retry': 'Try again',

  'settings.common.search': 'Search',
  'settings.common.edit': 'Edit',
  'settings.common.save': 'Save',
  'settings.common.cancel': 'Cancel',
  'settings.common.create': 'Create',
  'settings.common.close': 'Close',
  'settings.common.loading': 'Loading...',
  'settings.common.empty': 'No records found.',
  'settings.common.noData': 'No records yet.',
  'settings.common.noData.body': 'Once you create the first record, it appears here.',
  'settings.common.actions': 'Actions',
  'settings.pagination.nav': 'Pagination',
  'settings.pagination.previous': 'Previous',
  'settings.pagination.next': 'Next',

  'settings.company.updated': 'Company details updated.',
  'settings.company.field.name': 'Company name',
  'settings.company.field.legalName': 'Legal name',
  'settings.company.field.taxNumber': 'Tax number',
  'settings.company.field.taxOffice': 'Tax office',
  'settings.company.field.address': 'Address',
  'settings.company.field.phone': 'Phone',
  'settings.company.field.email': 'Email',

  'settings.branches.title': 'Branches',
  'settings.branches.count': '{{count}} branches listed',
  'settings.branches.count_one': '{{count}} branch listed',
  'settings.branches.searchPlaceholder': 'Search branch name or code',
  'settings.branches.new': 'New branch',
  'settings.branches.col.name': 'Branch',
  'settings.branches.col.code': 'Code',
  'settings.branches.col.address': 'Address',
  'settings.branches.col.phone': 'Phone',
  'settings.branches.action.delete': 'Delete branch',
  'settings.branches.action.openMenu': 'Actions for {{name}}',
  'settings.branches.create.title': 'New branch',
  'settings.branches.edit.title': 'Edit branch',
  'settings.branches.field.name': 'Branch name',
  'settings.branches.field.code': 'Code',
  'settings.branches.field.address': 'Address',
  'settings.branches.field.phone': 'Phone',
  'settings.branches.created': 'Branch created.',
  'settings.branches.updated': 'Branch updated.',
  'settings.branches.deleted': 'Branch deleted.',
  'settings.branches.delete.title': 'Delete branch',
  'settings.branches.delete.body':
    'The branch "{{name}}" will be deleted. This action cannot be undone. Continue?',
  'settings.branches.delete.confirm': 'Delete',

  'settings.sites.title': 'Sites',
  'settings.sites.count': '{{count}} sites listed',
  'settings.sites.count_one': '{{count}} site listed',
  'settings.sites.searchPlaceholder': 'Search site name or code',
  'settings.sites.new': 'New site',
  'settings.sites.noBranches':
    'To add a site you must first create at least one branch. Please add a branch from the Branches tab.',
  'settings.sites.branchPlaceholder': 'Select a branch',
  'settings.sites.filter.branch': 'Filter by branch',
  'settings.sites.filter.allBranches': 'All branches',
  'settings.sites.col.name': 'Site',
  'settings.sites.col.code': 'Code',
  'settings.sites.col.branch': 'Branch',
  'settings.sites.col.address': 'Address',
  'settings.sites.action.delete': 'Delete site',
  'settings.sites.action.openMenu': 'Actions for {{name}}',
  'settings.sites.create.title': 'New site',
  'settings.sites.edit.title': 'Edit site',
  'settings.sites.field.branch': 'Branch',
  'settings.sites.field.name': 'Site name',
  'settings.sites.field.code': 'Code',
  'settings.sites.field.address': 'Address',
  'settings.sites.created': 'Site created.',
  'settings.sites.updated': 'Site updated.',
  'settings.sites.deleted': 'Site deleted.',
  'settings.sites.delete.title': 'Delete site',
  'settings.sites.delete.body':
    'The site "{{name}}" will be deleted. This action cannot be undone. Continue?',
  'settings.sites.delete.confirm': 'Delete',

  'settings.validation.nameRequired': 'Name is required.',
  'settings.validation.branchRequired': 'Branch selection is required.',

  // --- Visitors — api-contract §11 (tenant-scoped) ---
  'visitors.nav': 'Visitors',
  'visitors.title': 'Visitors',
  'visitors.subtitle': 'Track visitors on site, review past visits and manage the safety briefing.',
  'visitors.tab.onSite': 'On site',
  'visitors.tab.history': 'History',
  'visitors.tab.briefing': 'Safety briefing',
  'visitors.gate.loadingLabel': 'Loading visitors',
  'visitors.forbidden.title': 'You do not have access to visitors',
  'visitors.forbidden.body':
    'Visitor management is reserved for authorized users. If you need access, please contact your company administrator.',
  'visitors.forbidden.back': 'Back to dashboard',
  'visitors.unavailable.title': 'Visitors are unavailable',
  'visitors.unavailable.body':
    'The visitor service is not responding right now. Please try again shortly.',
  'visitors.unavailable.retry': 'Try again',

  'visitors.common.search': 'Search',
  'visitors.common.loading': 'Loading...',
  'visitors.common.empty': 'No records found.',
  'visitors.common.actions': 'Actions',
  'visitors.common.cancel': 'Cancel',
  'visitors.common.close': 'Close',
  'visitors.common.save': 'Save',
  'visitors.pagination.nav': 'Pagination',
  'visitors.pagination.previous': 'Previous',
  'visitors.pagination.next': 'Next',

  // On-site (emergency / evacuation screen)
  'visitors.onSite.title': 'Currently on site',
  'visitors.onSite.checkIn': 'Check in visitor',
  'visitors.onSite.searchPlaceholder': 'Search visitor name or phone',
  'visitors.onSite.count': '{{count}} visitors on site',
  'visitors.onSite.count_one': '{{count}} visitor on site',
  'visitors.onSite.col.visitor': 'Visitor',
  'visitors.onSite.col.location': 'Site / branch',
  'visitors.onSite.col.host': 'Host',
  'visitors.onSite.col.purpose': 'Purpose',
  'visitors.onSite.col.checkInAt': 'Check-in time',
  'visitors.onSite.action.checkOut': 'Check out',
  'visitors.onSite.empty': 'There are no visitors on site right now.',
  'visitors.onSite.empty.body': 'Once a visitor checks in, they appear here.',
  'visitors.onSite.noResults': 'No visitors match your search.',
  'visitors.onSite.checkOut.title': 'Confirm check-out',
  'visitors.onSite.checkOut.body':
    '"{{name}}" will be checked out and removed from the on-site list. Continue?',
  'visitors.onSite.checkOut.confirm': 'Check out',
  'visitors.onSite.checkedOut': '"{{name}}" has been checked out.',

  // Check-in form
  'visitors.checkIn.title': 'Check in visitor',
  'visitors.checkIn.description':
    'Enter the visitor details. KVKK (data protection) consent and safety briefing acknowledgement are required.',
  'visitors.checkIn.section.visitor': 'Visitor details',
  'visitors.checkIn.section.visit': 'Visit details',
  'visitors.checkIn.section.consent': 'Acknowledgements (required)',
  'visitors.checkIn.field.firstName': 'First name',
  'visitors.checkIn.field.lastName': 'Last name',
  'visitors.checkIn.field.phone': 'Phone',
  'visitors.checkIn.field.email': 'Email',
  'visitors.checkIn.field.idNumber': 'ID / passport no',
  'visitors.checkIn.field.organization': 'Organization represented',
  'visitors.checkIn.field.site': 'Site',
  'visitors.checkIn.field.branch': 'Branch',
  'visitors.checkIn.field.host': 'Host',
  'visitors.checkIn.field.purpose': 'Purpose of visit',
  'visitors.checkIn.site.placeholder': 'Select a site (optional)',
  'visitors.checkIn.branch.placeholder': 'Select a branch (optional)',
  'visitors.checkIn.branch.autoFilledHint': "Filled in from the selected site's branch.",
  'visitors.checkIn.host.placeholder': 'Select a host (optional)',
  'visitors.checkIn.consent.kvkk':
    'I shared the KVKK (data protection) notice with the visitor; the visitor gave explicit consent to processing their personal data.',
  'visitors.checkIn.consent.kvkkHint':
    'Check-in is not possible without explicit consent; if consent is not given, no visitor data is stored.',
  'visitors.checkIn.consent.briefing':
    'I delivered the safety briefing to the visitor; the visitor read and acknowledged the rules.',
  'visitors.checkIn.briefing.title': 'Safety briefing',
  'visitors.checkIn.briefing.version': 'Version {{version}}',
  'visitors.checkIn.briefing.notConfigured':
    'No safety briefing text has been configured yet. You can add it from the "Safety briefing" tab; the visitor must still acknowledge that the briefing was delivered.',
  'visitors.checkIn.submit': 'Check in',
  'visitors.checkIn.success': 'Visitor checked in.',
  'visitors.checkIn.badge': 'Check-out code: {{code}}',

  // History / report
  'visitors.history.title': 'Visit history',
  'visitors.history.count': '{{count}} visits listed',
  'visitors.history.count_one': '{{count}} visit listed',
  'visitors.history.searchPlaceholder': 'Search visitor name or phone',
  'visitors.history.filter.status': 'Status',
  'visitors.history.filter.site': 'Site',
  'visitors.history.filter.branch': 'Branch',
  'visitors.history.filter.from': 'Start date',
  'visitors.history.filter.to': 'End date',
  'visitors.history.filter.allStatuses': 'All statuses',
  'visitors.history.filter.allSites': 'All sites',
  'visitors.history.filter.allBranches': 'All branches',
  'visitors.history.col.visitor': 'Visitor',
  'visitors.history.col.status': 'Status',
  'visitors.history.col.location': 'Site / branch',
  'visitors.history.col.host': 'Host',
  'visitors.history.col.checkInAt': 'Check-in',
  'visitors.history.col.checkOutAt': 'Check-out',
  'visitors.history.action.detail': 'Visit detail',
  'visitors.history.empty': 'No visit records yet.',
  'visitors.history.empty.body': 'Once a visitor checks out, they appear here.',
  'visitors.history.noResults': 'No visit records match the filters.',

  'visitors.status.onSite': 'On site',
  'visitors.status.checkedOut': 'Checked out',
  'visitors.entryMethod.manual': 'Manual',
  'visitors.entryMethod.kiosk': 'Kiosk',

  // Visit detail
  'visitors.detail.title': 'Visit detail',
  'visitors.detail.section.visitor': 'Visitor',
  'visitors.detail.section.visit': 'Visit',
  'visitors.detail.field.phone': 'Phone',
  'visitors.detail.field.email': 'Email',
  'visitors.detail.field.idNumber': 'ID / passport no',
  'visitors.detail.field.organization': 'Organization',
  'visitors.detail.field.status': 'Status',
  'visitors.detail.field.location': 'Site / branch',
  'visitors.detail.field.host': 'Host',
  'visitors.detail.field.purpose': 'Purpose',
  'visitors.detail.field.entryMethod': 'Entry method',
  'visitors.detail.field.checkInAt': 'Check-in',
  'visitors.detail.field.checkOutAt': 'Check-out',
  'visitors.detail.field.briefing': 'Safety briefing acknowledgement',
  'visitors.detail.field.badge': 'Check-out code',
  'visitors.detail.briefingAccepted': 'Acknowledged',
  'visitors.detail.briefingNotAccepted': 'Not acknowledged',
  'visitors.detail.loading': 'Loading visit...',

  // Safety briefing configuration
  'visitors.briefing.subtitle':
    'The safety briefing text visitors acknowledge at check-in. Saving increments the version automatically; the acknowledged version is written to the visit record.',
  'visitors.briefing.currentVersion': 'Current version: {{version}}',
  'visitors.briefing.notConfigured': 'No briefing text configured yet (version 0).',
  'visitors.briefing.field.tr': 'Text (Turkish)',
  'visitors.briefing.field.en': 'Text (English)',
  'visitors.briefing.field.de': 'Text (German)',
  'visitors.briefing.placeholder': 'Write the safety rules visitors must follow.',
  'visitors.briefing.save': 'Save briefing',
  'visitors.briefing.updated': 'Safety briefing updated.',

  'visitors.validation.firstNameRequired': 'First name is required.',
  'visitors.validation.lastNameRequired': 'Last name is required.',
  'visitors.validation.kvkkRequired': 'KVKK explicit consent is required.',
  'visitors.validation.briefingRequired': 'Safety briefing acknowledgement is required.',
  'visitors.validation.contentTrRequired': 'Turkish text is required.',

  // --- Contractor / Subcontractor Management — api-contract §13 + §8 ---
  'contractors.nav': 'Contractors',
  'contractors.title': 'Contractors',
  'contractors.gate.loadingLabel': 'Loading contractor module...',
  'contractors.forbidden.title': 'No access',
  'contractors.forbidden.body':
    'You do not have permission to access the Contractor module. Please contact your company administrator to request access.',
  'contractors.forbidden.back': 'Back to dashboard',
  'contractors.unavailable.title': 'Module unavailable',
  'contractors.unavailable.body':
    'Contractor data cannot be reached right now. Please try again shortly.',
  'contractors.unavailable.retry': 'Try again',

  'contractors.common.close': 'Close',
  'contractors.common.cancel': 'Cancel',
  'drawer.discard.title': 'Close without saving?',
  'drawer.discard.body':
    'The form contains unsaved information. If you close this panel, what you entered will not be saved.',
  'drawer.discard.cancel': 'Go back',
  'drawer.discard.confirm': 'Close without saving',
  'contractors.common.save': 'Save',
  'contractors.common.create': 'Create',
  'contractors.common.add': 'Add',
  'contractors.common.done': 'Done',
  'contractors.common.loading': 'Loading...',
  'contractors.common.actions': 'Actions',

  'contractors.status.active': 'Active',
  'contractors.status.suspended': 'Suspended',
  'contractors.status.inactive': 'Inactive',

  'contractors.compliance.valid': 'Compliant',
  'contractors.compliance.expiring': 'Expiring Soon',
  'contractors.compliance.expired': 'Expired',
  'contractors.compliance.missing': 'Missing',

  // List
  'contractors.list.subtitle':
    'Manage the subcontractor and supplier firms working on your sites, their compliance documents and site access.',
  'contractors.list.search': 'Search contractors',
  'contractors.list.searchPlaceholder': 'Search by company name or tax number',
  'contractors.list.new': 'Add Contractor',
  'contractors.list.filter.status': 'Filter by status',
  'contractors.list.filter.allStatuses': 'All statuses',
  'contractors.list.filter.compliance.expired': 'Expired document',
  'contractors.list.filter.compliance.expiring': 'Document expiring soon',
  'contractors.list.count': '{{count}} contractors listed',
  'contractors.list.count_one': '{{count}} contractor listed',
  'contractors.list.col.name': 'Company',
  'contractors.list.col.taxNumber': 'Tax No',
  'contractors.list.col.hazardClass': 'Hazard class',
  'contractors.list.col.status': 'Status',
  'contractors.list.col.compliance': 'Compliance',
  'contractors.list.empty': 'No contractors yet.',
  'contractors.list.empty.body': 'Once you add the first contractor, it appears here.',
  'contractors.list.noResults': 'No contractors match your filters.',

  'contractors.pagination.nav': 'Pagination',
  'contractors.pagination.previous': 'Previous',
  'contractors.pagination.next': 'Next',

  // Create/edit form
  'contractors.form.create.title': 'Add Contractor',
  'contractors.form.edit.title': 'Edit Contractor',
  'contractors.form.description':
    'Enter the company details, hazard class and contract period. Fields marked with an asterisk are required.',
  'contractors.form.section.identity': 'Company identity',
  'contractors.form.section.contact': 'Contact and contract',
  'contractors.form.field.name': 'Company name',
  'contractors.form.field.legalName': 'Legal name',
  'contractors.form.field.taxNumber': 'Tax number',
  'contractors.form.field.taxOffice': 'Tax office',
  'contractors.form.field.isgKatipNo': 'İSG-KATİP number',
  'contractors.form.field.hazardClass': 'Hazard class',
  'contractors.form.field.phone': 'Phone',
  'contractors.form.field.email': 'Email',
  'contractors.form.field.address': 'Address',
  'contractors.form.field.contractStart': 'Contract start',
  'contractors.form.field.contractEnd': 'Contract end',
  'contractors.form.field.status': 'Status',
  'contractors.validation.nameRequired': 'Company name is required.',

  // Detail
  'contractors.detail.back': 'Back to contractor list',
  'contractors.detail.loading': 'Loading contractor...',
  'contractors.detail.edit': 'Edit',
  'contractors.detail.header.compliance': 'Compliance: {{status}}',
  'contractors.detail.compliance.title': 'Compliance',
  'contractors.detail.identity.title': 'Identity',
  'contractors.detail.compliance.documents': 'Documents',
  'contractors.detail.compliance.expiring': 'Expiring',
  'contractors.detail.compliance.expired': 'Expired',
  'contractors.detail.compliance.overall': 'Overall compliance',
  'contractors.detail.tab.documents': 'Compliance Documents',
  'contractors.detail.tab.personnel': 'Personnel',
  'contractors.detail.tab.vehicles': 'Vehicles',
  'contractors.detail.tab.sites': 'Site Access',

  // Documents
  'contractors.documents.title': 'Compliance documents',
  'contractors.documents.subtitle':
    'Upload documents such as social security, tax certificate, İSG-KATİP, contract and insurance; track their validity.',
  'contractors.documents.empty': 'No documents have been added for this contractor yet.',
  'contractors.documents.col.type': 'Document type',
  'contractors.documents.col.file': 'File',
  'contractors.documents.col.validity': 'Validity',
  'contractors.documents.col.status': 'Status',
  'contractors.documents.action.download': 'Download',
  'contractors.documents.action.delete': 'Delete',
  'contractors.documents.add.new': 'Add Document',
  'contractors.documents.add.title': 'Add compliance document',
  'contractors.documents.add.description':
    'Select a file, choose the document type and enter the validity date. The file is uploaded directly to secure storage.',
  'contractors.documents.add.submit': 'Upload and add',
  'contractors.documents.add.uploading': 'Uploading...',
  'contractors.documents.add.progress': 'Uploading: {{percent}}%',
  'contractors.documents.field.file': 'Document file',
  'contractors.documents.field.filePlaceholder': 'Select a file (PDF, image or office document)',
  'contractors.documents.field.fileHint': 'Up to 20 MB. PDF, image (PNG/JPG) or office document.',
  'contractors.documents.field.type': 'Document type',
  'contractors.documents.field.validFrom': 'Valid from',
  'contractors.documents.field.validUntil': 'Valid until',
  'documents.validity.fromOnly': 'Valid from {{date}}',
  'documents.validity.untilOnly': 'Valid until {{date}}',
  'contractors.documents.field.note': 'Note (optional)',
  'contractors.documents.delete.title': 'Remove document',
  'contractors.documents.delete.body':
    'Are you sure you want to remove the "{{type}}" document from this contractor? The record will be archived.',
  'contractors.documents.delete.confirm': 'Remove document',

  // Personnel
  'contractors.personnel.title': 'Personnel',
  'contractors.personnel.subtitle':
    'View the personnel linked to this contractor; create new personnel and optionally send them a link to activate their account.',
  'contractors.personnel.empty': 'No personnel have been linked to this contractor yet.',
  'contractors.personnel.create': 'Create Personnel',
  'contractors.personnel.col.name': 'Full name',
  'contractors.personnel.col.contact': 'Email / phone',
  'contractors.personnel.col.status': 'Status',
  'contractors.personnel.col.access': 'Access',
  'contractors.personnel.col.date': 'Date',
  // Status badges (active personnel + pending invitations — §13.3)
  'contractors.personnel.status.active': 'Active',
  'contractors.personnel.status.inactive': 'Inactive',
  'contractors.personnel.status.notactivated': 'Not activated',
  'contractors.personnel.status.pending': 'Pending',
  'contractors.personnel.status.expired': 'Expired',
  // Access level (§13.3)
  'contractors.personnel.access.personeli': 'Staff',
  'contractors.personnel.access.yetkili': 'Manager',
  'contractors.personnel.drawer.activatedAt': 'Activation date',
  'contractors.personnel.drawer.createdAt': 'Registration date',
  // Row actions
  'contractors.personnel.action.delete': 'Remove personnel',
  'contractors.personnel.action.openMenu': 'Actions for {{name}}',
  // Remove personnel (confirm)
  'contractors.personnel.delete.title': 'Remove personnel',
  'contractors.personnel.delete.body':
    'Are you sure you want to remove "{{name}}" from this contractor? Any assignments to other companies are preserved.',
  'contractors.personnel.delete.confirm': 'Remove',
  // Revoke invitation (confirm)

  // Personnel invitation

  // Site access
  'contractors.sites.title': 'Site access',
  'contractors.sites.subtitle':
    'Define which sites the contractor may work on. You can revoke access at any time.',
  'contractors.sites.empty': 'No site access has been defined for this contractor yet.',
  'contractors.sites.add.new': 'Add Site',
  'contractors.sites.add.title': 'Add site access',
  'contractors.sites.add.description': 'Select a site the contractor may access.',
  'contractors.sites.field.site': 'Site',
  'contractors.sites.sitePlaceholder': 'Select a site',
  'contractors.sites.noSites': 'No other sites available to add. Sites are defined under Settings.',
  'contractors.sites.col.site': 'Site',
  'contractors.sites.col.code': 'Code',
  'contractors.sites.col.since': 'Access date',
  'contractors.sites.action.remove': 'Revoke access',
  'contractors.sites.remove.title': 'Revoke site access',
  'contractors.sites.remove.body': 'Are you sure you want to revoke access to the "{{site}}" site?',
  'contractors.sites.remove.confirm': 'Revoke access',
  'contractors.validation.siteRequired': 'Please select a site.',

  // Contractor / document error codes (api-contract §13 + §8; SITE_NOT_FOUND defined in §9)
  CONTRACTOR_NOT_FOUND: 'Contractor record not found.',
  CONTRACTOR_DOCUMENT_NOT_FOUND: 'Document not found or does not belong to this contractor.',
  CONTRACTOR_SITE_NOT_FOUND: 'The contractor has no active access to this site.',
  PERSONNEL_NOT_FOUND: 'Personnel not found or not linked to this contractor.',
  INVITATION_NOT_FOUND: 'No such invitation was found.',
  ACCESS_LEVEL_ROLE_NOT_CONFIGURED:
    'No role is configured for the selected access level. Please contact your system administrator.',
  DOCUMENT_NOT_FOUND: 'Document not found. Please upload the file again.',
  DOCUMENT_NOT_UPLOADED: 'The file upload could not be completed. Please try again.',
  DOCUMENT_NOT_CONFIRMED: 'The file has not been verified yet. Please try again.',
  DOCUMENT_TOO_LARGE: 'The file size exceeds the allowed limit (max 20 MB).',
  DOCUMENT_TYPE_UNSUPPORTED:
    'This file type is not supported. Upload a PDF, image or office document.',
  DOCUMENT_UPLOAD_FAILED: 'The file could not be uploaded. Check your connection and try again.',
  DOCUMENT_UPLOAD_ABORTED: 'The file upload was cancelled.',
  GUEST_INVITE_INVALID: 'The invitation link is invalid or already used.',
  GUEST_INVITE_EXPIRED: 'The invitation has expired. Please create a new one.',
  INVITE_CHANNEL_UNAVAILABLE:
    "The selected delivery channel cannot be used with this invitation's contact details. Please choose a channel that matches the email address or phone number on the invitation.",
  ACTIVATION_LINK_COOLDOWN:
    'An activation link was just sent to this contact detail. Please wait a little and try again.',
  'personnelCreate.title': 'Create personnel',
  'personnelCreate.description':
    'Add the person; you can also send them a link to activate their account.',
  'personnelCreate.submit': 'Create',
  'personnelCreate.another': 'Create another',
  'personnelCreate.contact.title': 'Activation link (optional)',
  'personnelCreate.contact.hint':
    "If you enter an email or phone, the person receives a link to activate their account. This is not saved on the person's record.",
  'personnelCreate.success.created': 'Personnel created.',
  'personnelCreate.success.linkSent': 'Personnel created. The activation link is ready.',
  'personnelCreate.validation.tcRequired': 'The T.C. kimlik number is required.',
  'personnelCreate.cooldownUntil':
    'A link was sent to this contact a moment ago. Try again from {{availableAt}}, or clear the contact fields and create the person now; you can send the link later.',
  'personnelCreate.cooldownGeneric':
    'A link was sent to this contact a moment ago. Wait a little and try again, or clear the contact fields and create the person now; you can send the link later.',
  'personnelCreate.dailyLimit':
    'The daily limit for sending links has been reached for this contractor. Clear the contact fields and create the person now; you can send the link later.',
  'personnelLink.cooldownUntil':
    'An activation link was just sent to this person or this contact detail. You can try again from {{availableAt}}.',
  'personnelLink.field.email': 'Email',
  'personnelLink.field.emailPlaceholder': 'name@company.com',
  'personnelLink.field.phone': 'Phone',
  'personnelLink.field.phonePlaceholder': '+90 555 123 45 67',
  'personnelLink.field.phoneHint':
    'Mobile number. For numbers outside Türkiye, include + and the country code.',
  'personnelLink.field.channel': 'Delivery channel',
  'personnelLink.field.channelHint':
    'The activation link is sent automatically via the channel you choose; it also stays on screen.',
  'personnelLink.channel.email': 'Email',
  'personnelLink.channel.sms': 'SMS',
  'personnelLink.channel.both': 'Email and SMS',
  'personnelLink.field.link': 'Activation link',
  'personnelLink.copy': 'Copy',
  'personnelLink.copied': 'Copied',
  'personnelLink.copyFailed': 'Could not copy the link. Please select and copy it manually.',
  'personnelLink.expiresAt': 'The link is valid until {{date}}.',
  'personnelLink.dispatch.emailSent': 'The activation link was sent by email.',
  'personnelLink.dispatch.smsSent': 'The activation link was sent by SMS.',
  'personnelLink.dispatch.emailFailed':
    'The activation link could not be sent by email. Copy the link and share it with the person.',
  'personnelLink.dispatch.smsFailed':
    'The activation link could not be sent by SMS. Copy the link and share it with the person.',
  'personnelLink.dispatch.none':
    'Automatic delivery could not be completed. Please copy the link below and share it with the person.',
  'personnelLink.validation.contactRequired': 'Email or phone is required.',
  'personnelLink.validation.emailInvalid': 'Enter a valid email address.',
  'personnelLink.validation.phoneInvalid':
    'Enter a valid mobile number. For numbers outside Türkiye, include + and the country code.',
  'personnelLink.validation.emailTaken':
    'An activation link cannot be sent to this email address. Try another email address or phone number.',
  'personnelLink.validation.phoneTaken':
    'An activation link cannot be sent to this phone number. Try another phone number or email address.',
  'personnelLink.validation.contactTaken':
    'An activation link cannot be sent to the contact you entered. Try another email address or phone number.',
  'personnelLink.pending.sent': 'Sent',
  'personnelLink.pending.expired': 'Expired',
  'personnelLink.action.send': 'Send activation link',
  'personnelLink.action.resend': 'Resend link',
  'personnelLink.action.cancel': 'Cancel link',
  'personnelLink.cancel.title': 'Cancel link',
  'personnelLink.cancel.body.person':
    'The activation link sent for {{name}} is cancelled; the person can no longer use it to activate their account and stays in the list as “Not activated”.',
  'personnelLink.notFound':
    "This link is no longer valid; it may have been resent or cancelled in the meantime, or the person may have activated their account. The list has been refreshed; close this window and check the person's current status.",
  'personnelLink.cancel.body.invite':
    'The activation link sent for {{name}} is cancelled; the person can no longer use it to activate their account. This row is removed from the list.',
  'personnelLink.cancel.confirm': 'Cancel link',
  'personnelLink.send.title': 'Send activation link',
  'personnelLink.send.description':
    "Send an activation link for {{name}}. It goes only to the email address or phone number you enter; this contact is not saved on the person's record.",
  'personnelLink.send.tcMissing':
    "This person's record has no T.C. kimlik number. It must be added to the record before an activation link can be sent.",
  'personnelLink.send.contactHint':
    'Enter at least an email or a phone number; you can enter both.',
  'personnelLink.send.submit': 'Send',
  'personnelLink.resend.title': 'Resend link',
  'personnelLink.resend.description':
    'A new activation link is created and sent for {{name}}. The previous link stops working.',
  'personnelLink.resend.channelHint':
    'The new link is sent via the channel you choose and stays here so you can copy it.',
  'personnelLink.resend.via.email': 'The new link will be sent by email.',
  'personnelLink.resend.via.sms': 'The new link will be sent by SMS.',
  'personnelLink.resend.submit': 'Resend',
  'personnelLink.resend.noContact':
    'There is no email or phone on record for this link, so it cannot be resent.',
  'personnelLink.success.title': 'Activation link ready',
  'personnelLink.success.body':
    'The delivery status is below. You can also copy the link and pass it to the person yourself.',
  ACTIVATION_LINK_DAILY_LIMIT:
    'The daily limit for sending links has been reached. Please try again later.',
  PERSONNEL_INACTIVE:
    'An activation link cannot be sent to inactive personnel. Set the person to Active first.',
  PERSONNEL_TC_REQUIRED:
    "The person's record has no T.C. kimlik number. Until it is added to the record, no activation link can be sent and activation cannot be completed.",
  GUEST_INVITE_CONTACT_ALREADY_EXISTS:
    'This email address or phone number is already registered to another account; the invitation cannot be completed with these contact details.',
  PERSONNEL_ALREADY_HAS_LOGIN:
    'This person already has an account; a new invitation cannot be sent.',

  // Visitor error codes (api-contract §11) — SITE/BRANCH_NOT_FOUND defined in §9 above
  VEHICLE_DOCUMENT_IN_USE:
    'This document is in use and cannot be deleted: site entry was granted to the vehicle while it was on file, or the vehicle is on an active permit. If the document is wrong, reject it; to update it, upload a new one.',
  VEHICLE_DOCUMENT_NOT_PENDING:
    'This document has already been reviewed and can no longer be deleted. Upload a replacement instead.',
  VEHICLE_HAS_OPEN_PERMITS:
    'This vehicle is on an open permit and cannot be deleted. Remove it from its open permits first.',
  VEHICLE_HAS_LOCKED_DOCUMENTS:
    'This vehicle cannot be deleted: it has an approved document, or one of its documents is in use (site entry was granted while it was on file, or the vehicle is on an active permit). The vehicle stays in the list; for a different vehicle, add a new one.',
  VEHICLE_PLATE_LOCKED:
    "This vehicle's plate can no longer be changed: the vehicle has been added to a permit or one of its documents has been approved. To use a different plate, add a new vehicle.",
  VEHICLE_PLATE_ALREADY_EXISTS:
    'A vehicle with this plate is already registered (spaces and punctuation are ignored). Use the existing vehicle in the list.',
  VEHICLE_DOCUMENT_NOT_FOUND: 'This vehicle document could not be found or no longer exists.',
  VEHICLE_NOT_FOUND: 'Vehicle not found; it may have been deleted or removed from the permit.',
  VISIT_NOT_FOUND: 'Visit record not found.',
  HOST_NOT_FOUND: 'The selected host is not an active user of the company.',
  SAFETY_BRIEFING_REQUIRED: 'Safety briefing acknowledgement is required.',
  KVKK_CONSENT_REQUIRED: 'KVKK explicit consent is required; check-in is not possible without it.',
  VISIT_ALREADY_CHECKED_OUT: 'This visit has already been checked out.',

  // Admin error codes (api-contract §9)
  FORBIDDEN: 'You are not authorized to perform this action.',
  ROLE_NOT_FOUND: 'Role not found.',
  SYSTEM_ADMIN_ROLE_LOCKED: 'The system administrator role is locked and cannot be changed.',
  UNKNOWN_ACTION: 'An unknown action was sent. Please refresh the page and try again.',
  COMPANY_NOT_FOUND: 'Company not found.',
  BRANCH_NOT_FOUND: 'Branch not found.',
  SITE_NOT_FOUND: 'Site not found.',
  USER_ALREADY_EXISTS: 'This email is already in use. Please enter a different email.',

  'validation.emailRequired': 'Email is required.',
  'validation.emailInvalid': 'Enter a valid email address.',
  'validation.passwordRequired': 'Password is required.',
  'validation.identifierRequired': 'Email or phone is required.',
  'validation.codeRequired': 'Verification code is required.',
  'validation.passwordPolicy': 'Password must be at least 8 characters with a letter and a digit.',

  'error.generic': 'An unexpected error occurred. Please try again.',
  NETWORK_ERROR: 'Could not reach the server. Check your connection and try again.',
  INVALID_CREDENTIALS: 'Email or password is incorrect.',
  VALIDATION_FAILED: 'Please check the fields.',
  UNAUTHORIZED: 'Your session could not be verified. Please sign in again.',
  PASSWORD_POLICY_ERROR: 'Password must be at least 8 characters with a letter and a digit.',
  CODE_INVALID: 'The verification code is incorrect or used. Request a new code.',
  CODE_EXPIRED: 'The verification code has expired. Request a new code.',
  CODE_TOO_FREQUENT: 'You requested codes too often. Please wait and try again.',

  // ---- Work Permits (§14/§17) ----
  'permits.nav': 'Work Permits',
  'permits.nav.pendingApproval': 'Pending Approval',
  'permits.nav.active': 'Active',
  'permits.nav.all': 'All Permits',
  'permits.title': 'Work Permits',
  'permits.list.subtitle': 'Manage contractor work permits for hazardous tasks.',
  'permits.common.actions': 'Actions',
  'permits.common.loading': 'Loading...',
  'permits.common.close': 'Close',
  'permits.common.cancel': 'Cancel',
  'permits.common.save': 'Save',
  'permits.common.create': 'Create',
  'permits.common.add': 'Add',
  'permits.gate.loadingLabel': 'Checking Work Permit access...',
  'permits.forbidden.title': 'No access',
  'permits.forbidden.body':
    'You do not have access to the Work Permit module. Please contact your company administrator.',
  'permits.forbidden.back': 'Back to dashboard',
  'permits.unavailable.title': 'Work Permits unavailable',
  'permits.unavailable.body': 'The service is currently unavailable. Please try again later.',
  'permits.unavailable.retry': 'Try again',
  'permits.list.search': 'Search permits',
  'permits.list.searchPlaceholder': 'Search by title',
  'permits.list.new': 'New Permit',
  'permits.list.count': '{{count}} work permits listed',
  'permits.list.count_one': '{{count}} work permit listed',
  'permits.list.empty': 'No work permits yet.',
  'permits.list.empty.body': 'Once you create the first permit, it appears here.',
  'permits.list.noResults': 'No work permits match your filters.',
  'permits.list.col.permitType': 'Permit type',
  'permits.list.col.title': 'Title',
  'permits.list.col.contractorSites': 'Contractor / Site',
  'permits.list.sitesMore': '+{{count}}',
  'permits.list.col.hazard': 'Hazard',
  'permits.list.col.validity': 'Validity',
  'permits.list.col.status': 'Status',
  'permits.list.col.personnel': 'Personnel',
  'permits.list.filter.status': 'Status',
  'permits.list.filter.contractor': 'Contractor',
  'permits.list.filter.site': 'Site',
  'permits.list.filter.permitType': 'Permit type',
  'permits.list.filter.from': 'From (earliest)',
  'permits.list.filter.to': 'To (latest)',
  'permits.list.filter.validityEndFrom': 'Ends (earliest)',
  'permits.list.filter.validityEndTo': 'Ends (latest)',
  'permits.list.filter.allStatuses': 'All statuses',
  'permits.list.filter.allContractors': 'All contractors',
  'permits.list.filter.allSites': 'All sites',
  'permits.list.filter.allPermitTypes': 'All permit types',
  'permits.pagination.nav': 'Pagination',
  'permits.pagination.previous': 'Previous',
  'permits.pagination.next': 'Next',
  'permits.status.Draft': 'Draft',
  'permits.status.Submitted': 'Pending Approval',
  'permits.status.Approved': 'Approved',
  'permits.status.Active': 'Active',
  'permits.status.Rejected': 'Rejected',
  'permits.status.Expired': 'Expired',
  'permits.status.Closed': 'Closed',
  'permits.form.create.title': 'New Work Permit',
  'permits.form.edit.title': 'Edit Work Permit',
  'permits.form.description':
    'Enter the task details and validity window. The permit is created as a draft.',
  'permits.form.section.task': 'Task details',
  'permits.form.section.validity': 'Validity',
  'permits.form.section.trainings': 'Required trainings',
  'permits.form.field.contractor': 'Contractor',
  'permits.form.field.sites': 'Sites',
  'permits.form.field.permitType': 'Permit type',
  'permits.form.field.title': 'Title',
  'permits.form.field.description': 'Description',
  'permits.form.field.hazardClass': 'Hazard class',
  'permits.form.field.validityStart': 'Start',
  'permits.form.field.validityEnd': 'End',
  'permits.form.field.notes': 'Notes',
  'permits.form.contractorPlaceholder': 'Select a contractor',
  'permits.form.permitTypePlaceholder': 'Select a permit type',
  'permits.form.hazardPlaceholder': 'Select hazard class',
  'permits.form.hazardFromTypeHint':
    'The hazard class comes from the selected permit type and cannot be changed.',
  'permits.form.hazardManualHint': 'Select the hazard class for this permit type.',
  'permits.form.noPermitTypes':
    'Define at least one permit type first. You can add one from the Permit Types screen.',
  'permits.form.sitesNote':
    'Select the sites this permit covers (optional, multiple allowed). Leave empty to keep the permit unbound to a specific site.',
  'permits.form.sitesLoading': 'Loading sites...',
  'permits.form.sitesEmpty': 'No sites defined. Sites can be added from the Settings screen.',
  'permits.form.trainingsEmpty': 'No active trainings to add.',
  'permits.form.trainingsLoading': 'Loading trainings...',
  'permits.form.trainingsNote':
    'Personnel are not selected at creation; add them from the detail screen after the permit is created. You can also keep managing required trainings from the detail screen.',
  'permits.validation.contractorRequired': 'Please select a contractor.',
  'permits.validation.permitTypeRequired': 'Please select a permit type.',
  'permits.validation.hazardClassRequired': 'Please select a hazard class.',
  'permits.validation.titleRequired': 'Title is required.',
  'permits.validation.validityStartRequired': 'Start date is required.',
  'permits.validation.validityEndRequired': 'End date is required.',
  'permits.validation.validityRange': 'End cannot be before start.',
  'permits.validation.reasonRequired': 'A rejection reason is required.',
  'permits.detail.back': 'Back to Work Permits',
  'permits.detail.loading': 'Loading permit...',
  'permits.detail.edit': 'Edit',
  'permits.detail.readOnlyNote': 'This permit can no longer be edited ({{status}}).',
  'permits.detail.field.contractor': 'Contractor',
  'permits.detail.field.sites': 'Sites',
  'permits.detail.field.permitType': 'Permit type',
  'permits.detail.field.hazardClass': 'Hazard class',
  'permits.detail.field.validity': 'Validity',
  'permits.detail.field.description': 'Description',
  'permits.detail.field.notes': 'Notes',
  'permits.detail.field.approvedBy': 'Approved by',
  'permits.detail.field.approvedAt': 'Approved at',
  'permits.detail.field.createdAt': 'Created',
  'permits.detail.section.personnel': 'Covered personnel',
  'permits.detail.section.trainings': 'Required trainings',
  'permits.detail.requiredDocuments': 'Required documents',
  'permits.detail.requiredDocumentsEmpty': 'This permit type requires no personnel documents.',
  'permits.lifecycle.submit': 'Submit',
  'permits.lifecycle.approve': 'Approve',
  'permits.lifecycle.reject': 'Reject',
  'permits.lifecycle.close': 'Close',
  'permits.lifecycle.submit.title': 'Submit permit',
  'permits.lifecycle.submit.body': 'The permit will be submitted for approval. Continue?',
  'permits.lifecycle.submit.confirm': 'Submit',
  'permits.lifecycle.approve.title': 'Approve permit',
  'permits.lifecycle.approve.body':
    'The permit will be approved and the contractor will be asked to complete the permit details (personnel, vehicles, documents); the contractor contacts are notified. Continue?',
  'permits.lifecycle.approve.confirm': 'Approve',
  'permits.lifecycle.close.title': 'Close permit',
  'permits.lifecycle.close.body': 'The permit will be closed permanently. Continue?',
  'permits.lifecycle.close.confirm': 'Close',
  'permits.lifecycle.rerunAiReview': 'Re-run AI review',
  'permits.lifecycle.rerunAiReview.title': 'Re-run AI review',
  'permits.lifecycle.rerunAiReview.body':
    'The AI review will run again; depending on the outcome, the permit moves to Department Review or back to Revision. Continue?',
  'permits.lifecycle.rerunAiReview.confirm': 'Re-run',
  'permits.lifecycle.issueEntryPermits': 'Issue entry permits',
  'permits.lifecycle.issueEntryPermits.title': 'Issue entry permits',
  'permits.lifecycle.issueEntryPermits.body':
    'All covered personnel and vehicles (if any) will be granted site entry, personnel will be notified, and the permit becomes Active. Continue?',
  'permits.lifecycle.issueEntryPermits.confirm': 'Issue entry',
  'permits.lifecycle.goToReview': 'Go to Department Review',
  'permits.lifecycle.action.openMenu': 'Actions for {{name}}',
  'permits.reject.title': 'Reject permit',
  'permits.reject.description': 'The permit will be rejected. Please enter a reason.',
  'permits.reject.field.reason': 'Reason',
  'permits.reject.reasonPlaceholder': 'Enter the rejection reason',
  'permits.reject.confirm': 'Reject',
  'permits.personnel.subtitle':
    'Contractor personnel covered by the permit and their training readiness.',
  'permits.personnel.add': 'Add Personnel',
  'permits.personnel.empty': 'No personnel added to this permit yet.',
  'permits.personnel.col.name': 'Name',
  'permits.personnel.col.contact': 'Contact',
  'permits.personnel.col.training': 'Training',
  'permits.personnel.col.readiness': 'Readiness',
  'permits.personnel.trainingProgress': '{{completed}} / {{required}} completed',
  'permits.personnel.ready': 'Ready',
  'permits.personnel.notReady': 'Incomplete',
  'permits.personnel.action.remove': 'Remove from coverage',
  'permits.personnel.remove.title': 'Remove personnel',
  'permits.personnel.remove.body': 'Remove {{name}} from the permit coverage?',
  'permits.personnel.remove.confirm': 'Remove',
  'permits.personnel.add.title': 'Add Personnel',
  'permits.personnel.add.description':
    "Choose from the personnel linked to the permit's contractor. People who have not activated their account can be added too.",
  'permits.personnel.add.createNew': 'Create new personnel',
  'permits.personnel.notActivated': 'Not activated',
  'permits.personnel.notActivated.hint':
    "This person cannot complete the training this permit requires until they activate their account. The activation link is sent from the contractor's Personnel tab.",
  'permits.personnel.add.field.personnel': 'Personnel',
  'permits.personnel.add.empty': 'No eligible personnel to add.',
  'permits.personnel.readiness.documents': 'Documents',
  'permits.personnel.readiness.training': 'Training',
  'permits.personnel.missingDocuments': 'Missing documents',
  'permits.personnel.missingTrainings': 'Missing trainings',

  'permits.entry.grant': 'Grant Site Entry',
  'permits.entry.grantBlocked': 'Grant Site Entry (documents or training missing)',
  'permits.entry.granted': 'Site entry granted',
  'permits.entry.grantedMeta': '{{date}} · by {{by}}',
  'permits.entry.revoke': 'Revoke Entry',
  'permits.entry.readyHint': 'Personnel is ready; site entry can be granted.',
  'permits.entry.notReadyHint':
    'All documents must be approved and training completed before entry can be granted.',
  'permits.entry.grantSuccess': 'Site entry granted.',
  'permits.entry.revokeSuccess': 'Site entry revoked.',
  'permits.entry.grantError':
    'Could not grant entry. All of the personnel documents must be approved and training completed.',
  'permits.entry.revoke.title': 'Revoke site entry',
  'permits.entry.revoke.body': 'Revoke the site entry granted to {{name}}?',
  'permits.entry.revoke.confirm': 'Revoke',

  'permits.personnelDocs.title': 'Documents',
  'permits.personnelDocs.col.type': 'Type',
  'permits.personnelDocs.col.validityStatus': 'Status',
  'documents.review.download': 'Download: {{type}}',
  'documents.review.approve': 'Approve: {{type}}',
  'documents.review.reject': 'Reject: {{type}}',
  'documents.review.delete': 'Delete: {{type}}',
  'documents.review.reason.label': 'Rejection reason',
  'documents.review.reason.placeholder': 'e.g. Document illegible or expired.',
  'documents.review.reason.required': 'A rejection reason is required.',
  'documents.review.reason.tooLong': 'The rejection reason can be at most {{max}} characters.',
  'documents.review.reject.confirm': 'Reject',
  'documents.review.rejectionReason': 'Rejection reason: {{reason}}',
  'documents.review.approveSuccess': 'Document approved.',
  'documents.review.rejectSuccess': 'Document rejected.',
  'vehicles.docStatus.allApproved': 'All approved',
  'vehicles.docStatus.none': 'No documents',
  'vehicles.docStatus.missingEnd': 'No end date',
  'vehicles.openPermits.yes': 'On an open permit',
  'vehicles.sheet.docs.title': 'Vehicle documents',
  'vehicles.sheet.docs.upload': 'Upload document',
  'vehicles.sheet.docs.empty': 'No documents added to this vehicle yet.',
  'vehicles.sheet.docs.note':
    'Documents are kept on the vehicle; an approval or rejection counts on every permit it is on.',
  'vehicles.sheet.plateLocked': 'Plate locked',
  'vehicles.doc.inUse': 'In use: cannot be deleted',
  'vehicles.doc.delete.title': 'Delete document',
  'vehicles.doc.delete.body':
    'Delete the "{{type}}" document? It will also disappear from every permit the vehicle is on.',
  'vehicles.doc.delete.confirm': 'Delete',
  'vehicles.upload.title': 'Upload Vehicle Document',
  'vehicles.upload.description': 'Add a document for vehicle {{plate}}. It awaits approval.',
  'vehicles.upload.chooseFile': 'Choose file',
  'vehicles.upload.submit': 'Upload',
  'vehicles.upload.uploading': 'Uploading…',
  'vehicles.upload.progress': '{{percent}}% uploaded',
  'vehicles.upload.noteTooLong': 'The note can be at most {{max}} characters.',
  'vehicles.validation.plateInvalid':
    'The plate is invalid: it can have at most {{max}} characters and at most {{keyMax}} letters and digits, and no invisible characters. Retype the plate by hand.',
  'vehicles.title': 'Vehicles',
  'vehicles.subtitle':
    "The contractor's vehicles at this company. Add vehicles, upload and approve their documents; an approval counts on every permit the vehicle is on.",
  'vehicles.add': 'Add Vehicle',
  'vehicles.empty': 'No vehicles have been added for this contractor yet.',
  'vehicles.col.plate': 'Plate',
  'vehicles.col.description': 'Description',
  'vehicles.col.documents': 'Documents',
  'vehicles.col.docStatus': 'Document status',
  'vehicles.col.openPermits': 'Open permit',
  'vehicles.action.openMenu': 'Actions for vehicle {{plate}}',
  'vehicles.action.upload': 'Upload document',
  'vehicles.action.edit': 'Edit',
  'vehicles.action.delete': 'Delete',
  'vehicles.action.deleteBlocked': 'Delete (remove from open permits first)',
  'vehicles.action.deleteBlockedInUse': 'Delete (a document is in use)',
  'vehicles.delete.title': 'Delete vehicle',
  'vehicles.delete.body':
    'Delete vehicle {{plate}} and its documents? Past permits will still show the plate.',
  'vehicles.delete.confirm': 'Delete',
  'vehicles.form.edit.title': 'Edit vehicle',
  'vehicles.form.edit.description': 'Changes apply on every permit the vehicle is on.',
  'vehicles.form.create.description': "Add a new vehicle to the contractor's vehicle list.",
  'vehicles.form.submit.edit': 'Save',
  'vehicles.form.submit.create': 'Add',
  'vehicles.form.field.plate': 'Plate',
  'vehicles.form.field.description': 'Description',
  'vehicles.form.platePlaceholder': 'e.g. 34 ABC 123',
  'vehicles.form.plateLocked':
    "The plate can no longer be changed: one of the vehicle's documents has been approved. Add a new vehicle for a different plate.",
  'vehicles.validation.plateRequired': 'The plate is required.',
  'vehicles.validation.plateTooLong': 'The plate can be at most {{max}} characters.',
  'vehicles.validation.plateKeyTooLong':
    'The plate can contain at most {{max}} letters and digits.',
  'vehicles.validation.descriptionTooLong': 'The description can be at most {{max}} characters.',
  'vehicles.permitAdd.title': 'Add Vehicle',
  'vehicles.permitAdd.description':
    "Pick from the contractor's vehicles or enter a new plate. A new plate is also added to the contractor's vehicle list.",
  'vehicles.permitAdd.submit': 'Add',
  'vehicles.permitAdd.registered': 'Registered vehicles',
  'vehicles.permitAdd.registeredEmpty': 'No registered vehicles available to add to the permit.',
  'vehicles.permitAdd.newVehicle': 'New vehicle',
  'vehicles.permitAdd.plateOnPermit': 'This vehicle is already on the permit.',
  'vehicles.permitAdd.plateExisting':
    'This plate is already in the list; the existing vehicle will be added to the permit.',
  'vehicles.permitAdd.plateNew': 'New vehicle; it will also be added to the vehicle list.',
  'vehicles.permitAdd.partialFailure': 'Vehicle {{plate}} could not be added.',
  'vehicles.unlink.action': 'Remove from permit',
  'vehicles.unlink.title': 'Remove vehicle from permit',
  'vehicles.unlink.body':
    'Remove vehicle {{plate}} from this permit? The vehicle and its documents stay in the vehicle list.',
  'vehicles.unlink.confirm': 'Remove',

  'permits.docApproval.pending': 'Pending approval',
  'permits.docApproval.approved': 'Approved',
  'permits.docApproval.rejected': 'Rejected',

  // Vehicles (§23). Vehicle document type labels come from the §27 registry (no app keys).
  'permits.form.field.hasVehicles': 'Will vehicles be involved?',
  'permits.form.hasVehiclesHint':
    'If checked, you can add vehicle plates and documents on the permit detail page.',
  'permits.detail.section.vehicles': 'Vehicles',
  'permits.detail.tab.personnelIncomplete_one': '{{count}} person incomplete',
  'permits.detail.tab.personnelIncomplete_other': '{{count}} people incomplete',
  'permits.detail.tab.vehiclesIncomplete_one': '{{count}} vehicle incomplete',
  'permits.detail.tab.vehiclesIncomplete_other': '{{count}} vehicles incomplete',
  'permits.detail.section.ppe': 'PPE',
  'permits.detail.section.controls': 'Control checklist',
  'permits.detail.section.documentRequests': 'Additional document requests',
  'permits.ppe.subtitle':
    'Personal protective equipment required by the permit type (the contractor provides the equipment).',
  'permits.ppe.empty': 'No PPE on this permit.',
  'permits.ppe.col.name': 'PPE',
  'permits.controls.subtitle':
    'Control items for the permit — check them off as you verify on site.',
  'permits.controls.lockedHint':
    'The control checklist can be filled once the permit is active (work has started). You can still add and remove items.',
  'permits.controls.empty': 'No control items on this permit.',
  'permits.controls.col.item': 'Item',
  'permits.controls.col.status': 'Status',
  'permits.controls.checked': 'Checked',
  'permits.controls.unchecked': 'Not checked',
  'permits.controls.checkedBy': '{{name}} · {{date}}',
  'permits.controls.note': 'Note',
  'permits.controls.notePlaceholder': 'Optional note',
  'permits.controls.noteSave': 'Save note',
  'permits.docRequests.subtitle':
    'In addition to the standard documents required by the permit type, request a document type specific to this permit. The request applies to all personnel on the permit and counts toward readiness.',
  'permits.docRequests.empty': 'There are no additional document requests for this permit.',
  'permits.docRequests.readOnlyHint':
    'You are viewing the additional document requests only; adding or removing requires edit permission.',
  'permits.docRequests.allRequested':
    'A request already exists for every document type in the catalog.',
  'permits.docRequests.typeLabel': 'Document type',
  'permits.docRequests.typePlaceholder': 'Select a document type',
  'permits.docRequests.note': 'Note',
  'permits.docRequests.col.requested': 'Requested by',
  'permits.docRequests.notePlaceholder': 'Optional note',
  'permits.docRequests.add': 'Add request',
  'permits.docRequests.requestedBy': '{{name}} · {{date}}',
  'permits.docRequests.remove': 'Remove request',
  'permits.docRequests.remove.title': 'Remove document request',
  'permits.docRequests.remove.body': 'Remove the "{{type}}" document request from this permit?',
  'permits.docRequests.remove.confirm': 'Remove',
  'permits.vehicles.requiredDocumentsEmpty': 'No vehicle documents required for this permit type.',
  'permits.vehicles.requiredDocsLine': 'Required vehicle documents: {{list}}',
  'permits.vehicles.readySummary': '{{ready}} of {{total}} ready',
  'permits.vehicles.col.documents': 'Documents',
  'permits.vehicles.col.readiness': 'Readiness',
  'permits.vehicles.action.openMenu': 'Actions for {{plate}}',
  'permits.vehicles.add': 'Add Vehicle',
  'permits.vehicles.empty': 'No vehicles added to this permit yet.',
  'permits.vehicles.ready': 'Ready',
  'permits.vehicles.notReady': 'Incomplete',
  'permits.vehicles.missingDocuments': 'Missing vehicle documents',
  'permits.vehicles.form.field.plate': 'Plate',
  'permits.vehicles.docs.col.type': 'Type',
  'permits.vehicles.docs.col.approval': 'Approval',
  'permits.trainings.subtitle': 'Trainings the covered personnel must complete.',
  'permits.trainings.add': 'Add Training',
  'permits.trainings.empty': 'No required trainings defined for this permit.',
  'permits.trainings.action.remove': 'Remove',
  'permits.trainings.remove.title': 'Remove training',
  'permits.trainings.remove.body': 'Remove "{{title}}" from the required trainings?',
  'permits.trainings.remove.confirm': 'Remove',
  'permits.trainings.add.title': 'Add Required Training',
  'permits.trainings.add.description': 'Select active trainings required for this permit.',
  'permits.trainings.add.field.trainings': 'Trainings',
  'permits.trainings.add.empty': 'No active trainings to add.',
  // Approval workflow status labels (SPEC §1) — Faz B extension.
  'permits.status.AwaitingSupplierInfo': 'Awaiting Contractor Info',
  'permits.status.AwaitingAiReview': 'Awaiting AI Review',
  'permits.status.Revision': 'Revision',
  'permits.status.DepartmentReview': 'Department Review',
  'permits.status.AwaitingEntryPermit': 'Awaiting Entry Permit',
  // ===== Department review (Kontrol) + firm approval routing (§31 / brief 095) — Phase B Wave 2 =====
  'permits.department.Isg': 'OHS',
  'permits.department.Hekim': 'Occupational Physician',
  'permits.department.Ik': 'Human Resources',
  'departmentReview.nav': 'Review',
  'departmentReview.title': 'Review',
  'departmentReview.subtitle': 'Work permits awaiting your department approval.',
  'departmentReview.count': '{{count}} permits awaiting your approval',
  'departmentReview.count_one': '{{count}} permit awaiting your approval',
  'departmentReview.loading': 'Loading review queue...',
  'departmentReview.empty': 'No permits are awaiting your approval right now.',
  'departmentReview.col.permit': 'Permit',
  'departmentReview.col.contractor': 'Contractor',
  'departmentReview.col.validity': 'Validity',
  'departmentReview.col.permitStatus': 'Permit status',
  'departmentReview.col.myStatus': 'Your department status',
  'departmentReview.pagination.nav': 'Pagination',
  'departmentReview.pagination.previous': 'Previous',
  'departmentReview.pagination.next': 'Next',
  'departmentReview.status.Pending': 'Pending',
  'departmentReview.status.Approved': 'Approved',
  'departmentReview.status.Rejected': 'Rejected',
  'departmentReview.gate.loadingLabel': 'Checking review access...',
  'departmentReview.forbidden.title': 'No review access',
  'departmentReview.forbidden.body':
    'This area is available only to approval departments (OHS, Occupational Physician, Human Resources). Please contact your administrator if you need access.',
  'departmentReview.forbidden.back': 'Back to dashboard',
  'departmentReview.unavailable.title': 'Review is currently unavailable',
  'departmentReview.unavailable.body':
    'The review service cannot be reached right now. Please try again shortly.',
  'departmentReview.unavailable.retry': 'Try again',
  'departmentReview.detail.back': 'Back to review queue',
  'departmentReview.detail.loading': 'Loading permit...',
  'departmentReview.detail.sitesLabel': 'Sites covered by the permit',
  'departmentReview.detail.reviewUnavailable':
    'Department approval details could not be loaded right now; permit content is shown. Please try again shortly.',
  'departmentReview.detail.approvalsTitle': 'Department approvals',
  'departmentReview.detail.escalatedFrom': 'Escalated from {{department}}',
  'departmentReview.detail.section.aiNotes': 'AI notes',
  // §31 alignment block (aligned to live §31.2/§31.4/§31.5) — Phase B Wave 2
  DEPARTMENT_FORBIDDEN:
    'This action requires you to be a member of the relevant department (OHS, Occupational Physician or Human Resources).',
  'approvalRouting.filter.allTypes': 'All document types',
  'approvalRouting.filter.entity': 'Document group filter',
  'departmentReview.detail.reviewingAs': 'Reviewing as:',
  'departmentReview.detail.noDepartment':
    'No review department is registered for you. This screen is available only to the OHS, Occupational Physician or Human Resources roles.',
  'departmentReview.detail.responsibleDocsTitle': 'Documents you are responsible for',
  'departmentReview.detail.responsibleDocsEmpty':
    'Your department is not responsible for any document type on this permit.',
  'departmentReview.detail.responsibleDocs.personnel': 'Personnel documents',
  'departmentReview.detail.responsibleDocs.vehicle': 'Vehicle documents',
  'departmentReview.detail.trainingsEmpty': 'No required training is defined for this permit.',
  'departmentReview.detail.vehiclesEmpty': 'No vehicles have been added to this permit.',
  'departmentReview.detail.vehicleNoDocs': 'No documents have been added to this vehicle yet.',
  'departmentReview.action.approve': 'Approve',
  'departmentReview.action.reject': 'Reject',
  'departmentReview.approve.title': 'Approve permit',
  'departmentReview.approve.body':
    'You are approving this permit on behalf of the {{department}} department. Once all required departments approve, the permit advances to entry permit.',
  'departmentReview.approve.confirm': 'Approve',
  'departmentReview.reject.title': 'Reject permit',
  'departmentReview.reject.description':
    'The permit returns to revision; the contractor and the creator are notified. Please enter a reason.',
  'departmentReview.reject.confirm': 'Reject',
  'departmentReview.reject.reasonRequired': 'Please enter a reason.',
  'departmentReview.reject.reasonPlaceholder': 'Write the rejection reason',
  'departmentReview.reject.field.reason': 'Reason',
  'permitTypes.catalog.tabs.approvalRouting': 'Approval Routing',
  'approvalRouting.title': 'Approval Routing',
  'approvalRouting.defaultNote':
    'Document types without a rule require OHS approval only by default.',
  'approvalRouting.list.new': 'New Rule',
  'approvalRouting.list.col.documentType': 'Document type',
  'approvalRouting.list.col.departments': 'Approving departments',
  'approvalRouting.list.col.escalation': 'Escalation',
  'approvalRouting.list.count': '{{count}} approval routing rules listed',
  'approvalRouting.list.count_one': '{{count}} approval routing rule listed',
  'approvalRouting.list.action.openMenu': 'Actions for {{name}}',
  'approvalRouting.list.empty': 'No approval routing rules yet.',
  'approvalRouting.list.empty.body':
    'Unless a rule is defined, every document type needs OHS approval only.',
  'approvalRouting.list.noResults': 'No approval routing rules match this filter.',
  'approvalRouting.list.deleted': 'Approval routing rule removed.',
  'approvalRouting.list.escalationSummary': '{{department}} after {{hours}} hours',
  'approvalRouting.delete.title': 'Remove rule',
  'approvalRouting.delete.body':
    'Remove the approval routing rule for {{documentType}}? This type returns to the default (OHS only) approval.',
  'approvalRouting.form.create.title': 'New Approval Routing Rule',
  'approvalRouting.form.edit.title': 'Edit Approval Routing Rule',
  'approvalRouting.form.description':
    'Define the document type, approving departments and optional escalation.',
  'approvalRouting.form.field.documentType': 'Document type',
  'approvalRouting.form.field.departments': 'Approving departments',
  'approvalRouting.form.field.escalationHours': 'Escalation time (hours)',
  'approvalRouting.form.field.escalationDepartment': 'Escalation department',
  'approvalRouting.form.departmentsHint':
    'You can select one or more departments (for example HR and OHS together).',
  'approvalRouting.form.escalationHint':
    'When the time elapses, approval moves to the escalation department. If you enter a time, the department is also required.',
  'approvalRouting.form.escalationHoursPlaceholder': 'e.g. 24',
  'approvalRouting.form.noEscalationDept': 'No escalation',
  'approvalRouting.form.created': 'Approval routing rule created.',
  'approvalRouting.form.updated': 'Approval routing rule updated.',
  'approvalRouting.form.error.documentType': 'Please select a document type.',
  'approvalRouting.form.error.departments': 'Please select at least one department.',
  'approvalRouting.form.error.hoursPositive': 'The time must be a positive whole number.',
  'approvalRouting.form.error.hoursRequired':
    'The time is also required when you select an escalation department.',
  'approvalRouting.form.error.escalationDeptRequired':
    'The escalation department is required when you enter a time.',
  'approvalRouting.form.allConfigured':
    'Every active personnel and vehicle document type already has an approval routing rule. To change one, edit its rule in the list.',
  // Create save-mode buttons (SPEC §2).
  'permits.form.saveDraft': 'Save Draft',
  'permits.form.submitForApproval': 'Submit for Approval',
  // Activities tab (SPEC §5).
  'permits.detail.section.activities': 'Activity',
  'permits.activities.subtitle':
    'All changes and comments on this permit appear here, newest first.',
  'permits.activities.loading': 'Loading activity...',
  'permits.activities.empty': 'No activity recorded yet.',
  'permits.activities.systemAuthor': 'System',
  'permits.activities.systemLog': 'System log',
  'permits.activities.comment': 'Comment',
  'permits.activities.commentLabel': 'Add a comment',
  'permits.activities.commentPlaceholder': 'Write a note or comment about this permit',
  'permits.activities.commentSubmit': 'Send',
  'permits.activities.aiAuthor': 'AI',
  'permits.activities.actorRole.supplier': 'Contractor',
  'permits.activities.actorRole.reviewer': 'OHS approver',
  'permits.activities.actorRole.opener': 'Permit submitter',
  'permits.activities.reasonLabel': 'Reason: {{reason}}',
  'permits.activities.subjectLabel': 'Person: {{name}}',
  'permits.activities.event.Created': 'Permit draft created',
  'permits.activities.event.Submitted': 'Permit submitted for approval',
  'permits.activities.event.AutoApproved':
    'Auto-approved because the creator had approval authority',
  'permits.activities.event.Approved': 'Permit approved',
  'permits.activities.event.Rejected': 'Permit rejected',
  'permits.activities.event.SupplierSubmitted': 'Contractor information submitted',
  'permits.activities.event.AiRevisionRequested': 'AI requested a revision',
  'permits.activities.event.DepartmentReviewStarted': 'Department review started',
  'permits.activities.event.DepartmentRejected': 'Department rejected',
  'permits.activities.event.DepartmentReviewCompleted': 'Department review completed',
  'permits.activities.event.EntryPermitsIssued': 'Entry permits issued',
  'permits.activities.event.Closed': 'Permit closed',
  'permits.activities.event.Expired': 'Permit expired',
  'permits.activities.event.AiReviewCompleted': 'AI review completed',
  'permits.activities.event.AiReviewFailed': 'AI review failed',
  'permits.activities.event.DepartmentApproved': 'Department approved',
  'permits.activities.event.DepartmentEscalated': 'Department escalated',
  'permits.activities.event.EntryGranted': 'Entry permit granted',
  'permits.activities.event.EntryRevoked': 'Entry permit revoked',
  'permits.activities.event.PersonnelAssigned': 'Personnel added to permit coverage',
  'permits.activities.event.PersonnelUnassigned': 'Personnel removed from permit coverage',
  'permits.activities.event.InfoUpdated': 'Information updated',
  'permits.activities.event.ProtectiveEquipmentAdded': 'PPE added: {{item}}',
  'permits.activities.event.ProtectiveEquipmentRemoved': 'PPE removed: {{item}}',
  'permits.activities.event.ControlItemAdded': 'Control item added: {{item}}',
  'permits.activities.event.ControlItemRemoved': 'Control item removed: {{item}}',
  'permits.activities.event.DocumentRequestAdded': 'Additional document request added: {{item}}',
  'permits.activities.event.DocumentRequestRemoved':
    'Additional document request removed: {{item}}',
  // Change-log field labels (ChangeSet "field: old → new"); missing fields fall back to the
  // machine name (defaultValue).
  'permits.field.title': 'Title',
  'permits.field.description': 'Description',
  'permits.field.hazardClass': 'Hazard class',
  'permits.field.validityStart': 'Validity start',
  'permits.field.validityEnd': 'Validity end',
  'permits.field.status': 'Status',
  'permits.field.permitType': 'Permit type',
  'permits.field.sites': 'Sites',
  'permits.field.hasVehicles': 'Vehicles involved?',
  // Control item add/remove (SPEC §2.1).
  'permits.controls.add': 'Add item',
  'permits.controls.addPlaceholder': 'Write a new control item',
  'permits.controls.remove': 'Remove item',
  'permits.controls.remove.title': 'Remove control item',
  'permits.controls.remove.body': 'Remove "{{text}}" from this permit?',
  'permits.controls.remove.confirm': 'Remove',
  // PPE add/remove (SPEC §2.1).
  'permits.ppe.add': 'Add PPE',
  'permits.ppe.addPlaceholder': 'Select PPE from the catalog',
  'permits.ppe.addEmpty': 'No further PPE to add.',
  'permits.ppe.remove': 'Remove {{name}}',
  'permits.ppe.remove.title': 'Remove PPE',
  'permits.ppe.remove.body': 'Remove "{{name}}" from this permit?',
  'permits.ppe.remove.confirm': 'Remove',
  // S33 Carbon Slice 3 (permit detail — reference page) new keys.
  'permits.detail.section.details': 'Details',
  'permits.detail.section.progress': 'Progress',
  'permits.detail.issues.message_one': '{{count}} item blocks approval.',
  'permits.detail.issues.message_other': '{{count}} items block approval.',
  'permits.detail.issues.entryMessage_one': '{{count}} item is not ready for site entry.',
  'permits.detail.issues.entryMessage_other': '{{count}} items are not ready for site entry.',
  'permits.detail.issues.personnelFacts': 'Personnel: {{list}}',
  'permits.detail.issues.vehicleFacts': 'Vehicles: {{list}}',
  'permits.detail.issues.moreCount_one': '+{{count}} more',
  'permits.detail.issues.moreCount_other': '+{{count}} more',
  'permits.progress.review': 'Review',
  'permits.progress.activeMeta': '{{date}} · Approved by {{name}}',
  'permits.personnel.readySummary': '{{ready}} of {{total}} ready',
  'permits.personnel.search': 'Search personnel',
  'permits.personnel.searchPlaceholder': 'Search by name or contact',
  'permits.personnel.searchPlaceholderNameOnly': 'Search by name',
  'permits.personnel.requiredDocsLine': 'Required personnel documents: {{list}}',
  'permits.personnel.col.documents': 'Documents',
  'permits.personnel.col.siteAccess': 'Site Entry',
  'permits.personnel.searchEmpty': 'No personnel match the search.',
  'permits.personnel.readiness.trainingMissing': 'Training missing',
  'permits.personnel.readiness.documentsMissing': 'Documents missing',
  'permits.personnel.siteAccess.granted': 'Granted',
  'permits.personnel.siteAccess.notGranted': 'Not granted',
  'permits.personnel.action.openMenu': 'Actions for {{name}}',
  PERMIT_NOT_FOUND: 'Work permit not found.',
  PROTECTIVE_EQUIPMENT_NOT_FOUND: 'PPE item not found.',
  CONTROL_ITEM_NOT_FOUND: 'Control item not found.',
  DUPLICATE_DOCUMENT_REQUEST: 'A request for this document type already exists.',
  DOCUMENT_REQUEST_NOT_FOUND: 'Document request not found.',
  PERMIT_NOT_EDITABLE: 'This permit can only be edited while Draft or Submitted.',
  PERMIT_INVALID_STATE: 'The permit is not in a valid state for this action.',
  TRAINING_NOT_FOUND: 'Training not found or inactive.',
  PERSONNEL_DOCUMENT_NOT_FOUND: 'Document not found or does not belong to this personnel.',
  VIDEO_TOO_LARGE: 'The video size exceeds the allowed limit (max 500 MB).',
  VIDEO_TYPE_UNSUPPORTED: 'Unsupported video type. Upload MP4, WebM or MOV.',

  // ---- Eğitim & Test (Training — §16 authoring) ----
  'trainings.nav': 'Trainings',
  'trainings.title': 'Trainings',
  'trainings.gate.loadingLabel': 'Loading trainings…',
  'trainings.forbidden.title': 'No access',
  'trainings.forbidden.body':
    'You are not authorized to view this section. Contact your administrator for access.',
  'trainings.forbidden.back': 'Back to dashboard',
  'trainings.unavailable.title': 'Trainings unavailable',
  'trainings.unavailable.body': 'The service is currently unavailable. Please try again shortly.',
  'trainings.unavailable.retry': 'Try again',
  'trainings.common.actions': 'Actions',
  'trainings.common.loading': 'Loading…',
  'trainings.common.cancel': 'Cancel',
  'trainings.common.save': 'Save',
  'trainings.common.create': 'Create',
  'trainings.status.active': 'Active',
  'trainings.status.inactive': 'Inactive',
  'trainings.list.subtitle': 'Author the trainings personnel must watch and pass.',
  'trainings.list.search': 'Search trainings',
  'trainings.list.searchPlaceholder': 'Search by title…',
  'trainings.list.new': 'New Training',
  'trainings.list.filter.status': 'Status',
  'trainings.list.filter.allStatuses': 'All statuses',
  'trainings.list.count': '{{count}} trainings listed',
  'trainings.list.count_one': '{{count}} training listed',
  'trainings.list.col.title': 'Title',
  'trainings.list.col.video': 'Video',
  'trainings.list.col.questions': 'Questions',
  'trainings.list.col.passThreshold': 'Pass mark',
  'trainings.list.passThreshold.ratio': '{{correct}}/{{total}}',
  'trainings.list.passThreshold.correctOnly': '{{correct}} correct',
  'trainings.list.passThreshold.warning.label': 'Pass mark is inconsistent with the question count',
  'trainings.list.passThreshold.warning.content':
    'The pass mark (correct answers required) must be between 1 and the number of questions. Edit the training to fix it.',
  'trainings.list.col.status': 'Status',
  'trainings.list.col.created': 'Created',
  'trainings.list.video.yes': 'Yes',
  'trainings.list.video.no': 'None',
  'trainings.list.action.delete': 'Delete',
  'trainings.list.action.openMenu': 'Actions for {{name}}',
  'trainings.list.empty': 'No trainings defined yet.',
  'trainings.list.empty.body': 'Once you create the first training, it appears here.',
  'trainings.list.noResults': 'No trainings match your filters.',
  'trainings.pagination.nav': 'Pagination',
  'trainings.pagination.previous': 'Previous',
  'trainings.pagination.next': 'Next',
  'trainings.delete.title': 'Delete training',
  'trainings.delete.body': 'Delete the training "{{title}}"? This cannot be undone.',
  'trainings.delete.confirm': 'Delete training',
  'trainings.editor.back': 'Back to trainings',
  'trainings.editor.loading': 'Loading training…',
  'trainings.editor.createTitle': 'New Training',
  'trainings.editor.editTitle': 'Edit Training',
  'trainings.editor.section.meta': 'Training details',
  'trainings.editor.section.video': 'Training video',
  'trainings.editor.field.title': 'Title',
  'trainings.editor.field.description': 'Description',
  'trainings.editor.field.passThreshold': 'Pass mark (correct answers)',
  'trainings.editor.field.passThresholdHint': 'Must be between 1 and the number of questions.',
  'trainings.editor.field.isActive': 'Active (assignable to personnel)',
  'trainings.editor.video.description': 'Optional. Large files upload directly to secure storage.',
  'trainings.editor.video.placeholder': 'Click to upload a video',
  'trainings.editor.video.hint': 'MP4, WebM or MOV — up to 500 MB',
  'trainings.editor.video.linked': 'Uploaded video',
  'trainings.editor.video.replace': 'Replace',
  'trainings.editor.video.remove': 'Remove',
  'trainings.editor.video.uploading': 'Uploading video',
  'trainings.editor.video.progress': '{{percent}}% uploaded',
  'trainings.editor.quiz.title': 'Test questions',
  'trainings.editor.quiz.hint':
    'Mark the correct answer for each question. Personnel see only the questions; the answer key stays here.',
  'trainings.editor.quiz.addQuestion': 'Add question',
  'trainings.editor.quiz.empty': 'Add at least one question.',
  'trainings.editor.quiz.questionText': 'Question text',
  'trainings.editor.quiz.removeQuestion': 'Remove question',
  'trainings.editor.quiz.options': 'Options',
  'trainings.editor.quiz.correctHint': 'Select the correct answer with the radio',
  'trainings.editor.quiz.markCorrect': 'Mark option {{number}} as correct',
  'trainings.editor.quiz.optionPlaceholder': 'Option {{number}}',
  'trainings.editor.quiz.removeOption': 'Remove option',
  'trainings.editor.quiz.addOption': 'Add option',
  'trainings.editor.quiz.correctAnswerNote': 'Correct answer: option {{number}}',
  'trainings.editor.validation.titleRequired': 'Title is required.',
  'trainings.editor.validation.passThresholdRange':
    'The pass mark must be between 1 and the number of questions.',
  'trainings.editor.validation.questionRequired': 'Question text is required.',
  'trainings.editor.validation.optionRequired': 'Option cannot be empty.',
  'trainings.editor.validation.optionsRange': 'Each question must have between 2 and 5 options.',
  'trainings.editor.validation.correctRequired': 'Select the correct answer.',
  'trainings.editor.validation.correctRange': 'The correct answer must be one of the options.',
  'trainings.editor.validation.atLeastOneQuestion': 'Add at least one question.',

  // ---- Personnel Documents (§15 path A — KVKK/PII) ----
  'contractors.personnelDocs.loading': 'Loading documents…',
  'contractors.personnelDocs.notFound': 'Personnel not found.',
  'contractors.personnelDocs.kvkk':
    'Sensitive personal data. Only authorized OHS experts can access these documents; download links are short-lived.',
  'contractors.personnelDocs.empty': 'No documents uploaded for this person yet.',
  'contractors.personnelDocs.add.new': 'Upload Document',
  'contractors.personnelDocs.add.title': 'Add Personnel Document',
  'contractors.personnelDocs.add.description':
    'Upload the file and enter the document type and validity.',
  'contractors.personnelDocs.add.submit': 'Add',
  'contractors.personnelDocs.add.uploading': 'Uploading…',
  'contractors.personnelDocs.add.progress': '{{percent}}% uploaded',
  'contractors.personnelDocs.field.file': 'File',
  'contractors.personnelDocs.field.filePlaceholder': 'Choose a file',
  'contractors.personnelDocs.field.fileHint': 'PDF or image — up to 20 MB',
  'contractors.personnelDocs.field.type': 'Document type',
  'contractors.personnelDocs.field.validFrom': 'Valid from',
  'contractors.personnelDocs.field.validUntil': 'Valid until',
  'contractors.personnelDocs.field.note': 'Note',
  'contractors.personnelDocs.delete.title': 'Delete document',
  'contractors.personnelDocs.delete.body': 'Delete the "{{type}}" document?',
  'contractors.personnelDocs.delete.confirm': 'Delete document',

  // ---- Risk Assessment (Risk — §19) ----
  RISK_ASSESSMENT_NOT_FOUND: 'Risk assessment not found.',
  RISK_ITEM_NOT_FOUND: 'Hazard item not found or does not belong to this assessment.',
  RISK_ACTION_NOT_FOUND: 'Corrective/preventive action not found or does not belong to this item.',
  RISK_ASSESSMENT_NOT_EDITABLE:
    'This assessment can only be edited while Draft, Submitted, Under Review or Revised.',
  RISK_ASSESSMENT_INVALID_STATE: 'The assessment is not in a valid state for this action.',
  USER_NOT_FOUND: 'The selected responsible person is not a user of the company.',

  'risk.nav': 'Risk Assessment',
  'risk.title': 'Risk Assessment',
  'risk.common.actions': 'Actions',
  'risk.common.loading': 'Loading...',
  'risk.common.close': 'Close',
  'risk.common.cancel': 'Cancel',
  'risk.common.save': 'Save',
  'risk.common.create': 'Create',
  'risk.common.add': 'Add',
  'risk.gate.loadingLabel': 'Checking Risk Assessment access...',
  'risk.forbidden.title': 'No access',
  'risk.forbidden.body':
    'You do not have access to the Risk Assessment module. Please contact your company administrator.',
  'risk.forbidden.back': 'Back to dashboard',
  'risk.unavailable.title': 'Risk Assessment could not be loaded',
  'risk.unavailable.body': 'The service is currently unavailable. Please try again later.',
  'risk.unavailable.retry': 'Try again',
  'risk.list.subtitle':
    'Assess hazards for your sites, assign controls and corrective actions, and track residual risk.',
  'risk.list.search': 'Search assessments',
  'risk.list.searchPlaceholder': 'Search by title',
  'risk.list.new': 'New Assessment',
  'risk.list.count': '{{count}} assessments listed',
  'risk.list.count_one': '{{count}} assessment listed',
  'risk.list.empty': 'No risk assessments yet.',
  'risk.list.empty.body': 'Once you create the first assessment, it appears here.',
  'risk.list.noResults': 'No risk assessments match your filters.',
  'risk.list.col.title': 'Title',
  'risk.list.col.site': 'Site',
  'risk.list.col.date': 'Assessment date',
  'risk.list.col.status': 'Status',
  'risk.list.col.revision': 'Revision',
  'risk.list.col.items': 'Items',
  'risk.list.col.highestLevel': 'Highest level',
  'risk.list.filter.status': 'Status',
  'risk.list.filter.site': 'Site',
  'risk.list.filter.level': 'Level',
  'risk.list.filter.from': 'From (earliest)',
  'risk.list.filter.to': 'To (latest)',
  'risk.list.filter.allStatuses': 'All statuses',
  'risk.list.filter.allSites': 'All sites',
  'risk.list.filter.allLevels': 'All levels',
  'risk.pagination.nav': 'Pagination',
  'risk.pagination.previous': 'Previous',
  'risk.pagination.next': 'Next',
  'risk.status.Draft': 'Draft',
  'risk.status.Submitted': 'Submitted',
  'risk.status.Approved': 'Approved',
  'risk.status.Active': 'Active',
  'risk.status.UnderReview': 'Under Review',
  'risk.status.Revised': 'Revised',
  'risk.status.Archived': 'Archived',
  'risk.level.Onemsiz': 'Negligible',
  'risk.level.Dusuk': 'Low',
  'risk.level.Orta': 'Medium',
  'risk.level.Yuksek': 'High',
  'risk.level.KabulEdilemez': 'Unacceptable',
  'risk.methodology.LType5x5': '5x5 L-Type Matrix',
  'risk.action.status.Open': 'Open',
  'risk.action.status.InProgress': 'In Progress',
  'risk.action.status.Done': 'Done',
  'risk.action.status.Cancelled': 'Cancelled',
  'risk.matrix.severity': 'Severity',
  'risk.matrix.probability': 'Probability',
  'risk.matrix.gridLabel': 'Probability × Severity matrix',
  'risk.matrix.cellLabel':
    'Probability {{probability}}, Severity {{severity}} — score {{score}}, {{level}}',
  'risk.matrix.previewLabel': 'Selected risk:',
  'risk.matrix.previewEmpty': 'Select a cell from the matrix to see the score.',
  'risk.editor.createTitle': 'New Risk Assessment',
  'risk.editor.section.meta': 'Assessment details',
  'risk.editor.section.items': 'Hazard items',
  'risk.editor.field.title': 'Title',
  'risk.editor.field.site': 'Site',
  'risk.editor.field.area': 'Area / activity',
  'risk.editor.field.assessmentDate': 'Assessment date',
  'risk.editor.field.nextReviewDate': 'Next review',
  'risk.editor.field.nextReviewDateHint': 'The validity date of the assessment (optional).',
  'risk.editor.field.notes': 'Notes',
  'risk.editor.sitePlaceholder': 'Select a site',
  'risk.editor.items.add': 'Add hazard',
  'risk.editor.items.hint':
    'For each hazard select Probability and Severity; the score and level are computed on the server. Corrective actions are added per item after the assessment is created.',
  'risk.editor.items.empty': 'You can create the assessment without items and add hazards later.',
  'risk.editor.items.remove': 'Remove item',
  'risk.editor.validation.titleRequired': 'Title is required.',
  'risk.editor.validation.siteRequired': 'Please select a site.',
  'risk.editor.validation.assessmentDateRequired': 'Assessment date is required.',
  'risk.editor.validation.hazardRequired': 'Hazard description is required.',
  'risk.editor.validation.scoreRequired': 'Please select Probability and Severity from the matrix.',
  'risk.editor.validation.residualIncomplete':
    'For residual risk, select both Probability and Severity or leave both empty.',
  'risk.form.edit.title': 'Edit Assessment',
  'risk.form.description':
    'Update the assessment details. Hazard items are managed from the detail screen.',
  'risk.item.field.hazard': 'Hazard',
  'risk.item.field.risk': 'Possible outcome / risk',
  'risk.item.field.affectedPersons': 'Affected persons',
  'risk.item.field.existingControls': 'Existing controls',
  'risk.item.field.recommendedControls': 'Recommended controls',
  'risk.item.score.title': 'Risk (Probability × Severity)',
  'risk.item.residual.title': 'Residual risk (after controls)',
  'risk.item.residual.hint':
    'Expected Probability and Severity after controls. Optional — filled together.',
  'risk.item.residual.clear': 'Clear',
  'risk.item.add.title': 'Add Hazard Item',
  'risk.item.edit.title': 'Edit Hazard Item',
  'risk.item.form.description':
    'Describe the hazard and score it with Probability × Severity. The score and level are computed on the server.',
  'risk.item.scoreDisplay': 'Probability {{probability}} × Severity {{severity}}',
  'risk.item.residualLabel': 'Residual:',
  'risk.action.add.title': 'Add Action',
  'risk.action.edit.title': 'Edit Action',
  'risk.action.form.description':
    'Describe the corrective/preventive action and assign a responsible person and due date.',
  'risk.action.field.description': 'Description',
  'risk.action.field.responsible': 'Responsible',
  'risk.action.field.dueDate': 'Due date',
  'risk.action.field.status': 'Status',
  'risk.action.field.note': 'Note',
  'risk.action.responsibleNone': 'No responsible',
  'risk.action.validation.descriptionRequired': 'Description is required.',
  'risk.lifecycle.submit': 'Submit',
  'risk.lifecycle.approve': 'Approve',
  'risk.lifecycle.review': 'Review',
  'risk.lifecycle.revise': 'Revise',
  'risk.lifecycle.archive': 'Archive',
  'risk.lifecycle.submit.title': 'Submit assessment',
  'risk.lifecycle.submit.body': 'The assessment will be submitted for approval. Continue?',
  'risk.lifecycle.submit.confirm': 'Submit',
  'risk.lifecycle.approve.title': 'Approve assessment',
  'risk.lifecycle.approve.body': 'Once approved, the assessment becomes active.',
  'risk.lifecycle.approve.confirm': 'Approve',
  'risk.lifecycle.review.title': 'Start review',
  'risk.lifecycle.review.body': 'The assessment will be put under review. Continue?',
  'risk.lifecycle.review.confirm': 'Review',
  'risk.lifecycle.revise.title': 'Revise',
  'risk.lifecycle.revise.body':
    'The assessment will be reopened for revision and the revision number will increase. Continue?',
  'risk.lifecycle.revise.confirm': 'Revise',
  'risk.lifecycle.archive.title': 'Archive assessment',
  'risk.lifecycle.archive.body':
    'The assessment will be permanently archived. This cannot be undone. Continue?',
  'risk.lifecycle.archive.confirm': 'Archive',
  'risk.detail.back': 'Back to Risk Assessments',
  'risk.detail.loading': 'Loading assessment...',
  'risk.detail.edit': 'Edit Details',
  'risk.detail.readOnlyNote': 'This assessment can no longer be edited ({{status}}).',
  'risk.detail.revision': 'Revision {{revision}}',
  'risk.detail.field.site': 'Site',
  'risk.detail.field.area': 'Area / activity',
  'risk.detail.field.assessmentDate': 'Assessment date',
  'risk.detail.field.nextReviewDate': 'Next review',
  'risk.detail.field.methodology': 'Methodology',
  'risk.detail.field.revision': 'Revision no',
  'risk.detail.field.assessedBy': 'Assessed by',
  'risk.detail.field.approvedBy': 'Approved by',
  'risk.detail.field.approvedAt': 'Approved at',
  'risk.detail.items.title': 'Hazard Items',
  'risk.detail.items.add': 'Add Item',
  'risk.detail.items.edit': 'Edit item',
  'risk.detail.items.remove': 'Remove item',
  'risk.detail.items.empty': 'This assessment has no hazard items yet.',
  'risk.detail.items.delete.title': 'Remove item',
  'risk.detail.items.delete.body':
    'Remove the hazard item "{{hazard}}"? Its corrective actions are removed too.',
  'risk.detail.items.delete.confirm': 'Remove',
  'risk.detail.action.title': 'Corrective/Preventive Actions',
  'risk.detail.action.add': 'Add Action',
  'risk.detail.action.edit': 'Edit action',
  'risk.detail.action.remove': 'Remove action',
  'risk.detail.action.empty': 'No corrective actions defined for this item.',
  'risk.detail.action.overdue': 'Overdue',
  'risk.detail.action.delete.title': 'Remove action',
  'risk.detail.action.delete.body': 'Remove the action "{{description}}"?',
  'risk.detail.action.delete.confirm': 'Remove',

  // ---- User management (Users — §12, tenant-scoped) ----
  'users.nav': 'Users',
  'users.title': 'Users',
  'users.subtitle': 'Add and edit your company users and manage their roles.',
  'users.count': '{{count}} users listed',
  'users.count_one': '{{count}} user listed',
  'users.searchPlaceholder': 'Search by name or email',
  'users.new': 'Add User',
  'users.col.name': 'Full Name',
  'users.col.email': 'Email',
  'users.col.role': 'Role',
  'users.col.status': 'Status',
  'users.status.active': 'Active',
  'users.status.passive': 'Inactive',
  'users.action.delete': 'Delete',
  'users.action.openMenu': 'Actions for {{name}}',
  'users.created': 'User created.',
  'users.updated': 'User updated.',
  'users.deleted': 'User deactivated.',
  'users.common.search': 'Search users',
  'users.common.actions': 'Actions',
  'users.common.loading': 'Loading users...',
  'users.common.empty': 'No users yet.',
  'users.common.empty.body': 'Once you add the first user, they appear here.',
  'users.list.noResults': 'No users match your search.',
  'users.common.close': 'Close',
  'users.common.cancel': 'Cancel',
  'users.common.save': 'Save',
  'users.common.create': 'Create',
  'users.pagination.nav': 'Pagination',
  'users.pagination.previous': 'Previous',
  'users.pagination.next': 'Next',
  'users.gate.loadingLabel': 'Loading users...',
  'users.forbidden.title': 'No access',
  'users.forbidden.body': 'You do not have permission for user management.',
  'users.forbidden.back': 'Back to dashboard',
  'users.unavailable.title': 'Users could not be loaded',
  'users.unavailable.body': 'The service is currently unavailable. Please try again shortly.',
  'users.unavailable.retry': 'Try again',
  'users.create.title': 'Add user',
  'users.create.description': 'Enter the name, email, password and roles.',
  'users.edit.title': 'Edit user',
  'users.edit.description': "Update the user's details and roles.",
  'users.edit.loading': 'Loading user details...',
  'users.field.firstName': 'First name',
  'users.field.lastName': 'Last name',
  'users.field.email': 'Email',
  'users.field.password': 'Password',
  'users.field.passwordShow': 'Show password',
  'users.field.passwordHide': 'Hide password',
  'users.field.status': 'Status',
  'users.field.isActive': 'Active',
  'users.field.selfActiveHint': 'You cannot deactivate your own account.',
  'users.field.roles': 'Roles',
  'users.roles.loading': 'Loading roles...',
  'users.roles.empty': 'No assignable roles available.',
  'users.validation.firstNameRequired': 'First name is required.',
  'users.validation.lastNameRequired': 'Last name is required.',
  'users.validation.emailRequired': 'Email is required.',
  'users.validation.emailInvalid': 'Enter a valid email.',
  'users.validation.passwordPolicy':
    'Password must be at least 8 characters with a letter and a digit.',
  'users.validation.rolesRequired': 'Select at least one role.',
  'users.delete.title': 'Deactivate user',
  'users.delete.body':
    'Deactivate the user "{{name}}"? They will not be able to sign in; the record is kept.',
  'users.delete.confirm': 'Deactivate',
  // User management error codes (§12 guards)
  CANNOT_DEACTIVATE_SELF: 'You cannot deactivate your own account.',
  CANNOT_DELETE_SELF: 'You cannot delete your own account.',
  ROLE_NOT_ASSIGNABLE:
    'The selected role cannot be assigned to this user. Please refresh and try again.',

  // ---- Document Schemas (GL #7 — platform document type registry admin) -----------------
  'documentSchemas.nav': 'Document Schemas',
  'documentSchemas.title': 'Document Schemas',
  'documentSchemas.tab.types': 'Types',
  'documentSchemas.common.search': 'Search',
  'documentSchemas.gate.loadingLabel': 'Loading document schemas…',
  'documentSchemas.forbidden.title': "You don't have access to this section",
  'documentSchemas.forbidden.body':
    "You don't have the permission required for Document Schema Management.",
  'documentSchemas.forbidden.back': 'Back to dashboard',
  'documentSchemas.unavailable.title': 'Unavailable right now',
  'documentSchemas.unavailable.body':
    'Document schemas could not be loaded right now. Please try again later.',
  'documentSchemas.unavailable.retry': 'Try again',
  'documentSchemas.types.subtitle':
    'Document types are shared by all companies. AI recognition is not changed on this screen.',
  'documentSchemas.types.count': '{{count}} document types listed',
  'documentSchemas.types.count_one': '{{count}} document type listed',
  'documentSchemas.types.searchPlaceholder': 'Search types…',
  'documentSchemas.types.pagination.nav': 'Pagination',
  'documentSchemas.types.pagination.previous': 'Previous',
  'documentSchemas.types.pagination.next': 'Next',
  'documentSchemas.types.new': 'New document type',
  'documentSchemas.types.created': 'Document type created.',
  'documentSchemas.types.updated': 'Document type updated.',
  'documentSchemas.types.aiUnknown':
    'AI recognition status could not be retrieved right now; all other details are current.',
  'documentSchemas.types.filter.entity': 'Document group',
  'documentSchemas.types.filter.allEntities': 'All groups',
  'documentSchemas.types.filter.status': 'Status',
  'documentSchemas.types.filter.allStatuses': 'All statuses',
  'documentSchemas.types.col.label': 'Label',
  'documentSchemas.types.col.entity': 'Group',
  'documentSchemas.types.col.sortOrder': 'Order',
  'documentSchemas.types.col.expiryRule': 'Validity rule',
  'documentSchemas.types.col.captureFormat': 'Capture',
  'documentSchemas.types.col.ai': 'AI recognition',
  'documentSchemas.types.col.status': 'Status',
  'documentSchemas.type.status.active': 'Active',
  'documentSchemas.type.status.inactive': 'Inactive',
  'documentSchemas.types.empty': 'No document types yet.',
  'documentSchemas.types.noResults': 'No matching document types.',
  // Document owner (contract `entity`, lowercase) — Approval Routing list/form read these words too.
  'documentSchemas.entity.personnel': 'Personnel document',
  'documentSchemas.entity.vehicle': 'Vehicle document',
  'documentSchemas.entity.company': 'Company document',
  // Validity rule (contract `expiryRule`). `documents.expiryHint.*`: per-rule hint shared by the admin form
  // and the upload forms.
  'documentSchemas.expiryRule.EndDateRequired': 'End date required',
  'documentSchemas.expiryRule.EndDateOptional': 'End date optional',
  'documentSchemas.expiryRule.NoExpiry': 'No expiry',
  'documents.expiryHint.EndDateRequired':
    'An end date is required; the document becomes invalid once it passes.',
  'documents.expiryHint.EndDateOptional':
    'An end date is optional; if entered, its expiry is tracked.',
  'documents.expiryHint.NoExpiry': 'No end date is tracked for this document type.',
  // Capture format (contract `captureFormat`): list short name + form option.
  'documentSchemas.captureFormat.Card': 'Card',
  'documentSchemas.captureFormat.Page': 'Page',
  'documentSchemas.captureFormat.option.Card': 'Card (front and back)',
  'documentSchemas.captureFormat.option.Page': 'Page (A4)',
  'documentSchemas.ai.manualOnly': 'Manual only',
  'documentSchemas.ai.unknownSr': 'AI recognition status could not be retrieved',
  // AI recognition mark (`RecognitionMark`: Document Schemas + the expert's personnel document rows).
  'documents.recognition.set': 'AI v{{n}}',
  'documents.recognition.none': 'Not AI-recognised',
  'documents.recognition.srSet': 'AI recognised this file as this type (recognition release {{n}})',
  // Document type picker (§27 registry; company/personnel/vehicle add modals) + end-date rule (GL #7).
  'documentTypes.placeholder': 'Select a document type',
  'documentTypes.loading': 'Loading…',
  'documentTypes.loadError': 'Document types could not be loaded.',
  'documentTypes.retry': 'Try again',
  'documentTypes.empty':
    'No active document type is available. Document types are managed in Document Schemas.',
  'documentTypes.required': 'Document type is required.',
  'documentTypes.typeRejected':
    'This document type can no longer be used. The type list has been refreshed; please choose again.',
  'documents.field.validUntilRequired': 'An end date is required for this document type.',
  'documentSchemas.form.create.title': 'New document type',
  'documentSchemas.form.edit.title': 'Edit document type',
  'documentSchemas.form.create': 'Create',
  'documentSchemas.form.save': 'Save',
  'documentSchemas.form.selectPlaceholder': 'Select',
  'documentSchemas.form.field.entity': 'Document group',
  'documentSchemas.form.field.code': 'Code',
  'documentSchemas.form.codeHint':
    'Starts with a capital letter; no Turkish letters or spaces. Cannot be changed later.',
  'documentSchemas.form.section.labels': 'Label',
  'documentSchemas.form.field.labelTr': 'Türkçe',
  'documentSchemas.form.field.labelEn': 'English',
  'documentSchemas.form.field.labelDe': 'Deutsch',
  'documentSchemas.form.section.rules': 'Rules',
  'documentSchemas.form.field.expiryRule': 'Validity rule',
  'documentSchemas.form.field.captureFormat': 'Capture format',
  'documentSchemas.form.captureFormatHint': 'Only sets the camera frame in the mobile app.',
  'documentSchemas.form.field.sortOrder': 'Order',
  'documentSchemas.form.sortOrderHint': 'If left empty, it is added at the end of this group.',
  'documentSchemas.form.field.isActive': 'Active',
  'documentSchemas.form.isActiveHint':
    'An inactive type cannot be chosen for uploads; permits that require it cannot become ready.',
  'documentSchemas.form.validation.entityRequired': 'Select the document group.',
  'documentSchemas.form.validation.codeRequired': 'Code is required.',
  'documentSchemas.form.validation.codeInvalid':
    'The code must start with a capital letter and contain only English letters and digits (2-40 characters).',
  'documentSchemas.form.validation.codeReserved':
    'The code "Other" is reserved; enter another code.',
  'documentSchemas.form.validation.labelRequired': 'Label is required.',
  'documentSchemas.form.validation.labelInvalid':
    'The label can be at most {{max}} characters and cannot contain control or invisible characters. Retype the text by hand.',
  'documentSchemas.form.validation.ruleRequired': 'Select a validity rule.',
  'documentSchemas.form.validation.formatRequired': 'Select a capture format.',
  'documentSchemas.form.validation.sortOrderRequired': 'Order is required.',
  'documentSchemas.form.validation.sortOrderInvalid': 'Order must be a whole number of 0 or more.',
  // Confirms (D1/D2): scope "all companies"; the rule change is direction-aware.
  'documentSchemas.confirm.deactivate.title': 'Deactivate document type',
  'documentSchemas.confirm.deactivate.confirm': 'Deactivate',
  'documentSchemas.confirm.deactivate.lead':
    '"{{label}}" ({{entity}}) will be deactivated in all companies.',
  'documentSchemas.confirm.deactivate.permits':
    'Permits that require this type cannot become ready until it is reactivated or the requirement is removed.',
  'documentSchemas.confirm.deactivate.documents':
    'Deactivation does not change existing documents.',
  'documentSchemas.confirm.rule.title': 'Change validity rule',
  'documentSchemas.confirm.rule.confirm': 'Change rule',
  'documentSchemas.confirm.rule.lead':
    'The validity rule of "{{label}}" ({{entity}}) will change in all companies: {{from}} → {{to}}.',
  'documentSchemas.confirm.rule.retroactive':
    'The new rule applies retroactively to existing documents in all companies.',
  'documentSchemas.confirm.rule.toRequired':
    'Existing documents without an end date count as "Missing"; permits that require this type are blocked in all companies.',
  'documentSchemas.confirm.both.title': 'This change affects permits and documents',
  'documentSchemas.confirm.both.confirm': 'Save and apply',
  'documentSchemas.confirm.both.lead':
    '"{{label}}" ({{entity}}) will be deactivated in all companies and its validity rule will change: {{from}} → {{to}}.',
  // Document type admin error codes (contract §4.6) — the backend language pack overrides these.
  DOCUMENT_TYPE_CODE_EXISTS:
    'This code is already used in this document group (including inactive types; case is ignored). Enter another code.',
  DOCUMENT_TYPE_NOT_FOUND: 'Document type not found. The list has been refreshed.',

  // ---- Site Entry / Security desk (§29, S32) ----
  'security.nav': 'Site Entry',
  'security.subtitle': 'Check site entry by gate code, personnel QR code or ID number.',
  'security.gate.loadingLabel': 'Checking Site Entry access...',
  'security.forbidden.title': 'You do not have access to Site Entry',
  'security.forbidden.body':
    'You do not have access to the Site Entry module. Please contact your company administrator.',
  'security.forbidden.back': 'Back to dashboard',
  'security.unavailable.title': 'Site Entry could not be reached',
  'security.unavailable.body': 'The service is currently unavailable. Please try again later.',
  'security.unavailable.retry': 'Retry',
  'security.common.loading': 'Loading...',
  'security.context.siteSelect': 'Select site',
  'security.context.sitePlaceholder': 'Select a site',
  'security.context.offline': 'No connection — lookups and updates may fail',
  'security.context.offlineGateStale':
    'No connection — the gate code has stopped refreshing; the code on screen may be stale',
  'security.context.fullScreen': 'Full screen',
  'security.context.exitFullScreen': 'Exit full screen',
  'security.noSites.body':
    'No sites are defined for this company. Sites are defined by the OHS expert/administrator.',
  'security.noSiteSelected.body': 'Select a site first.',
  'security.tab.gate': 'Gate code',
  'security.tab.tc': 'Look up by ID number',
  'security.panel.decision.title': 'Decision',
  'security.panel.entry.title': 'Entry',
  'security.panel.today.title': 'Today',
  'security.giris.tab.ariaLabel': 'Entry method',
  'security.giris.tab.qr.short': 'QR',
  'security.giris.tab.tc.short': 'ID number',
  'security.giris.codeActiveSr': 'code active',
  'security.giris.codeStillLive':
    'The gate code is still open; scans are still being recorded in the background.',
  'security.gate.intro.title': 'Show the gate code',
  'security.gate.intro.body':
    'A 120-second code appears on screen; workers scan it with their own phone. The code refreshes itself.',
  'security.gate.show': 'Show gate code',
  'security.gate.stop': 'Stop code',
  'security.gate.issuing': 'Generating code...',
  'security.gate.workerInstruction': 'Scan this code from your app.',
  'security.gate.rotatesIn': 'Refreshes in {{seconds}}s',
  'security.gate.qrRenderError': 'The code could not be generated.',
  'security.gate.qrAriaLabel': 'Gate code (QR)',
  'security.gate.forbidden.title': 'Gate code access has not been granted',
  'security.gate.forbidden.body':
    "Gate code access has not been granted. Your company administrator must grant the 'security: gate-result' permission from the permission matrix.",
  'security.gate.issueError.body':
    'The code could not be generated. Check your connection and try again.',
  'security.gate.retry': 'Retry',
  'security.gate.expired.title': 'Code expired',
  'security.gate.expired.body': 'This code has expired. Generate a new one.',
  'security.gate.newCode': 'Generate new code',
  'security.gate.hidden.title': 'Code hidden',
  'security.gate.hidden.body': 'A decision is on screen; the code stays hidden until you close it.',
  'security.verdict.allowed': 'ENTRY ALLOWED',
  'security.verdict.denied': 'ENTRY DENIED',
  'security.verdict.notFound': 'NOT FOUND',
  'security.verdict.networkError': 'NO DECISION',
  'security.verdict.decidedAt': 'Decided at {{time}}',
  'security.verdict.decidedAgo': '{{minutes}} min ago',
  'security.verdict.idle.title': 'No decision yet',
  'security.verdict.idle.body':
    'When a gate code is scanned or an ID lookup is run, the decision appears here.',
  'security.verdict.permit.entryPermitted': 'entry permitted',
  'security.verdict.permit.entryNotPermitted': 'entry not permitted',
  'security.verdict.permit.future': 'not yet started',
  'security.verdict.permit.expired': 'expired',
  'security.verdict.permit.grantedPast': 'entry permission granted',
  'security.verdict.permit.notGrantedPast': 'no entry permission',
  'security.verdict.permits.eyebrow': 'PERMITS ({{count}})',
  'security.verdict.permits.more': '+{{count}} more permit(s)',
  'security.verdict.permits.moreBlocked':
    '+{{count}} more permit(s) · {{blocked}} without entry permission',
  'security.verdict.permits.count.future': '{{count}} not yet started',
  'security.verdict.permits.count.expired': '{{count}} expired',
  'security.verdict.permits.scrollMore': 'continues below',
  'security.verdict.permits.empty': 'No permit information.',
  'security.verdict.liveMismatch': 'The permit changed after this scan.',
  'security.verdict.selectedSite': 'Selected site: {{site}}',
  'security.verdict.acknowledge': 'Close',
  'security.verdict.acknowledgeQueued': 'Next ({{count}})',
  'security.verdict.acknowledgeQueuedSr': 'Go to the next decision — {{count}} waiting',
  'security.verdict.acknowledgeQueuedDenialSr': 'The next decision is a denial',
  'security.contractor.srLabel': 'Contractor',
  'security.site.srLabel': 'Site',
  'security.verdict.networkError.title': 'No decision received',
  'security.verdict.networkError.body':
    'Could not reach the server. This is NOT a denial — try again once the connection is back.',
  'security.reason.NoPermit.label': 'No work permit',
  'security.reason.NoPermit.body': 'Do not allow entry.',
  'security.reason.NoPermit.action':
    'Refer the person to the contractor representative — a work permit must be opened.',
  'security.reason.OutOfSite.label': 'Not this site',
  'security.reason.OutOfSite.body': 'Do not allow entry.',
  'security.reason.OutOfSite.action': 'Ask for the correct site; check your site selection.',
  'security.reason.EntryNotPermitted.label': 'Entry not granted',
  'security.reason.EntryNotPermitted.body': 'Do not allow entry.',
  'security.reason.EntryNotPermitted.action': 'Notify the OHS expert — entry has not been granted.',
  'security.reason.OutOfValidity.label': 'Outside validity period',
  'security.reason.OutOfValidity.body': 'Do not allow entry.',
  'security.reason.OutOfValidity.action':
    'The permit is not currently valid — the contractor representative must extend it.',
  'security.reason.Terminal.label': 'Permit closed / rejected',
  'security.reason.Terminal.body': 'Do not allow entry.',
  'security.reason.Terminal.action':
    'Notify the OHS expert — this permit has been closed or rejected.',
  'security.reason.unknown.label': 'Reason not recognised',
  'security.reason.unknown.body': 'This result arrived with an unrecognised code.',
  'security.reason.unknown.action': 'Scan again; if this persists, notify the OHS expert.',
  'security.reason.TokenExpired.label': 'Code expired',
  'security.reason.TokenConsumed.label': 'Code reached its scan limit',
  'security.reason.TokenExpired.action':
    'Ask the worker to refresh their entry QR code; it renews automatically after a short while.',
  'security.reason.TokenConsumed.action':
    'This QR code has already been scanned. Ask the worker to generate a new entry QR code.',
  'security.reason.TokenInvalid.label': 'Invalid QR code',
  'security.reason.TokenInvalid.action':
    'The code could not be read or does not belong to this site. Ask the worker to show their entry QR code again.',
  'security.tab.scan': 'Scan personnel QR code',
  'security.giris.tab.scan.short': 'Personnel QR',
  'security.scan.intro.title': 'Scan the personnel entry QR code',
  'security.scan.intro.body':
    'Have the worker show the entry QR code generated in their mobile app to the camera; entry eligibility is checked instantly.',
  'security.scan.start': 'Open camera',
  'security.scan.stop': 'Close camera',
  'security.scan.instruction': 'Align the worker entry QR code within the camera frame.',
  'security.scan.verifying': 'Verifying...',
  'security.scan.cameraAriaLabel': 'Personnel QR code scanning camera preview',
  'security.scan.cameraError.denied.title': 'Camera permission denied',
  'security.scan.cameraError.denied.body':
    'Allow camera access in your browser and try again, or enter the code manually below.',
  'security.scan.cameraError.noDevice.title': 'No camera found',
  'security.scan.cameraError.noDevice.body':
    'No usable camera was found on this device. You can verify by entering the code manually below.',
  'security.scan.cameraError.error.title': 'Camera could not start',
  'security.scan.cameraError.error.body':
    'The camera is unavailable right now. You can verify by entering the code manually below.',
  'security.scan.manual.toggle': 'Enter code manually',
  'security.scan.manual.tryCamera': 'Try the camera',
  'security.scan.manual.hint':
    'If you cannot scan the worker entry QR code, paste its content below to verify.',
  'security.scan.manual.label': 'QR code',
  'security.scan.manual.placeholder': 'Paste the QR code content',
  'security.scan.manual.submit': 'Verify',
  'security.scan.manual.validation.required': 'Please enter the code to verify.',
  'security.tc.field.label': 'ID number (T.C. Kimlik No)',
  'security.tc.field.placeholder': '11-digit ID number',
  'security.tc.submit': 'Look up',
  'security.tc.hint': 'Look up a worker by ID number when you have no camera or code.',
  'security.tc.validation.required': 'ID number is required.',
  'security.tc.validation.invalid': 'Enter a valid ID number.',
  'security.tc.notFound.title': 'Not found',
  'security.tc.notFound.action':
    'Re-enter the ID number. If it is correct, this person is not registered with this company — refer them to the contractor representative.',
  'security.day.summary':
    '{{total}} entries · {{security}} security · {{selfAsserted}} self-declared',
  'security.day.empty': 'No entries at this site yet today.',
  'security.day.error': "Today's list could not be loaded.",
  'security.day.methodDisclaimer':
    "Rows from the gate code are the worker's own declaration; they have not been verified by security.",
  'security.day.filter.all': 'All',
  'security.day.filter.allowed': 'Entrants',
  'security.day.filter.groupLabel': 'Today filter',
  'security.day.status.allowed': 'Entered',
  'security.day.status.denied': 'Denied',
  'security.day.col.status': 'Status',
  'security.day.col.time': 'Time',
  'security.day.col.name': 'Name',
  'security.day.col.contractor': 'Contractor',
  'security.day.col.method': 'Method',
  'security.day.col.reason': 'Reason',
  'security.day.truncated':
    'Some denied attempts are not shown (only the newest 200 are shown); older denials do not appear in this list.',
  'security.day.deniedNote': 'Also {{count}} denied attempt(s) — not included in the entry count.',
  'security.day.col.detail': 'Detail',
  'security.common.close': 'Close',
  'security.detail.title': 'Entry record',
  'security.detail.open': 'Open entry record — {{name}}, {{time}}',
  'security.detail.section.reason': 'Denial reason',
  'security.detail.deniedAt': 'This attempt was denied at {{time}}.',
  'security.detail.permits.title': 'Compliance',
  'security.detail.permits.asOf': 'Current status — as of {{time}}',
  'security.detail.permits.empty': 'No permit record scoped to this site.',
  'security.detail.error': 'The permit list could not be loaded.',
  'security.eligibility.eyebrow': 'COMPLIANCE · {{title}}',
  'security.eligibility.documents': 'Required documents',
  'security.eligibility.trainings': 'OHS trainings',
  'security.eligibility.approval': 'OHS expert approval',
  'security.eligibility.approval.srLabel': 'OHS expert approval',
  'security.eligibility.state.verified': 'Verified',
  'security.eligibility.state.completed': 'Completed',
  'security.eligibility.state.missing': 'Missing ({{count}})',
  'security.eligibility.state.missingUnknown': 'Missing',
  'security.eligibility.state.granted': 'Granted',
  'security.eligibility.state.awaiting': 'Awaiting',
  'security.eligibility.state.revoked': 'Withdrawn',
  'security.eligibility.route.contractor':
    'Documents or training are missing — refer them to the contractor representative.',
  'security.eligibility.route.expert':
    'Documents and training are complete — awaiting approval from the OHS expert.',
  'security.eligibility.items.unresolved': 'Missing, but the name could not be resolved.',
  'security.method.gateQr': 'gate code',
  'security.method.gateQr.selfAsserted': 'gate code (self-asserted)',
  'security.method.tcLookup': 'ID lookup',
  'security.method.personnelQr': 'security',
};

const de: Record<string, string> = {
  'pagination.summary': '{{from}}–{{to}} von {{total}}',
  'pagination.summaryEmpty': '0 Einträge',
  'app.title': 'İSG Portal — Fachkraft-Portal',
  'hazard.1': 'Weniger gefährlich',
  'hazard.2': 'Gefährlich',
  'hazard.3': 'Sehr gefährlich',
  'common.clearFilters': 'Filter zurücksetzen',
  'common.cancel': 'Abbrechen',
  'personnelForm.tc.show': 'Anzeigen',
  'personnelForm.tc.hide': 'Ausblenden',
  'personnelForm.field.phone': 'Telefon',
  'personnelForm.field.email': 'E-Mail',
  'personnelForm.field.tcKimlikNo': 'T.C.-Ausweisnummer',
  'personnelForm.masked.notice':
    'Persönliche Angaben sind teilweise ausgeblendet, da Ihnen die Berechtigung „Personenbezogene Daten“ fehlt.',
  // Gemeinsames Personal-Bearbeitungsformular (#29) — dieselben Schlüssel wie SP; T.C.-Texte nutzen
  // den EP-eigenen Feldbegriff.
  'personnelForm.edit.action': 'Bearbeiten',
  'personnelForm.edit.title': 'Personal bearbeiten',
  'personnelForm.field.firstName': 'Vorname',
  'personnelForm.field.lastName': 'Nachname',
  'personnelForm.field.tcKimlikNoHint':
    '11 Ziffern mit gültiger Prüfsumme; kann nur einmal erfasst werden.',
  'personnelForm.field.accessLevel': 'Zugriffsebene',
  'personnelForm.access.personeli': 'Mitarbeiter',
  'personnelForm.access.yetkili': 'Verantwortlicher',
  'personnelForm.field.accessHint':
    'Ein Verantwortlicher kann im Web-Portal Personal hinzufügen und Firmendokumente hochladen; ein Mitarbeiter sieht nur seine eigenen Daten in der mobilen App.',
  'personnelForm.field.active': 'Aktiv',
  'personnelForm.field.activeHint':
    'Inaktives Personal kann sich nicht anmelden und hat keinen Zugang zu Standorten.',
  'personnelForm.refreshNote':
    'Änderungen der Zugriffsebene und des Aktiv-/Inaktiv-Status werden spätestens innerhalb von 15 Minuten (bei der nächsten Sitzungsaktualisierung) wirksam.',
  'personnelForm.lock.tcSetOnce':
    'Nach der Eingabe kann die T.C.-Ausweisnummer über diesen Bildschirm nicht mehr geändert werden. Wenden Sie sich bei Änderungsbedarf an den Support.',
  'personnelForm.lock.tcNoPermission':
    'Die T.C.-Ausweisnummer können nur Benutzer mit der Berechtigung „Personenbezogene Daten“ erfassen.',
  'personnelForm.lock.contact':
    'Telefon und E-Mail werden bei der Aktivierung des Kontos durch die Person bestätigt und gespeichert; sie können hier nicht geändert werden.',
  'personnelForm.submit': 'Speichern',
  'personnelForm.saved': 'Informationen aktualisiert.',
  'personnelForm.discardEdit.title': 'Änderungen verwerfen?',
  'personnelForm.discardEdit.body':
    'Wenn Sie die Bearbeitung verlassen, werden Ihre Änderungen nicht gespeichert.',
  'personnelForm.discardEdit.cancel': 'Zurück',
  'personnelForm.discardEdit.confirm': 'Änderungen verwerfen',
  'personnelForm.validation.firstNameRequired': 'Vorname ist erforderlich.',
  'personnelForm.validation.lastNameRequired': 'Nachname ist erforderlich.',
  'personnelForm.validation.firstNameTooLong':
    'Der Vorname darf höchstens {{max}} Zeichen lang sein.',
  'personnelForm.validation.lastNameTooLong':
    'Der Nachname darf höchstens {{max}} Zeichen lang sein.',
  'personnelForm.validation.tcInvalid':
    'Die eingegebene T.C.-Ausweisnummer ist ungültig. Bitte überprüfen Sie sie und versuchen Sie es erneut.',
  'personnelForm.validation.tcExistsFallback':
    'Es existiert bereits ein Mitarbeiterdatensatz mit dieser T.C.-Ausweisnummer.',
  'personnelForm.hydrate.loading': 'Personendatensatz wird geladen …',
  'personnelForm.hydrate.failed': 'Personendatensatz konnte nicht geladen werden.',
  'personnelForm.hydrate.retry': 'Erneut versuchen',
  'personnelForm.hydrate.notInRegistry':
    'Diese Person ist nicht mehr im Verzeichnis des Auftragnehmers und kann nicht bearbeitet werden.',
  'common.close': 'Schließen',
  'common.loading': 'Wird geladen...',
  'compliance.valid': 'Konform',
  'compliance.expiring': 'Läuft bald ab',
  'compliance.expired': 'Abgelaufen',
  'compliance.missing': 'Fehlt',
  'common.noResults.body': 'Ändern oder löschen Sie Suche und Filter.',
  'common.compactRows': 'Kompakte Zeilen',
  'common.moreFilters': 'Weitere Filter',
  'permitTypes.nav': 'Genehmigungsarten',
  'permitTypes.title': 'Genehmigungsarten',
  'permitTypes.subtitle':
    'Verwalten Sie Ihre Genehmigungsarten, PSA- und Kontrollpunkt-Kataloge sowie die Genehmigungsweiterleitung.',
  'permitTypes.list.search': 'Arten suchen',
  'permitTypes.list.searchPlaceholder': 'Nach Name suchen',
  'permitTypes.list.new': 'Neue Art',
  'permitTypes.list.count': '{{count}} Genehmigungsarten aufgelistet',
  'permitTypes.list.count_one': '{{count}} Genehmigungsart aufgelistet',
  'permitTypes.list.empty': 'Noch keine Genehmigungsarten.',
  'permitTypes.list.empty.body': 'Sobald Sie die erste Art erstellen, erscheint sie hier.',
  'permitTypes.list.noResults': 'Keine Genehmigungsarten entsprechen Ihren Filtern.',
  'permitTypes.list.col.name': 'Name',
  'permitTypes.list.col.hazard': 'Gefahrenklasse',
  'permitTypes.list.col.requiredDocs': 'Erforderliche Dokumente',
  'permitTypes.list.col.status': 'Status',
  'permitTypes.list.filter.status': 'Status',
  'permitTypes.list.filter.allStatuses': 'Alle Status',
  'permitTypes.list.filter.active': 'Aktiv',
  'permitTypes.list.filter.inactive': 'Inaktiv',
  'permitTypes.list.action.delete': 'Löschen',
  'permitTypes.list.action.openMenu': 'Aktionen für {{name}}',
  'permitTypes.list.created': 'Genehmigungsart erstellt.',
  'permitTypes.list.updated': 'Genehmigungsart aktualisiert.',
  'permitTypes.list.deleted': 'Genehmigungsart gelöscht.',
  'permitTypes.status.active': 'Aktiv',
  'permitTypes.status.inactive': 'Inaktiv',
  'permitTypes.common.actions': 'Aktionen',
  'permitTypes.common.loading': 'Wird geladen...',
  'permitTypes.common.cancel': 'Abbrechen',
  'permitTypes.common.save': 'Speichern',
  'permitTypes.common.create': 'Erstellen',
  'permitTypes.common.close': 'Schließen',
  'permitTypes.pagination.nav': 'Seitennummerierung',
  'permitTypes.pagination.previous': 'Zurück',
  'permitTypes.pagination.next': 'Weiter',
  'permitTypes.form.create.title': 'Neue Genehmigungsart',
  'permitTypes.form.edit.title': 'Genehmigungsart bearbeiten',
  'permitTypes.form.description':
    'Geben Sie den Namen der Art, die Gefahrenklasse und die erforderlichen Dokumente ein.',
  'permitTypes.form.loading': 'Art wird geladen...',
  'permitTypes.form.field.name': 'Name',
  'permitTypes.form.field.description': 'Beschreibung',
  'permitTypes.form.field.hazardClass': 'Gefahrenklasse',
  'permitTypes.form.field.requiredDocuments': 'Erforderliche Dokumente',
  'permitTypes.form.requiredDocs.personnel': 'Personaldokumente',
  'permitTypes.form.requiredDocs.vehicle': 'Fahrzeugdokumente',
  'permitTypes.form.requiredDocs.inactiveHint':
    'Inaktive Dokumenttypen können nicht hochgeladen werden; bleibt einer ausgewählt, können Genehmigungen dieser Art nicht bereit werden.',
  'permitTypes.form.requiredDocs.rejected':
    'Diese Dokumenttypen können nicht mehr ausgewählt werden und wurden aus der Auswahl entfernt: {{types}}. Die Dokumenttypliste wurde aktualisiert; prüfen Sie die Auswahl vor dem Speichern.',
  'permitTypes.form.field.isActive': 'Aktiv',
  'permitTypes.form.hazardNone': 'Sonstige',
  'permitTypes.form.hazardHint':
    "Bei Auswahl von 'Sonstige' wird die Gefahrenklasse bei der Genehmigungserstellung manuell gewählt.",
  'permitTypes.form.requiredDocsNote':
    'Wählen Sie die Personal- und Fahrzeugdokumente, die für eine Genehmigung dieser Art erforderlich sind.',
  'permitTypes.form.isActiveHint':
    'Eine inaktive Art kann für neue oder aktualisierte Genehmigungen nicht gewählt werden; bestehende Genehmigungen sind nicht betroffen.',
  'permitTypes.validation.nameRequired': 'Name ist erforderlich.',
  'permitTypes.delete.title': 'Genehmigungsart löschen',
  'permitTypes.delete.body':
    'Die Art "{{name}}" wird gelöscht. Bestehende Genehmigungen sind nicht betroffen. Fortfahren?',
  'permitTypes.delete.confirm': 'Löschen',
  'permitTypes.gate.loadingLabel': 'Zugriff auf Genehmigungsarten wird geprüft...',
  'permitTypes.forbidden.title': 'Sie haben keinen Zugriff',
  'permitTypes.forbidden.body':
    'Sie haben keinen Zugriff auf das Modul Genehmigungsarten. Bitte wenden Sie sich an Ihren Unternehmensadministrator.',
  'permitTypes.forbidden.back': 'Zurück zum Dashboard',
  'permitTypes.unavailable.title': 'Genehmigungsarten konnten nicht geladen werden',
  'permitTypes.unavailable.body':
    'Der Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
  'permitTypes.unavailable.retry': 'Erneut versuchen',
  'permitTypes.catalog.tabs.label': 'Genehmigungsarten-Bereiche',
  'permitTypes.catalog.tabs.types': 'Arten',
  'permitTypes.catalog.tabs.ppe': 'PSA-Katalog',
  'permitTypes.catalog.tabs.controls': 'Kontrollpunkte',
  'permitTypes.catalog.col.origin': 'Quelle',
  'permitTypes.catalog.origin.default': 'Allgemein',
  'permitTypes.catalog.origin.custom': 'Firma',
  'permitTypes.catalog.inactiveSuffix': '(inaktiv)',
  'permitTypes.catalog.delete.confirm': 'Deaktivieren',
  'permitTypes.catalog.form.field.isActive': 'Aktiv',
  'permitTypes.catalog.form.isActiveHint':
    'Ein inaktives Element bleibt für die Zuordnung neuer Arten auswählbar, wird aber nicht empfohlen.',
  'permitTypes.catalog.ppe.title': 'PSA-Katalog',
  'permitTypes.catalog.ppe.search': 'PSA suchen',
  'permitTypes.catalog.ppe.searchPlaceholder': 'Nach Name suchen',
  'permitTypes.catalog.ppe.new': 'Neue PSA',
  'permitTypes.catalog.ppe.count': '{{count}} PSA-Elemente aufgelistet',
  'permitTypes.catalog.ppe.count_one': '{{count}} PSA-Element aufgelistet',
  'permitTypes.catalog.ppe.empty': 'Noch keine PSA-Elemente.',
  'permitTypes.catalog.ppe.empty.body':
    'Sobald Sie das erste Element erstellen, erscheint es hier.',
  'permitTypes.catalog.ppe.noResults': 'Keine PSA-Elemente entsprechen Ihren Filtern.',
  'permitTypes.catalog.ppe.col.name': 'Name',
  'permitTypes.catalog.ppe.created': 'PSA-Element erstellt.',
  'permitTypes.catalog.ppe.updated': 'PSA-Element aktualisiert.',
  'permitTypes.catalog.ppe.deleted': 'PSA-Element deaktiviert.',
  'permitTypes.catalog.ppe.delete.title': 'PSA-Element deaktivieren',
  'permitTypes.catalog.ppe.delete.body':
    'Möchten Sie "{{name}}" wirklich deaktivieren? Bereits mit einer Art verknüpfte Genehmigungen sind nicht betroffen.',
  'permitTypes.catalog.ppe.validation.nameRequired': 'Name ist erforderlich.',
  'permitTypes.catalog.ppe.form.create.title': 'Neues PSA-Element',
  'permitTypes.catalog.ppe.form.edit.title': 'PSA-Element bearbeiten',
  'permitTypes.catalog.ppe.form.description':
    'Geben Sie den PSA-Namen und eine optionale Beschreibung ein.',
  'permitTypes.catalog.ppe.form.field.name': 'Name',
  'permitTypes.catalog.ppe.form.field.description': 'Beschreibung',
  'permitTypes.catalog.control.title': 'Kontrollpunkte',
  'permitTypes.catalog.control.search': 'Kontrollpunkte suchen',
  'permitTypes.catalog.control.searchPlaceholder': 'Nach Text suchen',
  'permitTypes.catalog.control.new': 'Neuer Kontrollpunkt',
  'permitTypes.catalog.control.count': '{{count}} Kontrollpunkte aufgelistet',
  'permitTypes.catalog.control.count_one': '{{count}} Kontrollpunkt aufgelistet',
  'permitTypes.catalog.control.empty': 'Noch keine Kontrollpunkte.',
  'permitTypes.catalog.control.empty.body':
    'Sobald Sie den ersten Punkt erstellen, erscheint er hier.',
  'permitTypes.catalog.control.noResults': 'Keine Kontrollpunkte entsprechen Ihren Filtern.',
  'permitTypes.catalog.control.col.text': 'Kontrollpunkt',
  'permitTypes.catalog.control.created': 'Kontrollpunkt erstellt.',
  'permitTypes.catalog.control.updated': 'Kontrollpunkt aktualisiert.',
  'permitTypes.catalog.control.deleted': 'Kontrollpunkt deaktiviert.',
  'permitTypes.catalog.control.delete.title': 'Kontrollpunkt deaktivieren',
  'permitTypes.catalog.control.delete.body':
    'Möchten Sie "{{text}}" wirklich deaktivieren? Bereits mit einer Art verknüpfte Genehmigungen sind nicht betroffen.',
  'permitTypes.catalog.control.validation.textRequired': 'Kontrollpunkt-Text ist erforderlich.',
  'permitTypes.catalog.control.form.create.title': 'Neuer Kontrollpunkt',
  'permitTypes.catalog.control.form.edit.title': 'Kontrollpunkt bearbeiten',
  'permitTypes.catalog.control.form.description':
    'Geben Sie die Kontrollaussage und eine optionale Beschreibung ein.',
  'permitTypes.catalog.control.form.field.text': 'Kontrollpunkt',
  'permitTypes.catalog.control.form.field.description': 'Beschreibung',
  'permitTypes.form.field.protectiveEquipment': 'Erforderliche PSA',
  'permitTypes.form.protectiveEquipmentNote':
    'Wählen Sie die persönliche Schutzausrüstung, die für eine Genehmigung dieser Art erforderlich ist.',
  'permitTypes.form.protectiveEquipmentEmpty':
    'Keine PSA-Elemente im Katalog. Fügen Sie zuerst Elemente über den Reiter PSA-Katalog hinzu.',
  'permitTypes.form.field.controlItems': 'Kontrollpunkte',
  'permitTypes.form.controlItemsNote':
    'Wählen Sie die Kontrollpunkte, die die Sicherheitsfachkraft bei einer Genehmigung dieser Art abhakt.',
  'permitTypes.form.controlItemsEmpty':
    'Keine Kontrollpunkte im Katalog. Fügen Sie zuerst Elemente über den Reiter Kontrollpunkte hinzu.',
  'app.name': 'İSG Portal',
  'app.expertPortal': 'Fachkraft-Portal',
  'app.tagline': 'Arbeitssicherheit und Gesundheitsschutz auf einer Plattform verwalten.',

  'login.title': 'Beim Fachkraft-Portal anmelden',
  'login.subtitle': 'Geben Sie E-Mail und Passwort ein, um auf Ihr Konto zuzugreifen.',
  'login.email': 'E-Mail',
  'login.emailPlaceholder': 'name@firma.com',
  'login.password': 'Passwort',
  'login.submit': 'Anmelden',
  'login.forgotPassword': 'Passwort vergessen',

  'forgot.title': 'Passwort zurücksetzen',
  'forgot.subtitle':
    'Geben Sie die mit Ihrem Konto verknüpfte E-Mail oder Telefonnummer ein; wir senden einen Code.',
  'forgot.identifier': 'E-Mail oder Telefon',
  'forgot.submit': 'Code senden',
  'forgot.backToLogin': 'Zurück zur Anmeldung',
  'forgot.sentTitle': 'Code gesendet',
  'forgot.sentBody':
    'Falls Ihr Konto besteht, haben wir einen Bestätigungscode gesendet. Damit können Sie ein neues Passwort festlegen.',
  'forgot.continue': 'Ich habe den Code, weiter',

  'reset.title': 'Neues Passwort festlegen',
  'reset.subtitle': 'Geben Sie den erhaltenen Bestätigungscode und Ihr neues Passwort ein.',
  'reset.code': 'Bestätigungscode',
  'reset.newPassword': 'Neues Passwort',
  'reset.passwordHint': 'Mindestens 8 Zeichen, davon ein Buchstabe und eine Ziffer.',
  'reset.submit': 'Passwort aktualisieren',
  'reset.successTitle': 'Ihr Passwort wurde aktualisiert',
  'reset.successBody': 'Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
  'reset.toLogin': 'Zur Anmeldung',

  'layout.dashboard': 'Übersicht',
  'layout.nav.primary': 'Hauptnavigation',
  'layout.skipToContent': 'Zum Inhalt springen',
  'layout.account': 'Konto',
  'layout.profile': 'Profil',
  'layout.logout': 'Abmelden',

  'layout.navGroup.operations': 'Betrieb',
  'layout.navGroup.compliance': 'Compliance',
  'layout.navGroup.system': 'System',
  'layout.rail.collapse': 'Menü einklappen',
  'layout.rail.expand': 'Menü ausklappen',
  'layout.rail.permitsPending': 'Arbeitserlaubnisse: {{count}} warten auf Freigabe',
  'layout.user.menu': 'Benutzermenü',
  'layout.user.signedInAs': 'Angemeldet als',
  'layout.user.role': 'Rolle',
  'layout.user.company': 'Unternehmen',
  'layout.user.language': 'Sprache',

  // Unbekannte Route (404, owner review B2 item 5) — innerhalb der Shell (bei Anmeldung), ohne
  // Breadcrumb (ein "unbekannter" Ort hat kein definiertes übergeordnetes Element); Rückkehr
  // zum Dashboard.
  'notFound.title': 'Seite nicht gefunden',
  'notFound.body': 'Die gesuchte Seite wurde verschoben oder existiert nicht.',
  'notFound.back': 'Zurück zum Dashboard',

  // Globale Kopfzeilensuche (S34-5, api-contract §34.3) — Carbon-UI-Shell-Muster; nur sichtbar
  // mit `permits/list`-Berechtigung (`AppHeader.tsx`).
  'search.trigger': 'Suchen',
  'search.shortcutHint': 'Mit „/“ öffnen',
  'search.label': 'Globale Suche',
  'search.placeholder': 'Arbeitserlaubnisse, Auftragnehmer oder Personal suchen',
  'search.close': 'Suche schließen',
  'search.minChars': 'Geben Sie mindestens 2 Zeichen ein, um zu suchen.',
  'search.loading': 'Wird gesucht…',
  'search.noResults': 'Keine Ergebnisse',
  'search.noResults.body': 'Versuchen Sie einen anderen Suchbegriff.',
  'search.group.permits': 'Arbeitserlaubnisse',
  'search.group.contractors': 'Auftragnehmer',
  'search.group.personnel': 'Personal',
  'search.group.hasMore': 'Es sind weitere Ergebnisse verfügbar; grenzen Sie Ihre Suche ein.',
  'search.status.results': '{{count}} Ergebnisse gefunden',
  'search.status.results_one': '{{count}} Ergebnis gefunden',

  'dashboard.site.label': 'Standort',
  'dashboard.site.all': 'Alle Standorte',

  // --- Dashboard (S34-4, api-contract §34) ---
  'dashboard.title': 'Dashboard',
  'dashboard.retry': 'Erneut versuchen',
  'dashboard.kpi.activePermits': 'Aktive Erlaubnisse',
  'dashboard.kpi.pendingApproval': 'Erlaubnisse zur Genehmigung',
  // QA B5 (S35-qa.md "B4 re-check" #6) — die alte Formulierung (48 Zeichen) brauchte bei
  // 1366×768 mit ausgeklappter Seitenleiste 3 Zeilen und wurde vom `line-clamp-2` in
  // `KpiTile.tsx` abgeschnitten ("Tagen ablaufen" verschwand). Kürzere Form, misst nach:
  // 2 Zeilen bei ~140px Kachelbreite (gemessen mit IBM Plex Sans 14px/20px).
  'dashboard.kpi.expiringPermits': 'Erlaubnisse mit Ablauf in 7 Tagen',
  'dashboard.kpi.personnelNotReady': 'Personal mit gesperrtem Zutritt',
  'dashboard.kpi.personnelNotReady.context_one': 'In {{count}} Erlaubnisdatensatz',
  'dashboard.kpi.personnelNotReady.context': 'In {{count}} Erlaubnisdatensätzen',
  'dashboard.kpi.entriesToday': 'Heutige Zutritte',
  'dashboard.kpi.entriesToday.context_one': '{{count}} Besucher vor Ort',
  'dashboard.kpi.entriesToday.context': '{{count}} Besucher vor Ort',
  // owner review B4-7 — eski etiket ("Auftragnehmer mit abgelaufenen Dokumenten", 41 karakter)
  // 1366px'te (nav genişletilmiş) `line-clamp-2` ile bile elipse düşüyordu; kısa biçim (bkz.
  // S35-design.md "QA note (a)") ANLAMI korur, DE konuşan sahip onayı ayrı bir tur gerektirebilir.
  'dashboard.kpi.contractorDocsExpiring': 'Auftragnehmer mit Ablauf',
  // owner review B4-7 — kısa, sayı-önce biçim; çekim farkı yok, `_one` varyantı GEREKMİYOR.
  'dashboard.kpi.contractorDocsExpiring.context': 'Fällig in 30 Tagen: {{count}}',
  'dashboard.kpi.scopeCompanyWide': 'Unternehmensweit',
  'dashboard.actions.title': 'Handlungsbedarf',
  'dashboard.actions.filter.all': 'Alle',
  'dashboard.actions.filter.groupLabel': 'Filter nach Aktionsart',
  'dashboard.actions.kind.entryBlocked': 'Zutritt gesperrt',
  'dashboard.actions.kind.permitExpiring': 'Erlaubnis läuft ab',
  'dashboard.actions.kind.pendingApproval': 'Wartet auf Genehmigung',
  'dashboard.actions.line.personReason': '{{person}} — {{reason}}',
  'dashboard.actions.reason.missingDocument': 'Fehlendes Dokument: {{document}}',
  'dashboard.actions.reason.missingTraining': 'Fehlende Schulung: {{training}}',
  'dashboard.actions.reason.missingTraining.generic': 'Fehlende Schulung',
  'dashboard.actions.due.overdue': 'Überfällig',
  'dashboard.actions.due.permitStarted': 'Erlaubnis hat begonnen',
  'dashboard.actions.due.startDatePassed': 'Startdatum ist überschritten',
  'dashboard.actions.due.startsToday': 'Beginnt heute',
  'dashboard.actions.due.startsTomorrow': 'Beginnt morgen',
  'dashboard.actions.due.startsOnDate': 'Beginnt am {{date}}',
  'dashboard.actions.due.endsToday': 'Endet heute',
  'dashboard.actions.due.endsTomorrow': 'Endet morgen',
  'dashboard.actions.due.endsOnDate': 'Endet am {{date}}',
  'dashboard.actions.empty': 'Derzeit ist keine Aktion erforderlich.',
  'dashboard.actions.empty.body':
    'Zutrittssperren, ablaufende Erlaubnisse und Erlaubnisse zur Genehmigung werden hier aufgelistet.',
  'dashboard.actions.empty.filtered': 'Für diese Art liegt keine ausstehende Aktion vor.',
  'dashboard.actions.empty.showAll': 'Alle anzeigen',
  'dashboard.actions.pagination.nav': 'Seitennummerierung',
  'dashboard.actions.pagination.previous': 'Zurück',
  'dashboard.actions.pagination.next': 'Weiter',
  'dashboard.chart.permitsByStatus.title': 'Offene Erlaubnisse nach Status',
  'dashboard.chart.bucket.preparing': 'Wird vorbereitet',
  'dashboard.chart.bucket.withContractor': 'Beim Auftragnehmer',
  'dashboard.chart.bucket.inReview': 'In Prüfung',
  'dashboard.chart.bucket.active': 'Aktiv',
  'dashboard.chart.permitsByStatus.empty': 'Es gibt keine offenen Arbeitserlaubnisse.',
  'dashboard.chart.permitsByStatus.total_one': '{{count}} offene Erlaubnis',
  'dashboard.chart.permitsByStatus.total': '{{count}} offene Erlaubnisse',
  'dashboard.chart.permitsByStatus.terminal': 'Geschlossen / abgelehnt / abgelaufen: {{count}}',
  'dashboard.chart.permitsOpened.title': 'In den letzten 30 Tagen eröffnete Erlaubnisse',
  'dashboard.chart.permitsOpened.axis': 'Anzahl der Erlaubnisse',
  'dashboard.chart.permitsOpened.col.date': 'Datum',
  'dashboard.chart.permitsOpened.empty':
    'In den letzten 30 Tagen wurden keine Erlaubnisse eröffnet.',
  'dashboard.chart.permitsOpened.summary_one':
    '{{count}} Erlaubnis in den letzten 30 Tagen; stärkster Tag {{date}} ({{peakCount}})',
  'dashboard.chart.permitsOpened.summary':
    '{{count}} Erlaubnisse in den letzten 30 Tagen; stärkster Tag {{date}} ({{peakCount}})',
  'dashboard.chart.unavailable': 'Konnte nicht geladen werden',
  'dashboard.entries.title': 'Heutige Zutritte',
  'dashboard.entries.summary': '{{allowed}} Zutritte · {{denied}} abgelehnt',
  'dashboard.entries.col.time': 'Uhrzeit',
  'dashboard.entries.col.name': 'Vor- und Nachname',
  'dashboard.entries.col.contractor': 'Auftragnehmer',
  'dashboard.entries.col.status': 'Status',
  'dashboard.entries.empty': 'Heute gibt es noch keine Zutritte.',
  'dashboard.entries.empty.body': 'Zutritte per Kiosk oder Türcode werden hier aufgelistet.',
  'dashboard.entries.selectSite': 'Wählen Sie einen Standort aus, um die Zutritte zu sehen.',
  'dashboard.entries.selectSite.body':
    'Diese Liste ist standortspezifisch – die Kachel „Heutige Zutritte" oben zählt unternehmensweit.',

  // Profil (Self) — api-contract §18.1
  'profile.title': 'Profil',
  'profile.subtitle': 'Sehen Sie Ihre Kontodaten ein und aktualisieren Sie sie.',
  'profile.loading': 'Profil wird geladen...',
  'profile.info.title': 'Kontodaten',
  'profile.info.subtitle': 'Diese Angaben sind schreibgeschützt.',
  'profile.field.fullName': 'Vor- und Nachname',
  'profile.field.firstName': 'Vorname',
  'profile.field.lastName': 'Nachname',
  'profile.field.email': 'E-Mail',
  'profile.field.company': 'Unternehmen',
  'profile.field.role': 'Rolle',
  'profile.edit.title': 'Namen bearbeiten',
  'profile.edit.subtitle': 'Aktualisieren Sie Ihren angezeigten Namen.',
  'profile.edit.save': 'Speichern',
  'profile.updated': 'Profil aktualisiert.',
  'profile.validation.firstNameRequired': 'Vorname ist erforderlich.',
  'profile.validation.lastNameRequired': 'Nachname ist erforderlich.',
  'profile.password.title': 'Passwort ändern',
  'profile.password.subtitle': 'Wählen Sie zu Ihrer Sicherheit ein starkes Passwort.',
  'profile.password.current': 'Aktuelles Passwort',
  'profile.password.new': 'Neues Passwort',
  'profile.password.confirm': 'Neues Passwort (wiederholen)',
  'profile.password.hint': 'Mindestens 8 Zeichen, davon ein Buchstabe und eine Ziffer.',
  'profile.password.save': 'Passwort aktualisieren',
  'profile.password.updated': 'Ihr Passwort wurde aktualisiert.',
  'profile.password.wrongCurrent': 'Das aktuelle Passwort ist falsch.',
  'profile.validation.currentPasswordRequired': 'Aktuelles Passwort ist erforderlich.',
  'profile.validation.confirmRequired': 'Bitte wiederholen Sie das Passwort.',
  'profile.validation.passwordMismatch': 'Die Passwörter stimmen nicht überein.',

  // --- Mobile App (§26 App-Store-Links; D4) + Systemadmin-App-Link-Einstellung ---
  'layout.mobileApp': 'Mobile App',
  'mobileApp.title': 'Mobile App',
  'mobileApp.subtitle':
    'Laden Sie die İSG-Portal-Manager-App herunter, um Ihre Vor-Ort-Kontrollen, Arbeitserlaubnisse und Benachrichtigungen per Telefon zu erreichen.',
  'appDownload.storesTitle': 'In den Stores herunterladen',
  'appDownload.ios': 'Im App Store laden',
  'appDownload.android': 'Bei Google Play holen',
  'appDownload.comingSoon.body':
    'Die mobile App ist bald in den Stores verfügbar. Die Download-Links erscheinen hier, sobald sie bereit sind.',
  'appDownload.loading': 'App-Informationen werden geladen…',
  // Systemadmin-App-Link-Einstellungsbildschirm (§26.2 PUT /admin/app-settings — IsSystemAdmin)
  'admin.tab.appSettings': 'App-Links',
  'appSettings.field.iosAppUrl': 'iOS-App-Link (App Store)',
  'appSettings.field.androidAppUrl': 'Android-App-Link (Google Play)',
  'appSettings.field.hint':
    'Geben Sie einen vollständigen https-Link ein. Leer lassen, um den Link zu entfernen.',
  'appSettings.validation.invalidUrl':
    'Geben Sie einen gültigen Link ein (muss mit https beginnen).',
  'appSettings.updated': 'Mobile-App-Links aktualisiert.',
  'appSettings.save': 'Speichern',
  'appSettings.loading': 'Links werden geladen…',

  // --- Verwaltung (Admin) — api-contract §9 ---
  'admin.nav': 'Verwaltung',
  'admin.subtitle':
    'Verwalten Sie Rollen und Berechtigungen, Unternehmen, Kiosk-Geräte und App-Links.',
  'admin.tab.roles': 'Berechtigungsverwaltung',
  'admin.tab.companies': 'Unternehmensverwaltung',
  'admin.gate.loadingLabel': 'Verwaltungsbereich wird geladen',
  'admin.forbidden.title': 'Sie haben keinen Zugriff auf diesen Bereich',
  'admin.forbidden.body':
    'Der Verwaltungsbereich ist Systemadministratoren vorbehalten. Wenn Sie Zugriff benötigen, wenden Sie sich bitte an Ihren Administrator.',
  'admin.forbidden.back': 'Zurück zur Übersicht',
  'admin.unavailable.title': 'Verwaltungsdienst nicht erreichbar',
  'admin.unavailable.body':
    'Die Verwaltungs-Endpunkte antworten derzeit nicht. Bitte versuchen Sie es in Kürze erneut.',
  'admin.unavailable.retry': 'Erneut versuchen',

  'admin.common.search': 'Suchen',
  'admin.common.new': 'Neu',
  'admin.common.edit': 'Bearbeiten',
  'admin.common.save': 'Speichern',
  'admin.common.cancel': 'Abbrechen',
  'admin.common.create': 'Erstellen',
  'admin.common.close': 'Schließen',
  'admin.common.loading': 'Wird geladen...',
  'admin.common.empty': 'Keine Einträge gefunden.',
  'admin.common.noData': 'Noch keine Einträge.',
  'admin.common.noData.body': 'Sobald Sie den ersten Eintrag erstellen, erscheint er hier.',
  'admin.common.actions': 'Aktionen',
  'admin.common.createdAt': 'Erstellt',
  'admin.pagination.nav': 'Seitennavigation',
  'admin.pagination.previous': 'Zurück',
  'admin.pagination.next': 'Weiter',

  'admin.roles.title': 'Rollen',
  'admin.roles.count': '{{count}} Rollen aufgelistet',
  'admin.roles.count_one': '{{count}} Rolle aufgelistet',
  'admin.roles.searchPlaceholder': 'Rollenname oder Code suchen',
  'admin.roles.new': 'Neue Rolle',
  'admin.roles.col.name': 'Name',
  'admin.roles.col.value': 'Code',
  'admin.roles.col.scope': 'Geltungsbereich',
  'admin.roles.col.status': 'Status',
  'admin.roles.scope.company': 'Unternehmen #{{id}}',
  'admin.roles.scope.global': 'Global',
  'admin.roles.status.active': 'Aktiv',
  'admin.roles.status.passive': 'Inaktiv',
  'admin.roles.badge.systemAdmin': 'Systemadministrator',
  'admin.roles.action.edit': 'Rolle bearbeiten',
  'admin.roles.action.delete': 'Rolle deaktivieren',
  'admin.roles.action.openMenu': 'Aktionen für {{name}}',
  'admin.roles.create.title': 'Neue Rolle',
  'admin.roles.edit.title': 'Rolle bearbeiten',
  'admin.roles.field.name': 'Rollenname',
  'admin.roles.field.description': 'Beschreibung',
  'admin.roles.field.active': 'Aktiv',
  'admin.roles.field.value': 'Code',
  'admin.roles.delete.title': 'Rolle deaktivieren',
  'admin.roles.delete.body':
    'Die Rolle "{{name}}" wird deaktiviert. Eine inaktive Rolle gewährt keine Berechtigungen. Fortfahren?',
  'admin.roles.delete.confirm': 'Deaktivieren',
  'admin.roles.created': 'Rolle erstellt.',
  'admin.roles.updated': 'Rolle aktualisiert.',
  'admin.roles.deleted': 'Rolle deaktiviert.',

  'admin.perm.title': 'Berechtigungsmatrix',
  'admin.perm.subtitle': 'Modul- und Aktionsberechtigungen der Rolle "{{role}}".',
  'admin.perm.back': 'Zurück zu den Rollen',
  'admin.perm.save': 'Berechtigungen speichern',
  'admin.perm.saved': 'Berechtigungen aktualisiert.',
  'admin.perm.locked':
    'Die Systemadministrator-Rolle ist gesperrt; ihre Berechtigungen können nicht geändert werden.',
  'admin.perm.reset': 'Änderungen verwerfen',
  'admin.perm.auto': 'Automatisch',
  'admin.perm.na': 'In diesem Modul nicht vorhanden',
  'admin.perm.legend':
    'Ein markiertes Feld bedeutet, dass der Rolle diese Aktion erteilt wurde. "Automatische" Aktionen sind öffentlich und erfordern keine Berechtigung.',
  'admin.perm.col.module': 'Modul',
  'admin.perm.cellLabel': '{{module}} — {{action}}',
  'admin.action.list': 'Auflisten',
  'admin.action.get': 'Ansehen',
  'admin.action.create': 'Erstellen',
  'admin.action.update': 'Aktualisieren',
  'admin.action.delete': 'Löschen',
  'admin.action.personal-data': 'Personenbezogene Daten',

  'admin.companies.title': 'Unternehmen',
  'admin.companies.count': '{{count}} Unternehmen aufgelistet',
  'admin.companies.count_one': '{{count}} Unternehmen aufgelistet',
  'admin.companies.searchPlaceholder': 'Name, Firmenname oder Steuernummer suchen',
  'admin.companies.new': 'Neues Unternehmen',
  'admin.companies.action.openMenu': 'Aktionen für {{name}}',
  'admin.companies.col.name': 'Unternehmen',
  'admin.companies.col.legalName': 'Firmenname',
  'admin.companies.col.taxNumber': 'Steuernummer',
  'admin.companies.col.createdAt': 'Erstellt',
  'admin.companies.create.title': 'Neues Unternehmen',
  'admin.companies.edit.title': 'Unternehmen bearbeiten',
  'admin.companies.field.name': 'Unternehmensname',
  'admin.companies.field.legalName': 'Firmenname',
  'admin.companies.field.taxNumber': 'Steuernummer',
  'admin.companies.field.adminFirstName': 'Vorname',
  'admin.companies.field.adminLastName': 'Nachname',
  'admin.companies.field.adminEmail': 'E-Mail',
  'admin.companies.field.adminPassword': 'Passwort',
  'admin.companies.adminToggle': 'Ersten Administrator ebenfalls erstellen',
  'admin.companies.adminHint':
    'Wenn aktiviert, wird ein an das Unternehmen gebundener Unternehmensadministrator (CorporateAdmin) erstellt. Dieser Administrator ist kein Systemadministrator.',
  'admin.companies.created': 'Unternehmen erstellt.',
  'admin.companies.updated': 'Unternehmen aktualisiert.',

  'admin.branches.title': 'Filialen',
  'admin.branches.new': 'Neue Filiale',
  'admin.branches.count': '{{count}} Filialen aufgelistet',
  'admin.branches.count_one': '{{count}} Filiale aufgelistet',
  'admin.branches.searchPlaceholder': 'Filialname oder Code suchen',
  'admin.branches.col.name': 'Filiale',
  'admin.branches.col.code': 'Code',
  'admin.branches.action.sites': 'Standorte',
  'admin.branches.create.title': 'Neue Filiale',
  'admin.branches.edit.title': 'Filiale bearbeiten',
  'admin.branches.field.name': 'Filialname',
  'admin.branches.field.code': 'Code',
  'admin.branches.created': 'Filiale erstellt.',
  'admin.branches.updated': 'Filiale aktualisiert.',

  'admin.sites.title': 'Standorte',
  'admin.sites.new': 'Neuer Standort',
  'admin.sites.count': '{{count}} Standorte aufgelistet',
  'admin.sites.count_one': '{{count}} Standort aufgelistet',
  'admin.sites.searchPlaceholder': 'Standortname oder Code suchen',
  'admin.sites.branchFallback': 'Ausgewählte Filiale',
  'admin.sites.col.name': 'Standort',
  'admin.sites.col.code': 'Code',
  'admin.sites.create.title': 'Neuer Standort',
  'admin.sites.edit.title': 'Standort bearbeiten',
  'admin.sites.field.name': 'Standortname',
  'admin.sites.field.code': 'Code',
  'admin.sites.created': 'Standort erstellt.',
  'admin.sites.updated': 'Standort aktualisiert.',

  'admin.validation.nameRequired': 'Name ist erforderlich.',
  'admin.validation.emailRequired': 'E-Mail ist erforderlich.',
  'admin.validation.emailInvalid': 'Geben Sie eine gültige E-Mail-Adresse ein.',
  'admin.validation.passwordPolicy':
    'Das Passwort muss mindestens 8 Zeichen, einen Buchstaben und eine Ziffer enthalten.',
  'admin.validation.firstNameRequired': 'Vorname ist erforderlich.',
  'admin.validation.lastNameRequired': 'Nachname ist erforderlich.',

  // --- Kiosk-Geräteverwaltung — api-contract §5.9 ---
  'admin.tab.kiosk': 'Kiosk-Geräte',
  'kiosk.title': 'Kiosk-Geräte',
  'kiosk.count': '{{count}} Kiosk-Geräte aufgelistet',
  'kiosk.count_one': '{{count}} Kiosk-Gerät aufgelistet',
  'kiosk.searchPlaceholder': 'Gerätename suchen',
  'kiosk.empty': 'Noch keine Kiosk-Geräte registriert.',
  'kiosk.empty.body': 'Sobald Sie das erste Gerät registrieren, erscheint es hier.',
  'kiosk.list.noResults': 'Keine Kiosk-Geräte entsprechen Ihrer Suche.',
  'kiosk.col.name': 'Gerät',
  'kiosk.col.site': 'Standort',
  'kiosk.col.status': 'Status',
  'kiosk.col.roles': 'Rollen',
  'kiosk.col.lastSeen': 'Zuletzt gesehen',
  'kiosk.col.createdAt': 'Erstellt',
  'kiosk.status.Active': 'Aktiv',
  'kiosk.status.Pending': 'Ausstehend',
  'kiosk.status.Disabled': 'Deaktiviert',
  'kiosk.action.revokeSessions': 'Sitzungen widerrufen',
  'kiosk.action.disable': 'Deaktivieren',
  'kiosk.action.openMenu': 'Aktionen für {{name}}',

  'kiosk.register.new': 'Gerät registrieren',
  'kiosk.register.title': 'Kiosk-Gerät registrieren',
  'kiosk.register.description':
    'Geben Sie dem Gerät einen Namen; optional können Sie einen Standort und Rollen zuweisen. Nach der Registrierung wird ein einmaliger Aktivierungscode erzeugt.',
  'kiosk.register.submit': 'Registrieren und Code erzeugen',
  'kiosk.register.field.name': 'Gerätename',
  'kiosk.register.field.namePlaceholder': 'z. B. Haupteingang Drehkreuz 1',
  'kiosk.register.field.site': 'Standort (optional)',
  'kiosk.register.field.siteHint':
    'Das Gerät wird an diesen Standort gebunden; Besucher-Check-ins werden diesem Standort zugeordnet.',
  'kiosk.register.site.placeholder': 'Standort auswählen (optional)',
  'kiosk.register.field.roles': 'Rollen (optional)',
  'kiosk.register.field.rolesHint':
    'Die Berechtigungen des Geräts stammen aus den ausgewählten Rollen. Wählen Sie eine kiosk-berechtigte Rolle (z. B. „Kiosk-Gerät“).',
  'kiosk.register.roles.empty': 'Keine aktiven Rollen zum Zuweisen verfügbar.',
  'kiosk.register.createdMessage': 'Kiosk-Gerät registriert.',
  'kiosk.register.successTitle': 'Gerät registriert',
  'kiosk.register.successDescription': 'Der Aktivierungscode für „{{name}}“ ist bereit.',
  'kiosk.register.codeWarning':
    'Dieser Code wird nur einmal angezeigt; geben Sie ihn am Kiosk-Gerät ein. Falls Sie ihn verlieren, registrieren Sie das Gerät erneut.',
  'kiosk.register.codeLabel': 'Aktivierungscode',
  'kiosk.register.copy': 'Kopieren',
  'kiosk.register.copied': 'Kopiert',
  'kiosk.register.deviceUuid': 'Geräte-ID',
  'kiosk.register.expiresAt': 'Läuft ab',
  'kiosk.register.nextStep':
    'Aktivieren Sie das Gerät, indem Sie diesen Code im Aktivierungsbildschirm des Kiosk-Geräts eingeben.',
  'kiosk.validation.nameRequired': 'Gerätename ist erforderlich.',

  'kiosk.revoke.revokeTitle': 'Sitzungen widerrufen',
  'kiosk.revoke.revokeBody':
    'Alle aktiven Sitzungen von „{{name}}“ werden beendet; die aktuelle Gerätesitzung wird ungültig. Die Geräteregistrierung bleibt erhalten. Fortfahren?',
  'kiosk.revoke.revokeConfirm': 'Sitzungen widerrufen',
  'kiosk.revoke.revokedMessage': 'Die Sitzungen von „{{name}}“ wurden widerrufen.',
  'kiosk.revoke.disableTitle': 'Gerät deaktivieren',
  'kiosk.revoke.disableBody':
    '„{{name}}“ wird deaktiviert und alle Sitzungen werden beendet. Das Gerät muss erneut aktiviert werden, um wieder verwendet zu werden. Fortfahren?',
  'kiosk.revoke.disableConfirm': 'Deaktivieren',
  'kiosk.revoke.disabledMessage': '„{{name}}“ wurde deaktiviert.',

  // --- Einstellungen (Settings) — api-contract §10 (tenant-scoped) ---
  'settings.nav': 'Einstellungen',
  'settings.subtitle': 'Verwalten Sie Ihre Unternehmensdaten, Niederlassungen und Standorte.',
  'settings.tab.company': 'Unternehmensdaten',
  'settings.tab.branches': 'Filialen',
  'settings.tab.sites': 'Standorte',
  'settings.gate.loadingLabel': 'Einstellungen werden geladen',
  'settings.forbidden.title': 'Sie haben keinen Zugriff auf die Einstellungen',
  'settings.forbidden.body':
    'Die Unternehmenseinstellungen sind berechtigten Benutzern vorbehalten. Wenn Sie Zugriff benötigen, wenden Sie sich bitte an Ihren Unternehmensadministrator.',
  'settings.forbidden.back': 'Zurück zur Übersicht',
  'settings.unavailable.title': 'Einstellungen nicht erreichbar',
  'settings.unavailable.body':
    'Der Einstellungsdienst antwortet derzeit nicht. Bitte versuchen Sie es in Kürze erneut.',
  'settings.unavailable.retry': 'Erneut versuchen',

  'settings.common.search': 'Suchen',
  'settings.common.edit': 'Bearbeiten',
  'settings.common.save': 'Speichern',
  'settings.common.cancel': 'Abbrechen',
  'settings.common.create': 'Erstellen',
  'settings.common.close': 'Schließen',
  'settings.common.loading': 'Wird geladen...',
  'settings.common.empty': 'Keine Einträge gefunden.',
  'settings.common.noData': 'Noch keine Einträge.',
  'settings.common.noData.body': 'Sobald Sie den ersten Eintrag erstellen, erscheint er hier.',
  'settings.common.actions': 'Aktionen',
  'settings.pagination.nav': 'Seitennavigation',
  'settings.pagination.previous': 'Zurück',
  'settings.pagination.next': 'Weiter',

  'settings.company.updated': 'Unternehmensdaten aktualisiert.',
  'settings.company.field.name': 'Unternehmensname',
  'settings.company.field.legalName': 'Firmenname',
  'settings.company.field.taxNumber': 'Steuernummer',
  'settings.company.field.taxOffice': 'Finanzamt',
  'settings.company.field.address': 'Adresse',
  'settings.company.field.phone': 'Telefon',
  'settings.company.field.email': 'E-Mail',

  'settings.branches.title': 'Filialen',
  'settings.branches.count': '{{count}} Filialen aufgelistet',
  'settings.branches.count_one': '{{count}} Filiale aufgelistet',
  'settings.branches.searchPlaceholder': 'Filialname oder Code suchen',
  'settings.branches.new': 'Neue Filiale',
  'settings.branches.col.name': 'Filiale',
  'settings.branches.col.code': 'Code',
  'settings.branches.col.address': 'Adresse',
  'settings.branches.col.phone': 'Telefon',
  'settings.branches.action.delete': 'Filiale löschen',
  'settings.branches.action.openMenu': 'Aktionen für {{name}}',
  'settings.branches.create.title': 'Neue Filiale',
  'settings.branches.edit.title': 'Filiale bearbeiten',
  'settings.branches.field.name': 'Filialname',
  'settings.branches.field.code': 'Code',
  'settings.branches.field.address': 'Adresse',
  'settings.branches.field.phone': 'Telefon',
  'settings.branches.created': 'Filiale erstellt.',
  'settings.branches.updated': 'Filiale aktualisiert.',
  'settings.branches.deleted': 'Filiale gelöscht.',
  'settings.branches.delete.title': 'Filiale löschen',
  'settings.branches.delete.body':
    'Die Filiale "{{name}}" wird gelöscht. Diese Aktion kann nicht rückgängig gemacht werden. Fortfahren?',
  'settings.branches.delete.confirm': 'Löschen',

  'settings.sites.title': 'Standorte',
  'settings.sites.count': '{{count}} Standorte aufgelistet',
  'settings.sites.count_one': '{{count}} Standort aufgelistet',
  'settings.sites.searchPlaceholder': 'Standortname oder Code suchen',
  'settings.sites.new': 'Neuer Standort',
  'settings.sites.noBranches':
    'Um einen Standort hinzuzufügen, müssen Sie zuerst mindestens eine Filiale erstellen. Bitte fügen Sie im Reiter Filialen eine Filiale hinzu.',
  'settings.sites.branchPlaceholder': 'Filiale auswählen',
  'settings.sites.filter.branch': 'Nach Filiale filtern',
  'settings.sites.filter.allBranches': 'Alle Filialen',
  'settings.sites.col.name': 'Standort',
  'settings.sites.col.code': 'Code',
  'settings.sites.col.branch': 'Filiale',
  'settings.sites.col.address': 'Adresse',
  'settings.sites.action.delete': 'Standort löschen',
  'settings.sites.action.openMenu': 'Aktionen für {{name}}',
  'settings.sites.create.title': 'Neuer Standort',
  'settings.sites.edit.title': 'Standort bearbeiten',
  'settings.sites.field.branch': 'Filiale',
  'settings.sites.field.name': 'Standortname',
  'settings.sites.field.code': 'Code',
  'settings.sites.field.address': 'Adresse',
  'settings.sites.created': 'Standort erstellt.',
  'settings.sites.updated': 'Standort aktualisiert.',
  'settings.sites.deleted': 'Standort gelöscht.',
  'settings.sites.delete.title': 'Standort löschen',
  'settings.sites.delete.body':
    'Der Standort "{{name}}" wird gelöscht. Diese Aktion kann nicht rückgängig gemacht werden. Fortfahren?',
  'settings.sites.delete.confirm': 'Löschen',

  'settings.validation.nameRequired': 'Name ist erforderlich.',
  'settings.validation.branchRequired': 'Filialauswahl ist erforderlich.',

  // --- Besucher (Visitors) — api-contract §11 (tenant-scoped) ---
  'visitors.nav': 'Besucher',
  'visitors.title': 'Besucher',
  'visitors.subtitle':
    'Verfolgen Sie Besucher vor Ort, sehen Sie frühere Besuche ein und verwalten Sie die Sicherheitsunterweisung.',
  'visitors.tab.onSite': 'Vor Ort',
  'visitors.tab.history': 'Verlauf',
  'visitors.tab.briefing': 'Sicherheitsunterweisung',
  'visitors.gate.loadingLabel': 'Besucher werden geladen',
  'visitors.forbidden.title': 'Sie haben keinen Zugriff auf Besucher',
  'visitors.forbidden.body':
    'Die Besucherverwaltung ist berechtigten Benutzern vorbehalten. Wenn Sie Zugriff benötigen, wenden Sie sich bitte an Ihren Unternehmensadministrator.',
  'visitors.forbidden.back': 'Zurück zur Übersicht',
  'visitors.unavailable.title': 'Besucher nicht erreichbar',
  'visitors.unavailable.body':
    'Der Besucherdienst antwortet derzeit nicht. Bitte versuchen Sie es in Kürze erneut.',
  'visitors.unavailable.retry': 'Erneut versuchen',

  'visitors.common.search': 'Suchen',
  'visitors.common.loading': 'Wird geladen...',
  'visitors.common.empty': 'Keine Einträge gefunden.',
  'visitors.common.actions': 'Aktionen',
  'visitors.common.cancel': 'Abbrechen',
  'visitors.common.close': 'Schließen',
  'visitors.common.save': 'Speichern',
  'visitors.pagination.nav': 'Seitennavigation',
  'visitors.pagination.previous': 'Zurück',
  'visitors.pagination.next': 'Weiter',

  // Vor Ort (Notfall- / Evakuierungsbildschirm)
  'visitors.onSite.title': 'Aktuell vor Ort',
  'visitors.onSite.checkIn': 'Besucher anmelden',
  'visitors.onSite.searchPlaceholder': 'Besuchername oder Telefon suchen',
  'visitors.onSite.count': '{{count}} Besucher vor Ort',
  'visitors.onSite.count_one': '{{count}} Besucher vor Ort',
  'visitors.onSite.col.visitor': 'Besucher',
  'visitors.onSite.col.location': 'Standort / Filiale',
  'visitors.onSite.col.host': 'Gastgeber',
  'visitors.onSite.col.purpose': 'Zweck',
  'visitors.onSite.col.checkInAt': 'Anmeldezeit',
  'visitors.onSite.action.checkOut': 'Abmelden',
  'visitors.onSite.empty': 'Derzeit sind keine Besucher vor Ort.',
  'visitors.onSite.empty.body': 'Sobald sich ein Besucher anmeldet, erscheint er hier.',
  'visitors.onSite.noResults': 'Keine Besucher entsprechen Ihrer Suche.',
  'visitors.onSite.checkOut.title': 'Abmeldung bestätigen',
  'visitors.onSite.checkOut.body':
    '"{{name}}" wird abgemeldet und aus der Vor-Ort-Liste entfernt. Fortfahren?',
  'visitors.onSite.checkOut.confirm': 'Abmelden',
  'visitors.onSite.checkedOut': '"{{name}}" wurde abgemeldet.',

  // Anmeldeformular
  'visitors.checkIn.title': 'Besucher anmelden',
  'visitors.checkIn.description':
    'Geben Sie die Besucherdaten ein. Die KVKK-Einwilligung (Datenschutz) und die Sicherheitsunterweisung sind erforderlich.',
  'visitors.checkIn.section.visitor': 'Besucherdaten',
  'visitors.checkIn.section.visit': 'Besuchsdaten',
  'visitors.checkIn.section.consent': 'Bestätigungen (erforderlich)',
  'visitors.checkIn.field.firstName': 'Vorname',
  'visitors.checkIn.field.lastName': 'Nachname',
  'visitors.checkIn.field.phone': 'Telefon',
  'visitors.checkIn.field.email': 'E-Mail',
  'visitors.checkIn.field.idNumber': 'Ausweis-/Passnummer',
  'visitors.checkIn.field.organization': 'Vertretene Organisation',
  'visitors.checkIn.field.site': 'Standort',
  'visitors.checkIn.field.branch': 'Filiale',
  'visitors.checkIn.field.host': 'Gastgeber',
  'visitors.checkIn.field.purpose': 'Zweck des Besuchs',
  'visitors.checkIn.site.placeholder': 'Standort auswählen (optional)',
  'visitors.checkIn.branch.placeholder': 'Filiale auswählen (optional)',
  'visitors.checkIn.branch.autoFilledHint':
    'Automatisch aus der Filiale der gewählten Anlage übernommen.',
  'visitors.checkIn.host.placeholder': 'Gastgeber auswählen (optional)',
  'visitors.checkIn.consent.kvkk':
    'Ich habe dem Besucher die KVKK-Datenschutzerklärung übergeben; der Besucher hat der Verarbeitung seiner personenbezogenen Daten ausdrücklich zugestimmt.',
  'visitors.checkIn.consent.kvkkHint':
    'Ohne ausdrückliche Einwilligung ist keine Anmeldung möglich; ohne Einwilligung werden keine Besucherdaten gespeichert.',
  'visitors.checkIn.consent.briefing':
    'Ich habe dem Besucher die Sicherheitsunterweisung übergeben; der Besucher hat die Regeln gelesen und bestätigt.',
  'visitors.checkIn.briefing.title': 'Sicherheitsunterweisung',
  'visitors.checkIn.briefing.version': 'Version {{version}}',
  'visitors.checkIn.briefing.notConfigured':
    'Es wurde noch kein Text für die Sicherheitsunterweisung konfiguriert. Sie können ihn im Reiter "Sicherheitsunterweisung" hinzufügen; der Besucher muss dennoch bestätigen, dass die Unterweisung übergeben wurde.',
  'visitors.checkIn.submit': 'Anmelden',
  'visitors.checkIn.success': 'Besucher angemeldet.',
  'visitors.checkIn.badge': 'Abmeldecode: {{code}}',

  // Verlauf / Bericht
  'visitors.history.title': 'Besuchsverlauf',
  'visitors.history.count': '{{count}} Besuche aufgelistet',
  'visitors.history.count_one': '{{count}} Besuch aufgelistet',
  'visitors.history.searchPlaceholder': 'Besuchername oder Telefon suchen',
  'visitors.history.filter.status': 'Status',
  'visitors.history.filter.site': 'Standort',
  'visitors.history.filter.branch': 'Filiale',
  'visitors.history.filter.from': 'Startdatum',
  'visitors.history.filter.to': 'Enddatum',
  'visitors.history.filter.allStatuses': 'Alle Status',
  'visitors.history.filter.allSites': 'Alle Standorte',
  'visitors.history.filter.allBranches': 'Alle Filialen',
  'visitors.history.col.visitor': 'Besucher',
  'visitors.history.col.status': 'Status',
  'visitors.history.col.location': 'Standort / Filiale',
  'visitors.history.col.host': 'Gastgeber',
  'visitors.history.col.checkInAt': 'Anmeldung',
  'visitors.history.col.checkOutAt': 'Abmeldung',
  'visitors.history.action.detail': 'Besuchsdetail',
  'visitors.history.empty': 'Noch keine Besuchsdatensätze.',
  'visitors.history.empty.body': 'Sobald sich ein Besucher abmeldet, erscheint er hier.',
  'visitors.history.noResults': 'Keine Besuchsdatensätze entsprechen den Filtern.',

  'visitors.status.onSite': 'Vor Ort',
  'visitors.status.checkedOut': 'Abgemeldet',
  'visitors.entryMethod.manual': 'Manuell',
  'visitors.entryMethod.kiosk': 'Kiosk',

  // Besuchsdetail
  'visitors.detail.title': 'Besuchsdetail',
  'visitors.detail.section.visitor': 'Besucher',
  'visitors.detail.section.visit': 'Besuch',
  'visitors.detail.field.phone': 'Telefon',
  'visitors.detail.field.email': 'E-Mail',
  'visitors.detail.field.idNumber': 'Ausweis-/Passnummer',
  'visitors.detail.field.organization': 'Organisation',
  'visitors.detail.field.status': 'Status',
  'visitors.detail.field.location': 'Standort / Filiale',
  'visitors.detail.field.host': 'Gastgeber',
  'visitors.detail.field.purpose': 'Zweck',
  'visitors.detail.field.entryMethod': 'Anmeldeart',
  'visitors.detail.field.checkInAt': 'Anmeldung',
  'visitors.detail.field.checkOutAt': 'Abmeldung',
  'visitors.detail.field.briefing': 'Bestätigung der Sicherheitsunterweisung',
  'visitors.detail.field.badge': 'Abmeldecode',
  'visitors.detail.briefingAccepted': 'Bestätigt',
  'visitors.detail.briefingNotAccepted': 'Nicht bestätigt',
  'visitors.detail.loading': 'Besuch wird geladen...',

  // Konfiguration der Sicherheitsunterweisung
  'visitors.briefing.subtitle':
    'Der Text der Sicherheitsunterweisung, den Besucher bei der Anmeldung bestätigen. Beim Speichern wird die Version automatisch erhöht; die bestätigte Version wird im Besuchsdatensatz vermerkt.',
  'visitors.briefing.currentVersion': 'Aktuelle Version: {{version}}',
  'visitors.briefing.notConfigured': 'Noch kein Unterweisungstext konfiguriert (Version 0).',
  'visitors.briefing.field.tr': 'Text (Türkisch)',
  'visitors.briefing.field.en': 'Text (Englisch)',
  'visitors.briefing.field.de': 'Text (Deutsch)',
  'visitors.briefing.placeholder':
    'Schreiben Sie die Sicherheitsregeln, die Besucher befolgen müssen.',
  'visitors.briefing.save': 'Unterweisung speichern',
  'visitors.briefing.updated': 'Sicherheitsunterweisung aktualisiert.',

  'visitors.validation.firstNameRequired': 'Vorname ist erforderlich.',
  'visitors.validation.lastNameRequired': 'Nachname ist erforderlich.',
  'visitors.validation.kvkkRequired': 'Die ausdrückliche KVKK-Einwilligung ist erforderlich.',
  'visitors.validation.briefingRequired':
    'Die Bestätigung der Sicherheitsunterweisung ist erforderlich.',
  'visitors.validation.contentTrRequired': 'Türkischer Text ist erforderlich.',

  // --- Auftragnehmer-/Subunternehmer-Verwaltung — api-contract §13 + §8 ---
  'contractors.nav': 'Auftragnehmer',
  'contractors.title': 'Auftragnehmer',
  'contractors.gate.loadingLabel': 'Auftragnehmer-Modul wird geladen...',
  'contractors.forbidden.title': 'Kein Zugriff',
  'contractors.forbidden.body':
    'Sie haben keine Berechtigung für das Auftragnehmer-Modul. Bitte wenden Sie sich an Ihren Firmenadministrator, um Zugriff anzufordern.',
  'contractors.forbidden.back': 'Zurück zum Dashboard',
  'contractors.unavailable.title': 'Modul nicht verfügbar',
  'contractors.unavailable.body':
    'Die Auftragnehmerdaten sind derzeit nicht erreichbar. Bitte versuchen Sie es in Kürze erneut.',
  'contractors.unavailable.retry': 'Erneut versuchen',

  'contractors.common.close': 'Schließen',
  'contractors.common.cancel': 'Abbrechen',
  'drawer.discard.title': 'Ohne Speichern schließen?',
  'drawer.discard.body':
    'Das Formular enthält nicht gespeicherte Eingaben. Wenn Sie das Panel schließen, werden sie nicht gespeichert.',
  'drawer.discard.cancel': 'Zurück',
  'drawer.discard.confirm': 'Ohne Speichern schließen',
  'contractors.common.save': 'Speichern',
  'contractors.common.create': 'Erstellen',
  'contractors.common.add': 'Hinzufügen',
  'contractors.common.done': 'Fertig',
  'contractors.common.loading': 'Wird geladen...',
  'contractors.common.actions': 'Aktionen',

  'contractors.status.active': 'Aktiv',
  'contractors.status.suspended': 'Ausgesetzt',
  'contractors.status.inactive': 'Inaktiv',

  'contractors.compliance.valid': 'Konform',
  'contractors.compliance.expiring': 'Läuft bald ab',
  'contractors.compliance.expired': 'Abgelaufen',
  'contractors.compliance.missing': 'Fehlt',

  // Liste
  'contractors.list.subtitle':
    'Verwalten Sie die auf Ihren Standorten tätigen Subunternehmer und Lieferanten, deren Konformitätsnachweise und Standortzugänge.',
  'contractors.list.search': 'Auftragnehmer suchen',
  'contractors.list.searchPlaceholder': 'Nach Firmenname oder Steuernummer suchen',
  'contractors.list.new': 'Auftragnehmer hinzufügen',
  'contractors.list.filter.status': 'Nach Status filtern',
  'contractors.list.filter.allStatuses': 'Alle Status',
  'contractors.list.filter.compliance.expired': 'Abgelaufenes Dokument',
  'contractors.list.filter.compliance.expiring': 'Bald ablaufendes Dokument',
  'contractors.list.count': '{{count}} Auftragnehmer aufgelistet',
  'contractors.list.count_one': '{{count}} Auftragnehmer aufgelistet',
  'contractors.list.col.name': 'Firma',
  'contractors.list.col.taxNumber': 'Steuernr.',
  'contractors.list.col.hazardClass': 'Gefahrenklasse',
  'contractors.list.col.status': 'Status',
  'contractors.list.col.compliance': 'Konformität',
  'contractors.list.empty': 'Noch keine Auftragnehmer.',
  'contractors.list.empty.body':
    'Sobald Sie den ersten Auftragnehmer hinzufügen, erscheint er hier.',
  'contractors.list.noResults': 'Keine Auftragnehmer entsprechen Ihren Filtern.',

  'contractors.pagination.nav': 'Seitennummerierung',
  'contractors.pagination.previous': 'Zurück',
  'contractors.pagination.next': 'Weiter',

  // Formular anlegen/bearbeiten
  'contractors.form.create.title': 'Auftragnehmer hinzufügen',
  'contractors.form.edit.title': 'Auftragnehmer bearbeiten',
  'contractors.form.description':
    'Geben Sie die Firmendaten, die Gefährdungsklasse und den Vertragszeitraum ein. Mit Sternchen markierte Felder sind Pflichtfelder.',
  'contractors.form.section.identity': 'Firmenidentität',
  'contractors.form.section.contact': 'Kontakt und Vertrag',
  'contractors.form.field.name': 'Firmenname',
  'contractors.form.field.legalName': 'Rechtlicher Name',
  'contractors.form.field.taxNumber': 'Steuernummer',
  'contractors.form.field.taxOffice': 'Finanzamt',
  'contractors.form.field.isgKatipNo': 'İSG-KATİP-Nummer',
  'contractors.form.field.hazardClass': 'Gefahrenklasse',
  'contractors.form.field.phone': 'Telefon',
  'contractors.form.field.email': 'E-Mail',
  'contractors.form.field.address': 'Adresse',
  'contractors.form.field.contractStart': 'Vertragsbeginn',
  'contractors.form.field.contractEnd': 'Vertragsende',
  'contractors.form.field.status': 'Status',
  'contractors.validation.nameRequired': 'Firmenname ist erforderlich.',

  // Detail
  'contractors.detail.back': 'Zurück zur Auftragnehmerliste',
  'contractors.detail.loading': 'Auftragnehmer wird geladen...',
  'contractors.detail.edit': 'Bearbeiten',
  'contractors.detail.header.compliance': 'Konformität: {{status}}',
  'contractors.detail.compliance.title': 'Konformität',
  'contractors.detail.identity.title': 'Stammdaten',
  'contractors.detail.compliance.documents': 'Nachweise',
  'contractors.detail.compliance.expiring': 'Läuft ab',
  'contractors.detail.compliance.expired': 'Abgelaufen',
  'contractors.detail.compliance.overall': 'Gesamtkonformität',
  'contractors.detail.tab.documents': 'Konformitätsnachweise',
  'contractors.detail.tab.personnel': 'Personal',
  'contractors.detail.tab.vehicles': 'Fahrzeuge',
  'contractors.detail.tab.sites': 'Standortzugang',

  // Nachweise
  'contractors.documents.title': 'Konformitätsnachweise',
  'contractors.documents.subtitle':
    'Laden Sie Nachweise wie Sozialversicherung, Steuerbescheinigung, İSG-KATİP, Vertrag und Versicherung hoch und überwachen Sie deren Gültigkeit.',
  'contractors.documents.empty':
    'Für diesen Auftragnehmer wurden noch keine Nachweise hinzugefügt.',
  'contractors.documents.col.type': 'Nachweistyp',
  'contractors.documents.col.file': 'Datei',
  'contractors.documents.col.validity': 'Gültigkeit',
  'contractors.documents.col.status': 'Status',
  'contractors.documents.action.download': 'Herunterladen',
  'contractors.documents.action.delete': 'Löschen',
  'contractors.documents.add.new': 'Nachweis hinzufügen',
  'contractors.documents.add.title': 'Konformitätsnachweis hinzufügen',
  'contractors.documents.add.description':
    'Wählen Sie eine Datei, den Nachweistyp und das Gültigkeitsdatum. Die Datei wird direkt in den sicheren Speicher hochgeladen.',
  'contractors.documents.add.submit': 'Hochladen und hinzufügen',
  'contractors.documents.add.uploading': 'Wird hochgeladen...',
  'contractors.documents.add.progress': 'Wird hochgeladen: {{percent}}%',
  'contractors.documents.field.file': 'Nachweisdatei',
  'contractors.documents.field.filePlaceholder': 'Datei auswählen (PDF, Bild oder Office-Dokument)',
  'contractors.documents.field.fileHint': 'Bis zu 20 MB. PDF, Bild (PNG/JPG) oder Office-Dokument.',
  'contractors.documents.field.type': 'Nachweistyp',
  'contractors.documents.field.validFrom': 'Gültig ab',
  'contractors.documents.field.validUntil': 'Gültig bis',
  'documents.validity.fromOnly': 'Gültig ab {{date}}',
  'documents.validity.untilOnly': 'Gültig bis {{date}}',
  'contractors.documents.field.note': 'Notiz (optional)',
  'contractors.documents.delete.title': 'Nachweis entfernen',
  'contractors.documents.delete.body':
    'Möchten Sie den Nachweis „{{type}}" wirklich von diesem Auftragnehmer entfernen? Der Eintrag wird archiviert.',
  'contractors.documents.delete.confirm': 'Nachweis entfernen',

  // Personal
  'contractors.personnel.title': 'Personal',
  'contractors.personnel.subtitle':
    'Sehen Sie das mit diesem Auftragnehmer verknüpfte Personal ein; legen Sie neues Personal an und senden Sie optional einen Link zur Kontoaktivierung.',
  'contractors.personnel.empty': 'Diesem Auftragnehmer wurde noch kein Personal zugeordnet.',
  'contractors.personnel.create': 'Personal anlegen',
  'contractors.personnel.col.name': 'Vollständiger Name',
  'contractors.personnel.col.contact': 'E-Mail / Telefon',
  'contractors.personnel.col.status': 'Status',
  'contractors.personnel.col.access': 'Zugriff',
  'contractors.personnel.col.date': 'Datum',
  // Statusabzeichen (aktives Personal + ausstehende Einladungen — §13.3)
  'contractors.personnel.status.active': 'Aktiv',
  'contractors.personnel.status.inactive': 'Inaktiv',
  'contractors.personnel.status.notactivated': 'Nicht aktiviert',
  'contractors.personnel.status.pending': 'Ausstehend',
  'contractors.personnel.status.expired': 'Abgelaufen',
  // Zugriffsebene (§13.3)
  'contractors.personnel.access.personeli': 'Mitarbeiter',
  'contractors.personnel.access.yetkili': 'Verantwortlicher',
  'contractors.personnel.drawer.activatedAt': 'Aktivierungsdatum',
  'contractors.personnel.drawer.createdAt': 'Erfassungsdatum',
  // Zeilenaktionen
  'contractors.personnel.action.delete': 'Personal entfernen',
  'contractors.personnel.action.openMenu': 'Aktionen für {{name}}',
  // Personal entfernen (Bestätigung)
  'contractors.personnel.delete.title': 'Personal entfernen',
  'contractors.personnel.delete.body':
    'Möchten Sie "{{name}}" wirklich von diesem Auftragnehmer entfernen? Zuordnungen zu anderen Unternehmen bleiben erhalten.',
  'contractors.personnel.delete.confirm': 'Entfernen',
  // Einladung widerrufen (Bestätigung)

  // Personaleinladung

  // Standortzugang
  'contractors.sites.title': 'Standortzugang',
  'contractors.sites.subtitle':
    'Legen Sie fest, auf welchen Standorten der Auftragnehmer arbeiten darf. Sie können den Zugang jederzeit widerrufen.',
  'contractors.sites.empty': 'Für diesen Auftragnehmer wurde noch kein Standortzugang definiert.',
  'contractors.sites.add.new': 'Standort hinzufügen',
  'contractors.sites.add.title': 'Standortzugang hinzufügen',
  'contractors.sites.add.description':
    'Wählen Sie einen Standort, auf den der Auftragnehmer zugreifen darf.',
  'contractors.sites.field.site': 'Standort',
  'contractors.sites.sitePlaceholder': 'Standort auswählen',
  'contractors.sites.noSites':
    'Keine weiteren Standorte zum Hinzufügen verfügbar. Standorte werden unter Einstellungen definiert.',
  'contractors.sites.col.site': 'Standort',
  'contractors.sites.col.code': 'Code',
  'contractors.sites.col.since': 'Zugangsdatum',
  'contractors.sites.action.remove': 'Zugang widerrufen',
  'contractors.sites.remove.title': 'Standortzugang widerrufen',
  'contractors.sites.remove.body':
    'Möchten Sie den Zugang zum Standort „{{site}}" wirklich widerrufen?',
  'contractors.sites.remove.confirm': 'Zugang widerrufen',
  'contractors.validation.siteRequired': 'Bitte wählen Sie einen Standort.',

  // Auftragnehmer-/Dokument-Fehlercodes (api-contract §13 + §8; SITE_NOT_FOUND in §9 definiert)
  CONTRACTOR_NOT_FOUND: 'Auftragnehmer-Datensatz nicht gefunden.',
  CONTRACTOR_DOCUMENT_NOT_FOUND:
    'Nachweis nicht gefunden oder gehört nicht zu diesem Auftragnehmer.',
  CONTRACTOR_SITE_NOT_FOUND: 'Der Auftragnehmer hat keinen aktiven Zugang zu diesem Standort.',
  PERSONNEL_NOT_FOUND: 'Personal nicht gefunden oder nicht mit diesem Auftragnehmer verknüpft.',
  INVITATION_NOT_FOUND: 'Es wurde keine solche Einladung gefunden.',
  ACCESS_LEVEL_ROLE_NOT_CONFIGURED:
    'Für die gewählte Zugriffsebene ist keine Rolle konfiguriert. Bitte wenden Sie sich an Ihren Systemadministrator.',
  DOCUMENT_NOT_FOUND: 'Dokument nicht gefunden. Bitte laden Sie die Datei erneut hoch.',
  DOCUMENT_NOT_UPLOADED:
    'Der Datei-Upload konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
  DOCUMENT_NOT_CONFIRMED: 'Die Datei wurde noch nicht verifiziert. Bitte versuchen Sie es erneut.',
  DOCUMENT_TOO_LARGE: 'Die Dateigröße überschreitet das zulässige Limit (max. 20 MB).',
  DOCUMENT_TYPE_UNSUPPORTED:
    'Dieser Dateityp wird nicht unterstützt. Laden Sie ein PDF, Bild oder Office-Dokument hoch.',
  DOCUMENT_UPLOAD_FAILED:
    'Die Datei konnte nicht hochgeladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  DOCUMENT_UPLOAD_ABORTED: 'Der Datei-Upload wurde abgebrochen.',
  GUEST_INVITE_INVALID: 'Der Einladungslink ist ungültig oder wurde bereits verwendet.',
  GUEST_INVITE_EXPIRED: 'Die Einladung ist abgelaufen. Bitte erstellen Sie eine neue.',
  INVITE_CHANNEL_UNAVAILABLE:
    'Der gewählte Versandkanal kann mit den Kontaktdaten dieser Einladung nicht verwendet werden. Bitte wählen Sie einen Kanal, der zur E-Mail-Adresse oder Telefonnummer der Einladung passt.',
  ACTIVATION_LINK_COOLDOWN:
    'An diese Kontaktangabe wurde gerade erst ein Aktivierungslink gesendet. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
  'personnelCreate.title': 'Personal anlegen',
  'personnelCreate.description':
    'Legen Sie die Person an; optional können Sie ihr auch einen Link zur Kontoaktivierung senden.',
  'personnelCreate.submit': 'Anlegen',
  'personnelCreate.another': 'Weitere Person anlegen',
  'personnelCreate.contact.title': 'Aktivierungslink (optional)',
  'personnelCreate.contact.hint':
    'Wenn Sie eine E-Mail-Adresse oder Telefonnummer eingeben, erhält die Person einen Link zur Kontoaktivierung. Diese Angabe wird nicht im Datensatz der Person gespeichert.',
  'personnelCreate.success.created': 'Person angelegt.',
  'personnelCreate.success.linkSent': 'Person angelegt. Der Aktivierungslink ist bereit.',
  'personnelCreate.validation.tcRequired': 'Die T.C.-Kimlik-Nummer ist erforderlich.',
  'personnelCreate.cooldownUntil':
    'An diese Kontaktangabe wurde gerade erst ein Link gesendet. Versuchen Sie es ab {{availableAt}} Uhr erneut oder leeren Sie die Kontaktfelder und legen Sie die Person jetzt an; den Link können Sie später senden.',
  'personnelCreate.cooldownGeneric':
    'An diese Kontaktangabe wurde gerade erst ein Link gesendet. Warten Sie einen Moment und versuchen Sie es erneut oder leeren Sie die Kontaktfelder und legen Sie die Person jetzt an; den Link können Sie später senden.',
  'personnelCreate.dailyLimit':
    'Für diesen Auftragnehmer ist das Tageslimit für den Versand von Links erreicht. Leeren Sie die Kontaktfelder und legen Sie die Person jetzt an; den Link können Sie später senden.',
  'personnelLink.cooldownUntil':
    'An diese Person oder diese Kontaktangabe wurde gerade erst ein Aktivierungslink gesendet. Sie können es ab {{availableAt}} Uhr erneut versuchen.',
  'personnelLink.field.email': 'E-Mail',
  'personnelLink.field.emailPlaceholder': 'name@firma.com',
  'personnelLink.field.phone': 'Telefon',
  'personnelLink.field.phonePlaceholder': '+90 555 123 45 67',
  'personnelLink.field.phoneHint':
    'Mobilnummer. Bei Nummern außerhalb der Türkei + und Ländervorwahl angeben.',
  'personnelLink.field.channel': 'Versandkanal',
  'personnelLink.field.channelHint':
    'Der Aktivierungslink wird automatisch über den gewählten Kanal gesendet; er bleibt außerdem auf dem Bildschirm.',
  'personnelLink.channel.email': 'E-Mail',
  'personnelLink.channel.sms': 'SMS',
  'personnelLink.channel.both': 'E-Mail und SMS',
  'personnelLink.field.link': 'Aktivierungslink',
  'personnelLink.copy': 'Kopieren',
  'personnelLink.copied': 'Kopiert',
  'personnelLink.copyFailed':
    'Der Link konnte nicht kopiert werden. Bitte markieren und kopieren Sie ihn manuell.',
  'personnelLink.expiresAt': 'Der Link ist gültig bis {{date}}.',
  'personnelLink.dispatch.emailSent': 'Der Aktivierungslink wurde per E-Mail gesendet.',
  'personnelLink.dispatch.smsSent': 'Der Aktivierungslink wurde per SMS gesendet.',
  'personnelLink.dispatch.emailFailed':
    'Der Aktivierungslink konnte nicht per E-Mail gesendet werden. Kopieren Sie den Link und leiten Sie ihn an die Person weiter.',
  'personnelLink.dispatch.smsFailed':
    'Der Aktivierungslink konnte nicht per SMS gesendet werden. Kopieren Sie den Link und leiten Sie ihn an die Person weiter.',
  'personnelLink.dispatch.none':
    'Der automatische Versand war nicht möglich. Bitte kopieren Sie den untenstehenden Link und leiten Sie ihn an die Person weiter.',
  'personnelLink.validation.contactRequired': 'E-Mail oder Telefon ist erforderlich.',
  'personnelLink.validation.emailInvalid': 'Geben Sie eine gültige E-Mail-Adresse ein.',
  'personnelLink.validation.phoneInvalid':
    'Geben Sie eine gültige Mobilnummer ein. Bei Nummern außerhalb der Türkei + und Ländervorwahl angeben.',
  'personnelLink.validation.emailTaken':
    'An diese E-Mail-Adresse kann kein Aktivierungslink gesendet werden. Versuchen Sie eine andere E-Mail-Adresse oder Telefonnummer.',
  'personnelLink.validation.phoneTaken':
    'An diese Telefonnummer kann kein Aktivierungslink gesendet werden. Versuchen Sie eine andere Telefonnummer oder E-Mail-Adresse.',
  'personnelLink.validation.contactTaken':
    'An die eingegebene Kontaktangabe kann kein Aktivierungslink gesendet werden. Versuchen Sie eine andere E-Mail-Adresse oder Telefonnummer.',
  'personnelLink.pending.sent': 'Gesendet',
  'personnelLink.pending.expired': 'Abgelaufen',
  'personnelLink.action.send': 'Aktivierungslink senden',
  'personnelLink.action.resend': 'Link erneut senden',
  'personnelLink.action.cancel': 'Link widerrufen',
  'personnelLink.cancel.title': 'Link widerrufen',
  'personnelLink.cancel.body.person':
    'Der für {{name}} gesendete Aktivierungslink wird widerrufen; die Person kann ihr Konto damit nicht mehr aktivieren und bleibt als „Nicht aktiviert“ in der Liste.',
  'personnelLink.notFound':
    'Dieser Link ist nicht mehr gültig; er wurde möglicherweise inzwischen erneut gesendet oder widerrufen, oder die Person hat ihr Konto bereits aktiviert. Die Liste wurde aktualisiert; schließen Sie das Fenster und prüfen Sie den aktuellen Status der Person.',
  'personnelLink.cancel.body.invite':
    'Der für {{name}} gesendete Aktivierungslink wird widerrufen; die Person kann ihr Konto damit nicht mehr aktivieren. Diese Zeile wird aus der Liste entfernt.',
  'personnelLink.cancel.confirm': 'Link widerrufen',
  'personnelLink.send.title': 'Aktivierungslink senden',
  'personnelLink.send.description':
    'Senden Sie einen Aktivierungslink für {{name}}. Er geht nur an die eingegebene E-Mail-Adresse oder Telefonnummer; diese Angabe wird nicht im Datensatz der Person gespeichert.',
  'personnelLink.send.tcMissing':
    'Im Datensatz dieser Person ist keine T.C.-Kimlik-Nummer hinterlegt. Sie muss zuerst eingetragen werden, bevor ein Aktivierungslink gesendet werden kann.',
  'personnelLink.send.contactHint':
    'Geben Sie mindestens eine E-Mail-Adresse oder eine Telefonnummer ein; Sie können auch beides angeben.',
  'personnelLink.send.submit': 'Senden',
  'personnelLink.resend.title': 'Link erneut senden',
  'personnelLink.resend.description':
    'Für {{name}} wird ein neuer Aktivierungslink erstellt und gesendet. Der bisherige Link wird ungültig.',
  'personnelLink.resend.channelHint':
    'Der neue Link wird über den gewählten Kanal gesendet und bleibt hier zum Kopieren.',
  'personnelLink.resend.via.email': 'Der neue Link wird per E-Mail gesendet.',
  'personnelLink.resend.via.sms': 'Der neue Link wird per SMS gesendet.',
  'personnelLink.resend.submit': 'Erneut senden',
  'personnelLink.resend.noContact':
    'Für diesen Link sind weder E-Mail noch Telefon hinterlegt; er kann nicht erneut gesendet werden.',
  'personnelLink.success.title': 'Aktivierungslink bereit',
  'personnelLink.success.body':
    'Der Versandstatus steht unten. Sie können den Link auch kopieren und selbst an die Person weitergeben.',
  ACTIVATION_LINK_DAILY_LIMIT:
    'Das Tageslimit für den Versand von Links ist erreicht. Bitte versuchen Sie es später erneut.',
  PERSONNEL_INACTIVE:
    'Ein Aktivierungslink kann nicht gesendet werden, da diese Person inaktiv ist. Setzen Sie die Person zuerst auf Aktiv.',
  PERSONNEL_TC_REQUIRED:
    'Im Datensatz der Person ist keine T.C.-Kimlik-Nummer hinterlegt. Solange sie dort nicht eingetragen ist, kann weder ein Aktivierungslink gesendet noch die Aktivierung abgeschlossen werden.',
  GUEST_INVITE_CONTACT_ALREADY_EXISTS:
    'Diese E-Mail-Adresse oder Telefonnummer ist bereits einem anderen Konto zugeordnet; die Einladung kann mit diesen Kontaktdaten nicht abgeschlossen werden.',
  PERSONNEL_ALREADY_HAS_LOGIN:
    'Diese Person hat bereits ein Konto; es kann keine neue Einladung gesendet werden.',

  // Besucher-Fehlercodes (api-contract §11) — SITE/BRANCH_NOT_FOUND in §9 definiert
  VEHICLE_DOCUMENT_IN_USE:
    'Dieses Dokument wird verwendet und kann nicht gelöscht werden: Dem Fahrzeug wurde der Zutritt gewährt, während das Dokument vorlag, oder das Fahrzeug ist einer aktiven Arbeitserlaubnis zugeordnet. Lehnen Sie ein fehlerhaftes Dokument ab oder laden Sie ein neues hoch.',
  VEHICLE_DOCUMENT_NOT_PENDING:
    'Dieses Dokument wurde bereits geprüft und kann nicht mehr gelöscht werden. Laden Sie stattdessen ein Ersatzdokument hoch.',
  VEHICLE_HAS_OPEN_PERMITS:
    'Dieses Fahrzeug ist einer offenen Arbeitserlaubnis zugeordnet und kann nicht gelöscht werden. Entfernen Sie es zuerst aus den offenen Arbeitserlaubnissen.',
  VEHICLE_HAS_LOCKED_DOCUMENTS:
    'Dieses Fahrzeug kann nicht gelöscht werden: Es hat ein genehmigtes Dokument, oder eines seiner Dokumente wird verwendet (der Zutritt wurde gewährt, während es vorlag, oder das Fahrzeug ist einer aktiven Arbeitserlaubnis zugeordnet). Das Fahrzeug bleibt in der Liste; legen Sie für ein anderes Fahrzeug ein neues an.',
  VEHICLE_PLATE_LOCKED:
    'Das Kennzeichen dieses Fahrzeugs kann nicht mehr geändert werden: Das Fahrzeug wurde bereits einer Arbeitserlaubnis hinzugefügt oder eines seiner Dokumente wurde genehmigt. Legen Sie für ein anderes Kennzeichen ein neues Fahrzeug an.',
  VEHICLE_PLATE_ALREADY_EXISTS:
    'Ein Fahrzeug mit diesem Kennzeichen ist bereits erfasst (Leerzeichen und Satzzeichen werden ignoriert). Verwenden Sie das vorhandene Fahrzeug aus der Liste.',
  VEHICLE_DOCUMENT_NOT_FOUND:
    'Dieses Fahrzeugdokument wurde nicht gefunden oder existiert nicht mehr.',
  VEHICLE_NOT_FOUND:
    'Fahrzeug nicht gefunden; es wurde möglicherweise gelöscht oder aus der Arbeitserlaubnis entfernt.',
  VISIT_NOT_FOUND: 'Besuchsdatensatz nicht gefunden.',
  HOST_NOT_FOUND: 'Der ausgewählte Gastgeber ist kein aktiver Benutzer des Unternehmens.',
  SAFETY_BRIEFING_REQUIRED: 'Die Bestätigung der Sicherheitsunterweisung ist erforderlich.',
  KVKK_CONSENT_REQUIRED:
    'Die ausdrückliche KVKK-Einwilligung ist erforderlich; ohne sie ist keine Anmeldung möglich.',
  VISIT_ALREADY_CHECKED_OUT: 'Dieser Besuch wurde bereits abgemeldet.',

  // Verwaltungs-Fehlercodes (api-contract §9)
  FORBIDDEN: 'Sie sind nicht berechtigt, diese Aktion auszuführen.',
  ROLE_NOT_FOUND: 'Rolle nicht gefunden.',
  SYSTEM_ADMIN_ROLE_LOCKED:
    'Die Systemadministrator-Rolle ist gesperrt und kann nicht geändert werden.',
  UNKNOWN_ACTION:
    'Eine unbekannte Aktion wurde gesendet. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
  COMPANY_NOT_FOUND: 'Unternehmen nicht gefunden.',
  BRANCH_NOT_FOUND: 'Filiale nicht gefunden.',
  SITE_NOT_FOUND: 'Standort nicht gefunden.',
  USER_ALREADY_EXISTS:
    'Diese E-Mail wird bereits verwendet. Bitte geben Sie eine andere E-Mail ein.',

  'validation.emailRequired': 'E-Mail ist erforderlich.',
  'validation.emailInvalid': 'Geben Sie eine gültige E-Mail-Adresse ein.',
  'validation.passwordRequired': 'Passwort ist erforderlich.',
  'validation.identifierRequired': 'E-Mail oder Telefon ist erforderlich.',
  'validation.codeRequired': 'Bestätigungscode ist erforderlich.',
  'validation.passwordPolicy':
    'Das Passwort muss mindestens 8 Zeichen, einen Buchstaben und eine Ziffer enthalten.',

  'error.generic': 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  NETWORK_ERROR: 'Server nicht erreichbar. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  INVALID_CREDENTIALS: 'E-Mail oder Passwort ist falsch.',
  VALIDATION_FAILED: 'Bitte überprüfen Sie die Felder.',
  UNAUTHORIZED: 'Ihre Sitzung konnte nicht bestätigt werden. Bitte melden Sie sich erneut an.',
  PASSWORD_POLICY_ERROR:
    'Das Passwort muss mindestens 8 Zeichen, einen Buchstaben und eine Ziffer enthalten.',
  CODE_INVALID: 'Der Bestätigungscode ist falsch oder verbraucht. Fordern Sie einen neuen Code an.',
  CODE_EXPIRED: 'Der Bestätigungscode ist abgelaufen. Fordern Sie einen neuen Code an.',
  CODE_TOO_FREQUENT:
    'Sie haben zu oft einen Code angefordert. Bitte warten Sie und versuchen Sie es erneut.',

  // ---- Arbeitserlaubnisse (Permits — §14/§17) ----
  'permits.nav': 'Arbeitserlaubnisse',
  'permits.nav.pendingApproval': 'Genehmigung ausstehend',
  'permits.nav.active': 'Aktiv',
  'permits.nav.all': 'Alle Erlaubnisse',
  'permits.title': 'Arbeitserlaubnisse',
  'permits.list.subtitle':
    'Arbeitserlaubnisse von Auftragnehmern für gefährliche Arbeiten verwalten.',
  'permits.common.actions': 'Aktionen',
  'permits.common.loading': 'Wird geladen...',
  'permits.common.close': 'Schließen',
  'permits.common.cancel': 'Abbrechen',
  'permits.common.save': 'Speichern',
  'permits.common.create': 'Erstellen',
  'permits.common.add': 'Hinzufügen',
  'permits.gate.loadingLabel': 'Zugang zu Arbeitserlaubnissen wird geprüft...',
  'permits.forbidden.title': 'Kein Zugang',
  'permits.forbidden.body':
    'Sie haben keinen Zugang zum Modul Arbeitserlaubnisse. Bitte wenden Sie sich an Ihren Unternehmensadministrator.',
  'permits.forbidden.back': 'Zurück zur Übersicht',
  'permits.unavailable.title': 'Arbeitserlaubnisse nicht verfügbar',
  'permits.unavailable.body':
    'Der Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
  'permits.unavailable.retry': 'Erneut versuchen',
  'permits.list.search': 'Erlaubnisse suchen',
  'permits.list.searchPlaceholder': 'Nach Titel suchen',
  'permits.list.new': 'Neue Erlaubnis',
  'permits.list.count': '{{count}} Arbeitserlaubnisse aufgelistet',
  'permits.list.count_one': '{{count}} Arbeitserlaubnis aufgelistet',
  'permits.list.empty': 'Noch keine Arbeitserlaubnisse.',
  'permits.list.empty.body': 'Sobald Sie die erste Erlaubnis erstellen, erscheint sie hier.',
  'permits.list.noResults': 'Keine Arbeitserlaubnisse entsprechen Ihren Filtern.',
  'permits.list.col.permitType': 'Genehmigungsart',
  'permits.list.col.title': 'Titel',
  'permits.list.col.contractorSites': 'Auftragnehmer / Standort',
  'permits.list.sitesMore': '+{{count}}',
  'permits.list.col.hazard': 'Gefahr',
  'permits.list.col.validity': 'Gültigkeit',
  'permits.list.col.status': 'Status',
  'permits.list.col.personnel': 'Personal',
  'permits.list.filter.status': 'Status',
  'permits.list.filter.contractor': 'Auftragnehmer',
  'permits.list.filter.site': 'Standort',
  'permits.list.filter.permitType': 'Genehmigungsart',
  'permits.list.filter.from': 'Von (frühestens)',
  'permits.list.filter.to': 'Bis (spätestens)',
  'permits.list.filter.validityEndFrom': 'Endet (frühestens)',
  'permits.list.filter.validityEndTo': 'Endet (spätestens)',
  'permits.list.filter.allStatuses': 'Alle Status',
  'permits.list.filter.allContractors': 'Alle Auftragnehmer',
  'permits.list.filter.allSites': 'Alle Standorte',
  'permits.list.filter.allPermitTypes': 'Alle Genehmigungsarten',
  'permits.pagination.nav': 'Seitennummerierung',
  'permits.pagination.previous': 'Zurück',
  'permits.pagination.next': 'Weiter',
  'permits.status.Draft': 'Entwurf',
  'permits.status.Submitted': 'Genehmigung ausstehend',
  'permits.status.Approved': 'Genehmigt',
  'permits.status.Active': 'Aktiv',
  'permits.status.Rejected': 'Abgelehnt',
  'permits.status.Expired': 'Abgelaufen',
  'permits.status.Closed': 'Geschlossen',
  'permits.form.create.title': 'Neue Arbeitserlaubnis',
  'permits.form.edit.title': 'Arbeitserlaubnis bearbeiten',
  'permits.form.description':
    'Geben Sie die Aufgabendetails und das Gültigkeitsfenster ein. Die Erlaubnis wird als Entwurf erstellt.',
  'permits.form.section.task': 'Aufgabendetails',
  'permits.form.section.validity': 'Gültigkeit',
  'permits.form.section.trainings': 'Erforderliche Schulungen',
  'permits.form.field.contractor': 'Auftragnehmer',
  'permits.form.field.sites': 'Standorte',
  'permits.form.field.permitType': 'Genehmigungsart',
  'permits.form.field.title': 'Titel',
  'permits.form.field.description': 'Beschreibung',
  'permits.form.field.hazardClass': 'Gefahrenklasse',
  'permits.form.field.validityStart': 'Beginn',
  'permits.form.field.validityEnd': 'Ende',
  'permits.form.field.notes': 'Notizen',
  'permits.form.contractorPlaceholder': 'Auftragnehmer auswählen',
  'permits.form.permitTypePlaceholder': 'Genehmigungsart auswählen',
  'permits.form.hazardPlaceholder': 'Gefahrenklasse wählen',
  'permits.form.hazardFromTypeHint':
    'Die Gefahrenklasse stammt aus der gewählten Genehmigungsart und kann nicht geändert werden.',
  'permits.form.hazardManualHint': 'Wählen Sie die Gefahrenklasse für diese Genehmigungsart.',
  'permits.form.noPermitTypes':
    'Definieren Sie zuerst mindestens eine Genehmigungsart. Sie können eine im Bereich Genehmigungsarten hinzufügen.',
  'permits.form.sitesNote':
    'Wählen Sie die Standorte, die diese Erlaubnis abdeckt (optional, Mehrfachauswahl möglich). Leer lassen, damit die Erlaubnis an keinen bestimmten Standort gebunden ist.',
  'permits.form.sitesLoading': 'Standorte werden geladen...',
  'permits.form.sitesEmpty':
    'Keine Standorte definiert. Standorte können im Bereich Einstellungen hinzugefügt werden.',
  'permits.form.trainingsEmpty': 'Keine aktiven Schulungen zum Hinzufügen.',
  'permits.form.trainingsLoading': 'Schulungen werden geladen...',
  'permits.form.trainingsNote':
    'Personal wird bei der Erstellung nicht ausgewählt; fügen Sie es nach Erstellung der Erlaubnis über den Detailbildschirm hinzu. Erforderliche Schulungen können Sie ebenfalls über den Detailbildschirm verwalten.',
  'permits.validation.contractorRequired': 'Bitte wählen Sie einen Auftragnehmer.',
  'permits.validation.permitTypeRequired': 'Bitte wählen Sie eine Genehmigungsart.',
  'permits.validation.hazardClassRequired': 'Bitte wählen Sie eine Gefahrenklasse.',
  'permits.validation.titleRequired': 'Titel ist erforderlich.',
  'permits.validation.validityStartRequired': 'Beginndatum ist erforderlich.',
  'permits.validation.validityEndRequired': 'Enddatum ist erforderlich.',
  'permits.validation.validityRange': 'Das Ende darf nicht vor dem Beginn liegen.',
  'permits.validation.reasonRequired': 'Ein Ablehnungsgrund ist erforderlich.',
  'permits.detail.back': 'Zurück zu Arbeitserlaubnissen',
  'permits.detail.loading': 'Erlaubnis wird geladen...',
  'permits.detail.edit': 'Bearbeiten',
  'permits.detail.readOnlyNote': 'Diese Erlaubnis kann nicht mehr bearbeitet werden ({{status}}).',
  'permits.detail.field.contractor': 'Auftragnehmer',
  'permits.detail.field.sites': 'Standorte',
  'permits.detail.field.permitType': 'Genehmigungsart',
  'permits.detail.field.hazardClass': 'Gefahrenklasse',
  'permits.detail.field.validity': 'Gültigkeit',
  'permits.detail.field.description': 'Beschreibung',
  'permits.detail.field.notes': 'Notizen',
  'permits.detail.field.approvedBy': 'Genehmigt von',
  'permits.detail.field.approvedAt': 'Genehmigt am',
  'permits.detail.field.createdAt': 'Erstellt',
  'permits.detail.section.personnel': 'Erfasstes Personal',
  'permits.detail.section.trainings': 'Erforderliche Schulungen',
  'permits.detail.requiredDocuments': 'Erforderliche Dokumente',
  'permits.detail.requiredDocumentsEmpty':
    'Für diese Genehmigungsart sind keine Personaldokumente erforderlich.',
  'permits.lifecycle.submit': 'Einreichen',
  'permits.lifecycle.approve': 'Genehmigen',
  'permits.lifecycle.reject': 'Ablehnen',
  'permits.lifecycle.close': 'Schließen',
  'permits.lifecycle.submit.title': 'Erlaubnis einreichen',
  'permits.lifecycle.submit.body': 'Die Erlaubnis wird zur Genehmigung eingereicht. Fortfahren?',
  'permits.lifecycle.submit.confirm': 'Einreichen',
  'permits.lifecycle.approve.title': 'Erlaubnis genehmigen',
  'permits.lifecycle.approve.body':
    'Die Erlaubnis wird genehmigt und der Auftragnehmer wird gebeten, die Erlaubnisangaben (Personal, Fahrzeuge, Dokumente) zu vervollständigen; die Ansprechpartner des Auftragnehmers werden benachrichtigt. Fortfahren?',
  'permits.lifecycle.approve.confirm': 'Genehmigen',
  'permits.lifecycle.close.title': 'Erlaubnis schließen',
  'permits.lifecycle.close.body': 'Die Erlaubnis wird dauerhaft geschlossen. Fortfahren?',
  'permits.lifecycle.close.confirm': 'Schließen',
  'permits.lifecycle.rerunAiReview': 'KI-Prüfung erneut ausführen',
  'permits.lifecycle.rerunAiReview.title': 'KI-Prüfung erneut ausführen',
  'permits.lifecycle.rerunAiReview.body':
    'Die KI-Prüfung wird erneut ausgeführt; je nach Ergebnis geht die Erlaubnis in die Fachprüfung oder zurück in die Überarbeitung. Fortfahren?',
  'permits.lifecycle.rerunAiReview.confirm': 'Erneut ausführen',
  'permits.lifecycle.issueEntryPermits': 'Zutrittsberechtigungen erteilen',
  'permits.lifecycle.issueEntryPermits.title': 'Zutrittsberechtigungen erteilen',
  'permits.lifecycle.issueEntryPermits.body':
    'Alle erfassten Personen und ggf. Fahrzeuge erhalten Zutritt zum Standort, die Personen werden benachrichtigt, und die Erlaubnis wird aktiv. Fortfahren?',
  'permits.lifecycle.issueEntryPermits.confirm': 'Zutritt erteilen',
  'permits.lifecycle.goToReview': 'Zur Fachprüfung',
  'permits.lifecycle.action.openMenu': 'Aktionen für {{name}}',
  'permits.reject.title': 'Erlaubnis ablehnen',
  'permits.reject.description': 'Die Erlaubnis wird abgelehnt. Bitte geben Sie einen Grund ein.',
  'permits.reject.field.reason': 'Grund',
  'permits.reject.reasonPlaceholder': 'Ablehnungsgrund eingeben',
  'permits.reject.confirm': 'Ablehnen',
  'permits.personnel.subtitle':
    'Von der Erlaubnis erfasstes Auftragnehmerpersonal und dessen Schulungsbereitschaft.',
  'permits.personnel.add': 'Personal hinzufügen',
  'permits.personnel.empty': 'Dieser Erlaubnis wurde noch kein Personal hinzugefügt.',
  'permits.personnel.col.name': 'Name',
  'permits.personnel.col.contact': 'Kontakt',
  'permits.personnel.col.training': 'Schulung',
  'permits.personnel.col.readiness': 'Bereitschaft',
  'permits.personnel.trainingProgress': '{{completed}} / {{required}} abgeschlossen',
  'permits.personnel.ready': 'Bereit',
  'permits.personnel.notReady': 'Unvollständig',
  'permits.personnel.action.remove': 'Aus Erfassung entfernen',
  'permits.personnel.remove.title': 'Personal entfernen',
  'permits.personnel.remove.body': '{{name}} aus der Erlaubniserfassung entfernen?',
  'permits.personnel.remove.confirm': 'Entfernen',
  'permits.personnel.add.title': 'Personal hinzufügen',
  'permits.personnel.add.description':
    'Wählen Sie aus dem Personal des Auftragnehmers der Genehmigung. Auch Personen, die ihr Konto noch nicht aktiviert haben, können hinzugefügt werden.',
  'permits.personnel.add.createNew': 'Neues Personal anlegen',
  'permits.personnel.notActivated': 'Nicht aktiviert',
  'permits.personnel.notActivated.hint':
    'Die Person kann die für diese Genehmigung erforderlichen Schulungen erst abschließen, wenn sie ihr Konto aktiviert hat. Der Aktivierungslink wird im Tab „Personal“ des Auftragnehmers versendet.',
  'permits.personnel.add.field.personnel': 'Personal',
  'permits.personnel.add.empty': 'Kein geeignetes Personal zum Hinzufügen.',
  'permits.personnel.readiness.documents': 'Dokumente',
  'permits.personnel.readiness.training': 'Schulungen',
  'permits.personnel.missingDocuments': 'Fehlende Dokumente',
  'permits.personnel.missingTrainings': 'Fehlende Schulungen',

  'permits.entry.grant': 'Zutritt gewähren',
  'permits.entry.grantBlocked': 'Zutritt gewähren (Dokument oder Schulung fehlt)',
  'permits.entry.granted': 'Zutritt gewährt',
  'permits.entry.grantedMeta': '{{date}} · durch {{by}}',
  'permits.entry.revoke': 'Zutritt entziehen',
  'permits.entry.readyHint': 'Personal ist bereit; der Baustellenzutritt kann gewährt werden.',
  'permits.entry.notReadyHint':
    'Vor der Zutrittsgewährung müssen alle Dokumente genehmigt und die Schulungen abgeschlossen sein.',
  'permits.entry.grantSuccess': 'Zutritt gewährt.',
  'permits.entry.revokeSuccess': 'Zutritt entzogen.',
  'permits.entry.grantError':
    'Zutritt konnte nicht gewährt werden. Alle Dokumente des Personals müssen genehmigt und die Schulungen abgeschlossen sein.',
  'permits.entry.revoke.title': 'Zutritt entziehen',
  'permits.entry.revoke.body': 'Den {{name}} gewährten Baustellenzutritt entziehen?',
  'permits.entry.revoke.confirm': 'Entziehen',

  'permits.personnelDocs.title': 'Dokumente',
  'permits.personnelDocs.col.type': 'Typ',
  'permits.personnelDocs.col.validityStatus': 'Status',
  'documents.review.download': 'Herunterladen: {{type}}',
  'documents.review.approve': 'Genehmigen: {{type}}',
  'documents.review.reject': 'Ablehnen: {{type}}',
  'documents.review.delete': 'Löschen: {{type}}',
  'documents.review.reason.label': 'Ablehnungsgrund',
  'documents.review.reason.placeholder': 'z. B. Dokument unleserlich oder abgelaufen.',
  'documents.review.reason.required': 'Ein Ablehnungsgrund ist erforderlich.',
  'documents.review.reason.tooLong':
    'Der Ablehnungsgrund darf höchstens {{max}} Zeichen lang sein.',
  'documents.review.reject.confirm': 'Ablehnen',
  'documents.review.rejectionReason': 'Ablehnungsgrund: {{reason}}',
  'documents.review.approveSuccess': 'Dokument genehmigt.',
  'documents.review.rejectSuccess': 'Dokument abgelehnt.',
  'vehicles.docStatus.allApproved': 'Alle genehmigt',
  'vehicles.docStatus.none': 'Keine Dokumente',
  'vehicles.docStatus.missingEnd': 'Kein Enddatum',
  'vehicles.openPermits.yes': 'In offener Erlaubnis',
  'vehicles.sheet.docs.title': 'Fahrzeugdokumente',
  'vehicles.sheet.docs.upload': 'Dokument hochladen',
  'vehicles.sheet.docs.empty': 'Diesem Fahrzeug wurden noch keine Dokumente hinzugefügt.',
  'vehicles.sheet.docs.note':
    'Dokumente werden beim Fahrzeug geführt; Genehmigung oder Ablehnung gilt für alle Arbeitserlaubnisse des Fahrzeugs.',
  'vehicles.sheet.plateLocked': 'Kennzeichen gesperrt',
  'vehicles.doc.inUse': 'In Verwendung: kann nicht gelöscht werden',
  'vehicles.doc.delete.title': 'Dokument löschen',
  'vehicles.doc.delete.body':
    'Dokument "{{type}}" löschen? Es verschwindet auch aus allen Arbeitserlaubnissen des Fahrzeugs.',
  'vehicles.doc.delete.confirm': 'Löschen',
  'vehicles.upload.title': 'Fahrzeugdokument hochladen',
  'vehicles.upload.description':
    'Fügen Sie ein Dokument für Fahrzeug {{plate}} hinzu. Es wartet auf Genehmigung.',
  'vehicles.upload.chooseFile': 'Datei wählen',
  'vehicles.upload.submit': 'Hochladen',
  'vehicles.upload.uploading': 'Wird hochgeladen…',
  'vehicles.upload.progress': '{{percent}} % hochgeladen',
  'vehicles.upload.noteTooLong': 'Die Notiz darf höchstens {{max}} Zeichen lang sein.',
  'vehicles.validation.plateInvalid':
    'Das Kennzeichen ist ungültig: höchstens {{max}} Zeichen und höchstens {{keyMax}} Buchstaben und Ziffern, keine unsichtbaren Zeichen. Geben Sie das Kennzeichen erneut von Hand ein.',
  'vehicles.title': 'Fahrzeuge',
  'vehicles.subtitle':
    'Die Fahrzeuge des Auftragnehmers in dieser Firma. Fügen Sie Fahrzeuge hinzu, laden Sie ihre Dokumente hoch und genehmigen Sie sie; eine Genehmigung gilt für alle Arbeitserlaubnisse, denen das Fahrzeug hinzugefügt wird.',
  'vehicles.add': 'Fahrzeug hinzufügen',
  'vehicles.empty': 'Für diesen Auftragnehmer wurden noch keine Fahrzeuge hinzugefügt.',
  'vehicles.col.plate': 'Kennzeichen',
  'vehicles.col.description': 'Beschreibung',
  'vehicles.col.documents': 'Dokumente',
  'vehicles.col.docStatus': 'Dokumentstatus',
  'vehicles.col.openPermits': 'Offene Erlaubnis',
  'vehicles.action.openMenu': 'Aktionen für Fahrzeug {{plate}}',
  'vehicles.action.upload': 'Dokument hochladen',
  'vehicles.action.edit': 'Bearbeiten',
  'vehicles.action.delete': 'Löschen',
  'vehicles.action.deleteBlocked': 'Löschen (zuerst aus offenen Arbeitserlaubnissen entfernen)',
  'vehicles.action.deleteBlockedInUse': 'Löschen (ein Dokument wird verwendet)',
  'vehicles.delete.title': 'Fahrzeug löschen',
  'vehicles.delete.body':
    'Fahrzeug {{plate}} und seine Dokumente löschen? In früheren Arbeitserlaubnissen bleibt das Kennzeichen sichtbar.',
  'vehicles.delete.confirm': 'Löschen',
  'vehicles.form.edit.title': 'Fahrzeug bearbeiten',
  'vehicles.form.edit.description': 'Änderungen gelten für alle Arbeitserlaubnisse des Fahrzeugs.',
  'vehicles.form.create.description':
    'Ein neues Fahrzeug zur Fahrzeugliste des Auftragnehmers hinzufügen.',
  'vehicles.form.submit.edit': 'Speichern',
  'vehicles.form.submit.create': 'Hinzufügen',
  'vehicles.form.field.plate': 'Kennzeichen',
  'vehicles.form.field.description': 'Beschreibung',
  'vehicles.form.platePlaceholder': 'z. B. 34 ABC 123',
  'vehicles.form.plateLocked':
    'Das Kennzeichen kann nicht mehr geändert werden: Eines der Fahrzeugdokumente wurde genehmigt. Legen Sie für ein anderes Kennzeichen ein neues Fahrzeug an.',
  'vehicles.validation.plateRequired': 'Das Kennzeichen ist erforderlich.',
  'vehicles.validation.plateTooLong': 'Das Kennzeichen darf höchstens {{max}} Zeichen lang sein.',
  'vehicles.validation.plateKeyTooLong':
    'Das Kennzeichen darf höchstens {{max}} Buchstaben und Ziffern enthalten.',
  'vehicles.validation.descriptionTooLong':
    'Die Beschreibung darf höchstens {{max}} Zeichen lang sein.',
  'vehicles.permitAdd.title': 'Fahrzeug hinzufügen',
  'vehicles.permitAdd.description':
    'Wählen Sie aus den Fahrzeugen des Auftragnehmers oder geben Sie ein neues Kennzeichen ein. Ein neues Kennzeichen wird auch in die Fahrzeugliste des Auftragnehmers aufgenommen.',
  'vehicles.permitAdd.submit': 'Hinzufügen',
  'vehicles.permitAdd.registered': 'Registrierte Fahrzeuge',
  'vehicles.permitAdd.registeredEmpty': 'Keine registrierten Fahrzeuge zum Hinzufügen vorhanden.',
  'vehicles.permitAdd.newVehicle': 'Neues Fahrzeug',
  'vehicles.permitAdd.plateOnPermit': 'Dieses Fahrzeug ist bereits in der Arbeitserlaubnis.',
  'vehicles.permitAdd.plateExisting':
    'Dieses Kennzeichen ist bereits in der Liste; das vorhandene Fahrzeug wird der Arbeitserlaubnis hinzugefügt.',
  'vehicles.permitAdd.plateNew': 'Neues Fahrzeug; es wird auch in die Fahrzeugliste aufgenommen.',
  'vehicles.permitAdd.partialFailure': 'Fahrzeug {{plate}} konnte nicht hinzugefügt werden.',
  'vehicles.unlink.action': 'Aus Arbeitserlaubnis entfernen',
  'vehicles.unlink.title': 'Fahrzeug aus der Arbeitserlaubnis entfernen',
  'vehicles.unlink.body':
    'Fahrzeug {{plate}} aus dieser Arbeitserlaubnis entfernen? Fahrzeug und Dokumente bleiben in der Fahrzeugliste erhalten.',
  'vehicles.unlink.confirm': 'Entfernen',

  'permits.docApproval.pending': 'Genehmigung ausstehend',
  'permits.docApproval.approved': 'Genehmigt',
  'permits.docApproval.rejected': 'Abgelehnt',

  // Fahrzeuge (§23). Fahrzeugdokumenttyp-Bezeichnungen kommen aus dem §27-Register (keine App-Schlüssel).
  'permits.form.field.hasVehicles': 'Sind Fahrzeuge beteiligt?',
  'permits.form.hasVehiclesHint':
    'Wenn aktiviert, können Sie auf der Genehmigungsdetailseite Fahrzeugkennzeichen und Dokumente hinzufügen.',
  'permits.detail.section.vehicles': 'Fahrzeuge',
  'permits.detail.tab.personnelIncomplete_one': '{{count}} Person unvollständig',
  'permits.detail.tab.personnelIncomplete_other': '{{count}} Personen unvollständig',
  'permits.detail.tab.vehiclesIncomplete_one': '{{count}} Fahrzeug unvollständig',
  'permits.detail.tab.vehiclesIncomplete_other': '{{count}} Fahrzeuge unvollständig',
  'permits.detail.section.ppe': 'PSA',
  'permits.detail.section.controls': 'Kontroll-Checkliste',
  'permits.detail.section.documentRequests': 'Zusätzliche Dokumentanforderungen',
  'permits.ppe.subtitle':
    'Von der Genehmigungsart geforderte persönliche Schutzausrüstung (die Ausrüstung stellt der Auftragnehmer).',
  'permits.ppe.empty': 'Keine PSA in dieser Genehmigung.',
  'permits.ppe.col.name': 'PSA',
  'permits.controls.subtitle':
    'Kontrollpunkte der Genehmigung — haken Sie sie ab, sobald Sie vor Ort geprüft haben.',
  'permits.controls.lockedHint':
    'Die Kontroll-Checkliste kann ausgefüllt werden, sobald die Genehmigung aktiv ist (Arbeit begonnen). Punkte können weiterhin hinzugefügt und entfernt werden.',
  'permits.controls.empty': 'Keine Kontrollpunkte in dieser Genehmigung.',
  'permits.controls.col.item': 'Punkt',
  'permits.controls.col.status': 'Status',
  'permits.controls.checked': 'Abgehakt',
  'permits.controls.unchecked': 'Nicht abgehakt',
  'permits.controls.checkedBy': '{{name}} · {{date}}',
  'permits.controls.note': 'Notiz',
  'permits.controls.notePlaceholder': 'Optionale Notiz',
  'permits.controls.noteSave': 'Notiz speichern',
  'permits.docRequests.subtitle':
    'Fordern Sie zusätzlich zu den von der Genehmigungsart geforderten Standarddokumenten einen für diese Genehmigung spezifischen Dokumenttyp an. Die Anforderung gilt für das gesamte Personal der Genehmigung und zählt zur Bereitschaft.',
  'permits.docRequests.empty':
    'Für diese Genehmigung liegen keine zusätzlichen Dokumentanforderungen vor.',
  'permits.docRequests.readOnlyHint':
    'Sie sehen die zusätzlichen Dokumentanforderungen nur an; zum Hinzufügen oder Entfernen ist eine Bearbeitungsberechtigung erforderlich.',
  'permits.docRequests.allRequested':
    'Für jeden Dokumenttyp im Katalog besteht bereits eine Anforderung.',
  'permits.docRequests.typeLabel': 'Dokumenttyp',
  'permits.docRequests.typePlaceholder': 'Dokumenttyp auswählen',
  'permits.docRequests.note': 'Notiz',
  'permits.docRequests.col.requested': 'Angefordert von',
  'permits.docRequests.notePlaceholder': 'Optionale Notiz',
  'permits.docRequests.add': 'Anforderung hinzufügen',
  'permits.docRequests.requestedBy': '{{name}} · {{date}}',
  'permits.docRequests.remove': 'Anforderung entfernen',
  'permits.docRequests.remove.title': 'Dokumentanforderung entfernen',
  'permits.docRequests.remove.body':
    'Die Dokumentanforderung "{{type}}" aus dieser Genehmigung entfernen?',
  'permits.docRequests.remove.confirm': 'Entfernen',
  'permits.vehicles.requiredDocsLine': 'Erforderliche Fahrzeugdokumente: {{list}}',
  'permits.vehicles.readySummary': '{{ready}} von {{total}} bereit',
  'permits.vehicles.col.documents': 'Dokumente',
  'permits.vehicles.col.readiness': 'Bereitschaft',
  'permits.vehicles.action.openMenu': 'Aktionen für {{plate}}',
  'permits.vehicles.requiredDocumentsEmpty':
    'Für diese Genehmigungsart sind keine Fahrzeugdokumente erforderlich.',
  'permits.vehicles.add': 'Fahrzeug hinzufügen',
  'permits.vehicles.empty': 'Dieser Erlaubnis wurde noch kein Fahrzeug hinzugefügt.',
  'permits.vehicles.ready': 'Bereit',
  'permits.vehicles.notReady': 'Unvollständig',
  'permits.vehicles.missingDocuments': 'Fehlende Fahrzeugdokumente',
  'permits.vehicles.form.field.plate': 'Kennzeichen',
  'permits.vehicles.docs.col.type': 'Typ',
  'permits.vehicles.docs.col.approval': 'Genehmigung',
  'permits.trainings.subtitle': 'Schulungen, die das erfasste Personal absolvieren muss.',
  'permits.trainings.add': 'Schulung hinzufügen',
  'permits.trainings.empty': 'Für diese Erlaubnis sind keine erforderlichen Schulungen definiert.',
  'permits.trainings.action.remove': 'Entfernen',
  'permits.trainings.remove.title': 'Schulung entfernen',
  'permits.trainings.remove.body': '"{{title}}" aus den erforderlichen Schulungen entfernen?',
  'permits.trainings.remove.confirm': 'Entfernen',
  'permits.trainings.add.title': 'Erforderliche Schulung hinzufügen',
  'permits.trainings.add.description':
    'Aktive Schulungen auswählen, die für diese Erlaubnis erforderlich sind.',
  'permits.trainings.add.field.trainings': 'Schulungen',
  'permits.trainings.add.empty': 'Keine aktiven Schulungen zum Hinzufügen.',
  // Statuslabels des Genehmigungsablaufs (SPEC §1) — Phase-B-Erweiterung.
  'permits.status.AwaitingSupplierInfo': 'Warten auf Auftragnehmerangaben',
  'permits.status.AwaitingAiReview': 'Warten auf KI-Prüfung',
  'permits.status.Revision': 'Überarbeitung',
  'permits.status.DepartmentReview': 'Fachprüfung',
  'permits.status.AwaitingEntryPermit': 'Warten auf Zutrittsberechtigung',
  // ===== Fachprüfung (Kontrol) + Genehmigungsweiterleitung (§31 / brief 095) — Phase B Welle 2 =====
  'permits.department.Isg': 'Arbeitssicherheit',
  'permits.department.Hekim': 'Betriebsarzt',
  'permits.department.Ik': 'Personalabteilung',
  'departmentReview.nav': 'Prüfung',
  'departmentReview.title': 'Prüfung',
  'departmentReview.subtitle':
    'Arbeitserlaubnisse, die auf die Genehmigung Ihrer Abteilung warten.',
  'departmentReview.count': '{{count}} Erlaubnisse warten auf Ihre Genehmigung',
  'departmentReview.count_one': '{{count}} Erlaubnis wartet auf Ihre Genehmigung',
  'departmentReview.loading': 'Prüfungswarteschlange wird geladen...',
  'departmentReview.empty': 'Derzeit warten keine Erlaubnisse auf Ihre Genehmigung.',
  'departmentReview.col.permit': 'Erlaubnis',
  'departmentReview.col.contractor': 'Auftragnehmer',
  'departmentReview.col.validity': 'Gültigkeit',
  'departmentReview.col.permitStatus': 'Erlaubnisstatus',
  'departmentReview.col.myStatus': 'Status Ihrer Abteilung',
  'departmentReview.pagination.nav': 'Seitennummerierung',
  'departmentReview.pagination.previous': 'Zurück',
  'departmentReview.pagination.next': 'Weiter',
  'departmentReview.status.Pending': 'Ausstehend',
  'departmentReview.status.Approved': 'Genehmigt',
  'departmentReview.status.Rejected': 'Abgelehnt',
  'departmentReview.gate.loadingLabel': 'Prüfungszugriff wird überprüft...',
  'departmentReview.forbidden.title': 'Kein Prüfungszugriff',
  'departmentReview.forbidden.body':
    'Dieser Bereich steht nur den Genehmigungsabteilungen (Arbeitssicherheit, Betriebsarzt, Personalabteilung) offen. Bitte wenden Sie sich an Ihren Administrator, wenn Sie Zugriff benötigen.',
  'departmentReview.forbidden.back': 'Zurück zum Dashboard',
  'departmentReview.unavailable.title': 'Prüfung derzeit nicht verfügbar',
  'departmentReview.unavailable.body':
    'Der Prüfungsdienst ist derzeit nicht erreichbar. Bitte versuchen Sie es in Kürze erneut.',
  'departmentReview.unavailable.retry': 'Erneut versuchen',
  'departmentReview.detail.back': 'Zurück zur Prüfungswarteschlange',
  'departmentReview.detail.loading': 'Erlaubnis wird geladen...',
  'departmentReview.detail.sitesLabel': 'Von der Erlaubnis abgedeckte Standorte',
  'departmentReview.detail.reviewUnavailable':
    'Die Abteilungsgenehmigungen konnten derzeit nicht geladen werden; der Erlaubnisinhalt wird angezeigt. Bitte versuchen Sie es in Kürze erneut.',
  'departmentReview.detail.approvalsTitle': 'Abteilungsgenehmigungen',
  'departmentReview.detail.escalatedFrom': 'Eskaliert von {{department}}',
  'departmentReview.detail.section.aiNotes': 'KI-Notizen',
  // §31-Abgleichblock (an live §31.2/§31.4/§31.5 angeglichen) — Phase B Welle 2
  DEPARTMENT_FORBIDDEN:
    'Für diese Aktion müssen Sie Mitglied der zuständigen Abteilung sein (Arbeitssicherheit, Betriebsarzt oder Personalabteilung).',
  'approvalRouting.filter.allTypes': 'Alle Dokumenttypen',
  'approvalRouting.filter.entity': 'Filter nach Zuordnung',
  'departmentReview.detail.reviewingAs': 'Prüfende Abteilung:',
  'departmentReview.detail.noDepartment':
    'Für Sie ist keine Prüfungsabteilung registriert. Dieser Bildschirm steht nur den Rollen Arbeitssicherheit, Betriebsarzt oder Personalabteilung offen.',
  'departmentReview.detail.responsibleDocsTitle': 'Dokumente in Ihrer Verantwortung',
  'departmentReview.detail.responsibleDocsEmpty':
    'Ihre Abteilung ist für keinen Dokumenttyp dieser Erlaubnis zuständig.',
  'departmentReview.detail.responsibleDocs.personnel': 'Personaldokumente',
  'departmentReview.detail.responsibleDocs.vehicle': 'Fahrzeugdokumente',
  'departmentReview.detail.trainingsEmpty':
    'Für diese Erlaubnis ist keine Pflichtschulung definiert.',
  'departmentReview.detail.vehiclesEmpty': 'Dieser Erlaubnis wurden keine Fahrzeuge hinzugefügt.',
  'departmentReview.detail.vehicleNoDocs':
    'Diesem Fahrzeug wurden noch keine Dokumente hinzugefügt.',
  'departmentReview.action.approve': 'Genehmigen',
  'departmentReview.action.reject': 'Ablehnen',
  'departmentReview.approve.title': 'Erlaubnis genehmigen',
  'departmentReview.approve.body':
    'Sie genehmigen diese Erlaubnis im Namen der Abteilung {{department}}. Sobald alle erforderlichen Abteilungen genehmigt haben, geht die Erlaubnis zur Zutrittserlaubnis über.',
  'departmentReview.approve.confirm': 'Genehmigen',
  'departmentReview.reject.title': 'Erlaubnis ablehnen',
  'departmentReview.reject.description':
    'Die Erlaubnis geht zur Überarbeitung zurück; der Auftragnehmer und der Ersteller werden benachrichtigt. Bitte geben Sie einen Grund an.',
  'departmentReview.reject.confirm': 'Ablehnen',
  'departmentReview.reject.reasonRequired': 'Bitte geben Sie einen Grund an.',
  'departmentReview.reject.reasonPlaceholder': 'Ablehnungsgrund eingeben',
  'departmentReview.reject.field.reason': 'Grund',
  'permitTypes.catalog.tabs.approvalRouting': 'Genehmigungsweiterleitung',
  'approvalRouting.title': 'Genehmigungsweiterleitung',
  'approvalRouting.defaultNote':
    'Dokumenttypen ohne Regel erfordern standardmäßig nur die Genehmigung der Arbeitssicherheit.',
  'approvalRouting.list.new': 'Neue Regel',
  'approvalRouting.list.col.documentType': 'Dokumenttyp',
  'approvalRouting.list.col.departments': 'Genehmigende Abteilungen',
  'approvalRouting.list.col.escalation': 'Eskalation',
  'approvalRouting.list.count': '{{count}} Weiterleitungsregeln aufgelistet',
  'approvalRouting.list.count_one': '{{count}} Weiterleitungsregel aufgelistet',
  'approvalRouting.list.action.openMenu': 'Aktionen für {{name}}',
  'approvalRouting.list.empty': 'Noch keine Weiterleitungsregeln.',
  'approvalRouting.list.empty.body':
    'Ohne Regel benötigen alle Dokumenttypen nur die Arbeitsschutz-Freigabe.',
  'approvalRouting.list.noResults': 'Keine Weiterleitungsregeln entsprechen diesem Filter.',
  'approvalRouting.list.deleted': 'Weiterleitungsregel entfernt.',
  'approvalRouting.list.escalationSummary': '{{department}} nach {{hours}} Stunden',
  'approvalRouting.delete.title': 'Regel entfernen',
  'approvalRouting.delete.body':
    'Weiterleitungsregel für {{documentType}} entfernen? Dieser Typ kehrt zur Standardgenehmigung (nur Arbeitssicherheit) zurück.',
  'approvalRouting.form.create.title': 'Neue Weiterleitungsregel',
  'approvalRouting.form.edit.title': 'Weiterleitungsregel bearbeiten',
  'approvalRouting.form.description':
    'Legen Sie den Dokumenttyp, die genehmigenden Abteilungen und die optionale Eskalation fest.',
  'approvalRouting.form.field.documentType': 'Dokumenttyp',
  'approvalRouting.form.field.departments': 'Genehmigende Abteilungen',
  'approvalRouting.form.field.escalationHours': 'Eskalationszeit (Stunden)',
  'approvalRouting.form.field.escalationDepartment': 'Eskalationsabteilung',
  'approvalRouting.form.departmentsHint':
    'Sie können eine oder mehrere Abteilungen auswählen (zum Beispiel Personalabteilung und Arbeitssicherheit zusammen).',
  'approvalRouting.form.escalationHint':
    'Nach Ablauf der Zeit geht die Genehmigung an die Eskalationsabteilung über. Wenn Sie eine Zeit eingeben, ist die Abteilung ebenfalls erforderlich.',
  'approvalRouting.form.escalationHoursPlaceholder': 'z. B. 24',
  'approvalRouting.form.noEscalationDept': 'Keine Eskalation',
  'approvalRouting.form.created': 'Weiterleitungsregel erstellt.',
  'approvalRouting.form.updated': 'Weiterleitungsregel aktualisiert.',
  'approvalRouting.form.error.documentType': 'Bitte wählen Sie einen Dokumenttyp.',
  'approvalRouting.form.error.departments': 'Bitte wählen Sie mindestens eine Abteilung.',
  'approvalRouting.form.error.hoursPositive': 'Die Zeit muss eine positive ganze Zahl sein.',
  'approvalRouting.form.error.hoursRequired':
    'Die Zeit ist ebenfalls erforderlich, wenn Sie eine Eskalationsabteilung auswählen.',
  'approvalRouting.form.error.escalationDeptRequired':
    'Die Eskalationsabteilung ist erforderlich, wenn Sie eine Zeit eingeben.',
  'approvalRouting.form.allConfigured':
    'Für jeden aktiven Personal- und Fahrzeugdokumenttyp gibt es bereits eine Weiterleitungsregel. Bearbeiten Sie zum Ändern die Regel in der Liste.',
  // Speicher-Modus-Schaltflächen beim Anlegen (SPEC §2).
  'permits.form.saveDraft': 'Entwurf speichern',
  'permits.form.submitForApproval': 'Einreichen',
  // Aktivitäten-Tab (SPEC §5).
  'permits.detail.section.activities': 'Aktivität',
  'permits.activities.subtitle':
    'Alle Änderungen und Kommentare zu dieser Erlaubnis erscheinen hier, die neuesten zuerst.',
  'permits.activities.loading': 'Aktivität wird geladen...',
  'permits.activities.empty': 'Noch keine Aktivität erfasst.',
  'permits.activities.systemAuthor': 'System',
  'permits.activities.systemLog': 'Systemeintrag',
  'permits.activities.comment': 'Kommentar',
  'permits.activities.commentLabel': 'Kommentar hinzufügen',
  'permits.activities.commentPlaceholder':
    'Eine Notiz oder einen Kommentar zu dieser Erlaubnis schreiben',
  'permits.activities.commentSubmit': 'Senden',
  'permits.activities.aiAuthor': 'KI',
  'permits.activities.actorRole.supplier': 'Auftragnehmer',
  'permits.activities.actorRole.reviewer': 'AS-Genehmiger',
  'permits.activities.actorRole.opener': 'Antragsteller',
  'permits.activities.reasonLabel': 'Grund: {{reason}}',
  'permits.activities.subjectLabel': 'Person: {{name}}',
  'permits.activities.event.Created': 'Erlaubnisentwurf erstellt',
  'permits.activities.event.Submitted': 'Erlaubnis zur Genehmigung eingereicht',
  'permits.activities.event.AutoApproved':
    'Automatisch genehmigt, da der Ersteller genehmigungsberechtigt war',
  'permits.activities.event.Approved': 'Erlaubnis genehmigt',
  'permits.activities.event.Rejected': 'Erlaubnis abgelehnt',
  'permits.activities.event.SupplierSubmitted': 'Auftragnehmerangaben eingereicht',
  'permits.activities.event.AiRevisionRequested': 'KI forderte eine Überarbeitung an',
  'permits.activities.event.DepartmentReviewStarted': 'Abteilungsprüfung gestartet',
  'permits.activities.event.DepartmentRejected': 'Abteilung hat abgelehnt',
  'permits.activities.event.DepartmentReviewCompleted': 'Abteilungsprüfung abgeschlossen',
  'permits.activities.event.EntryPermitsIssued': 'Zutrittsberechtigungen ausgestellt',
  'permits.activities.event.Closed': 'Erlaubnis geschlossen',
  'permits.activities.event.Expired': 'Erlaubnis abgelaufen',
  'permits.activities.event.AiReviewCompleted': 'KI-Prüfung abgeschlossen',
  'permits.activities.event.AiReviewFailed': 'KI-Prüfung fehlgeschlagen',
  'permits.activities.event.DepartmentApproved': 'Abteilung hat genehmigt',
  'permits.activities.event.DepartmentEscalated': 'Abteilung eskaliert',
  'permits.activities.event.EntryGranted': 'Zutrittsberechtigung erteilt',
  'permits.activities.event.EntryRevoked': 'Zutrittsberechtigung widerrufen',
  'permits.activities.event.PersonnelAssigned': 'Personal zur Erlaubniserfassung hinzugefügt',
  'permits.activities.event.PersonnelUnassigned': 'Personal aus der Erlaubniserfassung entfernt',
  'permits.activities.event.InfoUpdated': 'Angaben aktualisiert',
  'permits.activities.event.ProtectiveEquipmentAdded': 'PSA hinzugefügt: {{item}}',
  'permits.activities.event.ProtectiveEquipmentRemoved': 'PSA entfernt: {{item}}',
  'permits.activities.event.ControlItemAdded': 'Kontrollpunkt hinzugefügt: {{item}}',
  'permits.activities.event.ControlItemRemoved': 'Kontrollpunkt entfernt: {{item}}',
  'permits.activities.event.DocumentRequestAdded':
    'Zusätzliche Dokumentanforderung hinzugefügt: {{item}}',
  'permits.activities.event.DocumentRequestRemoved':
    'Zusätzliche Dokumentanforderung entfernt: {{item}}',
  // Feldbezeichnungen des Änderungsprotokolls (ChangeSet "Feld: alt → neu"); fehlende Felder
  // fallen auf den Maschinennamen zurück (defaultValue).
  'permits.field.title': 'Titel',
  'permits.field.description': 'Beschreibung',
  'permits.field.hazardClass': 'Gefahrenklasse',
  'permits.field.validityStart': 'Gültigkeitsbeginn',
  'permits.field.validityEnd': 'Gültigkeitsende',
  'permits.field.status': 'Status',
  'permits.field.permitType': 'Erlaubnistyp',
  'permits.field.sites': 'Standorte',
  'permits.field.hasVehicles': 'Fahrzeuge beteiligt?',
  // Kontrollpunkt hinzufügen/entfernen (SPEC §2.1).
  'permits.controls.add': 'Punkt hinzufügen',
  'permits.controls.addPlaceholder': 'Neuen Kontrollpunkt schreiben',
  'permits.controls.remove': 'Punkt entfernen',
  'permits.controls.remove.title': 'Kontrollpunkt entfernen',
  'permits.controls.remove.body': '"{{text}}" aus dieser Erlaubnis entfernen?',
  'permits.controls.remove.confirm': 'Entfernen',
  // PSA hinzufügen/entfernen (SPEC §2.1).
  'permits.ppe.add': 'PSA hinzufügen',
  'permits.ppe.addPlaceholder': 'PSA aus dem Katalog wählen',
  'permits.ppe.addEmpty': 'Keine weitere PSA zum Hinzufügen.',
  'permits.ppe.remove': '{{name}} entfernen',
  'permits.ppe.remove.title': 'PSA entfernen',
  'permits.ppe.remove.body': '"{{name}}" aus dieser Erlaubnis entfernen?',
  'permits.ppe.remove.confirm': 'Entfernen',
  // S33 Carbon Slice 3 (Erlaubnisdetail — Referenzseite) neue Schlüssel.
  'permits.detail.section.details': 'Details',
  'permits.detail.section.progress': 'Fortschritt',
  'permits.detail.issues.message_one': '{{count}} Punkt blockiert die Genehmigung.',
  'permits.detail.issues.message_other': '{{count}} Punkte blockieren die Genehmigung.',
  'permits.detail.issues.entryMessage_one':
    '{{count}} Punkt ist noch nicht bereit für den Zutritt.',
  'permits.detail.issues.entryMessage_other':
    '{{count}} Punkte sind noch nicht bereit für den Zutritt.',
  'permits.detail.issues.personnelFacts': 'Personal: {{list}}',
  'permits.detail.issues.vehicleFacts': 'Fahrzeuge: {{list}}',
  'permits.detail.issues.moreCount_one': '+{{count}} weitere',
  'permits.detail.issues.moreCount_other': '+{{count}} weitere',
  'permits.progress.review': 'Prüfung',
  'permits.progress.activeMeta': '{{date}} · Genehmigt von {{name}}',
  'permits.personnel.readySummary': '{{ready}} von {{total}} bereit',
  'permits.personnel.search': 'Personal suchen',
  'permits.personnel.searchPlaceholder': 'Nach Name oder Kontakt suchen',
  'permits.personnel.searchPlaceholderNameOnly': 'Nach Name suchen',
  'permits.personnel.requiredDocsLine': 'Erforderliche Personaldokumente: {{list}}',
  'permits.personnel.col.documents': 'Dokumente',
  'permits.personnel.col.siteAccess': 'Zutritt',
  'permits.personnel.searchEmpty': 'Keine Treffer für die Suche.',
  'permits.personnel.readiness.trainingMissing': 'Schulung fehlt',
  'permits.personnel.readiness.documentsMissing': 'Dokumente fehlen',
  'permits.personnel.siteAccess.granted': 'Erteilt',
  'permits.personnel.siteAccess.notGranted': 'Nicht erteilt',
  'permits.personnel.action.openMenu': 'Aktionen für {{name}}',
  PERMIT_NOT_FOUND: 'Arbeitserlaubnis nicht gefunden.',
  PROTECTIVE_EQUIPMENT_NOT_FOUND: 'PSA-Element nicht gefunden.',
  CONTROL_ITEM_NOT_FOUND: 'Kontrollpunkt nicht gefunden.',
  DUPLICATE_DOCUMENT_REQUEST: 'Für diesen Dokumenttyp besteht bereits eine Anforderung.',
  DOCUMENT_REQUEST_NOT_FOUND: 'Dokumentanforderung nicht gefunden.',
  PERMIT_NOT_EDITABLE:
    'Diese Erlaubnis kann nur im Status Entwurf oder Eingereicht bearbeitet werden.',
  PERMIT_INVALID_STATE:
    'Die Erlaubnis befindet sich nicht in einem gültigen Zustand für diese Aktion.',
  TRAINING_NOT_FOUND: 'Schulung nicht gefunden oder inaktiv.',
  PERSONNEL_DOCUMENT_NOT_FOUND: 'Dokument nicht gefunden oder gehört nicht zu diesem Personal.',
  VIDEO_TOO_LARGE: 'Die Videogröße überschreitet das zulässige Limit (max. 500 MB).',
  VIDEO_TYPE_UNSUPPORTED: 'Nicht unterstützter Videotyp. Laden Sie MP4, WebM oder MOV hoch.',

  // ---- Eğitim & Test (Training — §16 authoring) ----
  'trainings.nav': 'Schulungen',
  'trainings.title': 'Schulungen',
  'trainings.gate.loadingLabel': 'Schulungen werden geladen…',
  'trainings.forbidden.title': 'Kein Zugriff',
  'trainings.forbidden.body':
    'Sie sind nicht berechtigt, diesen Bereich anzuzeigen. Wenden Sie sich für den Zugriff an Ihren Administrator.',
  'trainings.forbidden.back': 'Zum Dashboard',
  'trainings.unavailable.title': 'Schulungen nicht verfügbar',
  'trainings.unavailable.body':
    'Der Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es in Kürze erneut.',
  'trainings.unavailable.retry': 'Erneut versuchen',
  'trainings.common.actions': 'Aktionen',
  'trainings.common.loading': 'Wird geladen…',
  'trainings.common.cancel': 'Abbrechen',
  'trainings.common.save': 'Speichern',
  'trainings.common.create': 'Erstellen',
  'trainings.status.active': 'Aktiv',
  'trainings.status.inactive': 'Inaktiv',
  'trainings.list.subtitle':
    'Erstellen Sie die Schulungen, die das Personal ansehen und bestehen muss.',
  'trainings.list.search': 'Schulungen suchen',
  'trainings.list.searchPlaceholder': 'Nach Titel suchen…',
  'trainings.list.new': 'Neue Schulung',
  'trainings.list.filter.status': 'Status',
  'trainings.list.filter.allStatuses': 'Alle Status',
  'trainings.list.count': '{{count}} Schulungen aufgelistet',
  'trainings.list.count_one': '{{count}} Schulung aufgelistet',
  'trainings.list.col.title': 'Titel',
  'trainings.list.col.video': 'Video',
  'trainings.list.col.questions': 'Fragen',
  'trainings.list.col.passThreshold': 'Bestehensgrenze',
  'trainings.list.passThreshold.ratio': '{{correct}}/{{total}}',
  'trainings.list.passThreshold.correctOnly': '{{correct}} richtig',
  'trainings.list.passThreshold.warning.label':
    'Bestehensgrenze stimmt nicht mit der Fragenanzahl überein',
  'trainings.list.passThreshold.warning.content':
    'Die Bestehensgrenze (geforderte richtige Antworten) muss zwischen 1 und der Fragenanzahl liegen. Bearbeiten Sie die Schulung, um sie zu korrigieren.',
  'trainings.list.col.status': 'Status',
  'trainings.list.col.created': 'Erstellt',
  'trainings.list.video.yes': 'Ja',
  'trainings.list.video.no': 'Keins',
  'trainings.list.action.delete': 'Löschen',
  'trainings.list.action.openMenu': 'Aktionen für {{name}}',
  'trainings.list.empty': 'Noch keine Schulungen definiert.',
  'trainings.list.empty.body': 'Sobald Sie die erste Schulung erstellen, erscheint sie hier.',
  'trainings.list.noResults': 'Keine Schulungen entsprechen Ihren Filtern.',
  'trainings.pagination.nav': 'Seitennummerierung',
  'trainings.pagination.previous': 'Zurück',
  'trainings.pagination.next': 'Weiter',
  'trainings.delete.title': 'Schulung löschen',
  'trainings.delete.body':
    'Die Schulung "{{title}}" löschen? Dies kann nicht rückgängig gemacht werden.',
  'trainings.delete.confirm': 'Schulung löschen',
  'trainings.editor.back': 'Zurück zu Schulungen',
  'trainings.editor.loading': 'Schulung wird geladen…',
  'trainings.editor.createTitle': 'Neue Schulung',
  'trainings.editor.editTitle': 'Schulung bearbeiten',
  'trainings.editor.section.meta': 'Schulungsdetails',
  'trainings.editor.section.video': 'Schulungsvideo',
  'trainings.editor.field.title': 'Titel',
  'trainings.editor.field.description': 'Beschreibung',
  'trainings.editor.field.passThreshold': 'Bestehensgrenze (richtige Antworten)',
  'trainings.editor.field.passThresholdHint': 'Muss zwischen 1 und der Anzahl der Fragen liegen.',
  'trainings.editor.field.isActive': 'Aktiv (dem Personal zuweisbar)',
  'trainings.editor.video.description':
    'Optional. Große Dateien werden direkt in den sicheren Speicher hochgeladen.',
  'trainings.editor.video.placeholder': 'Zum Hochladen eines Videos klicken',
  'trainings.editor.video.hint': 'MP4, WebM oder MOV — bis zu 500 MB',
  'trainings.editor.video.linked': 'Hochgeladenes Video',
  'trainings.editor.video.replace': 'Ersetzen',
  'trainings.editor.video.remove': 'Entfernen',
  'trainings.editor.video.uploading': 'Video wird hochgeladen',
  'trainings.editor.video.progress': '{{percent}}% hochgeladen',
  'trainings.editor.quiz.title': 'Testfragen',
  'trainings.editor.quiz.hint':
    'Markieren Sie für jede Frage die richtige Antwort. Das Personal sieht nur die Fragen; der Lösungsschlüssel bleibt hier.',
  'trainings.editor.quiz.addQuestion': 'Frage hinzufügen',
  'trainings.editor.quiz.empty': 'Fügen Sie mindestens eine Frage hinzu.',
  'trainings.editor.quiz.questionText': 'Fragetext',
  'trainings.editor.quiz.removeQuestion': 'Frage entfernen',
  'trainings.editor.quiz.options': 'Optionen',
  'trainings.editor.quiz.correctHint': 'Wählen Sie die richtige Antwort mit dem Radio-Button',
  'trainings.editor.quiz.markCorrect': 'Option {{number}} als richtig markieren',
  'trainings.editor.quiz.optionPlaceholder': 'Option {{number}}',
  'trainings.editor.quiz.removeOption': 'Option entfernen',
  'trainings.editor.quiz.addOption': 'Option hinzufügen',
  'trainings.editor.quiz.correctAnswerNote': 'Richtige Antwort: Option {{number}}',
  'trainings.editor.validation.titleRequired': 'Titel ist erforderlich.',
  'trainings.editor.validation.passThresholdRange':
    'Die Bestehensgrenze muss zwischen 1 und der Anzahl der Fragen liegen.',
  'trainings.editor.validation.questionRequired': 'Fragetext ist erforderlich.',
  'trainings.editor.validation.optionRequired': 'Option darf nicht leer sein.',
  'trainings.editor.validation.optionsRange': 'Jede Frage muss zwischen 2 und 5 Optionen haben.',
  'trainings.editor.validation.correctRequired': 'Wählen Sie die richtige Antwort.',
  'trainings.editor.validation.correctRange': 'Die richtige Antwort muss eine der Optionen sein.',
  'trainings.editor.validation.atLeastOneQuestion': 'Fügen Sie mindestens eine Frage hinzu.',

  // ---- Personaldokumente (§15 Pfad A — KVKK/PII) ----
  'contractors.personnelDocs.loading': 'Dokumente werden geladen…',
  'contractors.personnelDocs.notFound': 'Personal nicht gefunden.',
  'contractors.personnelDocs.kvkk':
    'Sensible personenbezogene Daten. Nur autorisierte Fachkräfte für Arbeitssicherheit können auf diese Dokumente zugreifen; Download-Links sind kurzlebig.',
  'contractors.personnelDocs.empty': 'Für diese Person wurden noch keine Dokumente hochgeladen.',
  'contractors.personnelDocs.add.new': 'Dokument hochladen',
  'contractors.personnelDocs.add.title': 'Personaldokument hinzufügen',
  'contractors.personnelDocs.add.description':
    'Laden Sie die Datei hoch und geben Sie Dokumenttyp und Gültigkeit ein.',
  'contractors.personnelDocs.add.submit': 'Hinzufügen',
  'contractors.personnelDocs.add.uploading': 'Wird hochgeladen…',
  'contractors.personnelDocs.add.progress': '{{percent}}% hochgeladen',
  'contractors.personnelDocs.field.file': 'Datei',
  'contractors.personnelDocs.field.filePlaceholder': 'Datei auswählen',
  'contractors.personnelDocs.field.fileHint': 'PDF oder Bild — bis zu 20 MB',
  'contractors.personnelDocs.field.type': 'Dokumenttyp',
  'contractors.personnelDocs.field.validFrom': 'Gültig ab',
  'contractors.personnelDocs.field.validUntil': 'Gültig bis',
  'contractors.personnelDocs.field.note': 'Notiz',
  'contractors.personnelDocs.delete.title': 'Dokument löschen',
  'contractors.personnelDocs.delete.body': 'Das Dokument "{{type}}" löschen?',
  'contractors.personnelDocs.delete.confirm': 'Dokument löschen',

  // ---- Risikobewertung (Risk — §19) ----
  RISK_ASSESSMENT_NOT_FOUND: 'Risikobewertung nicht gefunden.',
  RISK_ITEM_NOT_FOUND: 'Gefahrenposition nicht gefunden oder gehört nicht zu dieser Bewertung.',
  RISK_ACTION_NOT_FOUND:
    'Korrektur-/Vorbeugemaßnahme nicht gefunden oder gehört nicht zu dieser Position.',
  RISK_ASSESSMENT_NOT_EDITABLE:
    'Diese Bewertung kann nur im Status Entwurf, Eingereicht, In Prüfung oder Überarbeitet bearbeitet werden.',
  RISK_ASSESSMENT_INVALID_STATE: 'Die Bewertung ist für diese Aktion nicht im gültigen Status.',
  USER_NOT_FOUND: 'Die ausgewählte verantwortliche Person ist kein Benutzer des Unternehmens.',

  'risk.nav': 'Risikobewertung',
  'risk.title': 'Risikobewertung',
  'risk.common.actions': 'Aktionen',
  'risk.common.loading': 'Wird geladen...',
  'risk.common.close': 'Schließen',
  'risk.common.cancel': 'Abbrechen',
  'risk.common.save': 'Speichern',
  'risk.common.create': 'Erstellen',
  'risk.common.add': 'Hinzufügen',
  'risk.gate.loadingLabel': 'Zugriff auf Risikobewertung wird geprüft...',
  'risk.forbidden.title': 'Kein Zugriff',
  'risk.forbidden.body':
    'Sie haben keinen Zugriff auf das Modul Risikobewertung. Bitte wenden Sie sich an Ihren Unternehmensadministrator.',
  'risk.forbidden.back': 'Zurück zum Dashboard',
  'risk.unavailable.title': 'Risikobewertung konnte nicht geladen werden',
  'risk.unavailable.body':
    'Der Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
  'risk.unavailable.retry': 'Erneut versuchen',
  'risk.list.subtitle':
    'Bewerten Sie Gefahren für Ihre Standorte, weisen Sie Maßnahmen zu und verfolgen Sie das Restrisiko.',
  'risk.list.search': 'Bewertungen suchen',
  'risk.list.searchPlaceholder': 'Nach Titel suchen',
  'risk.list.new': 'Neue Bewertung',
  'risk.list.count': '{{count}} Bewertungen aufgelistet',
  'risk.list.count_one': '{{count}} Bewertung aufgelistet',
  'risk.list.empty': 'Noch keine Risikobewertungen.',
  'risk.list.empty.body': 'Sobald Sie die erste Bewertung erstellen, erscheint sie hier.',
  'risk.list.noResults': 'Keine Risikobewertungen entsprechen Ihren Filtern.',
  'risk.list.col.title': 'Titel',
  'risk.list.col.site': 'Standort',
  'risk.list.col.date': 'Bewertungsdatum',
  'risk.list.col.status': 'Status',
  'risk.list.col.revision': 'Revision',
  'risk.list.col.items': 'Positionen',
  'risk.list.col.highestLevel': 'Höchste Stufe',
  'risk.list.filter.status': 'Status',
  'risk.list.filter.site': 'Standort',
  'risk.list.filter.level': 'Stufe',
  'risk.list.filter.from': 'Von (frühestes)',
  'risk.list.filter.to': 'Bis (spätestes)',
  'risk.list.filter.allStatuses': 'Alle Status',
  'risk.list.filter.allSites': 'Alle Standorte',
  'risk.list.filter.allLevels': 'Alle Stufen',
  'risk.pagination.nav': 'Seitennummerierung',
  'risk.pagination.previous': 'Zurück',
  'risk.pagination.next': 'Weiter',
  'risk.status.Draft': 'Entwurf',
  'risk.status.Submitted': 'Eingereicht',
  'risk.status.Approved': 'Genehmigt',
  'risk.status.Active': 'Aktiv',
  'risk.status.UnderReview': 'In Prüfung',
  'risk.status.Revised': 'Überarbeitet',
  'risk.status.Archived': 'Archiviert',
  'risk.level.Onemsiz': 'Unbedeutend',
  'risk.level.Dusuk': 'Gering',
  'risk.level.Orta': 'Mittel',
  'risk.level.Yuksek': 'Hoch',
  'risk.level.KabulEdilemez': 'Nicht akzeptabel',
  'risk.methodology.LType5x5': '5x5 L-Typ-Matrix',
  'risk.action.status.Open': 'Offen',
  'risk.action.status.InProgress': 'In Bearbeitung',
  'risk.action.status.Done': 'Erledigt',
  'risk.action.status.Cancelled': 'Abgebrochen',
  'risk.matrix.severity': 'Schwere',
  'risk.matrix.probability': 'Wahrscheinlichkeit',
  'risk.matrix.gridLabel': 'Wahrscheinlichkeit × Schwere Matrix',
  'risk.matrix.cellLabel':
    'Wahrscheinlichkeit {{probability}}, Schwere {{severity}} — Punktzahl {{score}}, {{level}}',
  'risk.matrix.previewLabel': 'Gewähltes Risiko:',
  'risk.matrix.previewEmpty': 'Wählen Sie eine Zelle aus der Matrix, um die Punktzahl zu sehen.',
  'risk.editor.createTitle': 'Neue Risikobewertung',
  'risk.editor.section.meta': 'Bewertungsdetails',
  'risk.editor.section.items': 'Gefahrenpositionen',
  'risk.editor.field.title': 'Titel',
  'risk.editor.field.site': 'Standort',
  'risk.editor.field.area': 'Bereich / Tätigkeit',
  'risk.editor.field.assessmentDate': 'Bewertungsdatum',
  'risk.editor.field.nextReviewDate': 'Nächste Überprüfung',
  'risk.editor.field.nextReviewDateHint': 'Das Gültigkeitsdatum der Bewertung (optional).',
  'risk.editor.field.notes': 'Notizen',
  'risk.editor.sitePlaceholder': 'Standort auswählen',
  'risk.editor.items.add': 'Gefahr hinzufügen',
  'risk.editor.items.hint':
    'Wählen Sie für jede Gefahr Wahrscheinlichkeit und Schwere; Punktzahl und Stufe werden serverseitig berechnet. Maßnahmen werden je Position nach dem Erstellen der Bewertung hinzugefügt.',
  'risk.editor.items.empty':
    'Sie können die Bewertung ohne Positionen erstellen und Gefahren später hinzufügen.',
  'risk.editor.items.remove': 'Position entfernen',
  'risk.editor.validation.titleRequired': 'Titel ist erforderlich.',
  'risk.editor.validation.siteRequired': 'Bitte wählen Sie einen Standort.',
  'risk.editor.validation.assessmentDateRequired': 'Bewertungsdatum ist erforderlich.',
  'risk.editor.validation.hazardRequired': 'Gefahrenbeschreibung ist erforderlich.',
  'risk.editor.validation.scoreRequired':
    'Bitte wählen Sie Wahrscheinlichkeit und Schwere aus der Matrix.',
  'risk.editor.validation.residualIncomplete':
    'Für das Restrisiko wählen Sie beide (Wahrscheinlichkeit und Schwere) oder lassen Sie beide leer.',
  'risk.form.edit.title': 'Bewertung bearbeiten',
  'risk.form.description':
    'Aktualisieren Sie die Bewertungsdetails. Gefahrenpositionen werden im Detailbildschirm verwaltet.',
  'risk.item.field.hazard': 'Gefahr',
  'risk.item.field.risk': 'Mögliche Folge / Risiko',
  'risk.item.field.affectedPersons': 'Betroffene Personen',
  'risk.item.field.existingControls': 'Bestehende Maßnahmen',
  'risk.item.field.recommendedControls': 'Empfohlene Maßnahmen',
  'risk.item.score.title': 'Risiko (Wahrscheinlichkeit × Schwere)',
  'risk.item.residual.title': 'Restrisiko (nach Maßnahmen)',
  'risk.item.residual.hint':
    'Erwartete Wahrscheinlichkeit und Schwere nach Maßnahmen. Optional — gemeinsam ausgefüllt.',
  'risk.item.residual.clear': 'Löschen',
  'risk.item.add.title': 'Gefahrenposition hinzufügen',
  'risk.item.edit.title': 'Gefahrenposition bearbeiten',
  'risk.item.form.description':
    'Beschreiben Sie die Gefahr und bewerten Sie sie mit Wahrscheinlichkeit × Schwere. Punktzahl und Stufe werden serverseitig berechnet.',
  'risk.item.scoreDisplay': 'Wahrscheinlichkeit {{probability}} × Schwere {{severity}}',
  'risk.item.residualLabel': 'Rest:',
  'risk.action.add.title': 'Maßnahme hinzufügen',
  'risk.action.edit.title': 'Maßnahme bearbeiten',
  'risk.action.form.description':
    'Beschreiben Sie die Korrektur-/Vorbeugemaßnahme und weisen Sie Verantwortlichen und Fälligkeit zu.',
  'risk.action.field.description': 'Beschreibung',
  'risk.action.field.responsible': 'Verantwortlich',
  'risk.action.field.dueDate': 'Fällig am',
  'risk.action.field.status': 'Status',
  'risk.action.field.note': 'Notiz',
  'risk.action.responsibleNone': 'Kein Verantwortlicher',
  'risk.action.validation.descriptionRequired': 'Beschreibung ist erforderlich.',
  'risk.lifecycle.submit': 'Einreichen',
  'risk.lifecycle.approve': 'Genehmigen',
  'risk.lifecycle.review': 'Prüfen',
  'risk.lifecycle.revise': 'Überarbeiten',
  'risk.lifecycle.archive': 'Archivieren',
  'risk.lifecycle.submit.title': 'Bewertung einreichen',
  'risk.lifecycle.submit.body': 'Die Bewertung wird zur Genehmigung eingereicht. Fortfahren?',
  'risk.lifecycle.submit.confirm': 'Einreichen',
  'risk.lifecycle.approve.title': 'Bewertung genehmigen',
  'risk.lifecycle.approve.body': 'Nach der Genehmigung tritt die Bewertung in Kraft.',
  'risk.lifecycle.approve.confirm': 'Genehmigen',
  'risk.lifecycle.review.title': 'Prüfung starten',
  'risk.lifecycle.review.body': 'Die Bewertung wird in Prüfung genommen. Fortfahren?',
  'risk.lifecycle.review.confirm': 'Prüfen',
  'risk.lifecycle.revise.title': 'Überarbeiten',
  'risk.lifecycle.revise.body':
    'Die Bewertung wird zur Überarbeitung geöffnet und die Revisionsnummer erhöht. Fortfahren?',
  'risk.lifecycle.revise.confirm': 'Überarbeiten',
  'risk.lifecycle.archive.title': 'Bewertung archivieren',
  'risk.lifecycle.archive.body':
    'Die Bewertung wird dauerhaft archiviert. Dies kann nicht rückgängig gemacht werden. Fortfahren?',
  'risk.lifecycle.archive.confirm': 'Archivieren',
  'risk.detail.back': 'Zurück zu den Risikobewertungen',
  'risk.detail.loading': 'Bewertung wird geladen...',
  'risk.detail.edit': 'Details bearbeiten',
  'risk.detail.readOnlyNote': 'Diese Bewertung kann nicht mehr bearbeitet werden ({{status}}).',
  'risk.detail.revision': 'Revision {{revision}}',
  'risk.detail.field.site': 'Standort',
  'risk.detail.field.area': 'Bereich / Tätigkeit',
  'risk.detail.field.assessmentDate': 'Bewertungsdatum',
  'risk.detail.field.nextReviewDate': 'Nächste Überprüfung',
  'risk.detail.field.methodology': 'Methodik',
  'risk.detail.field.revision': 'Revisionsnr.',
  'risk.detail.field.assessedBy': 'Bewertet von',
  'risk.detail.field.approvedBy': 'Genehmigt von',
  'risk.detail.field.approvedAt': 'Genehmigt am',
  'risk.detail.items.title': 'Gefahrenpositionen',
  'risk.detail.items.add': 'Position hinzufügen',
  'risk.detail.items.edit': 'Position bearbeiten',
  'risk.detail.items.remove': 'Position entfernen',
  'risk.detail.items.empty': 'Diese Bewertung hat noch keine Gefahrenpositionen.',
  'risk.detail.items.delete.title': 'Position entfernen',
  'risk.detail.items.delete.body':
    'Gefahrenposition "{{hazard}}" entfernen? Zugehörige Maßnahmen werden ebenfalls entfernt.',
  'risk.detail.items.delete.confirm': 'Entfernen',
  'risk.detail.action.title': 'Korrektur-/Vorbeugemaßnahmen',
  'risk.detail.action.add': 'Maßnahme hinzufügen',
  'risk.detail.action.edit': 'Maßnahme bearbeiten',
  'risk.detail.action.remove': 'Maßnahme entfernen',
  'risk.detail.action.empty': 'Keine Maßnahmen für diese Position definiert.',
  'risk.detail.action.overdue': 'Überfällig',
  'risk.detail.action.delete.title': 'Maßnahme entfernen',
  'risk.detail.action.delete.body': 'Maßnahme "{{description}}" entfernen?',
  'risk.detail.action.delete.confirm': 'Entfernen',

  // ---- Benutzerverwaltung (Users — §12, tenant-scoped) ----
  'users.nav': 'Benutzer',
  'users.title': 'Benutzer',
  'users.subtitle':
    'Fügen Sie Benutzer Ihres Unternehmens hinzu, bearbeiten Sie sie und verwalten Sie ihre Rollen.',
  'users.count': '{{count}} Benutzer aufgelistet',
  'users.count_one': '{{count}} Benutzer aufgelistet',
  'users.searchPlaceholder': 'Nach Name oder E-Mail suchen',
  'users.new': 'Benutzer hinzufügen',
  'users.col.name': 'Vollständiger Name',
  'users.col.email': 'E-Mail',
  'users.col.role': 'Rolle',
  'users.col.status': 'Status',
  'users.status.active': 'Aktiv',
  'users.status.passive': 'Inaktiv',
  'users.action.delete': 'Löschen',
  'users.action.openMenu': 'Aktionen für {{name}}',
  'users.created': 'Benutzer erstellt.',
  'users.updated': 'Benutzer aktualisiert.',
  'users.deleted': 'Benutzer deaktiviert.',
  'users.common.search': 'Benutzer suchen',
  'users.common.actions': 'Aktionen',
  'users.common.loading': 'Benutzer werden geladen...',
  'users.common.empty': 'Noch keine Benutzer.',
  'users.common.empty.body': 'Sobald Sie den ersten Benutzer hinzufügen, erscheint er hier.',
  'users.list.noResults': 'Keine Benutzer entsprechen Ihrer Suche.',
  'users.common.close': 'Schließen',
  'users.common.cancel': 'Abbrechen',
  'users.common.save': 'Speichern',
  'users.common.create': 'Erstellen',
  'users.pagination.nav': 'Seitennummerierung',
  'users.pagination.previous': 'Zurück',
  'users.pagination.next': 'Weiter',
  'users.gate.loadingLabel': 'Benutzer werden geladen...',
  'users.forbidden.title': 'Kein Zugriff',
  'users.forbidden.body': 'Sie haben keine Berechtigung für die Benutzerverwaltung.',
  'users.forbidden.back': 'Zurück zum Dashboard',
  'users.unavailable.title': 'Benutzer konnten nicht geladen werden',
  'users.unavailable.body':
    'Der Dienst ist derzeit nicht erreichbar. Bitte versuchen Sie es in Kürze erneut.',
  'users.unavailable.retry': 'Erneut versuchen',
  'users.create.title': 'Benutzer hinzufügen',
  'users.create.description': 'Namen, E-Mail, Passwort und Rollen eingeben.',
  'users.edit.title': 'Benutzer bearbeiten',
  'users.edit.description': 'Benutzerdaten und Rollen aktualisieren.',
  'users.edit.loading': 'Benutzerdaten werden geladen...',
  'users.field.firstName': 'Vorname',
  'users.field.lastName': 'Nachname',
  'users.field.email': 'E-Mail',
  'users.field.password': 'Passwort',
  'users.field.passwordShow': 'Passwort anzeigen',
  'users.field.passwordHide': 'Passwort verbergen',
  'users.field.status': 'Status',
  'users.field.isActive': 'Aktiv',
  'users.field.selfActiveHint': 'Sie können Ihr eigenes Konto nicht deaktivieren.',
  'users.field.roles': 'Rollen',
  'users.roles.loading': 'Rollen werden geladen...',
  'users.roles.empty': 'Keine zuweisbaren Rollen verfügbar.',
  'users.validation.firstNameRequired': 'Vorname ist erforderlich.',
  'users.validation.lastNameRequired': 'Nachname ist erforderlich.',
  'users.validation.emailRequired': 'E-Mail ist erforderlich.',
  'users.validation.emailInvalid': 'Geben Sie eine gültige E-Mail ein.',
  'users.validation.passwordPolicy':
    'Das Passwort muss mindestens 8 Zeichen mit einem Buchstaben und einer Ziffer enthalten.',
  'users.validation.rolesRequired': 'Wählen Sie mindestens eine Rolle aus.',
  'users.delete.title': 'Benutzer deaktivieren',
  'users.delete.body':
    'Benutzer "{{name}}" deaktivieren? Der Benutzer kann sich nicht anmelden; der Datensatz bleibt erhalten.',
  'users.delete.confirm': 'Deaktivieren',
  // Fehlercodes der Benutzerverwaltung (§12 Sperren)
  CANNOT_DEACTIVATE_SELF: 'Sie können Ihr eigenes Konto nicht deaktivieren.',
  CANNOT_DELETE_SELF: 'Sie können Ihr eigenes Konto nicht löschen.',
  ROLE_NOT_ASSIGNABLE:
    'Die ausgewählte Rolle kann diesem Benutzer nicht zugewiesen werden. Bitte aktualisieren Sie und versuchen Sie es erneut.',

  // ---- Dokumentschemas (GL #7 — Verwaltung des Plattform-Dokumenttypregisters) ----------
  'documentSchemas.nav': 'Dokumentschemas',
  'documentSchemas.title': 'Dokumentschemas',
  'documentSchemas.tab.types': 'Typen',
  'documentSchemas.common.search': 'Suchen',
  'documentSchemas.gate.loadingLabel': 'Dokumentschemas werden geladen…',
  'documentSchemas.forbidden.title': 'Kein Zugriff auf diesen Bereich',
  'documentSchemas.forbidden.body':
    'Sie verfügen nicht über die erforderliche Berechtigung für die Dokumentschema-Verwaltung.',
  'documentSchemas.forbidden.back': 'Zurück zum Dashboard',
  'documentSchemas.unavailable.title': 'Derzeit nicht erreichbar',
  'documentSchemas.unavailable.body':
    'Dokumentschemas konnten derzeit nicht geladen werden. Bitte versuchen Sie es später erneut.',
  'documentSchemas.unavailable.retry': 'Erneut versuchen',
  'documentSchemas.types.subtitle':
    'Dokumenttypen gelten für alle Firmen. Die KI-Erkennung wird auf dieser Seite nicht geändert.',
  'documentSchemas.types.count': '{{count}} Dokumenttypen aufgelistet',
  'documentSchemas.types.count_one': '{{count}} Dokumenttyp aufgelistet',
  'documentSchemas.types.searchPlaceholder': 'Typ suchen…',
  'documentSchemas.types.pagination.nav': 'Seitennummerierung',
  'documentSchemas.types.pagination.previous': 'Zurück',
  'documentSchemas.types.pagination.next': 'Weiter',
  'documentSchemas.types.new': 'Neuer Dokumenttyp',
  'documentSchemas.types.created': 'Dokumenttyp erstellt.',
  'documentSchemas.types.updated': 'Dokumenttyp aktualisiert.',
  'documentSchemas.types.aiUnknown':
    'Der KI-Erkennungsstatus konnte derzeit nicht abgerufen werden; alle anderen Angaben sind aktuell.',
  'documentSchemas.types.filter.entity': 'Zuordnung',
  'documentSchemas.types.filter.allEntities': 'Alle Zuordnungen',
  'documentSchemas.types.filter.status': 'Status',
  'documentSchemas.types.filter.allStatuses': 'Alle Status',
  'documentSchemas.types.col.label': 'Bezeichnung',
  'documentSchemas.types.col.entity': 'Zuordnung',
  'documentSchemas.types.col.sortOrder': 'Position',
  'documentSchemas.types.col.expiryRule': 'Gültigkeitsregel',
  'documentSchemas.types.col.captureFormat': 'Erfassung',
  'documentSchemas.types.col.ai': 'KI-Erkennung',
  'documentSchemas.types.col.status': 'Status',
  'documentSchemas.type.status.active': 'Aktiv',
  'documentSchemas.type.status.inactive': 'Inaktiv',
  'documentSchemas.types.empty': 'Noch keine Dokumenttypen.',
  'documentSchemas.types.noResults': 'Keine passenden Dokumenttypen.',
  // Zuordnung (Vertrag `entity`, Kleinbuchstaben) — auch die Genehmigungsweiterleitung liest diese Wörter.
  'documentSchemas.entity.personnel': 'Personaldokument',
  'documentSchemas.entity.vehicle': 'Fahrzeugdokument',
  'documentSchemas.entity.company': 'Firmendokument',
  // Gültigkeitsregel (Vertrag `expiryRule`). `documents.expiryHint.*`: Hinweis je Regel, gemeinsam für
  // das Admin-Formular und die Upload-Formulare.
  'documentSchemas.expiryRule.EndDateRequired': 'Enddatum erforderlich',
  'documentSchemas.expiryRule.EndDateOptional': 'Enddatum optional',
  'documentSchemas.expiryRule.NoExpiry': 'Unbefristet',
  'documents.expiryHint.EndDateRequired':
    'Ein Enddatum ist erforderlich; nach Ablauf gilt das Dokument als ungültig.',
  'documents.expiryHint.EndDateOptional':
    'Ein Enddatum ist optional; wenn angegeben, wird der Ablauf überwacht.',
  'documents.expiryHint.NoExpiry': 'Für diesen Dokumenttyp wird kein Enddatum überwacht.',
  // Erfassungsformat (Vertrag `captureFormat`): Kurzname in der Liste + Formularoption.
  'documentSchemas.captureFormat.Card': 'Karte',
  'documentSchemas.captureFormat.Page': 'Seite',
  'documentSchemas.captureFormat.option.Card': 'Karte (Vorder- und Rückseite)',
  'documentSchemas.captureFormat.option.Page': 'Seite (A4)',
  'documentSchemas.ai.manualOnly': 'Nur manuell',
  'documentSchemas.ai.unknownSr': 'KI-Erkennungsstatus konnte nicht abgerufen werden',
  // KI-Erkennungsmarke (`RecognitionMark`: Dokumentschemas + Personaldokumentzeilen des Experten).
  'documents.recognition.set': 'KI v{{n}}',
  'documents.recognition.none': 'Nicht KI-erkannt',
  'documents.recognition.srSet':
    'Die KI hat diese Datei als diesen Typ erkannt (Erkennungsversion {{n}})',
  // Dokumenttyp-Auswahl (§27-Register; Hinzufügen-Dialoge für Firma/Personal/Fahrzeug) + Enddatum-Regel (GL #7).
  'documentTypes.placeholder': 'Dokumenttyp auswählen',
  'documentTypes.loading': 'Wird geladen…',
  'documentTypes.loadError': 'Dokumenttypen konnten nicht geladen werden.',
  'documentTypes.retry': 'Erneut versuchen',
  'documentTypes.empty':
    'Kein aktiver Dokumenttyp verfügbar. Dokumenttypen werden unter Dokumentschemas verwaltet.',
  'documentTypes.required': 'Dokumenttyp ist erforderlich.',
  'documentTypes.typeRejected':
    'Dieser Dokumenttyp kann nicht mehr verwendet werden. Die Typliste wurde aktualisiert; bitte erneut auswählen.',
  'documents.field.validUntilRequired': 'Für diesen Dokumenttyp ist ein Enddatum erforderlich.',
  'documentSchemas.form.create.title': 'Neuer Dokumenttyp',
  'documentSchemas.form.edit.title': 'Dokumenttyp bearbeiten',
  'documentSchemas.form.create': 'Erstellen',
  'documentSchemas.form.save': 'Speichern',
  'documentSchemas.form.selectPlaceholder': 'Auswählen',
  'documentSchemas.form.field.entity': 'Zuordnung',
  'documentSchemas.form.field.code': 'Code',
  'documentSchemas.form.codeHint':
    'Beginnt mit einem Großbuchstaben; keine türkischen Buchstaben und keine Leerzeichen. Kann später nicht geändert werden.',
  'documentSchemas.form.section.labels': 'Bezeichnung',
  'documentSchemas.form.field.labelTr': 'Türkçe',
  'documentSchemas.form.field.labelEn': 'English',
  'documentSchemas.form.field.labelDe': 'Deutsch',
  'documentSchemas.form.section.rules': 'Regeln',
  'documentSchemas.form.field.expiryRule': 'Gültigkeitsregel',
  'documentSchemas.form.field.captureFormat': 'Erfassungsformat',
  'documentSchemas.form.captureFormatHint': 'Bestimmt nur den Kamerarahmen in der mobilen App.',
  'documentSchemas.form.field.sortOrder': 'Position',
  'documentSchemas.form.sortOrderHint':
    'Bleibt das Feld leer, wird der Typ am Ende dieser Zuordnung angefügt.',
  'documentSchemas.form.field.isActive': 'Aktiv',
  'documentSchemas.form.isActiveHint':
    'Ein inaktiver Typ ist beim Hochladen nicht wählbar; Genehmigungen, die ihn verlangen, können nicht bereit werden.',
  'documentSchemas.form.validation.entityRequired': 'Wählen Sie die Zuordnung.',
  'documentSchemas.form.validation.codeRequired': 'Code ist erforderlich.',
  'documentSchemas.form.validation.codeInvalid':
    'Der Code muss mit einem Großbuchstaben beginnen und darf nur englische Buchstaben und Ziffern enthalten (2-40 Zeichen).',
  'documentSchemas.form.validation.codeReserved':
    'Der Code "Other" ist reserviert; geben Sie einen anderen Code ein.',
  'documentSchemas.form.validation.labelRequired': 'Bezeichnung ist erforderlich.',
  'documentSchemas.form.validation.labelInvalid':
    'Die Bezeichnung darf höchstens {{max}} Zeichen lang sein und keine Steuerzeichen oder unsichtbaren Zeichen enthalten. Geben Sie den Text erneut von Hand ein.',
  'documentSchemas.form.validation.ruleRequired': 'Wählen Sie eine Gültigkeitsregel.',
  'documentSchemas.form.validation.formatRequired': 'Wählen Sie ein Erfassungsformat.',
  'documentSchemas.form.validation.sortOrderRequired': 'Position ist erforderlich.',
  'documentSchemas.form.validation.sortOrderInvalid':
    'Die Position muss eine ganze Zahl ab 0 sein.',
  // Bestätigungen (D1/D2): Geltungsbereich "in allen Firmen"; Regeländerung richtungsabhängig.
  'documentSchemas.confirm.deactivate.title': 'Dokumenttyp deaktivieren',
  'documentSchemas.confirm.deactivate.confirm': 'Deaktivieren',
  'documentSchemas.confirm.deactivate.lead':
    '"{{label}}" ({{entity}}) wird in allen Firmen deaktiviert.',
  'documentSchemas.confirm.deactivate.permits':
    'Genehmigungen, die diesen Typ verlangen, können erst bereit werden, wenn er wieder aktiviert oder die Anforderung entfernt wird.',
  'documentSchemas.confirm.deactivate.documents':
    'Die Deaktivierung ändert vorhandene Dokumente nicht.',
  'documentSchemas.confirm.rule.title': 'Gültigkeitsregel ändern',
  'documentSchemas.confirm.rule.confirm': 'Regel ändern',
  'documentSchemas.confirm.rule.lead':
    'Die Gültigkeitsregel von "{{label}}" ({{entity}}) ändert sich in allen Firmen: {{from}} → {{to}}.',
  'documentSchemas.confirm.rule.retroactive':
    'Die neue Regel gilt rückwirkend für vorhandene Dokumente in allen Firmen.',
  'documentSchemas.confirm.rule.toRequired':
    'Vorhandene Dokumente ohne Enddatum gelten als fehlend; Genehmigungen, die diesen Typ verlangen, werden in allen Firmen blockiert.',
  'documentSchemas.confirm.both.title': 'Diese Änderung betrifft Genehmigungen und Dokumente',
  'documentSchemas.confirm.both.confirm': 'Speichern und anwenden',
  'documentSchemas.confirm.both.lead':
    '"{{label}}" ({{entity}}) wird in allen Firmen deaktiviert und seine Gültigkeitsregel ändert sich: {{from}} → {{to}}.',
  // Fehlercodes der Dokumenttyp-Verwaltung (Vertrag §4.6) — das Backend-Sprachpaket überschreibt sie.
  DOCUMENT_TYPE_CODE_EXISTS:
    'Dieser Code wird in dieser Zuordnung bereits verwendet (auch von inaktiven Typen; Groß- und Kleinschreibung wird nicht unterschieden). Geben Sie einen anderen Code ein.',
  DOCUMENT_TYPE_NOT_FOUND: 'Dokumenttyp nicht gefunden. Die Liste wurde aktualisiert.',

  // ---- Zugangskontrolle (§29, S32) ----
  'security.nav': 'Zugangskontrolle',
  'security.subtitle': 'Prüfen Sie den Zutritt per Torcode, Personal-QR-Code oder Ausweisnummer.',
  'security.gate.loadingLabel': 'Zugriff auf Zugangskontrolle wird geprüft...',
  'security.forbidden.title': 'Kein Zugriff auf die Zugangskontrolle',
  'security.forbidden.body':
    'Sie haben keinen Zugriff auf das Modul Zugangskontrolle. Bitte wenden Sie sich an Ihren Firmenadministrator.',
  'security.forbidden.back': 'Zurück zum Dashboard',
  'security.unavailable.title': 'Zugangskontrolle nicht erreichbar',
  'security.unavailable.body':
    'Der Dienst ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut.',
  'security.unavailable.retry': 'Erneut versuchen',
  'security.common.loading': 'Wird geladen...',
  'security.context.siteSelect': 'Standort wählen',
  'security.context.sitePlaceholder': 'Standort auswählen',
  'security.context.offline':
    'Keine Verbindung — Abfragen und Aktualisierungen können fehlschlagen',
  'security.context.offlineGateStale':
    'Keine Verbindung — der Torcode wird nicht mehr aktualisiert; der angezeigte Code ist möglicherweise veraltet',
  'security.context.fullScreen': 'Vollbild',
  'security.context.exitFullScreen': 'Vollbild beenden',
  'security.noSites.body':
    'Für diese Firma sind keine Standorte definiert. Standorte werden vom Arbeitssicherheitsexperten/Administrator angelegt.',
  'security.noSiteSelected.body': 'Wählen Sie zuerst einen Standort.',
  'security.tab.gate': 'Torcode',
  'security.tab.tc': 'Abfrage per Ausweisnummer',
  'security.panel.decision.title': 'Entscheidung',
  'security.panel.entry.title': 'Zutritt',
  'security.panel.today.title': 'Heute',
  'security.giris.tab.ariaLabel': 'Zutrittsmethode',
  'security.giris.tab.qr.short': 'QR',
  'security.giris.tab.tc.short': 'Ausweisnummer',
  'security.giris.codeActiveSr': 'Code aktiv',
  'security.giris.codeStillLive':
    'Der Torcode ist noch aktiv; Scans werden weiterhin im Hintergrund erfasst.',
  'security.gate.intro.title': 'Torcode anzeigen',
  'security.gate.intro.body':
    'Auf dem Bildschirm erscheint ein 120-sekündiger Code; die Mitarbeitenden scannen ihn mit dem eigenen Telefon. Der Code erneuert sich von selbst.',
  'security.gate.show': 'Torcode anzeigen',
  'security.gate.stop': 'Code stoppen',
  'security.gate.issuing': 'Code wird erstellt...',
  'security.gate.workerInstruction': 'Scannen Sie diesen Code mit Ihrer App.',
  'security.gate.rotatesIn': 'Erneuert sich in {{seconds}} s',
  'security.gate.qrRenderError': 'Der Code konnte nicht erstellt werden.',
  'security.gate.qrAriaLabel': 'Torcode (QR)',
  'security.gate.forbidden.title': 'Berechtigung für Torcode nicht erteilt',
  'security.gate.forbidden.body':
    'Die Berechtigung für den Torcode wurde nicht erteilt. Der Firmenadministrator muss in der Berechtigungsmatrix die Berechtigung „security: gate-result" erteilen.',
  'security.gate.issueError.body':
    'Der Code konnte nicht erstellt werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  'security.gate.retry': 'Erneut versuchen',
  'security.gate.expired.title': 'Code abgelaufen',
  'security.gate.expired.body': 'Dieser Code ist abgelaufen. Erstellen Sie einen neuen.',
  'security.gate.newCode': 'Neuen Code erstellen',
  'security.gate.hidden.title': 'Code ausgeblendet',
  'security.gate.hidden.body':
    'Eine Entscheidung wird angezeigt; der Code bleibt ausgeblendet, bis Sie sie schließen.',
  'security.verdict.allowed': 'ZUTRITT ERLAUBT',
  'security.verdict.denied': 'ZUTRITT VERWEIGERT',
  'security.verdict.notFound': 'NICHT GEFUNDEN',
  'security.verdict.networkError': 'KEINE ENTSCHEIDUNG',
  'security.verdict.decidedAt': 'Entschieden um {{time}}',
  'security.verdict.decidedAgo': 'vor {{minutes}} Min.',
  'security.verdict.idle.title': 'Noch keine Entscheidung',
  'security.verdict.idle.body':
    'Sobald ein Torcode gescannt oder eine Ausweisnummer abgefragt wird, erscheint die Entscheidung hier.',
  'security.verdict.permit.entryPermitted': 'Zutritt erlaubt',
  'security.verdict.permit.entryNotPermitted': 'Zutritt nicht erlaubt',
  'security.verdict.permit.future': 'noch nicht gültig',
  'security.verdict.permit.expired': 'abgelaufen',
  'security.verdict.permit.grantedPast': 'Zutritt freigegeben',
  'security.verdict.permit.notGrantedPast': 'kein Zutritt freigegeben',
  'security.verdict.permits.eyebrow': 'GENEHMIGUNGEN ({{count}})',
  'security.verdict.permits.more': '+{{count}} weitere Genehmigung(en)',
  'security.verdict.permits.moreBlocked': '+{{count}} weitere · {{blocked}} ohne Zutrittserlaubnis',
  'security.verdict.permits.count.future': '{{count}} noch nicht gültig',
  'security.verdict.permits.count.expired': '{{count}} abgelaufen',
  'security.verdict.permits.scrollMore': 'weiter unten',
  'security.verdict.permits.empty': 'Keine Genehmigungsinformationen.',
  'security.verdict.liveMismatch': 'Die Genehmigung hat sich nach diesem Scan geändert.',
  'security.verdict.selectedSite': 'Ausgewählter Standort: {{site}}',
  'security.verdict.acknowledge': 'Schließen',
  'security.verdict.acknowledgeQueued': 'Nächste ({{count}})',
  'security.verdict.acknowledgeQueuedSr': 'Zur nächsten Entscheidung — {{count}} warten',
  'security.verdict.acknowledgeQueuedDenialSr': 'Die nächste Entscheidung ist eine Ablehnung',
  'security.contractor.srLabel': 'Auftragnehmer',
  'security.site.srLabel': 'Standort',
  'security.verdict.networkError.title': 'Keine Entscheidung erhalten',
  'security.verdict.networkError.body':
    'Der Server war nicht erreichbar. Das ist KEINE Ablehnung — versuchen Sie es erneut, sobald die Verbindung wiederhergestellt ist.',
  'security.reason.NoPermit.label': 'Kein Arbeitserlaubnisschein',
  'security.reason.NoPermit.body': 'Gestatten Sie keinen Zutritt.',
  'security.reason.NoPermit.action':
    'Verweisen Sie die Person an den Auftragnehmer-Verantwortlichen — eine Arbeitserlaubnis muss eröffnet werden.',
  'security.reason.OutOfSite.label': 'Nicht dieser Standort',
  'security.reason.OutOfSite.body': 'Gestatten Sie keinen Zutritt.',
  'security.reason.OutOfSite.action':
    'Fragen Sie nach dem richtigen Standort und prüfen Sie Ihre Standortauswahl.',
  'security.reason.EntryNotPermitted.label': 'Zutritt nicht erteilt',
  'security.reason.EntryNotPermitted.body': 'Gestatten Sie keinen Zutritt.',
  'security.reason.EntryNotPermitted.action':
    'Benachrichtigen Sie den Arbeitssicherheitsexperten — der Zutritt wurde nicht erteilt.',
  'security.reason.OutOfValidity.label': 'Außerhalb der Gültigkeit',
  'security.reason.OutOfValidity.body': 'Gestatten Sie keinen Zutritt.',
  'security.reason.OutOfValidity.action':
    'Die Genehmigung ist derzeit nicht gültig — der Auftragnehmer-Verantwortliche muss sie verlängern.',
  'security.reason.Terminal.label': 'Genehmigung geschlossen / abgelehnt',
  'security.reason.Terminal.body': 'Gestatten Sie keinen Zutritt.',
  'security.reason.Terminal.action':
    'Benachrichtigen Sie den Arbeitssicherheitsexperten — diese Genehmigung wurde geschlossen oder abgelehnt.',
  'security.reason.unknown.label': 'Grund nicht erkannt',
  'security.reason.unknown.body': 'Dieses Ergebnis kam mit einem nicht erkannten Code.',
  'security.reason.unknown.action':
    'Erneut scannen; falls dies weiterhin auftritt, den Arbeitssicherheitsexperten benachrichtigen.',
  'security.reason.TokenExpired.label': 'Code abgelaufen',
  'security.reason.TokenConsumed.label': 'Code-Scan-Limit erreicht',
  'security.reason.TokenExpired.action':
    'Bitten Sie den Mitarbeiter, seinen Zutritts-QR-Code zu erneuern; er wird nach kurzer Zeit automatisch erneuert.',
  'security.reason.TokenConsumed.action':
    'Dieser QR-Code wurde bereits gescannt. Bitten Sie den Mitarbeiter, einen neuen Zutritts-QR-Code zu erzeugen.',
  'security.reason.TokenInvalid.label': 'Ungültiger QR-Code',
  'security.reason.TokenInvalid.action':
    'Der Code konnte nicht gelesen werden oder gehört nicht zu diesem Standort. Bitten Sie den Mitarbeiter, den Zutritts-QR-Code erneut zu zeigen.',
  'security.tab.scan': 'Personal-QR-Code scannen',
  'security.giris.tab.scan.short': 'Personal-QR',
  'security.scan.intro.title': 'Zutritts-QR-Code des Mitarbeiters scannen',
  'security.scan.intro.body':
    'Lassen Sie den Mitarbeiter den in seiner mobilen App erzeugten Zutritts-QR-Code in die Kamera halten; die Zutrittsberechtigung wird sofort geprüft.',
  'security.scan.start': 'Kamera öffnen',
  'security.scan.stop': 'Kamera schließen',
  'security.scan.instruction':
    'Richten Sie den Zutritts-QR-Code des Mitarbeiters im Kamerarahmen aus.',
  'security.scan.verifying': 'Wird überprüft...',
  'security.scan.cameraAriaLabel': 'Kameravorschau zum Scannen des Personal-QR-Codes',
  'security.scan.cameraError.denied.title': 'Kamerazugriff verweigert',
  'security.scan.cameraError.denied.body':
    'Erlauben Sie den Kamerazugriff im Browser und versuchen Sie es erneut, oder geben Sie den Code unten manuell ein.',
  'security.scan.cameraError.noDevice.title': 'Keine Kamera gefunden',
  'security.scan.cameraError.noDevice.body':
    'Auf diesem Gerät wurde keine nutzbare Kamera gefunden. Sie können den Code unten manuell eingeben, um zu überprüfen.',
  'security.scan.cameraError.error.title': 'Kamera konnte nicht gestartet werden',
  'security.scan.cameraError.error.body':
    'Die Kamera ist derzeit nicht verfügbar. Sie können den Code unten manuell eingeben, um zu überprüfen.',
  'security.scan.manual.toggle': 'Code manuell eingeben',
  'security.scan.manual.tryCamera': 'Kamera versuchen',
  'security.scan.manual.hint':
    'Wenn Sie den Zutritts-QR-Code des Mitarbeiters nicht scannen können, fügen Sie dessen Inhalt unten ein, um zu überprüfen.',
  'security.scan.manual.label': 'QR-Code',
  'security.scan.manual.placeholder': 'Inhalt des QR-Codes einfügen',
  'security.scan.manual.submit': 'Überprüfen',
  'security.scan.manual.validation.required': 'Bitte geben Sie den zu überprüfenden Code ein.',
  'security.tc.field.label': 'T.C.-Ausweisnummer',
  'security.tc.field.placeholder': '11-stellige Ausweisnummer',
  'security.tc.submit': 'Abfragen',
  'security.tc.hint': 'Fragen Sie einen Mitarbeitenden ohne Kamera oder Code per Ausweisnummer ab.',
  'security.tc.validation.required': 'Ausweisnummer ist erforderlich.',
  'security.tc.validation.invalid': 'Geben Sie eine gültige Ausweisnummer ein.',
  'security.tc.notFound.title': 'Nicht gefunden',
  'security.tc.notFound.action':
    'Geben Sie die Ausweisnummer erneut ein. Ist sie korrekt, ist diese Person bei dieser Firma nicht registriert — verweisen Sie sie an den Auftragnehmer-Verantwortlichen.',
  'security.day.summary':
    '{{total}} Zutritte · {{security}} Security · {{selfAsserted}} Selbstauskunft',
  'security.day.empty': 'Heute noch keine Zutritte an diesem Standort.',
  'security.day.error': 'Die heutige Liste konnte nicht geladen werden.',
  'security.day.methodDisclaimer':
    'Einträge über den Torcode sind die eigene Angabe der Mitarbeitenden; sie wurden nicht von der Security überprüft.',
  'security.day.filter.all': 'Alle',
  'security.day.filter.allowed': 'Eingetretene',
  'security.day.filter.groupLabel': 'Filter für heute',
  'security.day.status.allowed': 'Eingetreten',
  'security.day.status.denied': 'Abgelehnt',
  'security.day.col.status': 'Status',
  'security.day.col.time': 'Uhrzeit',
  'security.day.col.name': 'Name',
  'security.day.col.contractor': 'Auftragnehmer',
  'security.day.col.method': 'Methode',
  'security.day.col.reason': 'Grund',
  'security.day.truncated':
    'Einige abgelehnte Versuche werden nicht angezeigt (nur die neuesten 200 werden angezeigt); ältere Ablehnungen erscheinen nicht in dieser Liste.',
  'security.day.deniedNote':
    'Außerdem {{count}} abgelehnte(r) Versuch(e) — nicht in der Zutrittszahl enthalten.',
  'security.day.col.detail': 'Details',
  'security.common.close': 'Schließen',
  'security.detail.title': 'Zutrittsprotokoll',
  'security.detail.open': 'Zutrittsprotokoll öffnen — {{name}}, {{time}}',
  'security.detail.section.reason': 'Ablehnungsgrund',
  'security.detail.deniedAt': 'Dieser Versuch wurde um {{time}} abgelehnt.',
  'security.detail.permits.title': 'Konformität',
  'security.detail.permits.asOf': 'Aktueller Stand — Stand {{time}}',
  'security.detail.permits.empty': 'Kein an diesen Standort gebundener Genehmigungseintrag.',
  'security.detail.error': 'Die Genehmigungsliste konnte nicht geladen werden.',
  'security.eligibility.eyebrow': 'KONFORMITÄT · {{title}}',
  'security.eligibility.documents': 'Erforderliche Dokumente',
  'security.eligibility.trainings': 'Arbeitsschutzschulungen',
  // Kurze sichtbare Bezeichnung (§10 — der volle Satz sprengt die Zeile); voller Satz in
  // `.srLabel`, gleiches `aria-hidden`+`sr-only`-Muster wie `EntryPanel.tsx:83-88`.
  'security.eligibility.approval': 'Freigabe (Arbeitssicherheit)',
  'security.eligibility.approval.srLabel': 'Freigabe der Fachkraft für Arbeitssicherheit',
  'security.eligibility.state.verified': 'Bestätigt',
  'security.eligibility.state.completed': 'Abgeschlossen',
  'security.eligibility.state.missing': 'Fehlt ({{count}})',
  'security.eligibility.state.missingUnknown': 'Fehlt',
  'security.eligibility.state.granted': 'Erteilt',
  'security.eligibility.state.awaiting': 'Ausstehend',
  'security.eligibility.state.revoked': 'Zurückgezogen',
  'security.eligibility.route.contractor':
    'Es fehlen Dokumente oder Schulungen — verweisen Sie die Person an den Auftragnehmer-Verantwortlichen.',
  'security.eligibility.route.expert':
    'Dokumente und Schulungen sind vollständig — die Freigabe durch die Fachkraft für Arbeitssicherheit steht noch aus.',
  'security.eligibility.items.unresolved': 'Fehlt, der Name kann nicht angezeigt werden.',
  'security.method.gateQr': 'Torcode',
  'security.method.gateQr.selfAsserted': 'Torcode (Selbstauskunft)',
  'security.method.tcLookup': 'Ausweisnummer',
  'security.method.personnelQr': 'Security',
};

export const appResources: AppResources = {
  'tr-TR': tr,
  'en-US': en,
  'de-DE': de,
};
